// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"6MveM":[function(require,module,exports,__globalThis) {
require("edc5e513ddf6eee9").register(require("a6b2e58d8f0bcbc").getBundleURL('eZsNI'), JSON.parse("[\"eZsNI\",\"index.c0d8ddfb.js\",\"gkoA8\",\"default-cover.639b9f08.jpg\",\"jXGOU\",\"full-cloud.4926cd43.png\",\"8v2Nl\",\"information.47157bfb.png\",\"f80Gh\",\"cloud.5532fdb2.png\",\"kyX9I\",\"dreyfous.3b6e8040.png\",\"4xHv0\",\"dreyfous.cf832047.png\",\"gNvKP\",\"edusystem.b44b181b.png\",\"64zCO\",\"facebook.24c567aa.png\",\"cz2oX\",\"instagram.466c0244.png\",\"7lUiW\",\"logodry.a929e431.png\",\"dIrfH\",\"twitter.ce90a851.png\",\"6FhS6\",\"youtube.8317297a.png\",\"cRpe8\",\"9.dd4ea5ca.png\",\"1pz6d\",\"10.463d3f1c.png\",\"k23eO\",\"11.0686b384.png\",\"9wuWp\",\"13.5227b783.png\",\"c2dPe\",\"15.73ab16a8.png\",\"iubfy\",\"17.ae198b2f.png\",\"akLLG\",\"18.0942d5b1.png\",\"8jCXZ\",\"19.45dd38e9.png\",\"kReGd\",\"20.0fdf34fe.png\",\"iBV9q\",\"21.5f2123d1.png\",\"ahGSp\",\"23.6355f364.png\",\"gGGfQ\",\"amazon.e03d8aa1.png\",\"k8ae4\",\"amex.58ffc81b.png\",\"1BvPC\",\"default.0f9f8e6b.png\",\"dqo56\",\"diners.8c175fc1.png\",\"8Uwwk\",\"discover.100d93af.png\",\"hfBKe\",\"jcb.a33c4daa.png\",\"kqEse\",\"maestro.88bc6e46.png\",\"k8eeG\",\"mastercard.025dbb2b.png\",\"5g2SB\",\"paypal.43d67671.png\",\"7fKVq\",\"skrill.01ca4556.png\",\"hSstf\",\"visa.73b8ee7e.png\",\"5mr5t\",\"westerunion.f3e63f2f.png\",\"2hpTh\",\"worlpay.0cb47f2b.png\"]"));

},{"edc5e513ddf6eee9":"gSiLw","a6b2e58d8f0bcbc":"a2ypy"}],"gSiLw":[function(require,module,exports,__globalThis) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"a2ypy":[function(require,module,exports,__globalThis) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return '/';
}
function getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"4UKz9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _app = require("./App");
var _appDefault = parcelHelpers.interopDefault(_app);
const $root = document.getElementById('root');
if ($root) {
    const root = (0, _react.createRoot)($root);
    root.render((0, _jsxRuntime.jsxs)((0, _react.BrowserRouter), {
        children: [
            (0, _jsxRuntime.jsx)((0, _react.ToastContainer), {
                position: 'bottom-right',
                autoClose: 5000,
                hideProgressBar: false,
                newestOnTop: false,
                closeOnClick: true,
                rtl: false,
                pauseOnFocusLoss: true,
                draggable: true,
                pauseOnHover: true
            }),
            (0, _jsxRuntime.jsx)((0, _appDefault.default), {})
        ]
    }));
}

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","./App":"9fHn1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9fHn1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HomeSchoolerAppWithAuthentication);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _routes = require("./routes");
var _routesDefault = parcelHelpers.interopDefault(_routes);
var _hook = require("context/auth-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _context = require("./context");
const HomeShoolerApp = ()=>{
    const { role } = (0, _hookDefault.default)();
    const routes = (0, _routesDefault.default)(role);
    return (0, _jsxRuntime.jsx)((0, _react.PrimeReactProvider), {
        children: routes
    });
};
const HomeSchoolerAppWithAuthentication = (0, _context.withContext)(HomeShoolerApp, 'auth');

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","./routes":"GYnus","context/auth-context/hook":"2UX0M","./context":"VKWtn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"GYnus":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createRoutes);
var _react = require("external/react");
var _index = require("layout/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _index1 = require("pages/index");
const freePaths = [
    route('/success', (0, _index1.Page)('Success'))
];
const publicIndex = (0, _react.createElement)((0, _react.Navigate), {
    to: '/offers'
});
const publicPaths = [
    route('/offers', (0, _index1.Page)('Offers')),
    route('/offers/:offerId', (0, _index1.Page)('Offer')),
    route('/subjects/:offerId/:idSelectCourse/:typeSubject', (0, _index1.Page)('Subjects')),
    route('/courses/:idSubject/:offerId/:idSelectCourse/:typeSubject', (0, _index1.Page)('Courses')),
    route('/course-detail/:courseId', (0, _index1.Page)('CourseDetail')),
    route('/summary', (0, _index1.Page)('Summary'))
];
const parentPaths = [
    route('/home', (0, _index1.Page)('Home')),
    route('/home/profile', (0, _index1.Page)('Profile')),
    route('/home/support', (0, _index1.Page)('Support')),
    route('/home/packages', (0, _index1.Page)('Packages')),
    route('/home/packages/:packageId', (0, _index1.Page)('Package')),
    route('/home/payment', (0, _index1.Page)('Payment')),
    route('/home/payment/history', (0, _index1.Page)('PaymentHistory')),
    route('/home/users/:role', (0, _index1.Page)('Users')),
    route('/home/users/:role/new', (0, _index1.Page)('NewUser')),
    route('/home/users/:role/packages/:userId', (0, _index1.Page)('UserPackages'))
];
const parentIndex = (0, _react.createElement)((0, _react.Navigate), {
    to: '/home'
});
const adminPaths = [
    route('/admin', (0, _index1.AdminPage)('Home')),
    route('/admin/offers', (0, _index1.AdminPage)('Offers')),
    route('/admin/offers/configuration/:offerId', (0, _index1.AdminPage)('OfferConfiguration')),
    route('/admin/clients', (0, _index1.AdminPage)('Clients')),
    route('/admin/clients/:clientId', (0, _index1.AdminPage)('Client')),
    route('/admin/packages/details/:purchaseItemId', (0, _index1.AdminPage)('Home')),
    route('/admin/transactions', (0, _index1.AdminPage)('Home')),
    route('/admin/transactions/client/:clientId', (0, _index1.AdminPage)('Home')),
    route('/admin/transactions/history', (0, _index1.AdminPage)('Home')),
    route('/admin/profile', (0, _index1.AdminPage)('Home'))
];
const adminIndex = (0, _react.createElement)((0, _react.Navigate), {
    to: '/admin'
});
const accountingPaths = [
    route('/accounting', (0, _index1.AccountingPage)('Home')),
    route('/accounting/payouts', (0, _index1.AccountingPage)('Payouts')),
    route('/accounting/payouts/:payoutId', (0, _index1.AccountingPage)('Payout')),
    route('/accounting/clients', (0, _index1.AccountingPage)('Clients')),
    route('/accounting/clients/:clientId', (0, _index1.AccountingPage)('Client'))
];
const accountingIndex = (0, _react.createElement)((0, _react.Navigate), {
    to: '/accounting'
});
const roleIndexes = {
    'PARENT': parentIndex,
    'ADMIN_HOMESCHOOLER': adminIndex,
    'ACCOUNTING': accountingIndex
};
const roleLayoutNames = {
    'PARENT': 'Parent',
    'ADMIN_HOMESCHOOLER': 'Admin',
    'ACCOUNTING': 'Accounting'
};
function createRoutes(role) {
    const publicRoutes = publicPaths.map((props, key)=>(0, _react.createElement)((0, _react.Route), {
            ...props,
            key
        }));
    publicRoutes.push((0, _react.createElement)((0, _react.Route), {
        index: true,
        element: publicIndex,
        key: 'index'
    }));
    const roleRoutes = role ? rolePaths(role).map((props, key)=>(0, _react.createElement)((0, _react.Route), {
            ...props,
            key
        })) : [];
    const layoutRoutes = [
        (0, _react.createElement)((0, _react.Route), {
            path: '/',
            key: 'public',
            Component: (0, _indexDefault.default)('Public')
        }, publicRoutes)
    ];
    if (role && roleRoutes.length > 0) {
        const roleIndex = roleIndexes[role];
        const layoutName = roleLayoutNames[role];
        roleRoutes.push((0, _react.createElement)((0, _react.Route), {
            index: true,
            element: roleIndex,
            key: 'index'
        }));
        layoutRoutes.push((0, _react.createElement)((0, _react.Route), {
            path: '/',
            key: 'role',
            Component: (0, _indexDefault.default)(layoutName)
        }, roleRoutes));
    }
    const freeRoutes = freePaths.map((props, key)=>(0, _react.createElement)((0, _react.Route), {
            ...props,
            key
        }));
    return (0, _react.createElement)((0, _react.Routes), undefined, layoutRoutes.concat(freeRoutes));
}
function rolePaths(role) {
    switch(role){
        case 'PARENT':
            return parentPaths;
        case 'ADMIN_HOMESCHOOLER':
            return adminPaths;
        case 'ACCOUNTING':
            return accountingPaths;
        default:
            return [];
    }
}
function route(path, Component, named) {
    const props = {
        path,
        Component,
        ...named || {
            exact: true
        }
    };
    return props;
}

},{"external/react":"1Glst","layout/index":"j6iAm","pages/index":"ajHca","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j6iAm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Layout);
var _public = require("./Public");
var _publicDefault = parcelHelpers.interopDefault(_public);
var _admin = require("./Admin");
var _adminDefault = parcelHelpers.interopDefault(_admin);
var _parent = require("./Parent");
var _parentDefault = parcelHelpers.interopDefault(_parent);
var _accounting = require("./Accounting");
var _accountingDefault = parcelHelpers.interopDefault(_accounting);
const layouts = {
    Public: (0, _publicDefault.default),
    Admin: (0, _adminDefault.default),
    Parent: (0, _parentDefault.default),
    Accounting: (0, _accountingDefault.default)
};
function Layout(name) {
    return layouts[name];
}

},{"./Public":"k1TZY","./Admin":"QPS7J","./Parent":"cm0bI","./Accounting":"7pJwb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k1TZY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _index = require("context/index");
var _hook = require("context/auth-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _iconProfile = require("components/IconProfile");
var _iconProfileDefault = parcelHelpers.interopDefault(_iconProfile);
var _shoppingCart = require("components/ShoppingCart");
var _shoppingCartDefault = parcelHelpers.interopDefault(_shoppingCart);
var _login = require("./Login");
var _loginDefault = parcelHelpers.interopDefault(_login);
var _login1 = require("./Buttons/Login");
var _loginDefault1 = parcelHelpers.interopDefault(_login1);
var _continue = require("./Buttons/Continue");
var _continueDefault = parcelHelpers.interopDefault(_continue);
var _cancel = require("./Buttons/Cancel");
var _cancelDefault = parcelHelpers.interopDefault(_cancel);
var _adminMenu = require("../Menus/AdminMenu");
var _adminMenuDefault = parcelHelpers.interopDefault(_adminMenu);
var _parentMenu = require("../Menus/ParentMenu");
var _parentMenuDefault = parcelHelpers.interopDefault(_parentMenu);
var _accountingMenu = require("layout/Menus/AccountingMenu");
var _accountingMenuDefault = parcelHelpers.interopDefault(_accountingMenu);
const PublicLayout = ()=>{
    const { role } = (0, _hookDefault.default)();
    const Menu = (0, _react.useMemo)(()=>{
        switch(role){
            case 'ADMIN_HOMESCHOOLER':
                return 0, _adminMenuDefault.default;
            case 'PARENT':
                return 0, _parentMenuDefault.default;
            case 'ACCOUNTING':
                return 0, _accountingMenuDefault.default;
            default:
                return undefined;
        }
    }, [
        role
    ]);
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsxs)("div", {
                className: 'navbar navbar-light navbar-expand justify-content-between bg-white shadow header--navbar sticky-top',
                children: [
                    (0, _jsxRuntime.jsx)("span", {
                        className: 'navbar-brand',
                        children: (0, _jsxRuntime.jsx)((0, _react.Link), {
                            to: '/offers',
                            className: 'navbar-brand fw-bold',
                            style: {
                                color: '#42C3DB'
                            },
                            children: "EduSystem"
                        })
                    }),
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'navbar-collapse principal-menu',
                        style: {
                            justifyContent: 'flex-end'
                        },
                        id: 'navbar-collapse',
                        children: (0, _jsxRuntime.jsxs)("ul", {
                            className: 'nav navbar-nav ml-auto',
                            children: [
                                Menu && (0, _jsxRuntime.jsx)(Menu, {}),
                                (0, _jsxRuntime.jsx)((0, _cancelDefault.default), {}),
                                (0, _jsxRuntime.jsx)((0, _continueDefault.default), {}),
                                (0, _jsxRuntime.jsx)((0, _loginDefault1.default), {}),
                                (0, _jsxRuntime.jsx)((0, _loginDefault.default), {}),
                                (0, _jsxRuntime.jsx)((0, _shoppingCartDefault.default), {
                                    className: 'nav-item me-4 mt-2'
                                }),
                                role && (0, _jsxRuntime.jsx)((0, _iconProfileDefault.default), {})
                            ]
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _react.Outlet), {})
        ]
    });
};
exports.default = (0, _index.withContext)(PublicLayout, 'public');

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/index":"VKWtn","context/auth-context/hook":"2UX0M","components/IconProfile":"6SPYe","components/ShoppingCart":"cipmm","./Login":"fxeDC","./Buttons/Login":"4MKBu","./Buttons/Continue":"4XYmV","./Buttons/Cancel":"1vpiP","../Menus/AdminMenu":"8XFfs","../Menus/ParentMenu":"1JoP7","layout/Menus/AccountingMenu":"12ePZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"VKWtn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withContext", ()=>withContext);
var _packageContext = require("context/package-context");
var _packageContextDefault = parcelHelpers.interopDefault(_packageContext);
var _paymentContext = require("context/payment-context");
var _paymentContextDefault = parcelHelpers.interopDefault(_paymentContext);
var _adminContext = require("context/admin-context");
var _adminContextDefault = parcelHelpers.interopDefault(_adminContext);
var _accountingContext = require("context/accounting-context");
var _accountingContextDefault = parcelHelpers.interopDefault(_accountingContext);
var _publicContext = require("context/public-context");
var _publicContextDefault = parcelHelpers.interopDefault(_publicContext);
var _authContext = require("context/auth-context");
var _authContextDefault = parcelHelpers.interopDefault(_authContext);
var _parentContext = require("context/parent-context");
var _parentContextDefault = parcelHelpers.interopDefault(_parentContext);
var _create = require("context/create");
const providersSets = {
    auth: [
        (0, _authContextDefault.default).Provider
    ],
    public: [
        (0, _paymentContextDefault.default).Provider,
        (0, _publicContextDefault.default).Provider
    ],
    parent: [
        (0, _packageContextDefault.default).Provider,
        (0, _paymentContextDefault.default).Provider,
        (0, _publicContextDefault.default).Provider,
        (0, _parentContextDefault.default).Provider
    ],
    admin: [
        (0, _paymentContextDefault.default).Provider,
        (0, _publicContextDefault.default).Provider,
        (0, _adminContextDefault.default).Provider
    ],
    accounting: [
        (0, _paymentContextDefault.default).Provider,
        (0, _publicContextDefault.default).Provider,
        (0, _adminContextDefault.default).Provider,
        (0, _accountingContextDefault.default).Provider
    ]
};
const paramRoutes = {
    page: '/:pageName',
    offers: '/offers',
    offer: '/offers/:offerId',
    offerSubjects: '/subjects/:offerId/:idSelectCourse/:typeSubject',
    offerCourses: '/courses/:idSubject/:offerId/:idSelectCourse/:typeSubject',
    courseDetail: '/course-detail/:courseId',
    summary: '/summary',
    home: '/home',
    parentPage: '/home/:pageName',
    support: '/home/support',
    packages: '/home/packages',
    package: '/home/packages/:packageId',
    users: '/home/users/:role',
    newUser: '/home/users/:role/new',
    userPackages: '/home/users/:role/packages/:userId',
    profile: '/home/profile',
    payment: '/home/payment',
    history: '/home/payment/history',
    admin: '/admin',
    adminOffers: '/admin/offers',
    adminOfferConfiguration: '/admin/offers/configuration/:offerId',
    adminClients: '/admin/clients',
    adminClient: '/admin/clients/:clientId',
    accounting: '/accounting',
    accountingPayouts: '/accounting/payouts',
    accountingPayout: '/accounting/payouts/:payoutId',
    accountingClients: '/accounting/clients',
    accountingClient: '/accounting/clients/:clientId'
};
function withContext(Root, name) {
    return (0, _create.composeContext)(Root, providersSets[name], paramRoutes);
}

},{"context/package-context":"8XRXi","context/payment-context":"83C2r","context/admin-context":"kK0ry","context/accounting-context":"3UV2I","context/public-context":"3QiGy","context/auth-context":"j9e3M","context/parent-context":"go6YH","context/create":"iPmrn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8XRXi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "default", ()=>context);
var _immutabilityHelper = require("external/immutability-helper");
var _package = require("types/context/package");
var _create = require("context/create");
var _createDefault = parcelHelpers.interopDefault(_create);
var _triggers = require("./triggers");
var _triggersDefault = parcelHelpers.interopDefault(_triggers);
const id = 'Package';
const initialState = {
    packages: (0, _immutabilityHelper.createLoadableList)(),
    packageRefreshes: 0,
    packageItem: {
        loading: false,
        courses: {
            basic: [],
            elective: []
        },
        data: null
    },
    modals: {
        changePackageAlias: (0, _package.clearedChangedPackageAlias),
        selectStudent: (0, _package.clearedSelectUser),
        selectTutor: (0, _package.clearedSelectUser),
        addTutor: (0, _package.clearedUserState),
        addStudent: (0, _package.clearedUserState),
        studentAssignmentWarning: {
            open: false
        }
    },
    saving: {}
};
const context = (0, _createDefault.default)(id, initialState, {
    onInit: (0, _create.initializeAndRegisterHooks)(id, (0, _triggersDefault.default), _triggers)
});

},{"external/immutability-helper":"f8t05","types/context/package":"chkXs","context/create":"iPmrn","./triggers":"gnYtW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f8t05":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createLoadableList", ()=>createLoadableList);
parcelHelpers.export(exports, "default", ()=>expandedUpdate);
parcelHelpers.export(exports, "useImmutableState", ()=>useImmutableState);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _react = require("external/react");
var _deepDiff = require("external/deep-diff");
var _deepDiffDefault = parcelHelpers.interopDefault(_deepDiff);
function createLoadableList(override) {
    return {
        loading: false,
        initialized: false,
        items: [],
        refreshes: 0,
        ...override || {}
    };
}
(0, _immutabilityHelper.extend)('$shallow', shallowHandler);
(0, _immutabilityHelper.extend)('$auto', autoHandler);
(0, _immutabilityHelper.extend)('$autoArray', autoArrayHandler);
(0, _immutabilityHelper.extend)('$startLoading', startLoadingHandler);
(0, _immutabilityHelper.extend)('$updateLoadableList', updateLoadableListHandler);
// extend<CustomCommands<ExpandedCommands>>('$startLoading', startLoadingHandler)
function shallowHandler(value, object) {
    const commands = Object.entries(value || {}).reduce((obj, [key, value])=>({
            ...obj,
            [key]: {
                $set: value
            }
        }), {});
    return expandedUpdate(object, commands);
}
function autoHandler(value, object) {
    return object ? expandedUpdate(object, value) : expandedUpdate({}, value);
}
function autoArrayHandler(value, object) {
    return object ? expandedUpdate(object, value) : expandedUpdate([], value);
}
function startLoadingHandler(_, object) {
    const updateProps = {
        initialized: {
            $set: false
        },
        loading: {
            $set: true
        },
        items: {
            $set: []
        }
    };
    return expandedUpdate(object, updateProps);
}
function updateLoadableListHandler(value, object) {
    const updateProps = {
        initialized: {
            $set: true
        },
        loading: {
            $set: false
        },
        items: {
            $set: value
        }
    };
    return expandedUpdate(object, updateProps);
}
function expandedUpdate(object, spec) {
    return (0, _immutabilityHelperDefault.default)(object, spec);
}
function immutableReducer(state, action) {
    const { command, update, resolve } = action.value;
    const commands = Array.isArray(command) ? command : [
        command
    ];
    const newState = commands.reduce(expandedUpdate, state);
    if (action.type) (0, _deepDiffDefault.default)(action.type, newState, state, update);
    resolve(newState);
    return newState;
}
function useImmutableState(initialState, id) {
    const [state, dispatch] = (0, _react.useReducer)(immutableReducer, initialState);
    const update = (command)=>{
        return new Promise((resolve)=>{
            dispatch({
                type: id,
                value: {
                    command,
                    update,
                    resolve
                }
            });
        });
    };
    return {
        state,
        update
    };
}

},{"immutability-helper":"hwjCt","external/react":"1Glst","external/deep-diff":"594sO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hwjCt":[function(require,module,exports,__globalThis) {
var process = require("3b0661aaf46967c8");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function stringifiable(obj) {
    // Safely stringify Object.create(null)
    /* istanbul ignore next */ return typeof obj === 'object' && !('toString' in obj) ? Object.prototype.toString.call(obj).slice(8, -1) : obj;
}
var isProduction = typeof process === 'object' && true;
function invariant(condition, message) {
    if (!condition) {
        /* istanbul ignore next */ if (isProduction) throw new Error('Invariant failed');
        throw new Error(message());
    }
}
exports.invariant = invariant;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var splice = Array.prototype.splice;
var toString = Object.prototype.toString;
function type(obj) {
    return toString.call(obj).slice(8, -1);
}
var assign = Object.assign || /* istanbul ignore next */ function(target, source) {
    getAllKeys(source).forEach(function(key) {
        if (hasOwnProperty.call(source, key)) target[key] = source[key];
    });
    return target;
};
var getAllKeys = typeof Object.getOwnPropertySymbols === 'function' ? function(obj) {
    return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj));
} : function(obj) {
    return Object.keys(obj);
};
function copy(object) {
    return Array.isArray(object) ? assign(object.constructor(object.length), object) : type(object) === 'Map' ? new Map(object) : type(object) === 'Set' ? new Set(object) : object && typeof object === 'object' ? assign(Object.create(Object.getPrototypeOf(object)), object) : object;
}
var Context = /** @class */ function() {
    function Context() {
        this.commands = assign({}, defaultCommands);
        this.update = this.update.bind(this);
        // Deprecated: update.extend, update.isEquals and update.newContext
        this.update.extend = this.extend = this.extend.bind(this);
        this.update.isEquals = function(x, y) {
            return x === y;
        };
        this.update.newContext = function() {
            return new Context().update;
        };
    }
    Object.defineProperty(Context.prototype, "isEquals", {
        get: function() {
            return this.update.isEquals;
        },
        set: function(value) {
            this.update.isEquals = value;
        },
        enumerable: true,
        configurable: true
    });
    Context.prototype.extend = function(directive, fn) {
        this.commands[directive] = fn;
    };
    Context.prototype.update = function(object, $spec) {
        var _this = this;
        var spec = typeof $spec === 'function' ? {
            $apply: $spec
        } : $spec;
        if (!(Array.isArray(object) && Array.isArray(spec))) invariant(!Array.isArray(spec), function() {
            return "update(): You provided an invalid spec to update(). The spec may not contain an array except as the value of $set, $push, $unshift, $splice or any custom command allowing an array value.";
        });
        invariant(typeof spec === 'object' && spec !== null, function() {
            return "update(): You provided an invalid spec to update(). The spec and every included key path must be plain objects containing one of the " + ("following commands: " + Object.keys(_this.commands).join(', ') + ".");
        });
        var nextObject = object;
        getAllKeys(spec).forEach(function(key) {
            if (hasOwnProperty.call(_this.commands, key)) {
                var objectWasNextObject = object === nextObject;
                nextObject = _this.commands[key](spec[key], nextObject, spec, object);
                if (objectWasNextObject && _this.isEquals(nextObject, object)) nextObject = object;
            } else {
                var nextValueForKey = type(object) === 'Map' ? _this.update(object.get(key), spec[key]) : _this.update(object[key], spec[key]);
                var nextObjectValue = type(nextObject) === 'Map' ? nextObject.get(key) : nextObject[key];
                if (!_this.isEquals(nextValueForKey, nextObjectValue) || typeof nextValueForKey === 'undefined' && !hasOwnProperty.call(object, key)) {
                    if (nextObject === object) nextObject = copy(object);
                    if (type(nextObject) === 'Map') nextObject.set(key, nextValueForKey);
                    else nextObject[key] = nextValueForKey;
                }
            }
        });
        return nextObject;
    };
    return Context;
}();
exports.Context = Context;
var defaultCommands = {
    $push: function(value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, '$push');
        return value.length ? nextObject.concat(value) : nextObject;
    },
    $unshift: function(value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, '$unshift');
        return value.length ? value.concat(nextObject) : nextObject;
    },
    $splice: function(value, nextObject, spec, originalObject) {
        invariantSplices(nextObject, spec);
        value.forEach(function(args) {
            invariantSplice(args);
            if (nextObject === originalObject && args.length) nextObject = copy(originalObject);
            splice.apply(nextObject, args);
        });
        return nextObject;
    },
    $set: function(value, _nextObject, spec) {
        invariantSet(spec);
        return value;
    },
    $toggle: function(targets, nextObject) {
        invariantSpecArray(targets, '$toggle');
        var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;
        targets.forEach(function(target) {
            nextObjectCopy[target] = !nextObject[target];
        });
        return nextObjectCopy;
    },
    $unset: function(value, nextObject, _spec, originalObject) {
        invariantSpecArray(value, '$unset');
        value.forEach(function(key) {
            if (Object.hasOwnProperty.call(nextObject, key)) {
                if (nextObject === originalObject) nextObject = copy(originalObject);
                delete nextObject[key];
            }
        });
        return nextObject;
    },
    $add: function(values, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, '$add');
        invariantSpecArray(values, '$add');
        if (type(nextObject) === 'Map') values.forEach(function(_a) {
            var key = _a[0], value = _a[1];
            if (nextObject === originalObject && nextObject.get(key) !== value) nextObject = copy(originalObject);
            nextObject.set(key, value);
        });
        else values.forEach(function(value) {
            if (nextObject === originalObject && !nextObject.has(value)) nextObject = copy(originalObject);
            nextObject.add(value);
        });
        return nextObject;
    },
    $remove: function(value, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, '$remove');
        invariantSpecArray(value, '$remove');
        value.forEach(function(key) {
            if (nextObject === originalObject && nextObject.has(key)) nextObject = copy(originalObject);
            nextObject.delete(key);
        });
        return nextObject;
    },
    $merge: function(value, nextObject, _spec, originalObject) {
        invariantMerge(nextObject, value);
        getAllKeys(value).forEach(function(key) {
            if (value[key] !== nextObject[key]) {
                if (nextObject === originalObject) nextObject = copy(originalObject);
                nextObject[key] = value[key];
            }
        });
        return nextObject;
    },
    $apply: function(value, original) {
        invariantApply(value);
        return value(original);
    }
};
var defaultContext = new Context();
exports.isEquals = defaultContext.update.isEquals;
exports.extend = defaultContext.extend;
exports.default = defaultContext.update;
// @ts-ignore
exports.default.default = module.exports = assign(exports.default, exports);
// invariants
function invariantPushAndUnshift(value, spec, command) {
    invariant(Array.isArray(value), function() {
        return "update(): expected target of " + stringifiable(command) + " to be an array; got " + stringifiable(value) + ".";
    });
    invariantSpecArray(spec[command], command);
}
function invariantSpecArray(spec, command) {
    invariant(Array.isArray(spec), function() {
        return "update(): expected spec of " + stringifiable(command) + " to be an array; got " + stringifiable(spec) + ". " + "Did you forget to wrap your parameter in an array?";
    });
}
function invariantSplices(value, spec) {
    invariant(Array.isArray(value), function() {
        return "Expected $splice target to be an array; got " + stringifiable(value);
    });
    invariantSplice(spec.$splice);
}
function invariantSplice(value) {
    invariant(Array.isArray(value), function() {
        return "update(): expected spec of $splice to be an array of arrays; got " + stringifiable(value) + ". " + "Did you forget to wrap your parameters in an array?";
    });
}
function invariantApply(fn) {
    invariant(typeof fn === 'function', function() {
        return "update(): expected spec of $apply to be a function; got " + stringifiable(fn) + ".";
    });
}
function invariantSet(spec) {
    invariant(Object.keys(spec).length === 1, function() {
        return "Cannot have more than one key in an object with $set";
    });
}
function invariantMerge(target, specValue) {
    invariant(specValue && typeof specValue === 'object', function() {
        return "update(): $merge expects a spec of type 'object'; got " + stringifiable(specValue);
    });
    invariant(target && typeof target === 'object', function() {
        return "update(): $merge expects a target of type 'object'; got " + stringifiable(target);
    });
}
function invariantMapOrSet(target, command) {
    var typeOfTarget = type(target);
    invariant(typeOfTarget === 'Map' || typeOfTarget === 'Set', function() {
        return "update(): " + stringifiable(command) + " expects a target of type Set or Map; got " + stringifiable(typeOfTarget);
    });
}

},{"3b0661aaf46967c8":"5jT8D"}],"594sO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "contexts", ()=>contexts);
parcelHelpers.export(exports, "diff", ()=>(0, _deepDiff.diff));
parcelHelpers.export(exports, "register", ()=>register);
parcelHelpers.export(exports, "registerContext", ()=>registerContext);
parcelHelpers.export(exports, "default", ()=>trigger);
parcelHelpers.export(exports, "paramsHook", ()=>paramsHook);
var _deepDiff = require("deep-diff");
var _lodash = require("external/lodash");
const contexts = {};
const contextHooks = {};
function register(id, path, trigger) {
    const hooks = contextHooks[id] || (contextHooks[id] = []);
    const paths = (0, _lodash.isArray)(path) ? path : [
        path
    ];
    const triggers = (0, _lodash.isArray)(trigger) ? trigger : [
        trigger
    ];
    paths.forEach((p)=>triggers.forEach((t)=>hooks.push(createHook(p, t))));
}
function registerContext(id, context) {
    contexts[id] = context;
    if (!contextHooks[id]) contextHooks[id] = [];
}
function createHook(path, callback) {
    const trigger = (...diff)=>(...args)=>callback.apply(path, args.concat(diff));
    const hook = {
        path,
        trigger,
        hook: callback
    };
    return hook;
}
function paramsHook(...names) {
    const parseName = (name, query = 'query', param = 'params')=>name.startsWith('?') ? query : param;
    return names.map((name)=>`props/${parseName(name)}/${parseName(name, name.substring(1), name)}/`);
}
function trigger(id, current, previous, update) {
    const difference = (0, _deepDiff.diff)(current, previous, filterHooks(id));
    if (difference) {
        const triggers = (0, _lodash.flatten)(difference.map(createTrigger(id)));
        const hooks = (0, _lodash.uniqBy)(triggers, 'hook').map((hook)=>({
                ...hook,
                trigger: hook.trigger(hook.diff)
            }));
        hooks.forEach((hook)=>{
            hook.trigger({
                state: current,
                update
            }, {
                contexts,
                path: hook.path,
                diff: hook.diff
            });
        });
    }
}
function filterHooks(id) {
    const hooks = contextHooks[id];
    return (path, key)=>{
        const id = path.concat([
            key
        ]).join('/');
        return !hooks.some(matchHookId(id));
    };
}
function createTrigger(id) {
    const hooks = contextHooks[id];
    return (diff)=>{
        const ids = hooks.filter(matchHookId(diff.path.join('/')));
        return (0, _lodash.uniqBy)(ids, 'hook').map((trigger)=>({
                ...trigger,
                diff
            }));
    };
}
function matchHookId(id) {
    return ({ path })=>{
        if (path.length > id.length) return path.startsWith(id);
        else return id.startsWith(path);
    };
}

},{"deep-diff":"3ceMf","external/lodash":"h4nD2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ceMf":[function(require,module,exports,__globalThis) {
(function(root, factory) {
    var deepDiff = factory(root);
    // eslint-disable-next-line no-undef
    if (typeof define === 'function' && define.amd) // AMD
    define('DeepDiff', function() {
        return deepDiff;
    });
    else {
        var _deepdiff;
        // Node.js or ReactNative
        module.exports = deepDiff;
    }
})(this, function(root) {
    var validKinds = [
        'N',
        'E',
        'A',
        'D'
    ];
    // nodejs compatible on server side and in the browser.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
    function Diff(kind, path) {
        Object.defineProperty(this, 'kind', {
            value: kind,
            enumerable: true
        });
        if (path && path.length) Object.defineProperty(this, 'path', {
            value: path,
            enumerable: true
        });
    }
    function DiffEdit(path, origin, value) {
        DiffEdit.super_.call(this, 'E', path);
        Object.defineProperty(this, 'lhs', {
            value: origin,
            enumerable: true
        });
        Object.defineProperty(this, 'rhs', {
            value: value,
            enumerable: true
        });
    }
    inherits(DiffEdit, Diff);
    function DiffNew(path, value) {
        DiffNew.super_.call(this, 'N', path);
        Object.defineProperty(this, 'rhs', {
            value: value,
            enumerable: true
        });
    }
    inherits(DiffNew, Diff);
    function DiffDeleted(path, value) {
        DiffDeleted.super_.call(this, 'D', path);
        Object.defineProperty(this, 'lhs', {
            value: value,
            enumerable: true
        });
    }
    inherits(DiffDeleted, Diff);
    function DiffArray(path, index, item) {
        DiffArray.super_.call(this, 'A', path);
        Object.defineProperty(this, 'index', {
            value: index,
            enumerable: true
        });
        Object.defineProperty(this, 'item', {
            value: item,
            enumerable: true
        });
    }
    inherits(DiffArray, Diff);
    function arrayRemove(arr, from, to) {
        var rest = arr.slice((to || from) + 1 || arr.length);
        arr.length = from < 0 ? arr.length + from : from;
        arr.push.apply(arr, rest);
        return arr;
    }
    function realTypeOf(subject) {
        var type = typeof subject;
        if (type !== 'object') return type;
        if (subject === Math) return 'math';
        else if (subject === null) return 'null';
        else if (Array.isArray(subject)) return 'array';
        else if (Object.prototype.toString.call(subject) === '[object Date]') return 'date';
        else if (typeof subject.toString === 'function' && /^\/.*\//.test(subject.toString())) return 'regexp';
        return 'object';
    }
    // http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
    function hashThisString(string) {
        var hash = 0;
        if (string.length === 0) return hash;
        for(var i = 0; i < string.length; i++){
            var char = string.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
    }
    // Gets a hash of the given object in an array order-independent fashion
    // also object key order independent (easier since they can be alphabetized)
    function getOrderIndependentHash(object) {
        var accum = 0;
        var type = realTypeOf(object);
        if (type === 'array') {
            object.forEach(function(item) {
                // Addition is commutative so this is order indep
                accum += getOrderIndependentHash(item);
            });
            var arrayString = '[type: array, hash: ' + accum + ']';
            return accum + hashThisString(arrayString);
        }
        if (type === 'object') {
            for(var key in object)if (object.hasOwnProperty(key)) {
                var keyValueString = '[ type: object, key: ' + key + ', value hash: ' + getOrderIndependentHash(object[key]) + ']';
                accum += hashThisString(keyValueString);
            }
            return accum;
        }
        // Non object, non array...should be good?
        var stringToHash = '[ type: ' + type + ' ; value: ' + object + ']';
        return accum + hashThisString(stringToHash);
    }
    function deepDiff(lhs, rhs, changes, prefilter, path, key, stack, orderIndependent) {
        changes = changes || [];
        path = path || [];
        stack = stack || [];
        var currentPath = path.slice(0);
        if (typeof key !== 'undefined' && key !== null) {
            if (prefilter) {
                if (typeof prefilter === 'function' && prefilter(currentPath, key)) return;
                else if (typeof prefilter === 'object') {
                    if (prefilter.prefilter && prefilter.prefilter(currentPath, key)) return;
                    if (prefilter.normalize) {
                        var alt = prefilter.normalize(currentPath, key, lhs, rhs);
                        if (alt) {
                            lhs = alt[0];
                            rhs = alt[1];
                        }
                    }
                }
            }
            currentPath.push(key);
        }
        // Use string comparison for regexes
        if (realTypeOf(lhs) === 'regexp' && realTypeOf(rhs) === 'regexp') {
            lhs = lhs.toString();
            rhs = rhs.toString();
        }
        var ltype = typeof lhs;
        var rtype = typeof rhs;
        var i, j, k, other;
        var ldefined = ltype !== 'undefined' || stack && stack.length > 0 && stack[stack.length - 1].lhs && Object.getOwnPropertyDescriptor(stack[stack.length - 1].lhs, key);
        var rdefined = rtype !== 'undefined' || stack && stack.length > 0 && stack[stack.length - 1].rhs && Object.getOwnPropertyDescriptor(stack[stack.length - 1].rhs, key);
        if (!ldefined && rdefined) changes.push(new DiffNew(currentPath, rhs));
        else if (!rdefined && ldefined) changes.push(new DiffDeleted(currentPath, lhs));
        else if (realTypeOf(lhs) !== realTypeOf(rhs)) changes.push(new DiffEdit(currentPath, lhs, rhs));
        else if (realTypeOf(lhs) === 'date' && lhs - rhs !== 0) changes.push(new DiffEdit(currentPath, lhs, rhs));
        else if (ltype === 'object' && lhs !== null && rhs !== null) {
            for(i = stack.length - 1; i > -1; --i)if (stack[i].lhs === lhs) {
                other = true;
                break;
            }
            if (!other) {
                stack.push({
                    lhs: lhs,
                    rhs: rhs
                });
                if (Array.isArray(lhs)) {
                    // If order doesn't matter, we need to sort our arrays
                    if (orderIndependent) {
                        lhs.sort(function(a, b) {
                            return getOrderIndependentHash(a) - getOrderIndependentHash(b);
                        });
                        rhs.sort(function(a, b) {
                            return getOrderIndependentHash(a) - getOrderIndependentHash(b);
                        });
                    }
                    i = rhs.length - 1;
                    j = lhs.length - 1;
                    while(i > j)changes.push(new DiffArray(currentPath, i, new DiffNew(undefined, rhs[i--])));
                    while(j > i)changes.push(new DiffArray(currentPath, j, new DiffDeleted(undefined, lhs[j--])));
                    for(; i >= 0; --i)deepDiff(lhs[i], rhs[i], changes, prefilter, currentPath, i, stack, orderIndependent);
                } else {
                    var akeys = Object.keys(lhs);
                    var pkeys = Object.keys(rhs);
                    for(i = 0; i < akeys.length; ++i){
                        k = akeys[i];
                        other = pkeys.indexOf(k);
                        if (other >= 0) {
                            deepDiff(lhs[k], rhs[k], changes, prefilter, currentPath, k, stack, orderIndependent);
                            pkeys[other] = null;
                        } else deepDiff(lhs[k], undefined, changes, prefilter, currentPath, k, stack, orderIndependent);
                    }
                    for(i = 0; i < pkeys.length; ++i){
                        k = pkeys[i];
                        if (k) deepDiff(undefined, rhs[k], changes, prefilter, currentPath, k, stack, orderIndependent);
                    }
                }
                stack.length = stack.length - 1;
            } else if (lhs !== rhs) // lhs is contains a cycle at this element and it differs from rhs
            changes.push(new DiffEdit(currentPath, lhs, rhs));
        } else if (lhs !== rhs) {
            if (!(ltype === 'number' && isNaN(lhs) && isNaN(rhs))) changes.push(new DiffEdit(currentPath, lhs, rhs));
        }
    }
    function observableDiff(lhs, rhs, observer, prefilter, orderIndependent) {
        var changes = [];
        deepDiff(lhs, rhs, changes, prefilter, null, null, null, orderIndependent);
        if (observer) for(var i = 0; i < changes.length; ++i)observer(changes[i]);
        return changes;
    }
    function orderIndependentDeepDiff(lhs, rhs, changes, prefilter, path, key, stack) {
        return deepDiff(lhs, rhs, changes, prefilter, path, key, stack, true);
    }
    function accumulateDiff(lhs, rhs, prefilter, accum) {
        var observer = accum ? function(difference) {
            if (difference) accum.push(difference);
        } : undefined;
        var changes = observableDiff(lhs, rhs, observer, prefilter);
        return accum ? accum : changes.length ? changes : undefined;
    }
    function accumulateOrderIndependentDiff(lhs, rhs, prefilter, accum) {
        var observer = accum ? function(difference) {
            if (difference) accum.push(difference);
        } : undefined;
        var changes = observableDiff(lhs, rhs, observer, prefilter, true);
        return accum ? accum : changes.length ? changes : undefined;
    }
    function applyArrayChange(arr, index, change) {
        if (change.path && change.path.length) {
            var it = arr[index], i, u = change.path.length - 1;
            for(i = 0; i < u; i++)it = it[change.path[i]];
            switch(change.kind){
                case 'A':
                    applyArrayChange(it[change.path[i]], change.index, change.item);
                    break;
                case 'D':
                    delete it[change.path[i]];
                    break;
                case 'E':
                case 'N':
                    it[change.path[i]] = change.rhs;
                    break;
            }
        } else switch(change.kind){
            case 'A':
                applyArrayChange(arr[index], change.index, change.item);
                break;
            case 'D':
                arr = arrayRemove(arr, index);
                break;
            case 'E':
            case 'N':
                arr[index] = change.rhs;
                break;
        }
        return arr;
    }
    function applyChange(target, source, change) {
        if (typeof change === 'undefined' && source && ~validKinds.indexOf(source.kind)) change = source;
        if (target && change && change.kind) {
            var it = target, i = -1, last = change.path ? change.path.length - 1 : 0;
            while(++i < last){
                if (typeof it[change.path[i]] === 'undefined') it[change.path[i]] = typeof change.path[i + 1] !== 'undefined' && typeof change.path[i + 1] === 'number' ? [] : {};
                it = it[change.path[i]];
            }
            switch(change.kind){
                case 'A':
                    if (change.path && typeof it[change.path[i]] === 'undefined') it[change.path[i]] = [];
                    applyArrayChange(change.path ? it[change.path[i]] : it, change.index, change.item);
                    break;
                case 'D':
                    delete it[change.path[i]];
                    break;
                case 'E':
                case 'N':
                    it[change.path[i]] = change.rhs;
                    break;
            }
        }
    }
    function revertArrayChange(arr, index, change) {
        if (change.path && change.path.length) {
            // the structure of the object at the index has changed...
            var it = arr[index], i, u = change.path.length - 1;
            for(i = 0; i < u; i++)it = it[change.path[i]];
            switch(change.kind){
                case 'A':
                    revertArrayChange(it[change.path[i]], change.index, change.item);
                    break;
                case 'D':
                    it[change.path[i]] = change.lhs;
                    break;
                case 'E':
                    it[change.path[i]] = change.lhs;
                    break;
                case 'N':
                    delete it[change.path[i]];
                    break;
            }
        } else // the array item is different...
        switch(change.kind){
            case 'A':
                revertArrayChange(arr[index], change.index, change.item);
                break;
            case 'D':
                arr[index] = change.lhs;
                break;
            case 'E':
                arr[index] = change.lhs;
                break;
            case 'N':
                arr = arrayRemove(arr, index);
                break;
        }
        return arr;
    }
    function revertChange(target, source, change) {
        if (target && source && change && change.kind) {
            var it = target, i, u;
            u = change.path.length - 1;
            for(i = 0; i < u; i++){
                if (typeof it[change.path[i]] === 'undefined') it[change.path[i]] = {};
                it = it[change.path[i]];
            }
            switch(change.kind){
                case 'A':
                    // Array was modified...
                    // it will be an array...
                    revertArrayChange(it[change.path[i]], change.index, change.item);
                    break;
                case 'D':
                    // Item was deleted...
                    it[change.path[i]] = change.lhs;
                    break;
                case 'E':
                    // Item was edited...
                    it[change.path[i]] = change.lhs;
                    break;
                case 'N':
                    // Item is new...
                    delete it[change.path[i]];
                    break;
            }
        }
    }
    function applyDiff(target, source, filter) {
        if (target && source) {
            var onChange = function(change) {
                if (!filter || filter(target, source, change)) applyChange(target, source, change);
            };
            observableDiff(target, source, onChange);
        }
    }
    Object.defineProperties(accumulateDiff, {
        diff: {
            value: accumulateDiff,
            enumerable: true
        },
        orderIndependentDiff: {
            value: accumulateOrderIndependentDiff,
            enumerable: true
        },
        observableDiff: {
            value: observableDiff,
            enumerable: true
        },
        orderIndependentObservableDiff: {
            value: orderIndependentDeepDiff,
            enumerable: true
        },
        orderIndepHash: {
            value: getOrderIndependentHash,
            enumerable: true
        },
        applyDiff: {
            value: applyDiff,
            enumerable: true
        },
        applyChange: {
            value: applyChange,
            enumerable: true
        },
        revertChange: {
            value: revertChange,
            enumerable: true
        },
        isConflict: {
            value: function() {
                return typeof $conflict !== 'undefined';
            },
            enumerable: true
        }
    });
    // hackish...
    accumulateDiff.DeepDiff = accumulateDiff;
    // ...but works with:
    // import DeepDiff from 'deep-diff'
    // import { DeepDiff } from 'deep-diff'
    // const DeepDiff = require('deep-diff');
    // const { DeepDiff } = require('deep-diff');
    if (root) root.DeepDiff = accumulateDiff;
    return accumulateDiff;
});

},{}],"chkXs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clearedSelectUser", ()=>clearedSelectUser);
parcelHelpers.export(exports, "clearedChangedPackageAlias", ()=>clearedChangedPackageAlias);
parcelHelpers.export(exports, "clearedUserState", ()=>clearedUserState);
const clearedSelectUser = {
    open: false,
    search: '',
    loading: false,
    refresh: 0,
    users: [],
    purchase: null,
    selectedUser: null
};
const clearedChangedPackageAlias = {
    open: false,
    id: null,
    plan_alias: '',
    index: -1
};
const clearedUserState = {
    open: false,
    purchase: {},
    profile_id: '',
    person_id: '',
    first_name: '',
    last_name: '',
    email: '',
    phone: ''
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iPmrn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>create);
parcelHelpers.export(exports, "initializeAndRegisterHooks", ()=>initializeAndRegisterHooks);
parcelHelpers.export(exports, "composeContext", ()=>composeContext);
var _react = require("external/react");
var _deepDiff = require("external/deep-diff");
var _immutabilityHelper = require("external/immutability-helper");
var _navigate = require("utilities/navigate");
var _navigateDefault = parcelHelpers.interopDefault(_navigate);
function create(id, initialState, options) {
    const { onInit, onUpdate } = options || {};
    const Context = (0, _react.createContext)(null);
    Context.displayName = id;
    const { Provider, Consumer } = Context;
    const result = {
        Context,
        Consumer,
        Provider: (props)=>{
            const stateWithProps = {
                ...initialState,
                props: props.props
            };
            const context = (0, _immutabilityHelper.useImmutableState)(stateWithProps, id);
            (0, _deepDiff.registerContext)(id, context);
            (0, _react.useEffect)(()=>{
                onInit && onInit(context);
            }, []);
            (0, _react.useEffect)(()=>{
                onUpdate && onUpdate(context);
            }, [
                context.state
            ]);
            (0, _react.useEffect)(()=>{
                const updateProps = {
                    props: {
                        $set: props.props
                    }
                };
                context.update(updateProps);
            }, [
                props.props
            ]);
            return (0, _react.createElement)(Provider, {
                value: context
            }, props.children);
        }
    };
    result.Provider['displayName'] = `${id}.State`;
    return result;
}
function initializeAndRegisterHooks(id, hooks, resolves) {
    return (context)=>{
        Object.values(resolves).forEach(async (resolve)=>typeof resolve == 'function' && await resolve(context, {
                contexts: (0, _deepDiff.contexts)
            }));
        hooks.forEach(({ paths, resolves })=>(0, _deepDiff.register)(id, paths, resolves));
    };
}
const composeProviders = (props)=>(Previous, Next)=>(0, _react.createElement)(Next, {
            props
        }, Previous);
function composeContext(Dep, contextProviders, routes) {
    return (props)=>{
        const routingProps = (0, _navigateDefault.default)(routes);
        return contextProviders.reduce(composeProviders({
            ...props,
            ...routingProps
        }), (0, _react.createElement)(Dep, {}, props.children));
    };
}

},{"external/react":"1Glst","external/deep-diff":"594sO","external/immutability-helper":"f8t05","utilities/navigate":"l8kUI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l8kUI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useNavigation);
parcelHelpers.export(exports, "isLoggedInAndInRoute", ()=>isLoggedInAndInRoute);
parcelHelpers.export(exports, "isLoggedIn", ()=>isLoggedIn);
var _react = require("external/react");
var _lodash = require("external/lodash");
function useNavigation(routes) {
    const { search, pathname } = (0, _react.useLocation)();
    const query = (0, _react.parseQueryString)(search);
    const navigate = (0, _react.useNavigate)();
    const matched = (0, _react.useMemo)(()=>{
        return (0, _lodash.pickBy)((0, _lodash.mapValues)(routes, (pattern)=>(0, _react.matchPath)(pattern, pathname)), (match)=>match != null);
    }, [
        pathname
    ]);
    const params = (0, _react.useMemo)(()=>{
        return (0, _lodash.transform)(matched, (params, match)=>Object.assign(params, {
                ...match.params
            }), {});
    }, [
        matched
    ]);
    const navigation = (0, _react.useMemo)(()=>{
        return (0, _lodash.mapValues)(routes, (pattern, key)=>{
            const link = (override, ...trailing)=>buildPath(pattern, {
                    params,
                    override
                }, ...trailing);
            const go = (override, ...trailing)=>navigate(buildPath(pattern, {
                    params,
                    override
                }, ...trailing));
            const goWithQuery = (overrideQuery, preserveQuery, override, ...trailing)=>{
                navigate(buildQueryPath(pattern, {
                    params,
                    override,
                    query,
                    overrideQuery,
                    preserveQuery
                }, ...trailing));
            };
            const linkWithQuery = (overrideQuery, preserveQuery, override, ...trailing)=>{
                return buildQueryPath(pattern, {
                    params,
                    override,
                    query,
                    overrideQuery,
                    preserveQuery
                }, ...trailing);
            };
            const active = !!matched[key];
            return {
                link,
                go,
                active,
                linkWithQuery,
                goWithQuery
            };
        });
    }, [
        matched,
        params,
        query,
        pathname
    ]);
    const active = (0, _react.useMemo)(()=>{
        return Object.values(navigation).map(({ active })=>active).indexOf(true) >= 0;
    }, [
        navigation
    ]);
    return {
        active,
        params,
        query,
        navigation
    };
}
function buildQueryPath(...args) {
    const [_, options] = args;
    const path = buildPath(...args);
    const query = options.preserveQuery ? Object.assign({}, options.query, options.overrideQuery) : options.overrideQuery;
    return `${path}?${(0, _react.stringifyQueryString)(query)}`;
}
function buildPath(...args) {
    const [pattern, options, ...trailing] = args;
    const params = Object.assign({}, options.params, options.override);
    const pathname = (0, _react.generatePath)(pattern, params);
    return trailing.length == 0 ? pathname : `${pathname}/${trailing.join('/')}`;
}
function isLoggedInAndInRoute(route, { state, contexts }) {
    const { id } = contexts.Auth.state.user || {};
    const { props: { navigation } } = state;
    if (!(0, _lodash.isUUID)(id)) return false;
    const inRoute = Array.isArray(route) ? route.some((r)=>navigation[r].active) : navigation[route].active;
    if (!inRoute) return false;
    return id;
}
function isLoggedIn({ state, contexts }) {
    const { id } = contexts.Auth.state.user || {};
    const { props: { navigation } } = state;
    if (!(0, _lodash.isUUID)(id)) return false;
    return id;
}

},{"external/react":"1Glst","external/lodash":"h4nD2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gnYtW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchStudents", ()=>fetchStudents);
parcelHelpers.export(exports, "fetchTutors", ()=>fetchTutors);
parcelHelpers.export(exports, "default", ()=>hooks);
parcelHelpers.export(exports, "fetchPackages", ()=>fetchPackages);
parcelHelpers.export(exports, "fetchPackage", ()=>fetchPackage);
var _deepDiff = require("external/deep-diff");
var _lodash = require("external/lodash");
var _packageService = require("services/package.service");
var _userService = require("services/user.service");
var _purchaseService = require("services/purchase.service");
var _navigate = require("utilities/navigate");
const fetchStudents = fetchUsers('Student');
const fetchTutors = fetchUsers('Tutor');
const hooks = [
    {
        paths: (0, _deepDiff.paramsHook)('pageName'),
        resolves: fetchPackages
    },
    {
        paths: [
            ...(0, _deepDiff.paramsHook)('packageId'),
            'packageRefreshes/'
        ],
        resolves: fetchPackage
    },
    {
        paths: [
            'modals/selectStudent/open'
        ],
        resolves: fetchStudents
    },
    {
        paths: [
            'modals/selectTutor/open'
        ],
        resolves: fetchTutors
    }
];
async function fetchPackages({ update, state }, { contexts }) {
    const id = (0, _navigate.isLoggedInAndInRoute)('packages', {
        state,
        contexts
    });
    if (!id) return;
    update({
        packages: {
            $startLoading: {}
        }
    });
    const packages = await (0, _packageService.packageService).getPackageByClientId(id);
    update({
        packages: {
            $updateLoadableList: packages.data.data
        }
    });
}
function fetchUsers(role) {
    const modalName = `select${role}`;
    return async ({ update, state }, { contexts })=>{
        const id = (0, _navigate.isLoggedInAndInRoute)([
            'packages',
            'package'
        ], {
            state,
            contexts
        });
        if (!id) return;
        if (!state.modals[modalName].open) return;
        update({
            modals: {
                [modalName]: {
                    $shallow: {
                        loading: true,
                        users: []
                    }
                }
            }
        });
        const students = await (0, _userService.userService).getUsersByRole(role, id);
        update({
            modals: {
                [modalName]: {
                    $shallow: {
                        loading: false,
                        users: students.data.data
                    }
                }
            }
        });
    };
}
async function fetchPackage({ update, state }, { contexts }) {
    const id = (0, _navigate.isLoggedInAndInRoute)('package', {
        state,
        contexts
    });
    if (!id) return;
    const { props: { params: { packageId } } } = state;
    if (!(0, _lodash.isUUID)(packageId)) return;
    update({
        packageItem: {
            $shallow: {
                loading: true,
                id: null,
                users: {},
                courses: []
            }
        }
    });
    const [coursesResponse, usersResponse] = await Promise.all([
        (0, _purchaseService.purchaseService).getPurchaseCourses(packageId),
        (0, _purchaseService.purchaseService).getPurchaseItemUsers(packageId)
    ]);
    const [courses] = coursesResponse.data.data || [];
    const [data] = usersResponse.data.data || [];
    const [elective, basic] = (0, _lodash.partition)(courses, ({ id })=>/^C7/.test(id));
    update({
        packageItem: {
            $shallow: {
                loading: false,
                id: packageId,
                data,
                courses: {
                    basic,
                    elective
                }
            }
        }
    });
}

},{"external/deep-diff":"594sO","external/lodash":"h4nD2","services/package.service":"8O0gl","services/user.service":"81Nwf","services/purchase.service":"gVdre","utilities/navigate":"l8kUI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8O0gl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PackageService", ()=>PackageService);
parcelHelpers.export(exports, "packageService", ()=>packageService);
var _axios = require("external/axios");
class PackageService {
    async getPackageByClientId(clientId) {
        return (0, _axios.get)(`/homeschooler/purchase/client/${clientId}`);
    }
}
const packageService = new PackageService();

},{"external/axios":"3m9lf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3m9lf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "post", ()=>post);
parcelHelpers.export(exports, "remove", ()=>remove);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _environment = require("external/environment");
(0, _axiosDefault.default).defaults.baseURL = (0, _environment.GLOBAL_URL);
const updateHeader = (request)=>{
    request.headers['Content-Type'] = 'application/json';
    return request;
};
(0, _axiosDefault.default).interceptors.request.use(updateHeader);
(0, _axiosDefault.default).interceptors.response.use((r)=>r, (e)=>{
    console.log('error_', getValidationError(e.code));
    return Promise.reject(e);
});
function getValidationError(error) {
    const codeMatcher = {
        ERR_NETWORK: 'Bad Network',
        ERR_BAD_RESPONSE: 'Bad Response'
    };
    return codeMatcher[error];
}
const get = (0, _axiosDefault.default).get.bind((0, _axiosDefault.default));
const post = (0, _axiosDefault.default).post.bind((0, _axiosDefault.default));
const remove = (0, _axiosDefault.default).delete.bind((0, _axiosDefault.default));

},{"axios":"ffpgq","external/environment":"lOlfZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ffpgq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _axiosJsDefault.default));
parcelHelpers.export(exports, "Axios", ()=>Axios);
parcelHelpers.export(exports, "AxiosError", ()=>AxiosError);
parcelHelpers.export(exports, "CanceledError", ()=>CanceledError);
parcelHelpers.export(exports, "isCancel", ()=>isCancel);
parcelHelpers.export(exports, "CancelToken", ()=>CancelToken);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
parcelHelpers.export(exports, "all", ()=>all);
parcelHelpers.export(exports, "Cancel", ()=>Cancel);
parcelHelpers.export(exports, "isAxiosError", ()=>isAxiosError);
parcelHelpers.export(exports, "spread", ()=>spread);
parcelHelpers.export(exports, "toFormData", ()=>toFormData);
parcelHelpers.export(exports, "AxiosHeaders", ()=>AxiosHeaders);
parcelHelpers.export(exports, "HttpStatusCode", ()=>HttpStatusCode);
parcelHelpers.export(exports, "formToJSON", ()=>formToJSON);
parcelHelpers.export(exports, "getAdapter", ()=>getAdapter);
parcelHelpers.export(exports, "mergeConfig", ()=>mergeConfig);
var _axiosJs = require("./lib/axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios, AxiosError, CanceledError, isCancel, CancelToken, VERSION, all, Cancel, isAxiosError, spread, toFormData, AxiosHeaders, HttpStatusCode, formToJSON, getAdapter, mergeConfig } = (0, _axiosJsDefault.default);

},{"./lib/axios.js":"lHA81","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lHA81":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var _axiosJs = require("./core/Axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
var _mergeConfigJs = require("./core/mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _indexJs = require("./defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("./helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
var _canceledErrorJs = require("./cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _cancelTokenJs = require("./cancel/CancelToken.js");
var _cancelTokenJsDefault = parcelHelpers.interopDefault(_cancelTokenJs);
var _isCancelJs = require("./cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _dataJs = require("./env/data.js");
var _toFormDataJs = require("./helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _axiosErrorJs = require("./core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _spreadJs = require("./helpers/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
var _isAxiosErrorJs = require("./helpers/isAxiosError.js");
var _isAxiosErrorJsDefault = parcelHelpers.interopDefault(_isAxiosErrorJs);
var _axiosHeadersJs = require("./core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("./adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
var _httpStatusCodeJs = require("./helpers/HttpStatusCode.js");
var _httpStatusCodeJsDefault = parcelHelpers.interopDefault(_httpStatusCodeJs);
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function createInstance(defaultConfig) {
    const context = new (0, _axiosJsDefault.default)(defaultConfig);
    const instance = (0, _bindJsDefault.default)((0, _axiosJsDefault.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, _utilsJsDefault.default).extend(instance, (0, _axiosJsDefault.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, _utilsJsDefault.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return createInstance((0, _mergeConfigJsDefault.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const axios = createInstance((0, _indexJsDefault.default));
// Expose Axios class to allow class inheritance
axios.Axios = (0, _axiosJsDefault.default);
// Expose Cancel & CancelToken
axios.CanceledError = (0, _canceledErrorJsDefault.default);
axios.CancelToken = (0, _cancelTokenJsDefault.default);
axios.isCancel = (0, _isCancelJsDefault.default);
axios.VERSION = (0, _dataJs.VERSION);
axios.toFormData = (0, _toFormDataJsDefault.default);
// Expose AxiosError class
axios.AxiosError = (0, _axiosErrorJsDefault.default);
// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;
// Expose all/spread
axios.all = function all(promises) {
    return Promise.all(promises);
};
axios.spread = (0, _spreadJsDefault.default);
// Expose isAxiosError
axios.isAxiosError = (0, _isAxiosErrorJsDefault.default);
// Expose mergeConfig
axios.mergeConfig = (0, _mergeConfigJsDefault.default);
axios.AxiosHeaders = (0, _axiosHeadersJsDefault.default);
axios.formToJSON = (thing)=>(0, _formDataToJSONJsDefault.default)((0, _utilsJsDefault.default).isHTMLForm(thing) ? new FormData(thing) : thing);
axios.getAdapter = (0, _adaptersJsDefault.default).getAdapter;
axios.HttpStatusCode = (0, _httpStatusCodeJsDefault.default);
axios.default = axios;
// this module should only have a default export
exports.default = axios;

},{"./utils.js":"4uo9i","./helpers/bind.js":"gKyRf","./core/Axios.js":"dXDNP","./core/mergeConfig.js":"1xY8J","./defaults/index.js":"gguXD","./helpers/formDataToJSON.js":"jNEsW","./cancel/CanceledError.js":"lfAwZ","./cancel/CancelToken.js":"fa4h3","./cancel/isCancel.js":"5w9uS","./env/data.js":"hl0B4","./helpers/toFormData.js":"kISIL","./core/AxiosError.js":"kinyp","./helpers/spread.js":"kQZVl","./helpers/isAxiosError.js":"98mQL","./core/AxiosHeaders.js":"2Z6Oi","./adapters/adapters.js":"atJSg","./helpers/HttpStatusCode.js":"g7MYJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4uo9i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var global = arguments[3];
var process = require("a8d2c3349c87a903");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString } = Object.prototype;
const { getPrototypeOf } = Object;
const kindOf = ((cache)=>(thing)=>{
        const str = toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>kindOf(thing) === type;
};
const typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const isUndefined = typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const isArrayBuffer = kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const isString = typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const isFunction = typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const isNumber = typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const isPlainObject = (val)=>{
    if (kindOf(val) !== 'object') return false;
    const prototype = getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const isDate = kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const isFile = kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const isBlob = kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const isFileList = kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const isStream = (val)=>isObject(val) && isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || isFunction(thing.append) && ((kind = kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const isURLSearchParams = kindOfTest('URLSearchParams');
const [isReadableStream, isRequest, isResponse, isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map(kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function forEach(obj, fn, { allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if (isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const _global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : global;
})();
const isContextDefined = (context)=>!isUndefined(context) && context !== _global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function merge() {
    const { caseless } = isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && findKey(result, key) || key;
        if (isPlainObject(result[targetKey]) && isPlainObject(val)) result[targetKey] = merge(result[targetKey], val);
        else if (isPlainObject(val)) result[targetKey] = merge({}, val);
        else if (isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const extend = (a, b, thisArg, { allOwnKeys } = {})=>{
    forEach(b, (val, key)=>{
        if (thisArg && isFunction(val)) a[key] = (0, _bindJsDefault.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const toArray = (thing)=>{
    if (!thing) return null;
    if (isArray(thing)) return thing;
    let i = thing.length;
    if (!isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const isHTMLForm = kindOfTest('HTMLFormElement');
const toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const hasOwnProperty = (({ hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const isRegExp = kindOfTest('RegExp');
const reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const freezeMethods = (obj)=>{
    reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if (isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const noop = ()=>{};
const toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const ALPHA = 'abcdefghijklmnopqrstuvwxyz';
const DIGIT = '0123456789';
const ALPHABET = {
    DIGIT,
    ALPHA,
    ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};
const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT)=>{
    let str = '';
    const { length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function isSpecCompliantForm(thing) {
    return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}
const toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if (isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = isArray(source) ? [] : {};
                forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const isAsyncFn = kindOfTest('AsyncFunction');
const isThenable = (thing)=>thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const _setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        _global.addEventListener("message", ({ source, data })=>{
            if (source === _global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            _global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', isFunction(_global.postMessage));
const asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind(_global) : typeof process !== 'undefined' && process.nextTick || _setImmediate;
// *********************
exports.default = {
    isArray,
    isArrayBuffer,
    isBuffer,
    isFormData,
    isArrayBufferView,
    isString,
    isNumber,
    isBoolean,
    isObject,
    isPlainObject,
    isReadableStream,
    isRequest,
    isResponse,
    isHeaders,
    isUndefined,
    isDate,
    isFile,
    isBlob,
    isRegExp,
    isFunction,
    isStream,
    isURLSearchParams,
    isTypedArray,
    isFileList,
    forEach,
    merge,
    extend,
    trim,
    stripBOM,
    inherits,
    toFlatObject,
    kindOf,
    kindOfTest,
    endsWith,
    toArray,
    forEachEntry,
    matchAll,
    isHTMLForm,
    hasOwnProperty,
    hasOwnProp: hasOwnProperty,
    reduceDescriptors,
    freezeMethods,
    toObjectSet,
    toCamelCase,
    noop,
    toFiniteNumber,
    findKey,
    global: _global,
    isContextDefined,
    ALPHABET,
    generateString,
    isSpecCompliantForm,
    toJSONObject,
    isAsyncFn,
    isThenable,
    setImmediate: _setImmediate,
    asap
};

},{"a8d2c3349c87a903":"5jT8D","./helpers/bind.js":"gKyRf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gKyRf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bind);
'use strict';
function bind(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dXDNP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _buildURLJs = require("../helpers/buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
var _interceptorManagerJs = require("./InterceptorManager.js");
var _interceptorManagerJsDefault = parcelHelpers.interopDefault(_interceptorManagerJs);
var _dispatchRequestJs = require("./dispatchRequest.js");
var _dispatchRequestJsDefault = parcelHelpers.interopDefault(_dispatchRequestJs);
var _mergeConfigJs = require("./mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _buildFullPathJs = require("./buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _validatorJs = require("../helpers/validator.js");
var _validatorJsDefault = parcelHelpers.interopDefault(_validatorJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
'use strict';
const validators = (0, _validatorJsDefault.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, _interceptorManagerJsDefault.default)(),
            response: new (0, _interceptorManagerJsDefault.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const { transitional, paramsSerializer, headers } = config;
        if (transitional !== undefined) (0, _validatorJsDefault.default).assertOptions(transitional, {
            silentJSONParsing: validators.transitional(validators.boolean),
            forcedJSONParsing: validators.transitional(validators.boolean),
            clarifyTimeoutError: validators.transitional(validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, _utilsJsDefault.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, _validatorJsDefault.default).assertOptions(paramsSerializer, {
                encode: validators.function,
                serialize: validators.function
            }, true);
        }
        (0, _validatorJsDefault.default).assertOptions(config, {
            baseUrl: validators.spelling('baseURL'),
            withXsrfToken: validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, _utilsJsDefault.default).merge(headers.common, headers[config.method]);
        headers && (0, _utilsJsDefault.default).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, _axiosHeadersJsDefault.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, _dispatchRequestJsDefault.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, _dispatchRequestJsDefault.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const fullPath = (0, _buildFullPathJsDefault.default)(config.baseURL, config.url);
        return (0, _buildURLJsDefault.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, _utilsJsDefault.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ Axios.prototype[method] = function(url, config) {
        return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
            method,
            url,
            data: (config || {}).data
        }));
    };
});
(0, _utilsJsDefault.default).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
                method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url,
                data
            }));
        };
    }
    Axios.prototype[method] = generateHTTPMethod();
    Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
exports.default = Axios;

},{"./../utils.js":"4uo9i","../helpers/buildURL.js":"2yc3i","./InterceptorManager.js":"gBR9v","./dispatchRequest.js":"9BYjJ","./mergeConfig.js":"1xY8J","./buildFullPath.js":"dqGPZ","../helpers/validator.js":"jxy99","./AxiosHeaders.js":"2Z6Oi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2yc3i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildURL);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosURLSearchParamsJs = require("../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function buildURL(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || encode;
    if ((0, _utilsJsDefault.default).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, _utilsJsDefault.default).isURLSearchParams(params) ? params.toString() : new (0, _axiosURLSearchParamsJsDefault.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

},{"../utils.js":"4uo9i","../helpers/AxiosURLSearchParams.js":"cgFfA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cgFfA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, _toFormDataJsDefault.default)(params, this, options);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, encode);
    } : encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
exports.default = AxiosURLSearchParams;

},{"./toFormData.js":"kISIL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kISIL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored
var _formDataJs = require("../platform/node/classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var Buffer = require("adfd9b103875c2dd").Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function isVisitable(thing) {
    return (0, _utilsJsDefault.default).isPlainObject(thing) || (0, _utilsJsDefault.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function removeBrackets(key) {
    return (0, _utilsJsDefault.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function isFlatArray(arr) {
    return (0, _utilsJsDefault.default).isArray(arr) && !arr.some(isVisitable);
}
const predicates = (0, _utilsJsDefault.default).toFlatObject((0, _utilsJsDefault.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function toFormData(obj, formData, options) {
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, _formDataJsDefault.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, _utilsJsDefault.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, _utilsJsDefault.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, _utilsJsDefault.default).isSpecCompliantForm(formData);
    if (!(0, _utilsJsDefault.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, _utilsJsDefault.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, _utilsJsDefault.default).isBlob(value)) throw new (0, _axiosErrorJsDefault.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, _utilsJsDefault.default).isArrayBuffer(value) || (0, _utilsJsDefault.default).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, _utilsJsDefault.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, _utilsJsDefault.default).isArray(value) && isFlatArray(value) || ((0, _utilsJsDefault.default).isFileList(value) || (0, _utilsJsDefault.default).endsWith(key, '[]')) && (arr = (0, _utilsJsDefault.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if (isVisitable(value)) return true;
        formData.append(renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign(predicates, {
        defaultVisitor,
        convertValue,
        isVisitable
    });
    function build(value, path) {
        if ((0, _utilsJsDefault.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, _utilsJsDefault.default).forEach(value, function each(el, key) {
            const result = !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, _utilsJsDefault.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
exports.default = toFormData;

},{"adfd9b103875c2dd":"dB11O","../utils.js":"4uo9i","../core/AxiosError.js":"kinyp","../platform/node/classes/FormData.js":"3nCRV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dB11O":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 'use strict';
const base64 = require("9c62938f1dccc73c");
const ieee754 = require("aceacb6a4531a9d2");
const customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
const K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    const b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = byteLength(string, encoding) | 0;
    let buf = createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    const length = array.length < 0 ? 0 : checked(array.length) | 0;
    const buf = createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = exports.INSPECT_MAX_BYTES;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function wrtBigUInt64LE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function wrtBigUInt64BE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const errors = {};
function E(sym, getMessage, Base) {
    errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function checkBounds(buf, offset, byteLength) {
    validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
}
function checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    checkBounds(buf, offset, byteLength);
}
function validateNumber(value, name) {
    if (typeof value !== 'number') throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        validateNumber(value, type);
        throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn;
}
function BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

},{"9c62938f1dccc73c":"ettWx","aceacb6a4531a9d2":"6DXND"}],"ettWx":[function(require,module,exports,__globalThis) {
'use strict';
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join('');
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

},{}],"6DXND":[function(require,module,exports,__globalThis) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"kinyp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, _utilsJsDefault.default).inherits(AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, _utilsJsDefault.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const prototype = AxiosError.prototype;
const descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    descriptors[code] = {
        value: code
    };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create(prototype);
    (0, _utilsJsDefault.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
exports.default = AxiosError;

},{"../utils.js":"4uo9i","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3nCRV":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line strict
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gBR9v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
class InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled,
            rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, _utilsJsDefault.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
exports.default = InterceptorManager;

},{"./../utils.js":"4uo9i","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9BYjJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dispatchRequest);
var _transformDataJs = require("./transformData.js");
var _transformDataJsDefault = parcelHelpers.interopDefault(_transformDataJs);
var _isCancelJs = require("../cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("../adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, _canceledErrorJsDefault.default)(null, config);
}
function dispatchRequest(config) {
    throwIfCancellationRequested(config);
    config.headers = (0, _axiosHeadersJsDefault.default).from(config.headers);
    // Transform request data
    config.data = (0, _transformDataJsDefault.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, _adaptersJsDefault.default).getAdapter(config.adapter || (0, _indexJsDefault.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, response);
        response.headers = (0, _axiosHeadersJsDefault.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, _isCancelJsDefault.default)(reason)) {
            throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, _axiosHeadersJsDefault.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

},{"./transformData.js":"kzWBF","../cancel/isCancel.js":"5w9uS","../defaults/index.js":"gguXD","../cancel/CanceledError.js":"lfAwZ","../core/AxiosHeaders.js":"2Z6Oi","../adapters/adapters.js":"atJSg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kzWBF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transformData);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
'use strict';
function transformData(fns, response) {
    const config = this || (0, _indexJsDefault.default);
    const context = response || config;
    const headers = (0, _axiosHeadersJsDefault.default).from(context.headers);
    let data = context.data;
    (0, _utilsJsDefault.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

},{"./../utils.js":"4uo9i","../defaults/index.js":"gguXD","../core/AxiosHeaders.js":"2Z6Oi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gguXD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _transitionalJs = require("./transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _toFormDataJs = require("../helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _toURLEncodedFormJs = require("../helpers/toURLEncodedForm.js");
var _toURLEncodedFormJsDefault = parcelHelpers.interopDefault(_toURLEncodedFormJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("../helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function stringifySafely(rawValue, parser, encoder) {
    if ((0, _utilsJsDefault.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, _utilsJsDefault.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const defaults = {
    transitional: (0, _transitionalJsDefault.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, _utilsJsDefault.default).isObject(data);
            if (isObjectPayload && (0, _utilsJsDefault.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, _utilsJsDefault.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, _formDataToJSONJsDefault.default)(data)) : data;
            if ((0, _utilsJsDefault.default).isArrayBuffer(data) || (0, _utilsJsDefault.default).isBuffer(data) || (0, _utilsJsDefault.default).isStream(data) || (0, _utilsJsDefault.default).isFile(data) || (0, _utilsJsDefault.default).isBlob(data) || (0, _utilsJsDefault.default).isReadableStream(data)) return data;
            if ((0, _utilsJsDefault.default).isArrayBufferView(data)) return data.buffer;
            if ((0, _utilsJsDefault.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, _toURLEncodedFormJsDefault.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, _utilsJsDefault.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, _toFormDataJsDefault.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, _utilsJsDefault.default).isResponse(data) || (0, _utilsJsDefault.default).isReadableStream(data)) return data;
            if (data && (0, _utilsJsDefault.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, _axiosErrorJsDefault.default).from(e, (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, _indexJsDefault.default).classes.FormData,
        Blob: (0, _indexJsDefault.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, _utilsJsDefault.default).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    defaults.headers[method] = {};
});
exports.default = defaults;

},{"../utils.js":"4uo9i","../core/AxiosError.js":"kinyp","./transitional.js":"fnl8o","../helpers/toFormData.js":"kISIL","../helpers/toURLEncodedForm.js":"lYmci","../platform/index.js":"f1Kjw","../helpers/formDataToJSON.js":"jNEsW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fnl8o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
exports.default = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lYmci":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toURLEncodedForm);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
'use strict';
function toURLEncodedForm(data, options) {
    return (0, _toFormDataJsDefault.default)(data, new (0, _indexJsDefault.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, _indexJsDefault.default).isNode && (0, _utilsJsDefault.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

},{"../utils.js":"4uo9i","./toFormData.js":"kISIL","../platform/index.js":"f1Kjw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f1Kjw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./node/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("./common/utils.js");
exports.default = {
    ..._utilsJs,
    ...(0, _indexJsDefault.default)
};

},{"./node/index.js":"9WmFp","./common/utils.js":"99BaU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9WmFp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _urlsearchParamsJs = require("./classes/URLSearchParams.js");
var _urlsearchParamsJsDefault = parcelHelpers.interopDefault(_urlsearchParamsJs);
var _formDataJs = require("./classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var _blobJs = require("./classes/Blob.js");
var _blobJsDefault = parcelHelpers.interopDefault(_blobJs);
exports.default = {
    isBrowser: true,
    classes: {
        URLSearchParams: (0, _urlsearchParamsJsDefault.default),
        FormData: (0, _formDataJsDefault.default),
        Blob: (0, _blobJsDefault.default)
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

},{"./classes/URLSearchParams.js":"d4aCd","./classes/FormData.js":"kTIRP","./classes/Blob.js":"2KGV3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d4aCd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosURLSearchParamsJs = require("../../../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
'use strict';
exports.default = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, _axiosURLSearchParamsJsDefault.default);

},{"../../../helpers/AxiosURLSearchParams.js":"cgFfA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kTIRP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
exports.default = typeof FormData !== 'undefined' ? FormData : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2KGV3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
exports.default = typeof Blob !== 'undefined' ? Blob : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"99BaU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasBrowserEnv", ()=>hasBrowserEnv);
parcelHelpers.export(exports, "hasStandardBrowserWebWorkerEnv", ()=>hasStandardBrowserWebWorkerEnv);
parcelHelpers.export(exports, "hasStandardBrowserEnv", ()=>hasStandardBrowserEnv);
parcelHelpers.export(exports, "navigator", ()=>_navigator);
parcelHelpers.export(exports, "origin", ()=>origin);
const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';
const _navigator = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const hasStandardBrowserEnv = hasBrowserEnv && (!_navigator || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf(_navigator.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const hasStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const origin = hasBrowserEnv && window.location.href || 'http://localhost';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jNEsW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, _utilsJsDefault.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, _utilsJsDefault.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, _utilsJsDefault.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, _utilsJsDefault.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, _utilsJsDefault.default).isArray(target[name])) target[name] = arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, _utilsJsDefault.default).isFormData(formData) && (0, _utilsJsDefault.default).isFunction(formData.entries)) {
        const obj = {};
        (0, _utilsJsDefault.default).forEachEntry(formData, (name, value)=>{
            buildPath(parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
exports.default = formDataToJSON;

},{"../utils.js":"4uo9i","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Z6Oi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _parseHeadersJs = require("../helpers/parseHeaders.js");
var _parseHeadersJsDefault = parcelHelpers.interopDefault(_parseHeadersJs);
'use strict';
const $internals = Symbol('internals');
function normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, _utilsJsDefault.default).isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, _utilsJsDefault.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, _utilsJsDefault.default).isString(value)) return;
    if ((0, _utilsJsDefault.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, _utilsJsDefault.default).isRegExp(filter)) return filter.test(value);
}
function formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function buildAccessors(obj, header) {
    const accessorName = (0, _utilsJsDefault.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, _utilsJsDefault.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, _utilsJsDefault.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, _utilsJsDefault.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, _utilsJsDefault.default).isString(header) && (header = header.trim()) && !isValidHeaderName(header)) setHeaders((0, _parseHeadersJsDefault.default)(header), valueOrRewrite);
        else if ((0, _utilsJsDefault.default).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return parseTokens(value);
                if ((0, _utilsJsDefault.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, _utilsJsDefault.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = normalizeHeader(_header);
            if (_header) {
                const key = (0, _utilsJsDefault.default).findKey(self, _header);
                if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, _utilsJsDefault.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            const key = (0, _utilsJsDefault.default).findKey(headers, header);
            if (key) {
                self[key] = normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, _utilsJsDefault.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$internals] = this[$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = normalizeHeader(_header);
            if (!accessors[lHeader]) {
                buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, _utilsJsDefault.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, _utilsJsDefault.default).reduceDescriptors(AxiosHeaders.prototype, ({ value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, _utilsJsDefault.default).freezeMethods(AxiosHeaders);
exports.default = AxiosHeaders;

},{"../utils.js":"4uo9i","../helpers/parseHeaders.js":"7iHXN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7iHXN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = (0, _utilsJsDefault.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ exports.default = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

},{"./../utils.js":"4uo9i","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5w9uS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isCancel);
'use strict';
function isCancel(value) {
    return !!(value && value.__CANCEL__);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lfAwZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, _axiosErrorJsDefault.default).call(this, message == null ? 'canceled' : message, (0, _axiosErrorJsDefault.default).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, _utilsJsDefault.default).inherits(CanceledError, (0, _axiosErrorJsDefault.default), {
    __CANCEL__: true
});
exports.default = CanceledError;

},{"../core/AxiosError.js":"kinyp","../utils.js":"4uo9i","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"atJSg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _httpJs = require("./http.js");
var _httpJsDefault = parcelHelpers.interopDefault(_httpJs);
var _xhrJs = require("./xhr.js");
var _xhrJsDefault = parcelHelpers.interopDefault(_xhrJs);
var _fetchJs = require("./fetch.js");
var _fetchJsDefault = parcelHelpers.interopDefault(_fetchJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
const knownAdapters = {
    http: (0, _httpJsDefault.default),
    xhr: (0, _xhrJsDefault.default),
    fetch: (0, _fetchJsDefault.default)
};
(0, _utilsJsDefault.default).forEach(knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value
        });
    }
});
const renderReason = (reason)=>`- ${reason}`;
const isResolvedHandle = (adapter)=>(0, _utilsJsDefault.default).isFunction(adapter) || adapter === null || adapter === false;
exports.default = {
    getAdapter: (adapters)=>{
        adapters = (0, _utilsJsDefault.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!isResolvedHandle(nameOrAdapter)) {
                adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, _axiosErrorJsDefault.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, _axiosErrorJsDefault.default)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: knownAdapters
};

},{"../utils.js":"4uo9i","./http.js":"3nCRV","./xhr.js":"i0pe0","./fetch.js":"2L3NH","../core/AxiosError.js":"kinyp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i0pe0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _settleJs = require("./../core/settle.js");
var _settleJsDefault = parcelHelpers.interopDefault(_settleJs);
var _transitionalJs = require("../defaults/transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _parseProtocolJs = require("../helpers/parseProtocol.js");
var _parseProtocolJsDefault = parcelHelpers.interopDefault(_parseProtocolJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _progressEventReducerJs = require("../helpers/progressEventReducer.js");
var _resolveConfigJs = require("../helpers/resolveConfig.js");
var _resolveConfigJsDefault = parcelHelpers.interopDefault(_resolveConfigJs);
const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
exports.default = isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, _resolveConfigJsDefault.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, _axiosHeadersJsDefault.default).from(_config.headers).normalize();
        let { responseType, onUploadProgress, onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, _axiosHeadersJsDefault.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config,
                request
            };
            (0, _settleJsDefault.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, _axiosErrorJsDefault.default)('Request aborted', (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, _axiosErrorJsDefault.default)('Network Error', (0, _axiosErrorJsDefault.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, _transitionalJsDefault.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, _axiosErrorJsDefault.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, _axiosErrorJsDefault.default).ETIMEDOUT : (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, _utilsJsDefault.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, _utilsJsDefault.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, _progressEventReducerJs.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, _progressEventReducerJs.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, _canceledErrorJsDefault.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, _parseProtocolJsDefault.default)(_config.url);
        if (protocol && (0, _indexJsDefault.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, _axiosErrorJsDefault.default)('Unsupported protocol ' + protocol + ':', (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

},{"./../utils.js":"4uo9i","./../core/settle.js":"bYbho","../defaults/transitional.js":"fnl8o","../core/AxiosError.js":"kinyp","../cancel/CanceledError.js":"lfAwZ","../helpers/parseProtocol.js":"96o7u","../platform/index.js":"f1Kjw","../core/AxiosHeaders.js":"2Z6Oi","../helpers/progressEventReducer.js":"3BMKV","../helpers/resolveConfig.js":"8Lm4J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bYbho":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>settle);
var _axiosErrorJs = require("./AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
'use strict';
function settle(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, _axiosErrorJsDefault.default)('Request failed with status code ' + response.status, [
        (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST,
        (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

},{"./AxiosError.js":"kinyp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"96o7u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseProtocol);
'use strict';
function parseProtocol(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3BMKV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "progressEventReducer", ()=>progressEventReducer);
parcelHelpers.export(exports, "progressEventDecorator", ()=>progressEventDecorator);
parcelHelpers.export(exports, "asyncDecorator", ()=>asyncDecorator);
var _speedometerJs = require("./speedometer.js");
var _speedometerJsDefault = parcelHelpers.interopDefault(_speedometerJs);
var _throttleJs = require("./throttle.js");
var _throttleJsDefault = parcelHelpers.interopDefault(_throttleJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
const progressEventReducer = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, _speedometerJsDefault.default)(50, 250);
    return (0, _throttleJsDefault.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded,
            total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const progressEventDecorator = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable,
                total,
                loaded
            }),
        throttled[1]
    ];
};
const asyncDecorator = (fn)=>(...args)=>(0, _utilsJsDefault.default).asap(()=>fn(...args));

},{"./speedometer.js":"5HjJZ","./throttle.js":"dw4uI","../utils.js":"4uo9i","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5HjJZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
exports.default = speedometer;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dw4uI":[function(require,module,exports,__globalThis) {
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
exports.default = throttle;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Lm4J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _isURLSameOriginJs = require("./isURLSameOrigin.js");
var _isURLSameOriginJsDefault = parcelHelpers.interopDefault(_isURLSameOriginJs);
var _cookiesJs = require("./cookies.js");
var _cookiesJsDefault = parcelHelpers.interopDefault(_cookiesJs);
var _buildFullPathJs = require("../core/buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _mergeConfigJs = require("../core/mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _buildURLJs = require("./buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
exports.default = (config)=>{
    const newConfig = (0, _mergeConfigJsDefault.default)({}, config);
    let { data, withXSRFToken, xsrfHeaderName, xsrfCookieName, headers, auth } = newConfig;
    newConfig.headers = headers = (0, _axiosHeadersJsDefault.default).from(headers);
    newConfig.url = (0, _buildURLJsDefault.default)((0, _buildFullPathJsDefault.default)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, _utilsJsDefault.default).isFormData(data)) {
        if ((0, _indexJsDefault.default).hasStandardBrowserEnv || (0, _indexJsDefault.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, _indexJsDefault.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, _utilsJsDefault.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, _isURLSameOriginJsDefault.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, _cookiesJsDefault.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

},{"../platform/index.js":"f1Kjw","../utils.js":"4uo9i","./isURLSameOrigin.js":"3wNi6","./cookies.js":"fq1CU","../core/buildFullPath.js":"dqGPZ","../core/mergeConfig.js":"1xY8J","../core/AxiosHeaders.js":"2Z6Oi","./buildURL.js":"2yc3i","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3wNi6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, _indexJsDefault.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, _indexJsDefault.default).origin), (0, _indexJsDefault.default).navigator && /(msie|trident)/i.test((0, _indexJsDefault.default).navigator.userAgent)) : ()=>true;

},{"../platform/index.js":"f1Kjw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fq1CU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, _utilsJsDefault.default).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, _utilsJsDefault.default).isString(path) && cookie.push('path=' + path);
        (0, _utilsJsDefault.default).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

},{"./../utils.js":"4uo9i","../platform/index.js":"f1Kjw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dqGPZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildFullPath);
var _isAbsoluteURLJs = require("../helpers/isAbsoluteURL.js");
var _isAbsoluteURLJsDefault = parcelHelpers.interopDefault(_isAbsoluteURLJs);
var _combineURLsJs = require("../helpers/combineURLs.js");
var _combineURLsJsDefault = parcelHelpers.interopDefault(_combineURLsJs);
'use strict';
function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !(0, _isAbsoluteURLJsDefault.default)(requestedURL)) return (0, _combineURLsJsDefault.default)(baseURL, requestedURL);
    return requestedURL;
}

},{"../helpers/isAbsoluteURL.js":"kKGFA","../helpers/combineURLs.js":"aIa5z","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kKGFA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAbsoluteURL);
'use strict';
function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aIa5z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>combineURLs);
'use strict';
function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1xY8J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeConfig);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
'use strict';
const headersToObject = (thing)=>thing instanceof (0, _axiosHeadersJsDefault.default) ? {
        ...thing
    } : thing;
function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, _utilsJsDefault.default).isPlainObject(target) && (0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge.call({
            caseless
        }, target, source);
        else if ((0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge({}, source);
        else if ((0, _utilsJsDefault.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties(headersToObject(a), headersToObject(b), prop, true)
    };
    (0, _utilsJsDefault.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, _utilsJsDefault.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

},{"../utils.js":"4uo9i","./AxiosHeaders.js":"2Z6Oi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2L3NH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _composeSignalsJs = require("../helpers/composeSignals.js");
var _composeSignalsJsDefault = parcelHelpers.interopDefault(_composeSignalsJs);
var _trackStreamJs = require("../helpers/trackStream.js");
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _progressEventReducerJs = require("../helpers/progressEventReducer.js");
var _resolveConfigJs = require("../helpers/resolveConfig.js");
var _resolveConfigJsDefault = parcelHelpers.interopDefault(_resolveConfigJs);
var _settleJs = require("../core/settle.js");
var _settleJsDefault = parcelHelpers.interopDefault(_settleJs);
const isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const isReadableStreamSupported = isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const supportsRequestStream = isReadableStreamSupported && test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, _indexJsDefault.default).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const DEFAULT_CHUNK_SIZE = 65536;
const supportsResponseStream = isReadableStreamSupported && test(()=>(0, _utilsJsDefault.default).isReadableStream(new Response('').body));
const resolvers = {
    stream: supportsResponseStream && ((res)=>res.body)
};
isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !resolvers[type] && (resolvers[type] = (0, _utilsJsDefault.default).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, _axiosErrorJsDefault.default)(`Response type '${type}' is not supported`, (0, _axiosErrorJsDefault.default).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, _utilsJsDefault.default).isBlob(body)) return body.size;
    if ((0, _utilsJsDefault.default).isSpecCompliantForm(body)) {
        const _request = new Request((0, _indexJsDefault.default).origin, {
            method: 'POST',
            body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, _utilsJsDefault.default).isArrayBufferView(body) || (0, _utilsJsDefault.default).isArrayBuffer(body)) return body.byteLength;
    if ((0, _utilsJsDefault.default).isURLSearchParams(body)) body = body + '';
    if ((0, _utilsJsDefault.default).isString(body)) return (await encodeText(body)).byteLength;
};
const resolveBodyLength = async (headers, body)=>{
    const length = (0, _utilsJsDefault.default).toFiniteNumber(headers.getContentLength());
    return length == null ? getBodyLength(body) : length;
};
exports.default = isFetchSupported && (async (config)=>{
    let { url, method, data, signal, cancelToken, timeout, onDownloadProgress, onUploadProgress, responseType, headers, withCredentials = 'same-origin', fetchOptions } = (0, _resolveConfigJsDefault.default)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, _composeSignalsJsDefault.default)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, _utilsJsDefault.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, _progressEventReducerJs.progressEventDecorator)(requestContentLength, (0, _progressEventReducerJs.progressEventReducer)((0, _progressEventReducerJs.asyncDecorator)(onUploadProgress)));
                data = (0, _trackStreamJs.trackStream)(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, _utilsJsDefault.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, _utilsJsDefault.default).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, _progressEventReducerJs.progressEventDecorator)(responseContentLength, (0, _progressEventReducerJs.progressEventReducer)((0, _progressEventReducerJs.asyncDecorator)(onDownloadProgress), true)) || [];
            response = new Response((0, _trackStreamJs.trackStream)(response.body, DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await resolvers[(0, _utilsJsDefault.default).findKey(resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, _settleJsDefault.default)(resolve, reject, {
                data: responseData,
                headers: (0, _axiosHeadersJsDefault.default).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config,
                request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) throw Object.assign(new (0, _axiosErrorJsDefault.default)('Network Error', (0, _axiosErrorJsDefault.default).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, _axiosErrorJsDefault.default).from(err, err && err.code, config, request);
    }
});

},{"../platform/index.js":"f1Kjw","../utils.js":"4uo9i","../core/AxiosError.js":"kinyp","../helpers/composeSignals.js":"hGXat","../helpers/trackStream.js":"41KaY","../core/AxiosHeaders.js":"2Z6Oi","../helpers/progressEventReducer.js":"3BMKV","../helpers/resolveConfig.js":"8Lm4J","../core/settle.js":"bYbho","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hGXat":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
const composeSignals = (signals, timeout)=>{
    const { length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, _axiosErrorJsDefault.default) ? err : new (0, _canceledErrorJsDefault.default)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, _axiosErrorJsDefault.default)(`timeout ${timeout} of ms exceeded`, (0, _axiosErrorJsDefault.default).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal } = controller;
        signal.unsubscribe = ()=>(0, _utilsJsDefault.default).asap(unsubscribe);
        return signal;
    }
};
exports.default = composeSignals;

},{"../cancel/CanceledError.js":"lfAwZ","../core/AxiosError.js":"kinyp","../utils.js":"4uo9i","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"41KaY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "streamChunk", ()=>streamChunk);
parcelHelpers.export(exports, "readBytes", ()=>readBytes);
parcelHelpers.export(exports, "trackStream", ()=>trackStream);
const streamChunk = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const readBytes = async function*(iterable, chunkSize) {
    for await (const chunk of readStream(iterable))yield* streamChunk(chunk, chunkSize);
};
const readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done, value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const trackStream = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = readBytes(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done, value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jxy99":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dataJs = require("../env/data.js");
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
'use strict';
const validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, _dataJs.VERSION) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, _axiosErrorJsDefault.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, _axiosErrorJsDefault.default).ERR_DEPRECATED);
        if (version && !deprecatedWarnings[opt]) {
            deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, _axiosErrorJsDefault.default)('options must be an object', (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, _axiosErrorJsDefault.default)('option ' + opt + ' must be ' + result, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, _axiosErrorJsDefault.default)('Unknown option ' + opt, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION);
    }
}
exports.default = {
    assertOptions,
    validators
};

},{"../env/data.js":"hl0B4","../core/AxiosError.js":"kinyp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hl0B4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
const VERSION = "1.7.9";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fa4h3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _canceledErrorJs = require("./CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, _canceledErrorJsDefault.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token,
            cancel
        };
    }
}
exports.default = CancelToken;

},{"./CanceledError.js":"lfAwZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kQZVl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>spread);
'use strict';
function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"98mQL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAxiosError);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
function isAxiosError(payload) {
    return (0, _utilsJsDefault.default).isObject(payload) && payload.isAxiosError === true;
}

},{"./../utils.js":"4uo9i","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g7MYJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(([key, value])=>{
    HttpStatusCode[value] = key;
});
exports.default = HttpStatusCode;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lOlfZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GLOBAL_URL", ()=>GLOBAL_URL);
parcelHelpers.export(exports, "API_KEY_STRIPE", ()=>API_KEY_STRIPE);
parcelHelpers.export(exports, "FIELD_REQUIRED", ()=>FIELD_REQUIRED);
parcelHelpers.export(exports, "VALID_EMAIL", ()=>VALID_EMAIL);
parcelHelpers.export(exports, "PASSWORD_NOT_MATCH", ()=>PASSWORD_NOT_MATCH);
parcelHelpers.export(exports, "USED_EMAIL", ()=>USED_EMAIL);
const location = window.location;
const apiPort = undefined;
const apiVersion = undefined;
const apiPath = undefined;
const apiDomain = "homeschooler-api";
const stripeKey = "pk_live_51HC5lPCxvnwOviGZqS2AlcXJlHtqHlUIZHy3zQBz9yAGiKhSaZF68XhjqzlMd21lCZEXdxMtUu9NrY7IfE8eBWm000NkSXIt6O";
const apiHost = "edufile.net";
const settings = {
    api: {
        port: urlPort(apiPort),
        version: apiVersion || 'v1',
        path: apiPath || 'api',
        domain: apiDomain || 'maxelit-api',
        stripe_key: stripeKey,
        host: parentDomain(apiHost)
    }
};
const GLOBAL_URL = `//${settings.api.domain}.${settings.api.host}${settings.api.port}/${settings.api.path}/${settings.api.version}`;
const API_KEY_STRIPE = settings.api.stripe_key;
const FIELD_REQUIRED = 'Campo requerido';
const VALID_EMAIL = "Ingrese un correo electr\xf3nico v\xe1lido";
const PASSWORD_NOT_MATCH = "Las contrase\xf1as no coinciden";
const USED_EMAIL = "Correo electr\xf3nico en uso";
function parentDomain(settingsDomain) {
    if (settingsDomain !== undefined) return settingsDomain;
    const domains = location.hostname.split('.');
    return domains.length > 2 ? domains.slice(1).join('.') : location.hostname;
}
function urlPort(settingsPort) {
    switch(settingsPort){
        case '80':
        case '443':
        case undefined:
            return '';
        default:
            return `:${settingsPort}`;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"81Nwf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserService", ()=>UserService);
parcelHelpers.export(exports, "userService", ()=>userService);
var _axios = require("external/axios");
var _react = require("external/react");
class UserService {
    async create(request) {
        return (0, _axios.post)('/user/create', request);
    }
    async update(request) {
        return (0, _axios.post)('/user/update', request);
    }
    async delete(id, clientId) {
        const locator = (0, _react.stringifyQueryString)({
            id,
            clientId
        });
        return (0, _axios.remove)(`/user/delete?${locator}`);
    }
    async getUserByRoleId(role_id, client_id) {
        return (0, _axios.get)(`/user/role/${role_id}/client/${client_id}`);
    }
    async getUsersByRole(role, client, detailed) {
        const query = (0, _react.stringifyQueryString)({
            client,
            detailed
        });
        return (0, _axios.get)(`/user/users/${role.toLowerCase()}?${query}`);
    }
    async packages(id, clientId) {
        const locator = (0, _react.stringifyQueryString)({
            id,
            clientId
        });
        return (0, _axios.get)(`/user/packages?${locator}`);
    }
    async getHome(userId) {
        return (0, _axios.get)(`/user/getHomeAdmin/${userId}`);
    }
}
const userService = new UserService();

},{"external/axios":"3m9lf","external/react":"1Glst","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gVdre":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PurchaseService", ()=>PurchaseService);
parcelHelpers.export(exports, "purchaseService", ()=>purchaseService);
var _axios = require("external/axios");
class PurchaseService {
    async createPurchase(request) {
        return (0, _axios.post)('/homeschooler/purchase/create', request);
    }
    async getTransactions() {
        return (0, _axios.get)('/homeschooler/purchase/getTransactions');
    }
    async getTransactionByClientId(clientId) {
        return (0, _axios.get)(`homeschooler/purchase/getTransactions/client/${clientId}`);
    }
    async getPurchaseCourses(purchaseItemId) {
        return (0, _axios.get)(`/homeschooler/purchase/courses/${purchaseItemId}`);
    }
    async getPurchaseItemUsers(purchaseItemId) {
        return (0, _axios.get)(`/homeschooler/purchase/purchaseItemUsers/${purchaseItemId}`);
    }
    async assignPurchaseItemUser(request) {
        return (0, _axios.post)('/homeschooler/purchaseItem/assignUser', request);
    }
    async createPurchaseItemUser(request) {
        return (0, _axios.post)('/homeschooler/purchaseItem/create', request);
    }
    async updatePurchaseItemUser(request) {
        return (0, _axios.post)('/homeschooler/purchaseItem/update', request);
    }
}
const purchaseService = new PurchaseService();

},{"external/axios":"3m9lf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"83C2r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "default", ()=>context);
var _immutabilityHelper = require("external/immutability-helper");
var _create = require("context/create");
var _createDefault = parcelHelpers.interopDefault(_create);
var _triggers = require("./triggers");
var _triggersDefault = parcelHelpers.interopDefault(_triggers);
const id = 'Payment';
const initialState = {
    cart: {
        id: localStorage.getItem('cartId'),
        client: undefined,
        properties: {}
    },
    offersSummaryList: (0, _immutabilityHelper.createLoadableList)()
};
const context = (0, _createDefault.default)(id, initialState, {
    onInit: (0, _create.initializeAndRegisterHooks)(id, (0, _triggersDefault.default), _triggers)
});

},{"external/immutability-helper":"f8t05","context/create":"iPmrn","./triggers":"dqxCM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dqxCM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hooks);
parcelHelpers.export(exports, "fetchOffersSummary", ()=>fetchOffersSummary);
parcelHelpers.export(exports, "fetchCart", ()=>fetchCart);
var _cartService = require("services/cart.service");
var _offerService = require("services/offer.service");
var _lodash = require("external/lodash");
const hooks = [];
async function fetchOffersSummary({ update, state }) {
    const { offersSummaryList: { initialized } } = state;
    if (initialized) return;
    update({
        offersSummaryList: {
            $startLoading: {}
        }
    });
    const summary = await (0, _offerService.offerService).getOffersSummary();
    update({
        offersSummaryList: {
            $updateLoadableList: summary.data.data
        }
    });
}
async function fetchCart({ update, state }, { contexts }) {
    const { id: client } = contexts.Auth.state.user || {};
    const { id } = state.cart;
    let cart = undefined;
    if (client) {
        cart = await (0, _cartService.cartService).client(client, id);
        if (cart.data === false) {
            cart = await (0, _cartService.cartService).anonymous(id);
            if (cart.data) {
                const { basic = [], elective = [] } = cart.data.properties;
                const isNotEmpty = basic.concat(elective).filter((id)=>id !== false).length > 0;
                // Take ownership if the cart is not empty
                if (isNotEmpty) cart = await (0, _cartService.cartService).saveCart({
                    ...cart.data,
                    client
                });
                else cart.data = false;
            }
        }
        if (cart.data === false) cart = await (0, _cartService.cartService).client(client);
        if (cart.data === false) cart = await (0, _cartService.cartService).create(client);
    } else cart = await (0, _cartService.cartService).anonymous((0, _lodash.isUUID)(id) ? id : undefined);
    if (cart.data) {
        const properties = cart.data.properties;
        if (!properties.basic) properties.basic = Array(5).fill(false);
        if (!properties.basicExtra) properties.basicExtra = Array(5).fill(false);
        if (!properties.elective) properties.elective = Array(3).fill(false);
        if (!properties.electiveExtra) properties.electiveExtra = Array(3).fill(false);
        if (!properties.workbooks) properties.workbooks = {};
        localStorage.setItem('cartId', cart.data.id);
        update({
            cart: {
                id: {
                    $set: cart.data.id
                },
                client: {
                    $set: cart.data.client
                },
                properties: {
                    $set: properties
                }
            }
        });
    }
}

},{"services/cart.service":"khvXM","services/offer.service":"luCvD","external/lodash":"h4nD2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"khvXM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CartService", ()=>CartService);
parcelHelpers.export(exports, "cartService", ()=>cartService);
var _react = require("external/react");
var _axios = require("external/axios");
class CartService {
    async anonymous(id) {
        let url = '/cart/anonymous';
        if (id) url = `${url}?${(0, _react.stringifyQueryString)({
            id
        })}`;
        return (0, _axios.get)(url);
    }
    async client(client, id) {
        let url = '/cart/client';
        if (client) url = `${url}?${(0, _react.stringifyQueryString)({
            client,
            id
        })}`;
        return (0, _axios.get)(url);
    }
    async create(client) {
        return (0, _axios.post)('/cart/create', {
            client
        });
    }
    async saveCart(cart) {
        return (0, _axios.post)('/cart/save', cart);
    }
}
const cartService = new CartService();

},{"external/react":"1Glst","external/axios":"3m9lf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"luCvD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OfferService", ()=>OfferService);
parcelHelpers.export(exports, "offerService", ()=>offerService);
var _axios = require("external/axios");
class OfferService {
    async getOffers() {
        return (0, _axios.get)('/offer/all');
    }
    async getActiveOffers() {
        return (0, _axios.get)('/offer/all/actives');
    }
    async getOffersById(id) {
        return (0, _axios.get)(`/offer/${id}`);
    }
    async getOffersSubjectsById(id) {
        return (0, _axios.get)(`/offer/subjects/${id}`);
    }
    async getOffersSummary() {
        return (0, _axios.get)('/offer/summary/list');
    }
    async createOffer(request) {
        return (0, _axios.post)('/offer/create', request);
    }
    async updateOffer(request) {
        return (0, _axios.post)('/offer/update', request);
    }
    async updateOfferActive(request) {
        return (0, _axios.post)('/offer/updateActive', request);
    }
    async updateCustomNameOffer(request) {
        return (0, _axios.post)('/offer/updateCustomNameOffer', request);
    }
}
const offerService = new OfferService();

},{"external/axios":"3m9lf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kK0ry":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "default", ()=>context);
var _immutabilityHelper = require("external/immutability-helper");
var _create = require("context/create");
var _createDefault = parcelHelpers.interopDefault(_create);
var _triggers = require("./triggers");
var _triggersDefault = parcelHelpers.interopDefault(_triggers);
var _offer = require("types/offer");
const id = 'Admin';
const initialState = {
    currentOffer: (0, _offer.emptyOffer),
    subjects: [],
    grades: [],
    offers: (0, _immutabilityHelper.createLoadableList)(),
    clients: (0, _immutabilityHelper.createLoadableList)(),
    courses: (0, _immutabilityHelper.createLoadableList)(),
    courseMap: false,
    clientsPaging: false,
    packages: [],
    client: {
        loading: false,
        id: false,
        purchases: (0, _immutabilityHelper.createLoadableList)(),
        profile: false
    },
    changeCourseModal: {
        open: false,
        originalCourse: undefined,
        purchaseIndex: -1,
        source: '',
        selected: {
            subject: '',
            grade: '',
            course: ''
        }
    }
};
const context = (0, _createDefault.default)(id, initialState, {
    onInit: (0, _create.initializeAndRegisterHooks)(id, (0, _triggersDefault.default), _triggers)
});

},{"external/immutability-helper":"f8t05","context/create":"iPmrn","./triggers":"kWKAp","types/offer":"99sVx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kWKAp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hooks);
parcelHelpers.export(exports, "fetchOffers", ()=>fetchOffers);
parcelHelpers.export(exports, "fetchOffer", ()=>fetchOffer);
parcelHelpers.export(exports, "fetchClients", ()=>fetchClients);
parcelHelpers.export(exports, "fetchClientPurchases", ()=>fetchClientPurchases);
parcelHelpers.export(exports, "fetchCourses", ()=>fetchCourses);
var _deepDiff = require("external/deep-diff");
var _lodash = require("external/lodash");
var _offerService = require("services/offer.service");
var _adminService = require("services/admin.service");
var _offer = require("types/offer");
var _navigate = require("utilities/navigate");
var _course = require("types/course");
const hooks = [
    {
        paths: (0, _deepDiff.paramsHook)('pageName', 'offerId'),
        resolves: [
            fetchOffers
        ]
    },
    {
        paths: (0, _deepDiff.paramsHook)('pageName', 'offerId'),
        resolves: [
            fetchOffer
        ]
    },
    {
        paths: (0, _deepDiff.paramsHook)('pageName', '?pattern', '?pageSize', '?page', '?sortBy'),
        resolves: [
            fetchClients
        ]
    },
    {
        paths: (0, _deepDiff.paramsHook)('pageName', 'clientId', 'purchases/refreshes/', 'courseMap/'),
        resolves: [
            fetchClientPurchases
        ]
    }
];
async function fetchOffers({ update, state }, { contexts }) {
    const clientId = (0, _navigate.isLoggedInAndInRoute)('adminOffers', {
        state,
        contexts
    });
    if (!(0, _lodash.isUUID)(clientId)) return;
    const { props: { params: { offerId } } } = state;
    if ((0, _lodash.isUUID)(offerId)) return;
    update({
        offers: {
            $startLoading: {}
        }
    });
    const offers = await (0, _offerService.offerService).getOffers();
    update({
        offers: {
            $updateLoadableList: offers.data.data
        }
    });
}
async function fetchOffer({ update, state }, { contexts }) {
    const clientId = (0, _navigate.isLoggedInAndInRoute)('adminOfferConfiguration', {
        state,
        contexts
    });
    if (!(0, _lodash.isUUID)(clientId)) return;
    const { props: { params: { offerId } } } = state;
    if (!(0, _lodash.isUUID)(offerId)) return;
    update({
        currentOffer: {
            $set: (0, _lodash.cloneDeep)((0, _offer.emptyOffer))
        }
    });
    const response = await (0, _offerService.offerService).getOffersById(offerId);
    update({
        currentOffer: {
            $set: {
                loaded: true,
                ...response.data.data
            }
        }
    });
}
async function fetchClients({ update, state }, { contexts }) {
    const userId = (0, _navigate.isLoggedInAndInRoute)([
        'adminClients',
        'accountingClients'
    ], {
        state,
        contexts
    });
    if (!(0, _lodash.isUUID)(userId)) return;
    const { props: { query: { pattern, sortBy, pageSize = 10, page = 1 } } } = state;
    update({
        clients: {
            $startLoading: {}
        },
        clientsPaging: {
            $set: false
        }
    });
    const { data } = await (0, _adminService.adminService).searchClients(userId, {
        pattern,
        sortBy,
        pageSize,
        page
    });
    const { results, paging } = data;
    update({
        clients: {
            $updateLoadableList: results
        },
        clientsPaging: {
            $set: paging
        }
    });
}
async function fetchClientPurchases({ update, state }, { contexts }) {
    if (state.coursesMap === false) return;
    const userId = (0, _navigate.isLoggedInAndInRoute)([
        'adminClient',
        'accountingClient'
    ], {
        state,
        contexts
    });
    if (!(0, _lodash.isUUID)(userId)) return;
    const { props: { params: { clientId } } } = state;
    if (!(0, _lodash.isUUID)(clientId)) return;
    update({
        client: {
            loading: {
                $set: true
            },
            id: {
                $set: false
            },
            profile: {
                $set: false
            },
            purchases: {
                $startLoading: {}
            }
        }
    });
    const { data } = await (0, _adminService.adminService).clientPurchases(userId, clientId);
    const { purchases, profile } = data;
    const parsedPurchases = purchases.map((purchase)=>{
        const { courses = [], properties = {} } = purchase;
        const extra = properties.basicExtra || [];
        purchase.courses = {
            all: courses.map(({ id })=>id).concat(extra),
            basic: courses.filter((c)=>!(0, _course.isElective)(c)),
            elective: courses.filter((0, _course.isElective)),
            extra
        };
        return purchase;
    });
    update({
        client: {
            loading: {
                $set: false
            },
            id: {
                $set: clientId
            },
            profile: {
                $set: profile
            },
            purchases: {
                $updateLoadableList: parsedPurchases
            }
        }
    });
}
async function fetchCourses({ update, state }, { contexts }) {
    const userId = (0, _navigate.isLoggedIn)({
        state,
        contexts
    });
    if (!(0, _lodash.isUUID)(userId)) return;
    if (state.coursesMap === false) return;
    if (state.courses.loading) return;
    update({
        courses: {
            $startLoading: {}
        },
        courseMap: {
            $set: false
        }
    });
    const { data = [] } = await (0, _adminService.adminService).fetchCoursesInfo(userId);
    const [courses = [], subjects = [], grades = []] = data;
    const courseMap = courses.reduce((map, course)=>{
        map[course.id] = course;
        return map;
    }, {});
    update({
        courses: {
            $updateLoadableList: courses
        },
        courseMap: {
            $set: courseMap
        },
        subjects: {
            $set: subjects
        },
        grades: {
            $set: grades
        }
    });
}

},{"external/deep-diff":"594sO","external/lodash":"h4nD2","services/offer.service":"luCvD","services/admin.service":"jdp6E","types/offer":"99sVx","utilities/navigate":"l8kUI","types/course":"iQVac","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jdp6E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdminService", ()=>AdminService);
parcelHelpers.export(exports, "adminService", ()=>adminService);
var _react = require("external/react");
var _axios = require("external/axios");
class AdminService {
    async searchClients(id, clientSearchParams) {
        const url = `/admin/search-clients?${(0, _react.stringifyQueryString)({
            id,
            ...clientSearchParams
        })}`;
        return (0, _axios.get)(url);
    }
    async clientPurchases(id, clientId) {
        const url = `/admin/client-purchases?${(0, _react.stringifyQueryString)({
            id,
            clientId
        })}`;
        return (0, _axios.get)(url);
    }
    async getStripeInfo(id, clientId) {
        const url = `/admin/get-stripe-info?${(0, _react.stringifyQueryString)({
            id,
            clientId
        })}`;
        return (0, _axios.get)(url);
    }
    async fetchCoursesInfo(id) {
        const url = `/admin/courses-info?${(0, _react.stringifyQueryString)({
            id
        })}`;
        return (0, _axios.get)(url);
    }
    async updateClientCourse(id, params) {
        return (0, _axios.post)(`/admin/update-client-course?${(0, _react.stringifyQueryString)({
            id
        })}`, params);
    }
}
const adminService = new AdminService();

},{"external/react":"1Glst","external/axios":"3m9lf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"99sVx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "emptyOffer", ()=>emptyOffer);
parcelHelpers.export(exports, "isDiscounted", ()=>isDiscounted);
parcelHelpers.export(exports, "calculateDiscounts", ()=>calculateDiscounts);
var _moment = require("external/moment");
const emptyOffer = {
    id: '',
    loaded: false,
    name: '',
    discount: false,
    discount_type: 'quantity',
    frequency_unit_name: '',
    start_date: '',
    active: false,
    content: {
        html: '',
        preview: ''
    },
    plan: "",
    price: "",
    discount_amount: "",
    discount_startdate: "",
    discount_duedate: "",
    category_unit: '',
    frequency_unit: '',
    discount_name: ''
};
function isDiscounted(offer) {
    return offer.discount && (0, _moment.moment)().isBetween((0, _moment.moment)(offer.discount_startdate), (0, _moment.moment)(offer.discount_duedate));
}
function calculateDiscounts(offer) {
    let parsedPrice = parseFloat(offer.price.replace(/[$,]/g, ''));
    let discountedPrice = '';
    let discountedAmount = '';
    if (offer.discount_type === 'quantity') {
        discountedPrice = Number(parsedPrice - parseFloat(offer.discount_amount)).toFixed(2);
        discountedAmount = `$${offer.discount_amount}`;
    }
    if (offer.discount_type === 'percent') {
        const resultDiscount = parseFloat(offer.discount_amount) * parsedPrice / 100;
        discountedPrice = Number(parsedPrice - resultDiscount).toFixed(2);
        discountedAmount = `${Number(offer.discount_amount).toFixed(0)}%`;
    }
    return [
        discountedPrice,
        discountedAmount
    ];
}

},{"external/moment":"fMWlp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fMWlp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatUnix", ()=>formatUnix);
parcelHelpers.export(exports, "moment", ()=>(0, _momentDefault.default));
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
function formatUnix(stamp, format = 'DD/MM/YYYY') {
    return (0, _momentDefault.default).unix(stamp).format(format);
}

},{"moment":"1e4qG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1e4qG":[function(require,module,exports,__globalThis) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

},{}],"iQVac":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElective", ()=>isElective);
parcelHelpers.export(exports, "getCourseSubject", ()=>getCourseSubject);
function isElective(course) {
    return (course.courseId || course.id || '').startsWith('C7');
}
function getCourseSubject(course) {
    return course.courseId.substring(0, 2);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3UV2I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "default", ()=>context);
var _immutabilityHelper = require("external/immutability-helper");
var _create = require("context/create");
var _createDefault = parcelHelpers.interopDefault(_create);
var _triggers = require("./triggers");
var _triggersDefault = parcelHelpers.interopDefault(_triggers);
const id = 'Accounting';
const initialState = {
    payouts: (0, _immutabilityHelper.createLoadableList)(),
    payoutsPaging: false,
    payout: {
        loading: false,
        id: false,
        data: false
    }
};
const context = (0, _createDefault.default)(id, initialState, {
    onInit: (0, _create.initializeAndRegisterHooks)(id, (0, _triggersDefault.default), _triggers)
});

},{"external/immutability-helper":"f8t05","context/create":"iPmrn","./triggers":"43pZK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"43pZK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hooks);
parcelHelpers.export(exports, "fetchPayouts", ()=>fetchPayouts);
parcelHelpers.export(exports, "fetchPayout", ()=>fetchPayout);
var _deepDiff = require("external/deep-diff");
var _lodash = require("external/lodash");
var _text = require("utilities/text");
var _accountingService = require("services/accounting.service");
var _navigate = require("utilities/navigate");
const hooks = [
    {
        paths: (0, _deepDiff.paramsHook)('pageName', '?pattern', '?pageSize', '?page', '?sortBy', '?from', '?to'),
        resolves: [
            fetchPayouts
        ]
    },
    {
        paths: (0, _deepDiff.paramsHook)('pageName', 'payoutId', 'payouts/refreshes/'),
        resolves: [
            fetchPayout
        ]
    }
];
async function fetchPayouts({ update, state }, { contexts }) {
    const userId = (0, _navigate.isLoggedInAndInRoute)('accountingPayouts', {
        state,
        contexts
    });
    if (!(0, _lodash.isUUID)(userId)) return;
    const { props: { query: { pattern, sortBy, pageSize = 10, page = 1, from, to } } } = state;
    update({
        payouts: {
            $startLoading: {}
        },
        payoutsPaging: {
            $set: false
        }
    });
    const { data } = await (0, _accountingService.accountingService).searchPayouts(userId, {
        pattern,
        sortBy,
        pageSize,
        page,
        from,
        to
    });
    const { results, paging } = data;
    update({
        payouts: {
            $updateLoadableList: results
        },
        payoutsPaging: {
            $set: paging
        }
    });
}
async function fetchPayout({ update, state }, { contexts }) {
    const userId = (0, _navigate.isLoggedInAndInRoute)('accountingPayout', {
        state,
        contexts
    });
    if (!(0, _lodash.isUUID)(userId)) return;
    const { props: { params: { payoutId } } } = state;
    if ((0, _text.isEmpty)(payoutId)) return;
    // Don't re-fetch if already loaded for this payoutId
    if (state.payout.id === payoutId && state.payout.data) return;
    update({
        payout: {
            loading: {
                $set: true
            },
            id: {
                $set: false
            },
            data: {
                $set: false
            }
        }
    });
    const { data } = await (0, _accountingService.accountingService).getPayoutDetail(userId, payoutId);
    update({
        payout: {
            loading: {
                $set: false
            },
            id: {
                $set: payoutId
            },
            data: {
                $set: data
            }
        }
    });
}

},{"external/deep-diff":"594sO","external/lodash":"h4nD2","utilities/text":"aKcMC","services/accounting.service":"40iQF","utilities/navigate":"l8kUI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aKcMC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElective", ()=>isElective);
parcelHelpers.export(exports, "isEmpty", ()=>isEmpty);
parcelHelpers.export(exports, "formatNumber", ()=>formatNumber);
parcelHelpers.export(exports, "capitalizeFirstLetter", ()=>capitalizeFirstLetter);
parcelHelpers.export(exports, "searchSubstring", ()=>searchSubstring);
parcelHelpers.export(exports, "searchInStrings", ()=>searchInStrings);
parcelHelpers.export(exports, "sqlDate", ()=>sqlDate);
parcelHelpers.export(exports, "getFileExtension", ()=>getFileExtension);
parcelHelpers.export(exports, "convertDateToText", ()=>convertDateToText);
var _moment = require("external/moment");
var _latinise = require("external/latinise");
const electiveRegex = /^C7/;
const isElective = electiveRegex.test.bind(electiveRegex);
function isEmpty(str) {
    return !str || 0 === str.length;
}
const formatNumber = function(formatter) {
    return formatter.format.bind(formatter);
}(new Intl.NumberFormat('en-US', {
    maximumSignificantDigits: 3
}));
function capitalizeFirstLetter(str, capitalized = true) {
    if (!str) return '';
    const firstCP = str.codePointAt(0);
    const index = firstCP > 0xFFFF ? 2 : 1;
    return capitalized ? String.fromCodePoint(firstCP).toUpperCase() + str.slice(index) : String.fromCodePoint(firstCP).toLowerCase() + str.slice(index);
}
function searchSubstring(text, sub) {
    const processedText = (0, _latinise.latinise)(text.toLowerCase());
    const processedSub = (0, _latinise.latinise)(sub.toLowerCase());
    return processedText.includes(processedSub);
}
function searchInStrings(sub) {
    return (...strings)=>strings.some((text)=>searchSubstring(text, sub));
}
function sqlDate(date) {
    return (0, _moment.moment)(date).format();
}
function getFileExtension(filename) {
    return filename.split('.').pop();
}
function convertDateToText(_date, includeDay = false) {
    const date = new Date(_date);
    const formattedDate = date.toLocaleDateString('es-ES', {
        ...includeDay ? {
            day: 'numeric'
        } : {},
        year: 'numeric',
        month: 'long'
    });
    return formattedDate;
}

},{"external/moment":"fMWlp","external/latinise":"iXARS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iXARS":[function(require,module,exports,__globalThis) {
// Generated from latin_map.pl Sun Jun 20 20:17:18 2010
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "latinise", ()=>latinise);
parcelHelpers.export(exports, "isLatin", ()=>isLatin);
const latinMap = {
    "\xc1": 'A',
    "\u0102": 'A',
    "\u1EAE": 'A',
    "\u1EB6": 'A',
    "\u1EB0": 'A',
    "\u1EB2": 'A',
    "\u1EB4": 'A',
    "\u01CD": 'A',
    "\xc2": 'A',
    "\u1EA4": 'A',
    "\u1EAC": 'A',
    "\u1EA6": 'A',
    "\u1EA8": 'A',
    "\u1EAA": 'A',
    "\xc4": 'A',
    "\u01DE": 'A',
    "\u0226": 'A',
    "\u01E0": 'A',
    "\u1EA0": 'A',
    "\u0200": 'A',
    "\xc0": 'A',
    "\u1EA2": 'A',
    "\u0202": 'A',
    "\u0100": 'A',
    "\u0104": 'A',
    "\xc5": 'A',
    "\u01FA": 'A',
    "\u1E00": 'A',
    "\u023A": 'A',
    "\xc3": 'A',
    "\uA732": 'AA',
    "\xc6": 'AE',
    "\u01FC": 'AE',
    "\u01E2": 'AE',
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER AFRICAN D' (Ɖ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER ALPHA' (Ɑ)
    "\uA734": 'AO',
    "\uA736": 'AU',
    "\uA738": 'AV',
    "\uA73A": 'AV',
    "\uA73C": 'AY',
    "\u1E02": 'B',
    "\u1E04": 'B',
    "\u0181": 'B',
    "\u1E06": 'B',
    "\u0243": 'B',
    "\u0182": 'B',
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER BROKEN L' (Ꝇ)
    "\u0106": 'C',
    "\u010C": 'C',
    "\xc7": 'C',
    "\u1E08": 'C',
    "\u0108": 'C',
    "\u010A": 'C',
    "\u0187": 'C',
    "\u023B": 'C',
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER CON' (Ꝯ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER CUATRILLO' (Ꜭ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER CUATRILLO WITH COMMA' (Ꜯ)
    "\u010E": 'D',
    "\u1E10": 'D',
    "\u1E12": 'D',
    "\u1E0A": 'D',
    "\u1E0C": 'D',
    "\u018A": 'D',
    "\u1E0E": 'D',
    "\u01F2": 'D',
    "\u01C5": 'D',
    "\u0110": 'D',
    "\u018B": 'D',
    "\u01F1": 'DZ',
    "\u01C4": 'DZ',
    "\xc9": 'E',
    "\u0114": 'E',
    "\u011A": 'E',
    "\u0228": 'E',
    "\u1E1C": 'E',
    "\xca": 'E',
    "\u1EBE": 'E',
    "\u1EC6": 'E',
    "\u1EC0": 'E',
    "\u1EC2": 'E',
    "\u1EC4": 'E',
    "\u1E18": 'E',
    "\xcb": 'E',
    "\u0116": 'E',
    "\u1EB8": 'E',
    "\u0204": 'E',
    "\xc8": 'E',
    "\u1EBA": 'E',
    "\u0206": 'E',
    "\u0112": 'E',
    "\u1E16": 'E',
    "\u1E14": 'E',
    "\u0118": 'E',
    "\u0246": 'E',
    "\u1EBC": 'E',
    "\u1E1A": 'E',
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER EGYPTOLOGICAL AIN' (Ꜥ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER EGYPTOLOGICAL ALEF' (Ꜣ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER ENG' (Ŋ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER ESH' (Ʃ)
    "\uA76A": 'ET',
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER ETH' (Ð)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER EZH' (Ʒ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER EZH REVERSED' (Ƹ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER EZH WITH CARON' (Ǯ)
    "\u1E1E": 'F',
    "\u0191": 'F',
    "\u01F4": 'G',
    "\u011E": 'G',
    "\u01E6": 'G',
    "\u0122": 'G',
    "\u011C": 'G',
    "\u0120": 'G',
    "\u0193": 'G',
    "\u1E20": 'G',
    "\u01E4": 'G',
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER GAMMA' (Ɣ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER GLOTTAL STOP' (Ɂ)
    "\u1E2A": 'H',
    "\u021E": 'H',
    "\u1E28": 'H',
    "\u0124": 'H',
    "\u2C67": 'H',
    "\u1E26": 'H',
    "\u1E22": 'H',
    "\u1E24": 'H',
    "\u0126": 'H',
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER HALF H' (Ⱶ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER HENG' (Ꜧ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER HWAIR' (Ƕ)
    "\xcd": 'I',
    "\u012C": 'I',
    "\u01CF": 'I',
    "\xce": 'I',
    "\xcf": 'I',
    "\u1E2E": 'I',
    "\u0130": 'I',
    "\u1ECA": 'I',
    "\u0208": 'I',
    "\xcc": 'I',
    "\u1EC8": 'I',
    "\u020A": 'I',
    "\u012A": 'I',
    "\u012E": 'I',
    "\u0197": 'I',
    "\u0128": 'I',
    "\u1E2C": 'I',
    "\uA779": 'D',
    "\uA77B": 'F',
    "\uA77D": 'G',
    "\uA782": 'R',
    "\uA784": 'S',
    "\uA786": 'T',
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER IOTA' (Ɩ)
    "\uA76C": 'IS',
    "\u0134": 'J',
    "\u0248": 'J',
    "\u1E30": 'K',
    "\u01E8": 'K',
    "\u0136": 'K',
    "\u2C69": 'K',
    "\uA742": 'K',
    "\u1E32": 'K',
    "\u0198": 'K',
    "\u1E34": 'K',
    "\uA740": 'K',
    "\uA744": 'K',
    "\u0139": 'L',
    "\u023D": 'L',
    "\u013D": 'L',
    "\u013B": 'L',
    "\u1E3C": 'L',
    "\u1E36": 'L',
    "\u1E38": 'L',
    "\u2C60": 'L',
    "\uA748": 'L',
    "\u1E3A": 'L',
    "\u013F": 'L',
    "\u2C62": 'L',
    "\u01C8": 'L',
    "\u0141": 'L',
    "\u01C7": 'LJ',
    "\u1E3E": 'M',
    "\u1E40": 'M',
    "\u1E42": 'M',
    "\u2C6E": 'M',
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER MIDDLE-WELSH LL' (Ỻ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER MIDDLE-WELSH V' (Ỽ)
    "\u0143": 'N',
    "\u0147": 'N',
    "\u0145": 'N',
    "\u1E4A": 'N',
    "\u1E44": 'N',
    "\u1E46": 'N',
    "\u01F8": 'N',
    "\u019D": 'N',
    "\u1E48": 'N',
    "\u0220": 'N',
    "\u01CB": 'N',
    "\xd1": 'N',
    "\u01CA": 'NJ',
    "\xd3": 'O',
    "\u014E": 'O',
    "\u01D1": 'O',
    "\xd4": 'O',
    "\u1ED0": 'O',
    "\u1ED8": 'O',
    "\u1ED2": 'O',
    "\u1ED4": 'O',
    "\u1ED6": 'O',
    "\xd6": 'O',
    "\u022A": 'O',
    "\u022E": 'O',
    "\u0230": 'O',
    "\u1ECC": 'O',
    "\u0150": 'O',
    "\u020C": 'O',
    "\xd2": 'O',
    "\u1ECE": 'O',
    "\u01A0": 'O',
    "\u1EDA": 'O',
    "\u1EE2": 'O',
    "\u1EDC": 'O',
    "\u1EDE": 'O',
    "\u1EE0": 'O',
    "\u020E": 'O',
    "\uA74A": 'O',
    "\uA74C": 'O',
    "\u014C": 'O',
    "\u1E52": 'O',
    "\u1E50": 'O',
    "\u019F": 'O',
    "\u01EA": 'O',
    "\u01EC": 'O',
    "\xd8": 'O',
    "\u01FE": 'O',
    "\xd5": 'O',
    "\u1E4C": 'O',
    "\u1E4E": 'O',
    "\u022C": 'O',
    "\u01A2": 'OI',
    "\uA74E": 'OO',
    "\u0190": 'E',
    "\u0186": 'O',
    "\u0222": 'OU',
    "\u1E54": 'P',
    "\u1E56": 'P',
    "\uA752": 'P',
    "\u01A4": 'P',
    "\uA754": 'P',
    "\u2C63": 'P',
    "\uA750": 'P',
    "\uA758": 'Q',
    "\uA756": 'Q',
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER R ROTUNDA' (Ꝛ)
    "\u0154": 'R',
    "\u0158": 'R',
    "\u0156": 'R',
    "\u1E58": 'R',
    "\u1E5A": 'R',
    "\u1E5C": 'R',
    "\u0210": 'R',
    "\u0212": 'R',
    "\u1E5E": 'R',
    "\u024C": 'R',
    "\u2C64": 'R',
    "\uA73E": 'C',
    "\u018E": 'E',
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER RUM ROTUNDA' (Ꝝ)
    "\u015A": 'S',
    "\u1E64": 'S',
    "\u0160": 'S',
    "\u1E66": 'S',
    "\u015E": 'S',
    "\u015C": 'S',
    "\u0218": 'S',
    "\u1E60": 'S',
    "\u1E62": 'S',
    "\u1E68": 'S',
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER SALTILLO' (Ꞌ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER SCHWA' (Ə)
    "\u1E9E": 'SS',
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER SMALL Q WITH HOOK TAIL' (Ɋ)
    "\u0164": 'T',
    "\u0162": 'T',
    "\u1E70": 'T',
    "\u021A": 'T',
    "\u023E": 'T',
    "\u1E6A": 'T',
    "\u1E6C": 'T',
    "\u01AC": 'T',
    "\u1E6E": 'T',
    "\u01AE": 'T',
    "\u0166": 'T',
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER THORN' (Þ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER THORN WITH STROKE' (Ꝥ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER THORN WITH STROKE THROUGH DESCENDER' (Ꝧ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER TONE FIVE' (Ƽ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER TONE SIX' (Ƅ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER TONE TWO' (Ƨ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER TRESILLO' (Ꜫ)
    "\u2C6F": 'A',
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER TURNED INSULAR G' (Ꝿ)
    "\uA780": 'L',
    "\u019C": 'M',
    "\u0245": 'V',
    "\uA728": 'TZ',
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER U BAR' (Ʉ)
    "\xda": 'U',
    "\u016C": 'U',
    "\u01D3": 'U',
    "\xdb": 'U',
    "\u1E76": 'U',
    "\xdc": 'U',
    "\u01D7": 'U',
    "\u01D9": 'U',
    "\u01DB": 'U',
    "\u01D5": 'U',
    "\u1E72": 'U',
    "\u1EE4": 'U',
    "\u0170": 'U',
    "\u0214": 'U',
    "\xd9": 'U',
    "\u1EE6": 'U',
    "\u01AF": 'U',
    "\u1EE8": 'U',
    "\u1EF0": 'U',
    "\u1EEA": 'U',
    "\u1EEC": 'U',
    "\u1EEE": 'U',
    "\u0216": 'U',
    "\u016A": 'U',
    "\u1E7A": 'U',
    "\u0172": 'U',
    "\u016E": 'U',
    "\u0168": 'U',
    "\u1E78": 'U',
    "\u1E74": 'U',
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER UPSILON' (Ʊ)
    "\uA75E": 'V',
    "\u1E7E": 'V',
    "\u01B2": 'V',
    "\u1E7C": 'V',
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER VEND' (Ꝩ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER VISIGOTHIC Z' (Ꝣ)
    "\uA760": 'VY',
    "\u1E82": 'W',
    "\u0174": 'W',
    "\u1E84": 'W',
    "\u1E86": 'W',
    "\u1E88": 'W',
    "\u1E80": 'W',
    "\u2C72": 'W',
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER WYNN' (Ƿ)
    "\u1E8C": 'X',
    "\u1E8A": 'X',
    "\xdd": 'Y',
    "\u0176": 'Y',
    "\u0178": 'Y',
    "\u1E8E": 'Y',
    "\u1EF4": 'Y',
    "\u1EF2": 'Y',
    "\u01B3": 'Y',
    "\u1EF6": 'Y',
    "\u1EFE": 'Y',
    "\u0232": 'Y',
    "\u024E": 'Y',
    "\u1EF8": 'Y',
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER YOGH' (Ȝ)
    "\u0179": 'Z',
    "\u017D": 'Z',
    "\u1E90": 'Z',
    "\u2C6B": 'Z',
    "\u017B": 'Z',
    "\u1E92": 'Z',
    "\u0224": 'Z',
    "\u1E94": 'Z',
    "\u01B5": 'Z',
    "\u0132": 'IJ',
    "\u0152": 'OE',
    // CANNOT FIND APPROXIMATION FOR 'LATIN CROSS' (✝)
    // CANNOT FIND APPROXIMATION FOR 'LATIN EPIGRAPHIC LETTER ARCHAIC M' (ꟿ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN EPIGRAPHIC LETTER I LONGA' (ꟾ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN EPIGRAPHIC LETTER INVERTED M' (ꟽ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN EPIGRAPHIC LETTER REVERSED F' (ꟻ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN EPIGRAPHIC LETTER REVERSED P' (ꟼ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER AIN' (ᴥ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER ALVEOLAR CLICK' (ǂ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER BIDENTAL PERCUSSIVE' (ʭ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER BILABIAL CLICK' (ʘ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER BILABIAL PERCUSSIVE' (ʬ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER DENTAL CLICK' (ǀ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER GLOTTAL STOP' (ʔ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER GLOTTAL STOP WITH STROKE' (ʡ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER INVERTED GLOTTAL STOP' (ʖ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER INVERTED GLOTTAL STOP WITH STROKE' (ƾ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER LATERAL CLICK' (ǁ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER PHARYNGEAL VOICED FRICATIVE' (ʕ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER RETROFLEX CLICK' (ǃ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER REVERSED ESH LOOP' (ƪ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER REVERSED GLOTTAL STOP WITH STROKE' (ʢ)
    "\u1D00": 'A',
    "\u1D01": 'AE',
    "\u0299": 'B',
    "\u1D03": 'B',
    "\u1D04": 'C',
    "\u1D05": 'D',
    "\u1D07": 'E',
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER SMALL CAPITAL ETH' (ᴆ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER SMALL CAPITAL EZH' (ᴣ)
    "\uA730": 'F',
    "\u0262": 'G',
    "\u029B": 'G',
    "\u029C": 'H',
    "\u026A": 'I',
    "\u0281": 'R',
    "\u1D0A": 'J',
    "\u1D0B": 'K',
    "\u029F": 'L',
    "\u1D0C": 'L',
    "\u1D0D": 'M',
    "\u0274": 'N',
    "\u1D0F": 'O',
    "\u0276": 'OE',
    "\u1D10": 'O',
    "\u1D15": 'OU',
    "\u1D18": 'P',
    "\u0280": 'R',
    "\u1D0E": 'N',
    "\u1D19": 'R',
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER SMALL CAPITAL RUM' (ꝶ)
    "\uA731": 'S',
    "\u1D1B": 'T',
    "\u2C7B": 'E',
    "\u1D1A": 'R',
    "\u1D1C": 'U',
    "\u1D20": 'V',
    "\u1D21": 'W',
    "\u028F": 'Y',
    "\u1D22": 'Z',
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER STRETCHED C' (ʗ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER TWO WITH STROKE' (ƻ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER VOICED LARYNGEAL SPIRANT' (ᴤ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER WYNN' (ƿ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER YR' (Ʀ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL CAPITAL LETTER I WITH STROKE' (ᵻ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL CAPITAL LETTER U WITH STROKE' (ᵾ)
    "\xe1": 'a',
    "\u0103": 'a',
    "\u1EAF": 'a',
    "\u1EB7": 'a',
    "\u1EB1": 'a',
    "\u1EB3": 'a',
    "\u1EB5": 'a',
    "\u01CE": 'a',
    "\xe2": 'a',
    "\u1EA5": 'a',
    "\u1EAD": 'a',
    "\u1EA7": 'a',
    "\u1EA9": 'a',
    "\u1EAB": 'a',
    "\xe4": 'a',
    "\u01DF": 'a',
    "\u0227": 'a',
    "\u01E1": 'a',
    "\u1EA1": 'a',
    "\u0201": 'a',
    "\xe0": 'a',
    "\u1EA3": 'a',
    "\u0203": 'a',
    "\u0101": 'a',
    "\u0105": 'a',
    "\u1D8F": 'a',
    "\u1E9A": 'a',
    "\xe5": 'a',
    "\u01FB": 'a',
    "\u1E01": 'a',
    "\u2C65": 'a',
    "\xe3": 'a',
    "\uA733": 'aa',
    "\xe6": 'ae',
    "\u01FD": 'ae',
    "\u01E3": 'ae',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ALPHA' (ɑ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ALPHA WITH RETROFLEX HOOK' (ᶐ)
    "\uA735": 'ao',
    "\uA737": 'au',
    "\uA739": 'av',
    "\uA73B": 'av',
    "\uA73D": 'ay',
    "\u1E03": 'b',
    "\u1E05": 'b',
    "\u0253": 'b',
    "\u1E07": 'b',
    "\u1D6C": 'b',
    "\u1D80": 'b',
    "\u0180": 'b',
    "\u0183": 'b',
    "\u0275": 'o',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER BOTTOM HALF O' (ᴗ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER BROKEN L' (ꝇ)
    "\u0107": 'c',
    "\u010D": 'c',
    "\xe7": 'c',
    "\u1E09": 'c',
    "\u0109": 'c',
    "\u0255": 'c',
    "\u010B": 'c',
    "\u0188": 'c',
    "\u023C": 'c',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER CLOSED OMEGA' (ɷ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER CLOSED OPEN E' (ʚ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER CLOSED REVERSED OPEN E' (ɞ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER CON' (ꝯ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER CUATRILLO' (ꜭ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER CUATRILLO WITH COMMA' (ꜯ)
    "\u010F": 'd',
    "\u1E11": 'd',
    "\u1E13": 'd',
    "\u0221": 'd',
    "\u1E0B": 'd',
    "\u1E0D": 'd',
    "\u0257": 'd',
    "\u1D91": 'd',
    "\u1E0F": 'd',
    "\u1D6D": 'd',
    "\u1D81": 'd',
    "\u0111": 'd',
    "\u0256": 'd',
    "\u018C": 'd',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER DB DIGRAPH' (ȸ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER DELTA' (ẟ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER DEZH DIGRAPH' (ʤ)
    "\u0131": 'i',
    "\u0237": 'j',
    "\u025F": 'j',
    "\u0284": 'j',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER DUM' (ꝱ)
    "\u01F3": 'dz',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER DZ DIGRAPH' (ʣ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER DZ DIGRAPH WITH CURL' (ʥ)
    "\u01C6": 'dz',
    "\xe9": 'e',
    "\u0115": 'e',
    "\u011B": 'e',
    "\u0229": 'e',
    "\u1E1D": 'e',
    "\xea": 'e',
    "\u1EBF": 'e',
    "\u1EC7": 'e',
    "\u1EC1": 'e',
    "\u1EC3": 'e',
    "\u1EC5": 'e',
    "\u1E19": 'e',
    "\xeb": 'e',
    "\u0117": 'e',
    "\u1EB9": 'e',
    "\u0205": 'e',
    "\xe8": 'e',
    "\u1EBB": 'e',
    "\u0207": 'e',
    "\u0113": 'e',
    "\u1E17": 'e',
    "\u1E15": 'e',
    "\u2C78": 'e',
    "\u0119": 'e',
    "\u1D92": 'e',
    "\u0247": 'e',
    "\u1EBD": 'e',
    "\u1E1B": 'e',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EGYPTOLOGICAL AIN' (ꜥ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EGYPTOLOGICAL ALEF' (ꜣ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ENG' (ŋ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ESH' (ʃ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ESH WITH CURL' (ʆ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ESH WITH PALATAL HOOK' (ᶋ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ESH WITH RETROFLEX HOOK' (ᶘ)
    "\uA76B": 'et',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ETH' (ð)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EZH' (ʒ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EZH REVERSED' (ƹ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EZH WITH CARON' (ǯ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EZH WITH CURL' (ʓ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EZH WITH RETROFLEX HOOK' (ᶚ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EZH WITH TAIL' (ƺ)
    "\u1E1F": 'f',
    "\u0192": 'f',
    "\u1D6E": 'f',
    "\u1D82": 'f',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER FENG DIGRAPH' (ʩ)
    "\u01F5": 'g',
    "\u011F": 'g',
    "\u01E7": 'g',
    "\u0123": 'g',
    "\u011D": 'g',
    "\u0121": 'g',
    "\u0260": 'g',
    "\u1E21": 'g',
    "\u1D83": 'g',
    "\u01E5": 'g',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER GAMMA' (ɣ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER GLOTTAL STOP' (ɂ)
    "\u1E2B": 'h',
    "\u021F": 'h',
    "\u1E29": 'h',
    "\u0125": 'h',
    "\u2C68": 'h',
    "\u1E27": 'h',
    "\u1E23": 'h',
    "\u1E25": 'h',
    "\u0266": 'h',
    "\u1E96": 'h',
    "\u0127": 'h',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER HALF H' (ⱶ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER HENG' (ꜧ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER HENG WITH HOOK' (ɧ)
    "\u0195": 'hv',
    "\xed": 'i',
    "\u012D": 'i',
    "\u01D0": 'i',
    "\xee": 'i',
    "\xef": 'i',
    "\u1E2F": 'i',
    "\u1ECB": 'i',
    "\u0209": 'i',
    "\xec": 'i',
    "\u1EC9": 'i',
    "\u020B": 'i',
    "\u012B": 'i',
    "\u012F": 'i',
    "\u1D96": 'i',
    "\u0268": 'i',
    "\u0129": 'i',
    "\u1E2D": 'i',
    "\uA77A": 'd',
    "\uA77C": 'f',
    "\u1D79": 'g',
    "\uA783": 'r',
    "\uA785": 's',
    "\uA787": 't',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER IOTA' (ɩ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER IOTA WITH STROKE' (ᵼ)
    "\uA76D": 'is',
    "\u01F0": 'j',
    "\u0135": 'j',
    "\u029D": 'j',
    "\u0249": 'j',
    "\u1E31": 'k',
    "\u01E9": 'k',
    "\u0137": 'k',
    "\u2C6A": 'k',
    "\uA743": 'k',
    "\u1E33": 'k',
    "\u0199": 'k',
    "\u1E35": 'k',
    "\u1D84": 'k',
    "\uA741": 'k',
    "\uA745": 'k',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER KRA' (ĸ)
    "\u013A": 'l',
    "\u019A": 'l',
    "\u026C": 'l',
    "\u013E": 'l',
    "\u013C": 'l',
    "\u1E3D": 'l',
    "\u0234": 'l',
    "\u1E37": 'l',
    "\u1E39": 'l',
    "\u2C61": 'l',
    "\uA749": 'l',
    "\u1E3B": 'l',
    "\u0140": 'l',
    "\u026B": 'l',
    "\u1D85": 'l',
    "\u026D": 'l',
    "\u0142": 'l',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER LAMBDA WITH STROKE' (ƛ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER LEZH' (ɮ)
    "\u01C9": 'lj',
    "\u017F": 's',
    "\u1E9C": 's',
    "\u1E9B": 's',
    "\u1E9D": 's',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER LS DIGRAPH' (ʪ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER LUM' (ꝲ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER LZ DIGRAPH' (ʫ)
    "\u1E3F": 'm',
    "\u1E41": 'm',
    "\u1E43": 'm',
    "\u0271": 'm',
    "\u1D6F": 'm',
    "\u1D86": 'm',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER MIDDLE-WELSH LL' (ỻ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER MIDDLE-WELSH V' (ỽ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER MUM' (ꝳ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER N PRECEDED BY APOSTROPHE' (ŉ)
    "\u0144": 'n',
    "\u0148": 'n',
    "\u0146": 'n',
    "\u1E4B": 'n',
    "\u0235": 'n',
    "\u1E45": 'n',
    "\u1E47": 'n',
    "\u01F9": 'n',
    "\u0272": 'n',
    "\u1E49": 'n',
    "\u019E": 'n',
    "\u1D70": 'n',
    "\u1D87": 'n',
    "\u0273": 'n',
    "\xf1": 'n',
    "\u01CC": 'nj',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER NUM' (ꝴ)
    "\xf3": 'o',
    "\u014F": 'o',
    "\u01D2": 'o',
    "\xf4": 'o',
    "\u1ED1": 'o',
    "\u1ED9": 'o',
    "\u1ED3": 'o',
    "\u1ED5": 'o',
    "\u1ED7": 'o',
    "\xf6": 'o',
    "\u022B": 'o',
    "\u022F": 'o',
    "\u0231": 'o',
    "\u1ECD": 'o',
    "\u0151": 'o',
    "\u020D": 'o',
    "\xf2": 'o',
    "\u1ECF": 'o',
    "\u01A1": 'o',
    "\u1EDB": 'o',
    "\u1EE3": 'o',
    "\u1EDD": 'o',
    "\u1EDF": 'o',
    "\u1EE1": 'o',
    "\u020F": 'o',
    "\uA74B": 'o',
    "\uA74D": 'o',
    "\u2C7A": 'o',
    "\u014D": 'o',
    "\u1E53": 'o',
    "\u1E51": 'o',
    "\u01EB": 'o',
    "\u01ED": 'o',
    "\xf8": 'o',
    "\u01FF": 'o',
    "\xf5": 'o',
    "\u1E4D": 'o',
    "\u1E4F": 'o',
    "\u022D": 'o',
    "\u01A3": 'oi',
    "\uA74F": 'oo',
    "\u025B": 'e',
    "\u1D93": 'e',
    "\u0254": 'o',
    "\u1D97": 'o',
    "\u0223": 'ou',
    "\u1E55": 'p',
    "\u1E57": 'p',
    "\uA753": 'p',
    "\u01A5": 'p',
    "\u1D71": 'p',
    "\u1D88": 'p',
    "\uA755": 'p',
    "\u1D7D": 'p',
    "\uA751": 'p',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER PHI' (ɸ)
    "\uA759": 'q',
    "\u02A0": 'q',
    "\u024B": 'q',
    "\uA757": 'q',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER QP DIGRAPH' (ȹ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER R ROTUNDA' (ꝛ)
    "\u0155": 'r',
    "\u0159": 'r',
    "\u0157": 'r',
    "\u1E59": 'r',
    "\u1E5B": 'r',
    "\u1E5D": 'r',
    "\u0211": 'r',
    "\u027E": 'r',
    "\u1D73": 'r',
    "\u0213": 'r',
    "\u1E5F": 'r',
    "\u027C": 'r',
    "\u1D72": 'r',
    "\u1D89": 'r',
    "\u024D": 'r',
    "\u027D": 'r',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER RAMS HORN' (ɤ)
    "\u2184": 'c',
    "\uA73F": 'c',
    "\u0258": 'e',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER REVERSED OPEN E' (ɜ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER REVERSED OPEN E WITH HOOK' (ɝ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER REVERSED OPEN E WITH RETROFLEX HOOK' (ᶔ)
    "\u027F": 'r',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER RUM' (ꝵ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER RUM ROTUNDA' (ꝝ)
    "\u015B": 's',
    "\u1E65": 's',
    "\u0161": 's',
    "\u1E67": 's',
    "\u015F": 's',
    "\u015D": 's',
    "\u0219": 's',
    "\u1E61": 's',
    "\u1E63": 's',
    "\u1E69": 's',
    "\u0282": 's',
    "\u1D74": 's',
    "\u1D8A": 's',
    "\u023F": 's',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SALTILLO' (ꞌ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SCHWA' (ə)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SCHWA WITH HOOK' (ɚ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SCHWA WITH RETROFLEX HOOK' (ᶕ)
    "\u0261": 'g',
    "\xdf": 'ss',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SIDEWAYS DIAERESIZED U' (ᴞ)
    "\u1D11": 'o',
    "\u1D13": 'o',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SIDEWAYS OPEN O' (ᴒ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SIDEWAYS TURNED M' (ᴟ)
    "\u1D1D": 'u',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SQUAT REVERSED ESH' (ʅ)
    "\u0165": 't',
    "\u0163": 't',
    "\u1E71": 't',
    "\u021B": 't',
    "\u0236": 't',
    "\u1E97": 't',
    "\u2C66": 't',
    "\u1E6B": 't',
    "\u1E6D": 't',
    "\u01AD": 't',
    "\u1E6F": 't',
    "\u1D75": 't',
    "\u01AB": 't',
    "\u0288": 't',
    "\u0167": 't',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TAILLESS PHI' (ⱷ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TC DIGRAPH WITH CURL' (ʨ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TESH DIGRAPH' (ʧ)
    "\u1D7A": 'th',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER THORN' (þ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER THORN WITH STROKE' (ꝥ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER THORN WITH STROKE THROUGH DESCENDER' (ꝧ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TONE FIVE' (ƽ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TONE SIX' (ƅ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TONE TWO' (ƨ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TOP HALF O' (ᴖ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TRESILLO' (ꜫ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TS DIGRAPH' (ʦ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TUM' (ꝷ)
    "\u0250": 'a',
    "\u1D02": 'ae',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TURNED ALPHA' (ɒ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TURNED DELTA' (ƍ)
    "\u01DD": 'e',
    "\u1D77": 'g',
    "\u0265": 'h',
    "\u02AE": 'h',
    "\u02AF": 'h',
    "\u1D09": 'i',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TURNED INSULAR G' (ꝿ)
    "\u029E": 'k',
    "\uA781": 'l',
    "\u026F": 'm',
    "\u0270": 'm',
    "\u1D14": 'oe',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TURNED OPEN E' (ᴈ)
    "\u0279": 'r',
    "\u027B": 'r',
    "\u027A": 'r',
    "\u2C79": 'r',
    "\u0287": 't',
    "\u028C": 'v',
    "\u028D": 'w',
    "\u028E": 'y',
    "\uA729": 'tz',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER U BAR' (ʉ)
    "\xfa": 'u',
    "\u016D": 'u',
    "\u01D4": 'u',
    "\xfb": 'u',
    "\u1E77": 'u',
    "\xfc": 'u',
    "\u01D8": 'u',
    "\u01DA": 'u',
    "\u01DC": 'u',
    "\u01D6": 'u',
    "\u1E73": 'u',
    "\u1EE5": 'u',
    "\u0171": 'u',
    "\u0215": 'u',
    "\xf9": 'u',
    "\u1EE7": 'u',
    "\u01B0": 'u',
    "\u1EE9": 'u',
    "\u1EF1": 'u',
    "\u1EEB": 'u',
    "\u1EED": 'u',
    "\u1EEF": 'u',
    "\u0217": 'u',
    "\u016B": 'u',
    "\u1E7B": 'u',
    "\u0173": 'u',
    "\u1D99": 'u',
    "\u016F": 'u',
    "\u0169": 'u',
    "\u1E79": 'u',
    "\u1E75": 'u',
    "\u1D6B": 'ue',
    "\uA778": 'um',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER UPSILON' (ʊ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER UPSILON WITH STROKE' (ᵿ)
    "\u2C74": 'v',
    "\uA75F": 'v',
    "\u1E7F": 'v',
    "\u028B": 'v',
    "\u1D8C": 'v',
    "\u2C71": 'v',
    "\u1E7D": 'v',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER VEND' (ꝩ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER VISIGOTHIC Z' (ꝣ)
    "\uA761": 'vy',
    "\u1E83": 'w',
    "\u0175": 'w',
    "\u1E85": 'w',
    "\u1E87": 'w',
    "\u1E89": 'w',
    "\u1E81": 'w',
    "\u2C73": 'w',
    "\u1E98": 'w',
    "\u1E8D": 'x',
    "\u1E8B": 'x',
    "\u1D8D": 'x',
    "\xfd": 'y',
    "\u0177": 'y',
    "\xff": 'y',
    "\u1E8F": 'y',
    "\u1EF5": 'y',
    "\u1EF3": 'y',
    "\u01B4": 'y',
    "\u1EF7": 'y',
    "\u1EFF": 'y',
    "\u0233": 'y',
    "\u1E99": 'y',
    "\u024F": 'y',
    "\u1EF9": 'y',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER YOGH' (ȝ)
    "\u017A": 'z',
    "\u017E": 'z',
    "\u1E91": 'z',
    "\u0291": 'z',
    "\u2C6C": 'z',
    "\u017C": 'z',
    "\u1E93": 'z',
    "\u0225": 'z',
    "\u1E95": 'z',
    "\u1D76": 'z',
    "\u1D8E": 'z',
    "\u0290": 'z',
    "\u01B6": 'z',
    "\u0240": 'z',
    "\uFB00": 'ff',
    "\uFB03": 'ffi',
    "\uFB04": 'ffl',
    "\uFB01": 'fi',
    "\uFB02": 'fl',
    "\u0133": 'ij',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LIGATURE LONG S T' (ﬅ)
    "\u0153": 'oe',
    "\uFB06": 'st',
    "\u2090": 'a',
    "\u2091": 'e',
    "\u1D62": 'i',
    "\u2C7C": 'j',
    "\u2092": 'o',
    "\u1D63": 'r',
    // CANNOT FIND APPROXIMATION FOR 'LATIN SUBSCRIPT SMALL LETTER SCHWA' (ₔ)
    "\u1D64": 'u',
    "\u1D65": 'v',
    "\u2093": 'x' // LATIN SUBSCRIPT SMALL LETTER X
};
function latinise(str) {
    return str.replace(/[^A-Za-z0-9\[\] ]/g, (x)=>latinMap[x] || x);
}
function isLatin(str) {
    return str === latinise(str);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"40iQF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountingService", ()=>AccountingService);
parcelHelpers.export(exports, "accountingService", ()=>accountingService);
var _react = require("external/react");
var _axios = require("external/axios");
class AccountingService {
    async searchPayouts(id, searchParams) {
        const url = `/accounting/search-payouts?${(0, _react.stringifyQueryString)({
            id,
            ...searchParams
        })}`;
        return (0, _axios.get)(url);
    }
    async getPayoutDetail(id, payoutId) {
        const url = `/accounting/payout/${payoutId}?${(0, _react.stringifyQueryString)({
            id
        })}`;
        return (0, _axios.get)(url);
    }
    async exportPayouts(id, params) {
        const url = `/accounting/export-payouts?${(0, _react.stringifyQueryString)({
            id,
            ...params
        })}`;
        return (0, _axios.get)(url);
    }
}
const accountingService = new AccountingService();

},{"external/react":"1Glst","external/axios":"3m9lf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3QiGy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "default", ()=>context);
var _immutabilityHelper = require("external/immutability-helper");
var _create = require("context/create");
var _createDefault = parcelHelpers.interopDefault(_create);
var _triggers = require("./triggers");
var _triggersDefault = parcelHelpers.interopDefault(_triggers);
const id = 'Public';
const initialState = {
    offers: (0, _immutabilityHelper.createLoadableList)(),
    courseDetails: {},
    offersData: {}
};
const context = (0, _createDefault.default)(id, initialState, {
    onInit: (0, _create.initializeAndRegisterHooks)(id, (0, _triggersDefault.default), _triggers)
});

},{"external/immutability-helper":"f8t05","context/create":"iPmrn","./triggers":"3IlEu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3IlEu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hooks);
parcelHelpers.export(exports, "fetchOffers", ()=>fetchOffers);
parcelHelpers.export(exports, "fetchOfferData", ()=>fetchOfferData);
parcelHelpers.export(exports, "fetchCourseDetails", ()=>fetchCourseDetails);
var _offerService = require("services/offer.service");
var _courseService = require("services/course.service");
var _deepDiff = require("external/deep-diff");
var _lodash = require("external/lodash");
const hooks = [
    {
        paths: (0, _deepDiff.paramsHook)('pageName'),
        resolves: [
            fetchOffers
        ]
    },
    {
        paths: (0, _deepDiff.paramsHook)('pageName', 'offerId'),
        resolves: [
            fetchOfferData
        ]
    },
    {
        paths: (0, _deepDiff.paramsHook)('pageName', 'courseId'),
        resolves: [
            fetchCourseDetails
        ]
    }
];
async function fetchOffers({ update, state }) {
    const { offers: { initialized } } = state;
    if (initialized) return;
    update({
        offers: {
            $startLoading: {}
        }
    });
    const offers = await (0, _offerService.offerService).getActiveOffers();
    update({
        offers: {
            $updateLoadableList: offers.data.data
        }
    });
}
async function fetchOfferData({ update, state }) {
    const { offersData, props: { navigation, params: { offerId } } } = state;
    if (!(navigation.offer.active || navigation.offerSubjects.active || navigation.offerCourses.active)) return;
    if (!(0, _lodash.isUUID)(offerId)) return;
    if (offersData[offerId]) return;
    const subjectsResponse = await (0, _offerService.offerService).getOffersSubjectsById(offerId);
    const subjects = subjectsResponse.data.data.filter(({ active })=>active);
    const [basic, elective] = (0, _lodash.partition)(subjects, ({ id })=>id !== 'C7');
    const coursesResponse = await (0, _courseService.courseService).getCoursesForOffer(offerId);
    const courses = coursesResponse.data.data.filter(({ active })=>active);
    const data = {
        basic,
        elective,
        courses
    };
    update({
        offersData: {
            [offerId]: {
                $set: data
            }
        }
    });
}
async function fetchCourseDetails({ update, state }) {
    const { courseDetails, props: { params: { courseId } } } = state;
    if (!courseId) return;
    if (!courseDetails[courseId]) {
        const response = await (0, _courseService.courseService).getCoursesDetails(courseId);
        update({
            courseDetails: {
                [courseId]: {
                    $set: response.data.data
                }
            }
        });
    }
}

},{"services/offer.service":"luCvD","services/course.service":"lOXoY","external/deep-diff":"594sO","external/lodash":"h4nD2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lOXoY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CourseService", ()=>CourseService);
parcelHelpers.export(exports, "courseService", ()=>courseService);
var _axios = require("external/axios");
class CourseService {
    async getOffersCourses(idPrograms, idSubject, language) {
        return (0, _axios.get)(`/offer/courses/${idPrograms}/${idSubject}/${language}`);
    }
    async getCoursesForOffer(offerId) {
        return (0, _axios.get)(`/offer/courses/${offerId}`);
    }
    async getCoursesDetails(courseId) {
        return (0, _axios.get)(`/catalog/courses-detail/${courseId}`);
    }
    async getCourseBySubjectAll() {
        return (0, _axios.get)(`/catalog/coursesBySubject/all`);
    }
    async getCourseBySubjectConfiguration(offerId) {
        return (0, _axios.get)(`/catalog/coursesBySubject/configuration/${offerId}`);
    }
}
const courseService = new CourseService();

},{"external/axios":"3m9lf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j9e3M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialModals", ()=>initialModals);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "default", ()=>context);
var _create = require("context/create");
var _createDefault = parcelHelpers.interopDefault(_create);
var _triggers = require("./triggers");
var _triggersDefault = parcelHelpers.interopDefault(_triggers);
const initialModals = {
    login: {
        open: false,
        email: '',
        password: ''
    },
    reset: {
        open: false,
        email: ''
    },
    register: {
        open: false,
        id: '',
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        confirmPassword: ''
    }
};
const initialState = {
    user: JSON.parse(localStorage.getItem('user')) ?? undefined,
    modals: initialModals
};
const id = 'Auth';
const context = (0, _createDefault.default)(id, initialState, {
    onInit: (0, _create.initializeAndRegisterHooks)(id, (0, _triggersDefault.default), _triggers)
});

},{"context/create":"iPmrn","./triggers":"17NY0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"17NY0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hooks) // Data Fetches 
;
const hooks = [];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"go6YH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "default", ()=>context);
var _create = require("context/create");
var _createDefault = parcelHelpers.interopDefault(_create);
var _triggers = require("./triggers");
var _triggersDefault = parcelHelpers.interopDefault(_triggers);
var _parent = require("types/context/parent");
var _immutabilityHelper = require("external/immutability-helper");
const id = 'Parent';
const initialState = {
    homeData: {},
    userPackageDetailsProfile: false,
    userPackageDetails: (0, _immutabilityHelper.createLoadableList)(),
    userProfile: (0, _parent.clearedUserProfile),
    users: (0, _immutabilityHelper.createLoadableList)(),
    payments: (0, _immutabilityHelper.createLoadableList)(),
    paymentHistory: (0, _immutabilityHelper.createLoadableList)(),
    paymentHistorySubscription: {},
    paymentDetailIndex: false,
    changePaymentMethodIndex: false,
    supportForm: {
        name: '',
        email: '',
        id: '',
        message: ''
    },
    modals: {
        editUser: (0, _parent.clearedEditUser),
        addUser: (0, _parent.emptyUser),
        updatePassword: (0, _parent.clearedProfilePasswords),
        changePaymentMethod: (0, _parent.clearedChangePaymentMethod)
    },
    saving: {}
};
const context = (0, _createDefault.default)(id, initialState, {
    onInit: (0, _create.initializeAndRegisterHooks)(id, (0, _triggersDefault.default), _triggers)
});

},{"context/create":"iPmrn","./triggers":"i6wcq","types/context/parent":"5MNF8","external/immutability-helper":"f8t05","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i6wcq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hooks);
parcelHelpers.export(exports, "fetchHome", ()=>fetchHome);
parcelHelpers.export(exports, "fetchUsers", ()=>fetchUsers);
parcelHelpers.export(exports, "fetchUserPackageDetails", ()=>fetchUserPackageDetails);
parcelHelpers.export(exports, "fetchPayments", ()=>fetchPayments);
parcelHelpers.export(exports, "fetchPaymentHistory", ()=>fetchPaymentHistory);
parcelHelpers.export(exports, "fetchProfile", ()=>fetchProfile);
var _lodash = require("external/lodash");
var _deepDiff = require("external/deep-diff");
var _userService = require("services/user.service");
var _navigate = require("utilities/navigate");
var _packageService = require("services/package.service");
var _clientService = require("services/client.service");
var _paymentService = require("services/payment.service");
var _text = require("utilities/text");
const hooks = [
    {
        paths: (0, _deepDiff.paramsHook)('pageName'),
        resolves: [
            fetchHome
        ]
    },
    {
        paths: [
            ...(0, _deepDiff.paramsHook)('pageName', 'role', 'userId'),
            'users/refreshes/'
        ],
        resolves: fetchUsers
    },
    {
        paths: [
            ...(0, _deepDiff.paramsHook)('pageName', 'role', 'userId')
        ],
        resolves: fetchUserPackageDetails
    },
    {
        paths: [
            ...(0, _deepDiff.paramsHook)('pageName'),
            'payments/refreshes'
        ],
        resolves: fetchPayments
    },
    {
        paths: [
            ...(0, _deepDiff.paramsHook)('pageName', '?subscription'),
            'paymentHistory/refreshes'
        ],
        resolves: fetchPaymentHistory
    },
    {
        paths: [
            ...(0, _deepDiff.paramsHook)('pageName')
        ],
        resolves: fetchProfile
    }
];
async function fetchHome({ update, state }, { contexts }) {
    const id = (0, _navigate.isLoggedInAndInRoute)('home', {
        state,
        contexts
    });
    if (!(0, _lodash.isUUID)(id)) return;
    const home = await (0, _userService.userService).getHome(id);
    update({
        homeData: {
            $set: home.data
        }
    });
}
async function fetchUsers({ update, state }, { contexts }) {
    const id = (0, _navigate.isLoggedInAndInRoute)('users', {
        state,
        contexts
    });
    if (!(0, _lodash.isUUID)(id)) return;
    const { role } = state.props.params;
    const validRole = [
        'student',
        'tutor'
    ].indexOf(role) >= 0;
    if (!validRole) return;
    const response = await (0, _userService.userService).getUsersByRole(role, id, true);
    update({
        users: {
            $startLoading: {}
        }
    });
    const users = response.data.data || [];
    update({
        users: {
            $updateLoadableList: users
        }
    });
}
async function fetchUserPackageDetails({ update, state }, { contexts }) {
    const clientId = (0, _navigate.isLoggedInAndInRoute)('userPackages', {
        state,
        contexts
    });
    if (!(0, _lodash.isUUID)(clientId)) return;
    const { role, userId } = state.props.params;
    const validRole = [
        'student',
        'tutor'
    ].indexOf(role) >= 0;
    if (!validRole) return;
    if (!(0, _lodash.isUUID)(userId)) return;
    const response = await (0, _userService.userService).packages(userId, clientId);
    update({
        userPackageDetailsProfile: {
            $set: false
        },
        userPackageDetails: {
            $startLoading: {}
        }
    });
    const { packages, profile } = response.data || {
        packages: [],
        profile: {}
    };
    update({
        userPackageDetailsProfile: {
            $set: profile
        },
        userPackageDetails: {
            $updateLoadableList: packages
        }
    });
}
async function fetchPayments({ update, state }, { contexts }) {
    const clientId = (0, _navigate.isLoggedInAndInRoute)('payment', {
        state,
        contexts
    });
    if (!(0, _lodash.isUUID)(clientId)) return;
    const response = await (0, _packageService.packageService).getPackageByClientId(clientId);
    update({
        payments: {
            $startLoading: {}
        }
    });
    const payments = response.data.data || [];
    update({
        payments: {
            $updateLoadableList: payments
        }
    });
}
async function fetchPaymentHistory({ update, state }, { contexts }) {
    const clientId = (0, _navigate.isLoggedInAndInRoute)('history', {
        state,
        contexts
    });
    if (!(0, _lodash.isUUID)(clientId)) return;
    const { subscription: subscriptionId } = state.props.query;
    if ((0, _text.isEmpty)(subscriptionId)) return;
    const response = await (0, _paymentService.paymentService).getPaymentHistory(subscriptionId);
    update({
        paymentHistorySubscription: {
            $set: {}
        },
        paymentHistory: {
            $startLoading: {}
        }
    });
    const subscription = response.data.data && (0, _lodash.omit)(response.data.data, [
        'invoices'
    ]) || {};
    const payments = response.data.data && response.data.data.invoices || [];
    update({
        paymentHistorySubscription: {
            $set: subscription
        },
        paymentHistory: {
            $updateLoadableList: payments
        }
    });
}
async function fetchProfile({ update, state }, { contexts }) {
    const clientId = (0, _navigate.isLoggedInAndInRoute)('profile', {
        state,
        contexts
    });
    if (!(0, _lodash.isUUID)(clientId)) return;
    const response = await (0, _clientService.clientService).getProfile(clientId);
    const { data: { data: profile } } = response;
    update({
        userProfile: {
            $set: profile
        }
    });
}

},{"external/lodash":"h4nD2","external/deep-diff":"594sO","services/user.service":"81Nwf","utilities/navigate":"l8kUI","services/package.service":"8O0gl","services/client.service":"dQ0II","services/payment.service":"gDcUl","utilities/text":"aKcMC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dQ0II":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientService", ()=>ClientService);
parcelHelpers.export(exports, "clientService", ()=>clientService);
var _axios = require("external/axios");
class ClientService {
    async getClients() {
        return (0, _axios.get)(`/client/all`);
    }
    async getClientById(clientId) {
        return (0, _axios.get)(`/client/id/${clientId}`);
    }
    async getProfile(clientId) {
        return (0, _axios.get)(`/client/fetchProfile/${clientId}`);
    }
    async updateProfile(request) {
        return (0, _axios.post)('/client/updateProfile', request);
    }
    async updatePassword(request) {
        return (0, _axios.post)('/client/updatePassword', request);
    }
    async createClient(client) {
        return (0, _axios.post)('/client/create', client);
    }
    async updateClient(client) {
        return (0, _axios.post)('/client/update', client);
    }
}
const clientService = new ClientService();

},{"external/axios":"3m9lf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gDcUl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PaymentService", ()=>PaymentService);
parcelHelpers.export(exports, "paymentService", ()=>paymentService);
var _axios = require("external/axios");
class PaymentService {
    async completePurchase(purchaseCart) {
        return (0, _axios.post)('/payment/complete-purchase', purchaseCart);
    }
    async createSessionCheckout(response) {
        return (0, _axios.post)('/payment/create-checkout-session', response);
    }
    async getSessionRetriveById(id) {
        return (0, _axios.get)(`/payment/success/${id}`);
    }
    async cancelSubscription(request) {
        return (0, _axios.post)('/payment/cancel-subscription', request);
    }
    async reactiveSubscription(request) {
        return (0, _axios.post)('/payment/reactive-subscription', request);
    }
    async activateCanceledSubscription(request) {
        return (0, _axios.post)('/payment/activate-canceled-subscription', request);
    }
    async updatePaymentMethod(request) {
        return (0, _axios.post)('/payment/update-payment-method', request);
    }
    async getPaymentHistory(subscription_id) {
        return (0, _axios.get)(`/payment/history/${subscription_id}`);
    }
}
const paymentService = new PaymentService();

},{"external/axios":"3m9lf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5MNF8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "emptyUser", ()=>emptyUser);
parcelHelpers.export(exports, "clearedSupportForm", ()=>clearedSupportForm);
parcelHelpers.export(exports, "clearedEditUser", ()=>clearedEditUser);
parcelHelpers.export(exports, "clearedUserProfile", ()=>clearedUserProfile);
parcelHelpers.export(exports, "emptyPasswords", ()=>emptyPasswords);
parcelHelpers.export(exports, "clearedProfilePasswords", ()=>clearedProfilePasswords);
parcelHelpers.export(exports, "clearedChangePaymentMethod", ()=>clearedChangePaymentMethod);
const emptyUser = {
    id: '',
    index: -1,
    username: '',
    password: '',
    name: '',
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    packages: 0
};
const clearedSupportForm = {
    name: '',
    email: '',
    id: '',
    message: ''
};
const clearedEditUser = {
    open: false,
    user: emptyUser
};
const clearedUserProfile = {
    id: '',
    newPassword: '',
    confirmPassword: '',
    validatePassword: '',
    first_name: '',
    last_name: '',
    email: '',
    phone: ''
};
const emptyPasswords = {
    oldPassword: '',
    password: '',
    confirmPassword: ''
};
const clearedProfilePasswords = {
    open: false,
    passwords: emptyPasswords
};
const clearedChangePaymentMethod = {
    error: ''
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2UX0M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useAuth);
var _react = require("external/react");
var _authService = require("services/auth.service");
var _authContext = require("context/auth-context");
var _authContextDefault = parcelHelpers.interopDefault(_authContext);
var _enum = require("utilities/enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
function useAuth() {
    const { state, update } = (0, _react.useContext)((0, _authContextDefault.default).Context);
    const { user, modals } = state;
    const handleClose = (0, _react.useCallback)(()=>{
        const modalUpdates = Object.entries((0, _authContext.initialModals)).reduce((modalUpdates, [modal, initial])=>{
            modalUpdates[modal] = getValueUpdates(initial);
            return modalUpdates;
        }, {});
        update({
            modals: modalUpdates
        });
    }, [
        update
    ]);
    const updateModal = (0, _react.useCallback)((modal, open, values)=>{
        const valueUpdates = getValueUpdates(values);
        update({
            modals: {
                [modal]: {
                    open: {
                        $set: open
                    },
                    ...valueUpdates
                }
            }
        });
    }, [
        update
    ]);
    function showReset() {
        update({
            modals: {
                login: getValueUpdates((0, _authContext.initialModals).login),
                register: getValueUpdates((0, _authContext.initialModals).register),
                reset: {
                    open: {
                        $set: true
                    },
                    email: {
                        $set: modals.login.email
                    }
                }
            }
        });
    }
    function showRegister() {
        update({
            modals: {
                register: getValueUpdates({
                    ...(0, _authContext.initialModals).register,
                    open: true
                }),
                login: getValueUpdates((0, _authContext.initialModals).login),
                reset: getValueUpdates((0, _authContext.initialModals).reset)
            }
        });
    }
    function showLogin() {
        update({
            modals: {
                login: getValueUpdates({
                    ...(0, _authContext.initialModals).login,
                    open: true
                }),
                register: getValueUpdates((0, _authContext.initialModals).register),
                reset: getValueUpdates((0, _authContext.initialModals).reset)
            }
        });
    }
    async function login(user) {
        const response = await (0, _authService.authService).login({
            ...user
        });
        const { data, status, message } = response.data;
        if (status) throw new Error(message);
        else {
            update({
                user: {
                    $set: data
                }
            });
            localStorage.setItem('user', JSON.stringify(data));
            return data;
        }
    }
    function logout() {
        update({
            user: {
                $set: undefined
            }
        });
        localStorage.removeItem('user');
        window.location.replace('/');
    }
    const role = (0, _react.useMemo)(()=>user && (0, _enumDefault.default)('role', user.role), [
        user
    ]);
    const modalsOpen = (0, _react.useMemo)(()=>modals.login.open || modals.reset.open || modals.register.open, [
        modals.login.open,
        modals.reset.open,
        modals.register.open
    ]);
    return {
        user,
        role,
        modalsOpen,
        modals,
        handleClose,
        showReset,
        showRegister,
        showLogin,
        updateModal,
        login,
        logout,
        state,
        update
    };
}
function getValueUpdates(values = {}) {
    return Object.entries(values).reduce((updates, [prop, value])=>{
        updates[prop] = {
            $set: value
        };
        return updates;
    }, {});
}

},{"external/react":"1Glst","services/auth.service":"2kjzr","context/auth-context":"j9e3M","utilities/enum":"bEPnh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2kjzr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthService", ()=>AuthService);
parcelHelpers.export(exports, "authService", ()=>authService);
var _axios = require("external/axios");
class AuthService {
    async login(data) {
        return (0, _axios.post)('/auth/login', data);
    }
    async resetPassword(data) {
        return (0, _axios.post)('/auth/resetPassword', data);
    }
    async changePassword(data) {
        return (0, _axios.post)('/auth/changePassword', data);
    }
    async getProfileById(clientId) {
        return (0, _axios.get)(`/client/getprofile/${clientId}`);
    }
}
const authService = new AuthService();

},{"external/axios":"3m9lf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bEPnh":[function(require,module,exports,__globalThis) {
//termino
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "frequency_unit", ()=>frequency_unit);
parcelHelpers.export(exports, "category_unit", ()=>category_unit);
parcelHelpers.export(exports, "duration", ()=>duration);
parcelHelpers.export(exports, "role", ()=>role);
parcelHelpers.export(exports, "default", ()=>getName);
const frequency_unit = [
    {
        value: 'mensual',
        cod: 1645
    },
    {
        value: 'anual',
        cod: 1070
    }
];
const category_unit = [
    {
        value: 'basico',
        cod: 1
    },
    {
        value: 'premium',
        cod: 2
    },
    {
        value: 'intermedio',
        cod: 3
    }
];
const duration = [
    {
        value: 'una vez',
        cod: 'once'
    },
    {
        value: 'varios meses',
        cod: 'repeating'
    }
];
const role = {
    TUTOR: 1712,
    PARENT: 2298,
    TEACHER: 2929,
    STUDENT: 3075,
    DIRECTOR: 3936,
    HELP_DESK: 4493,
    LOGISTICS: 4892,
    ACCOUNTING: 5953,
    ADMIN_CLIENT: 7978,
    ADMIN_DREYFOUS: 11180,
    ACCOUNT_MANAGER: 12241,
    ASSITANT_CLIENT: 12388,
    ADMIN_HOMESCHOOLER: 17992
};
const enumsByName = {
    frequency_unit,
    category_unit,
    duration,
    role
};
function getName(enumName, code) {
    const targetEnum = enumsByName[enumName];
    if (!targetEnum) return undefined;
    if (Array.isArray(targetEnum)) {
        const item = targetEnum.find(({ cod })=>cod === code);
        if (item) return item.value;
    }
    const [name] = Object.entries(targetEnum).find(([_, cod])=>cod === code) || [];
    return name;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6SPYe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>IconProfile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _hook = require("context/auth-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _hook1 = require("context/payment-context/hook");
var _hookDefault1 = parcelHelpers.interopDefault(_hook1);
function IconProfile(props) {
    const { path = 'home' } = props;
    const { logout: logOut, user } = (0, _hookDefault.default)();
    const { dettachCart } = (0, _hookDefault1.default)();
    const email = (0, _react.useMemo)(()=>user ? user.email : '', [
        user
    ]);
    function handleLogout() {
        dettachCart();
        logOut();
    }
    return (0, _jsxRuntime.jsx)("li", {
        className: 'nav-item mr-1',
        children: (0, _jsxRuntime.jsxs)((0, _react.Dropdown), {
            className: 'ml-1',
            children: [
                (0, _jsxRuntime.jsx)((0, _react.Dropdown).Toggle, {
                    variant: 'light',
                    id: 'dropdown-basic',
                    children: (0, _jsxRuntime.jsxs)("span", {
                        children: [
                            (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                name: "faCircleUser",
                                className: 'img--user'
                            }),
                            email
                        ]
                    })
                }),
                (0, _jsxRuntime.jsxs)((0, _react.Dropdown).Menu, {
                    children: [
                        (0, _jsxRuntime.jsx)((0, _react.Dropdown).Item, {
                            href: `/${path}/profile`,
                            children: (0, _jsxRuntime.jsxs)("span", {
                                children: [
                                    (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                        name: "faUser"
                                    }),
                                    " Perfil"
                                ]
                            })
                        }),
                        (0, _jsxRuntime.jsx)((0, _react.Dropdown).Divider, {}),
                        (0, _jsxRuntime.jsx)((0, _react.Dropdown).Item, {
                            onClick: handleLogout,
                            children: (0, _jsxRuntime.jsxs)("span", {
                                children: [
                                    (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                        name: "faRightFromBracket"
                                    }),
                                    " Salir"
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/fortawesome":"7JvBl","context/auth-context/hook":"2UX0M","context/payment-context/hook":"h0PVX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h0PVX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePayment);
var _moment = require("external/moment");
var _immutabilityHelper = require("external/immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _react = require("external/react");
var _enum = require("utilities/enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _cartService = require("services/cart.service");
var _paymentContext = require("context/payment-context");
var _paymentContextDefault = parcelHelpers.interopDefault(_paymentContext);
var _course = require("types/course");
function usePayment() {
    const { state, update } = (0, _react.useContext)((0, _paymentContextDefault.default).Context);
    const { offersSummaryList: { initialized: initializedOffers, items: offers }, cart, props: { params } } = state;
    const { properties: { offer: offerId, basic, elective, workbooks } } = cart;
    const coursesInCart = (0, _react.useMemo)(()=>{
        const filterCart = (cart = [])=>cart.map((id, cartIndex)=>({
                    id,
                    cartIndex
                })).filter(({ id })=>id);
        return filterCart(basic).concat(filterCart(elective));
    }, [
        basic,
        elective
    ]);
    const basicCoursesInCart = (0, _react.useMemo)(()=>{
        const selectedCourses = (cart.properties.basic || []).filter((id)=>id);
        return selectedCourses;
    }, [
        cart.properties
    ]);
    async function dettachCart() {
        localStorage.removeItem('cartId');
    }
    async function updateCart(type, index, id, action) {
        const value = action === 'delete' ? false : id;
        const properties = type === 'basic' || type === 'elective' ? (0, _immutabilityHelperDefault.default)(state.cart.properties, {
            offer: {
                $set: params.offerId
            },
            [type]: {
                [index]: {
                    $set: value
                }
            },
            [`${type}Extra`]: {
                [index]: {
                    $set: false
                }
            }
        }) : (0, _immutabilityHelperDefault.default)(state.cart.properties, {
            offer: {
                $set: params.offerId
            },
            [type]: {
                [index]: {
                    $set: value
                }
            }
        });
        const updatedCart = await (0, _cartService.cartService).saveCart({
            ...state.cart,
            properties
        });
        update({
            cart: {
                properties: {
                    $set: updatedCart.data.properties
                }
            }
        });
        return updatedCart;
    }
    async function toggleWorkbook(id, value) {
        const properties = (0, _immutabilityHelperDefault.default)(state.cart.properties, {
            workbooks: {
                [id]: {
                    $set: value
                }
            }
        });
        update({
            cart: {
                properties: {
                    $set: properties
                }
            }
        });
        return (0, _cartService.cartService).saveCart({
            ...state.cart,
            properties
        });
    }
    async function emptyCart() {
        const defaultCart = (length)=>Array(length).fill(false);
        const properties = (0, _immutabilityHelperDefault.default)(state.cart.properties, {
            workbooks: {
                $set: {}
            },
            basic: {
                $set: defaultCart(5)
            },
            basicExtra: {
                $set: defaultCart(5)
            },
            elective: {
                $set: defaultCart(3)
            },
            electiveExtra: {
                $set: defaultCart(3)
            },
            offer: {
                $set: undefined
            }
        });
        update({
            cart: {
                properties: {
                    $set: properties
                }
            }
        });
        return (0, _cartService.cartService).saveCart({
            ...state.cart,
            properties
        });
    }
    const [selectedBasic, selectedElective] = (0, _react.useMemo)(()=>{
        const { basic, elective } = state.cart.properties;
        return [
            basic || [],
            elective || []
        ];
    }, [
        state.cart.properties
    ]);
    /*
    const offerCourses = useMemo(() => {
        if (!isUUID(params.offerId)) return []
        return state.offerCourses[params.offerId] || []
    }, [params.offerId, state.offerCourses])
    */ const [packageItem, packageStatus] = (0, _react.useMemo)(()=>{
        if (initializedOffers) {
            const offer = offers.find(({ id })=>id === offerId);
            if (!offer) return [
                undefined,
                {
                    notFound: true,
                    missingCourses: false,
                    coursesCount: 0
                }
            ];
            const findCourse = (id)=>offer.courses.find(({ course })=>id === course) || {};
            const courses = coursesInCart.map(({ id, cartIndex })=>({
                    cartIndex,
                    ...findCourse(id)
                })).map((course)=>({
                    cartIndex: course.cartIndex,
                    courseId: course.course,
                    courseName: course.name_course,
                    extraCourse: findCourse(course.id === 'C7' ? cart.properties.electiveExtra[course.cartIndex] : cart.properties.basicExtra[course.cartIndex]),
                    subjectName: course.name[course.language] || '',
                    subjectId: course.id,
                    offerId,
                    quantity: 1,
                    language: course.language,
                    workbookPrice: course.workbook_price,
                    workbook: course.workbook,
                    type: course.id === 'C7' ? 'elective' : course.licenseType,
                    cartIndex: course.cartIndex,
                    grade: course.grade,
                    gradeName: course.gradeName[course.language] || ''
                }));
            courses.sort((a, b)=>a.courseId.localeCompare(b.courseId));
            const [workbooksCount, workbooksAmount] = courses.reduce((totals, { courseId, workbook, workbookPrice })=>{
                if (workbook && workbooks[courseId]) {
                    totals[0] = totals[0] + 1;
                    totals[1] = totals[1] + Number(workbookPrice);
                }
                return totals;
            }, [
                0,
                0
            ]);
            const price = Number(offer.price.slice(1));
            const subTotal = price + workbooksAmount;
            const discounted = offer.discount && (0, _moment.moment)().isBetween((0, _moment.moment)(offer.promotion.discount_start_date), (0, _moment.moment)(offer.promotion.discount_end_date));
            const discountAmountText = offer.promotion.discount_type === 'percent' ? `${offer.promotion.discount_amount}%` : `$ ${offer.promotion.discount_amount}`;
            const paymentTotal = discounted ? offer.promotion.discount_type === 'percent' ? subTotal * (1 - parseFloat(offer.promotion.discount_amount) / 100) : subTotal - Number(offer.promotion.discount_amount) : subTotal;
            const packageItem = {
                offerId,
                offerName: offer.name,
                price,
                subTotal,
                courses,
                frequency: (0, _enumDefault.default)('frequency_unit', offer.frequency_unit),
                workbooksCount,
                workbooksAmount,
                discounted,
                discountAmountText,
                paymentTotal
            };
            const missingCoursesCount = courses.filter(({ id, type })=>type === 'basic').length;
            const missingCourses = missingCoursesCount < 5;
            return [
                packageItem,
                {
                    notFound: false,
                    missingCourses,
                    coursesCount: courses.length
                }
            ];
        }
        return [
            undefined,
            {
                notFound: false,
                missingCourses: false,
                coursesCount: 0
            }
        ];
    }, [
        initializedOffers,
        offerId,
        coursesInCart,
        offers,
        workbooks,
        cart.properties
    ]);
    const [packages, hasPackages] = (0, _react.useMemo)(()=>{
        const packages = (state.cart.properties.basic || []).concat(state.cart.properties.elective || []).filter((id)=>id);
        const hasPackages = packages.length > 0;
        return [
            packages,
            hasPackages
        ];
    }, [
        state.cart.properties
    ]);
    return {
        basic,
        elective,
        packageItem,
        packageStatus,
        packages,
        hasPackages,
        cart: state.cart,
        offers: state.offers,
        update,
        updateCart,
        emptyCart,
        toggleWorkbook,
        dettachCart,
        selectedBasic,
        selectedElective,
        offerCourses: [],
        courseInDetails: [],
        basicCoursesInCart
    };
}

},{"external/moment":"fMWlp","external/immutability-helper":"f8t05","external/react":"1Glst","utilities/enum":"bEPnh","services/cart.service":"khvXM","context/payment-context":"83C2r","types/course":"iQVac","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cipmm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ShoppingCart);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("external/clsx");
var _lodash = require("external/lodash");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _hook = require("context/payment-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
function ShoppingCart(props) {
    const { className } = props;
    const { packageStatus, packageItem } = (0, _hookDefault.default)();
    const { offerId } = (0, _react.useParams)();
    const { pathname } = (0, _react.useLocation)();
    const hidden = (0, _react.useMemo)(()=>{
        if (packageStatus.coursesCount === 0) return true;
        if (packageStatus.notFound) return true;
        if (pathname === '/summary') return true;
        if ((0, _lodash.isUUID)(offerId)) return true;
        return false;
    }, [
        pathname,
        packageStatus,
        offerId
    ]);
    const to = (0, _react.useMemo)(()=>{
        return packageStatus.missingCourses && packageItem ? `/offers/${packageItem.offerId}` : '/summary';
    }, [
        packageItem,
        packageStatus
    ]);
    return (0, _jsxRuntime.jsx)("li", {
        className: (0, _clsx.clsx)(className, {
            'd-none': hidden
        }),
        children: (0, _jsxRuntime.jsxs)((0, _react.Link), {
            to: to,
            className: 'cart',
            children: [
                (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                    name: "faShoppingCart",
                    style: {
                        width: '1.4rem',
                        height: '1.4rem'
                    }
                }),
                (0, _jsxRuntime.jsx)("span", {
                    "data-action": 'cart-can',
                    className: 'badge rounded-circle'
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","external/clsx":"012R0","external/lodash":"h4nD2","external/react":"1Glst","external/fortawesome":"7JvBl","context/payment-context/hook":"h0PVX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"012R0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>(0, _clsxDefault.default));
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);

},{"clsx":"d2NWs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fxeDC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PublicLayoutModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/auth-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _loginForm = require("./LoginForm");
var _loginFormDefault = parcelHelpers.interopDefault(_loginForm);
var _registerForm = require("./RegisterForm");
var _registerFormDefault = parcelHelpers.interopDefault(_registerForm);
var _resetPasswordForm = require("./ResetPasswordForm");
var _resetPasswordFormDefault = parcelHelpers.interopDefault(_resetPasswordForm);
var _formLayout = require("./FormLayout");
var _formLayoutDefault = parcelHelpers.interopDefault(_formLayout);
function PublicLayoutModal() {
    const { modalsOpen, handleClose, modals } = (0, _hookDefault.default)();
    const Form = (0, _react.useMemo)(()=>{
        if (modals.login.open) return 0, _loginFormDefault.default;
        if (modals.register.open) return 0, _registerFormDefault.default;
        if (modals.reset.open) return 0, _resetPasswordFormDefault.default;
        return undefined;
    }, [
        modals
    ]);
    return (0, _jsxRuntime.jsxs)((0, _react.Modal), {
        show: modalsOpen,
        onHide: handleClose,
        size: 'xl',
        centered: true,
        contentClassName: 'modal__height',
        children: [
            (0, _jsxRuntime.jsx)((0, _react.Modal).Header, {
                closeButton: true,
                style: {
                    borderBottom: 'none'
                }
            }),
            (0, _jsxRuntime.jsx)((0, _react.Modal).Body, {
                className: 'd-flex',
                children: (0, _jsxRuntime.jsx)((0, _formLayoutDefault.default), {
                    children: Form && (0, _jsxRuntime.jsx)(Form, {})
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/auth-context/hook":"2UX0M","./LoginForm":"fgjZk","./RegisterForm":"oBAh9","./ResetPasswordForm":"dker2","./FormLayout":"01DTO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fgjZk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LoginForm);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("external/clsx");
var _react = require("external/react");
var _enum = require("utilities/enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _hook = require("context/auth-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _formValidation = require("utilities/form-validation");
var _formValidationDefault = parcelHelpers.interopDefault(_formValidation);
var _formTextfield = require("components/FormTextfield");
var _formTextfieldDefault = parcelHelpers.interopDefault(_formTextfield);
var _notify = require("components/Notify");
const { createEmailValidation, createRequiredFieldValidation } = (0, _formValidation.validators);
const loginValidations = {
    email: [
        createRequiredFieldValidation('email'),
        createEmailValidation('email')
    ],
    password: [
        createRequiredFieldValidation('password')
    ]
};
function LoginForm() {
    const { modals: { login: user }, login, showReset, showRegister, update } = (0, _hookDefault.default)();
    const [errors, validate] = (0, _formValidationDefault.default)(loginValidations);
    function createFieldProps(placeholder, fieldName, maxLength) {
        return {
            placeholder,
            maxLength,
            fieldName,
            error: errors[fieldName],
            submitted: errors.submitted,
            onChange: (e)=>{
                update({
                    modals: {
                        login: {
                            [fieldName]: {
                                $set: e.target.value.trim()
                            }
                        }
                    }
                });
            }
        };
    }
    (0, _react.useEffect)(()=>{
        validate(user, false);
    }, [
        user
    ]);
    async function loginHandler() {
        if (!validate(user, true)) return;
        try {
            const data = await login(user);
            const role = (0, _enumDefault.default)('role', data.role);
            switch(role){
                case 'PARENT':
                    if (window.location.pathname === '/summary') window.location.reload();
                    else window.location.replace('/home');
                    break;
                case 'ADMIN_HOMESCHOOLER':
                    window.location.replace('/admin');
                    break;
                case 'ACCOUNTING':
                    window.location.replace('/accounting');
                    break;
                default:
                    break;
            }
        } catch (err) {
            err && err['message'] && (0, _notify.notifyError)(err['message']);
        }
    }
    return (0, _jsxRuntime.jsxs)("form", {
        autoComplete: 'on',
        children: [
            (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                value: user.email,
                ...createFieldProps('Correo', 'email'),
                controlProps: {
                    autoComplete: 'username'
                }
            }),
            (0, _jsxRuntime.jsx)((0, _formTextfield.PasswordField), {
                value: user.password,
                ...createFieldProps("Contrase\xf1a", 'password'),
                controlProps: {
                    autoComplete: 'current-password',
                    onKeyUp: (e)=>{
                        if (e.code === 'Enter') loginHandler();
                    }
                }
            }),
            (0, _jsxRuntime.jsx)("div", {
                className: (0, _clsx.clsx)('form-group', 'd-flex', 'justify-content-end'),
                children: (0, _jsxRuntime.jsx)("a", {
                    className: 'actions_reset_password',
                    href: '/',
                    onClick: (e)=>{
                        e.preventDefault();
                        showReset();
                    },
                    children: "Reiniciar contrase\u00F1a"
                })
            }),
            (0, _jsxRuntime.jsxs)("div", {
                className: 'actions_login mt-3',
                children: [
                    (0, _jsxRuntime.jsx)((0, _react.Button), {
                        variant: 'primary',
                        onClick: loginHandler,
                        children: "Log In"
                    }),
                    (0, _jsxRuntime.jsx)((0, _react.Button), {
                        className: 'mt-2',
                        variant: 'light',
                        onClick: ()=>showRegister(),
                        children: "Registrar"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/clsx":"012R0","external/react":"1Glst","utilities/enum":"bEPnh","context/auth-context/hook":"2UX0M","utilities/form-validation":"1fpQO","components/FormTextfield":"6jQpP","components/Notify":"gZyef","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1fpQO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _hookDefault.default));
parcelHelpers.export(exports, "errorText", ()=>(0, _errorTextDefault.default));
parcelHelpers.export(exports, "validators", ()=>_validators);
var _hook = require("./hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _errorText = require("./error-text");
var _errorTextDefault = parcelHelpers.interopDefault(_errorText);
var _validators = require("./validators");

},{"./hook":"jTrct","./error-text":"gC1yg","./validators":"jQctS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jTrct":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useFormValidation);
var _react = require("external/react");
var _immutabilityHelper = require("external/immutability-helper");
function useFormValidation(validationMap) {
    const errorsTemplate = Object.keys(validationMap).reduce((errors, field)=>{
        errors[field] = false;
        return errors;
    }, {
        notEmpty: false,
        submitted: false
    });
    const { state, update } = (0, _immutabilityHelper.useImmutableState)(errorsTemplate);
    const errors = state;
    const validations = (0, _react.useMemo)(()=>Object.entries(validationMap), [
        validationMap
    ]);
    function validate(state, submitted) {
        let isValid = true;
        const errorUpdates = validations.reduce((errorUpdates, [fieldName, fieldValidations])=>{
            let isFieldValid = true;
            for (const validation of fieldValidations){
                const [field, validationResult] = validation(state);
                if (validationResult !== false) {
                    isValid = false;
                    isFieldValid = false;
                    if (errorUpdates[field]) {
                        if (!Array.isArray(errorUpdates[field].$set)) errorUpdates[field].$set = [
                            errorUpdates[field].$set
                        ];
                        errorUpdates[field].$set.push(validationResult);
                    } else errorUpdates[field] = {
                        $set: validationResult
                    };
                }
            }
            if (isFieldValid) errorUpdates[fieldName] = {
                $set: false
            };
            return errorUpdates;
        }, {
            submitted: {
                $apply: (current)=>current || submitted === true
            }
        });
        if (!isValid) errorUpdates.notEmpty = {
            $set: !isValid
        };
        update(errorUpdates);
        return isValid;
    }
    function reset() {
        update({
            $shallow: errorsTemplate
        });
    }
    return [
        errors,
        validate,
        reset
    ];
}

},{"external/react":"1Glst","external/immutability-helper":"f8t05","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gC1yg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>errorText);
const displayErrorText = {
    REQUIRED_FIELD: 'Campo requerido',
    VALID_EMAIL: "Ingrese un correo electr\xf3nico v\xe1lido",
    VALID_PHONE: "Ingrese un n\xfamero de tel\xe9fono v\xe1lido",
    PASSWORD_NOT_MATCH: "Las contrase\xf1as no coinciden",
    USED_EMAIL: "Correo electr\xf3nico en uso"
};
function errorText(error) {
    return displayErrorText[error] || error;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jQctS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createRegexValidation", ()=>createRegexValidation);
parcelHelpers.export(exports, "createPhoneValidation", ()=>createPhoneValidation);
parcelHelpers.export(exports, "createEmailValidation", ()=>createEmailValidation);
parcelHelpers.export(exports, "createRequiredFieldValidation", ()=>createRequiredFieldValidation);
parcelHelpers.export(exports, "createPasswordMatchValidation", ()=>createPasswordMatchValidation);
parcelHelpers.export(exports, "blacklistValidation", ()=>blacklistValidation);
parcelHelpers.export(exports, "createConditionallyRequiredFieldValidation", ()=>createConditionallyRequiredFieldValidation);
parcelHelpers.export(exports, "createStrongPaswordValidation", ()=>createStrongPaswordValidation);
var _errorText = require("./error-text");
var _errorTextDefault = parcelHelpers.interopDefault(_errorText);
function createRegexValidation(fieldName, errorName, pattern, negated) {
    return (state)=>[
            fieldName,
            pattern.test(state[fieldName]) !== negated && (0, _errorTextDefault.default)(errorName)
        ];
}
function createPhoneValidation(fieldName) {
    const phonePattern = /^\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/i;
    return createRegexValidation(fieldName, 'VALID_PHONE', phonePattern, true);
}
function createEmailValidation(fieldName) {
    const emailPattern = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
    return createRegexValidation(fieldName, 'VALID_EMAIL', emailPattern, true);
}
function isEmpty(str) {
    return !str || 0 === str.length;
}
function createRequiredFieldValidation(fieldName) {
    return (state)=>[
            fieldName,
            isEmpty(state[fieldName]) && (0, _errorTextDefault.default)('REQUIRED_FIELD')
        ];
}
function createPasswordMatchValidation(passwordField, confirmationField) {
    return (state)=>[
            passwordField,
            state[passwordField] !== state[confirmationField] && (0, _errorTextDefault.default)('PASSWORD_NOT_MATCH')
        ];
}
function blacklistValidation(fieldName, blacklist, errorName) {
    return (state)=>{
        return [
            fieldName,
            blacklist.length > 0 && blacklist.indexOf(state[fieldName]) >= 0 && (0, _errorTextDefault.default)(errorName)
        ];
    };
}
function createConditionallyRequiredFieldValidation(fieldName, cond) {
    return (state)=>[
            fieldName,
            (cond(state) ? isEmpty(state[fieldName]) : false) && (0, _errorTextDefault.default)('REQUIRED_FIELD')
        ];
}
function createStrongPaswordValidation(passwordField) {
    return (state)=>{
        const password = typeof state[passwordField] == 'string' ? state[passwordField] : '';
        const errors = [];
        if (password.length < 8) errors.push("La longitud de la contrase\xf1a debe ser igual o mayor a 8 caracteres.");
        if (!/[a-zA-Z]/.test(password) || !/\d/.test(password)) errors.push("La contrase\xf1a debe incluir letras y n\xfameros.");
        if (!/[a-z]/.test(password) || !/[A-Z]/.test(password)) errors.push("La contrase\xf1a debe combinar letras may\xfasculas y min\xfasculas.");
        if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) errors.push("La contrase\xf1a debe incluir caracteres especiales.");
        return [
            passwordField,
            errors.length > 0 && errors
        ];
    };
}

},{"./error-text":"gC1yg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6jQpP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FormTextfield);
parcelHelpers.export(exports, "PasswordField", ()=>PasswordField);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("external/clsx");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
function FormTextfield(props) {
    const { fieldName, error, type = 'text', defaultValue, value, placeholder, onChange, maxLength = 255, className, children, submitted, controlProps } = props;
    const errorType = (0, _react.useMemo)(()=>Array.isArray(error) ? 'multiple' : error && 'simple', [
        error
    ]);
    const errorClass = (0, _react.useMemo)(()=>errorType === 'simple' && submitted ? 'visible' : 'd-none', [
        errorType,
        submitted
    ]);
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsxs)("div", {
                className: (0, _clsx.clsx)('form-group', 'mt-2', 'mb-1', className),
                children: [
                    (0, _jsxRuntime.jsx)((0, _react.Form).Control, {
                        type: type,
                        defaultValue: defaultValue,
                        value: value,
                        placeholder: placeholder,
                        name: fieldName,
                        onChange: onChange,
                        maxLength: maxLength,
                        ...controlProps
                    }),
                    children
                ]
            }),
            errorType !== 'multiple' && (0, _jsxRuntime.jsx)("small", {
                className: (0, _clsx.clsx)('text-danger', errorClass),
                children: error || '&nbsp;'
            }),
            submitted && errorType === 'multiple' && error.length > 0 && (0, _jsxRuntime.jsx)("div", {
                children: (0, _jsxRuntime.jsx)("ul", {
                    className: 'text-danger',
                    style: {
                        fontSize: '12px',
                        margin: 'auto'
                    },
                    children: error.map((text, key)=>(0, _jsxRuntime.jsx)("li", {
                            children: text
                        }, key))
                })
            })
        ]
    });
}
function PasswordField(props) {
    const [clear, setClear] = (0, _react.useState)(false);
    const [type, icon] = (0, _react.useMemo)(()=>clear ? [
            'text',
            'faEyeSlash'
        ] : [
            'password',
            'faEye'
        ], [
        clear
    ]);
    return (0, _jsxRuntime.jsx)(FormTextfield, {
        ...props,
        type: type,
        className: (0, _clsx.clsx)('input-icon-wrapper', props.className),
        children: (0, _jsxRuntime.jsx)("div", {
            className: 'icon-container',
            onClick: ()=>setClear(!clear),
            children: (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                name: icon
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","external/clsx":"012R0","external/react":"1Glst","external/fortawesome":"7JvBl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gZyef":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "notifySuccess", ()=>notifySuccess);
parcelHelpers.export(exports, "notifyWarning", ()=>notifyWarning);
parcelHelpers.export(exports, "notifyError", ()=>notifyError);
parcelHelpers.export(exports, "showConfirmDialog", ()=>showConfirmDialog);
parcelHelpers.export(exports, "showConfirmCancelSubscription", ()=>showConfirmCancelSubscription);
parcelHelpers.export(exports, "alert", ()=>alert);
var _react = require("external/react");
var _text = require("utilities/text");
const notifySuccess = (message)=>{
    (0, _react.toast).success(message, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored"
    });
};
const notifyWarning = (message)=>{
    (0, _react.toast).warning(message, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored"
    });
};
const notifyError = (message)=>{
    (0, _react.toast).error(message, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored"
    });
};
function showConfirmDialog(text, options) {
    const dialogOptions = {
        title: '',
        text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1797D0',
        cancelButtonColor: '#e9e9e9',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        ...options || {}
    };
    return (0, _react.Swal).fire(dialogOptions);
}
function showConfirmCancelSubscription(subscriptionEnds) {
    const title = `<h3>\xbfEst\xe1s seguro de que deseas cancelar tu suscripci\xf3n?</h3>`;
    const text = `Perder\xe1s acceso a los beneficios a partir del <b>${(0, _text.convertDateToText)(subscriptionEnds, true)}.</b>`;
    const html = `Perder\xe1s acceso a los beneficios a partir del <b>${(0, _text.convertDateToText)(subscriptionEnds, true)}.</b>`;
    return showConfirmDialog(text, {
        title,
        html,
        cancelButtonText: 'No cancelar',
        confirmButtonText: 'Continuar'
    });
}
const alert = async ()=>{
    return (0, _react.Swal).fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
    }).then((result)=>{
        if (result.isConfirmed) (0, _react.Swal).fire({
            title: 'Deleted!',
            text: 'Your file has been deleted.',
            icon: 'success'
        });
    });
};

},{"external/react":"1Glst","utilities/text":"aKcMC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"oBAh9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RegisterForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _clientService = require("services/client.service");
var _formValidation = require("utilities/form-validation");
var _formValidationDefault = parcelHelpers.interopDefault(_formValidation);
var _formTextfield = require("components/FormTextfield");
var _formTextfieldDefault = parcelHelpers.interopDefault(_formTextfield);
var _notify = require("components/Notify");
var _hook = require("context/auth-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const { blacklistValidation, createEmailValidation, createPasswordMatchValidation, createRequiredFieldValidation, createStrongPaswordValidation } = (0, _formValidation.validators);
const triedEmails = [];
const registerValidations = {
    first_name: [
        createRequiredFieldValidation('first_name')
    ],
    last_name: [
        createRequiredFieldValidation('last_name')
    ],
    email: [
        createRequiredFieldValidation('email'),
        createEmailValidation('email'),
        blacklistValidation('email', triedEmails, (0, _formValidation.errorText)('USED_EMAIL'))
    ],
    password: [
        createRequiredFieldValidation('password'),
        createStrongPaswordValidation('password')
    ],
    confirmPassword: [
        createRequiredFieldValidation('confirmPassword'),
        createPasswordMatchValidation('confirmPassword', 'password')
    ]
};
function RegisterForm() {
    const { update, showLogin, modals: { register: user } } = (0, _hookDefault.default)();
    const [errors, validate] = (0, _formValidationDefault.default)(registerValidations);
    async function registerHandler(e) {
        e.preventDefault();
        if (!validate(user, true)) return;
        const response = await (0, _clientService.clientService).createClient(user);
        if (response.data.statusResponse.success) {
            (0, _notify.notifySuccess)(response.data.statusResponse.message);
            showLogin();
        } else {
            triedEmails.push(user.email);
            (0, _notify.notifyError)(response.data.statusResponse.message);
            validate(user, true);
        }
    }
    function createFieldProps(placeholder, fieldName, maxLength) {
        return {
            placeholder,
            maxLength,
            fieldName,
            value: user[fieldName],
            submitted: errors.submitted,
            error: errors[fieldName],
            onChange: (e)=>{
                update({
                    modals: {
                        register: {
                            [fieldName]: {
                                $set: e.target.value.trim()
                            }
                        }
                    }
                });
            }
        };
    }
    (0, _react.useEffect)(()=>{
        validate(user);
    }, [
        user
    ]);
    return (0, _jsxRuntime.jsxs)("form", {
        autoComplete: 'on',
        children: [
            (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                controlProps: {
                    autoComplete: 'firstname'
                },
                ...createFieldProps('Nombre', 'first_name', 25)
            }),
            (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                controlProps: {
                    autoComplete: 'lastname'
                },
                ...createFieldProps('Apellido', 'last_name', 25)
            }),
            (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                controlProps: {
                    autoComplete: 'email'
                },
                ...createFieldProps('Correo', 'email')
            }),
            (0, _jsxRuntime.jsx)((0, _formTextfield.PasswordField), {
                controlProps: {
                    autoComplete: 'new-password'
                },
                ...createFieldProps("Contrase\xf1a", 'password')
            }),
            (0, _jsxRuntime.jsx)((0, _formTextfield.PasswordField), {
                controlProps: {
                    autoComplete: 'new-password'
                },
                ...createFieldProps("Confirmar contrase\xf1a", 'confirmPassword')
            }),
            (0, _jsxRuntime.jsxs)("div", {
                className: 'actions_login mt-3',
                children: [
                    (0, _jsxRuntime.jsx)((0, _react.Button), {
                        variant: 'primary',
                        onClick: registerHandler,
                        children: "Registrar"
                    }),
                    (0, _jsxRuntime.jsx)((0, _react.Button), {
                        variant: 'light',
                        onClick: ()=>showLogin(),
                        children: "Iniciar Sesion"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","services/client.service":"dQ0II","utilities/form-validation":"1fpQO","components/FormTextfield":"6jQpP","components/Notify":"gZyef","context/auth-context/hook":"2UX0M","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dker2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ResetForm);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("external/immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _react = require("external/react");
var _authService = require("services/auth.service");
var _formValidation = require("utilities/form-validation");
var _formValidationDefault = parcelHelpers.interopDefault(_formValidation);
var _notify = require("components/Notify");
var _formTextfield = require("components/FormTextfield");
var _formTextfieldDefault = parcelHelpers.interopDefault(_formTextfield);
var _hook = require("context/auth-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const { createEmailValidation, createRequiredFieldValidation, createPasswordMatchValidation, createStrongPaswordValidation } = (0, _formValidation.validators);
const resetValidations = {
    email: [
        createRequiredFieldValidation('email'),
        createEmailValidation('email')
    ]
};
const changeValidations = {
    code: [
        createRequiredFieldValidation('code')
    ],
    password: [
        createRequiredFieldValidation('password'),
        createStrongPaswordValidation('password')
    ],
    confirmPassword: [
        createRequiredFieldValidation('confirmPassword'),
        createPasswordMatchValidation('confirmPassword', 'password')
    ]
};
function ResetForm() {
    const { modals, showLogin } = (0, _hookDefault.default)();
    const [resetState, setResetState] = (0, _react.useState)({
        email: '',
        codeSent: false
    });
    const [changeState, setChangeState] = (0, _react.useState)({
        code: '',
        password: '',
        confirmPassword: ''
    });
    const [resetErrors, validateReset] = (0, _formValidationDefault.default)(resetValidations);
    const [changeErrors, validateChange] = (0, _formValidationDefault.default)(changeValidations);
    function createFieldProps(placeholder, fieldName, maxLength) {
        return {
            placeholder,
            maxLength,
            fieldName,
            defaultValue: resetState[fieldName],
            error: resetErrors[fieldName],
            submitted: resetErrors.submitted,
            onChange: (e)=>{
                setResetState((0, _immutabilityHelperDefault.default)(resetState, {
                    [fieldName]: {
                        $set: e.target.value.trim()
                    }
                }));
            }
        };
    }
    function createChangeFieldProps(placeholder, fieldName, maxLength) {
        return {
            placeholder,
            maxLength,
            fieldName,
            error: changeErrors[fieldName],
            submitted: changeErrors.submitted,
            onChange: (e)=>{
                setChangeState((0, _immutabilityHelperDefault.default)(changeState, {
                    [fieldName]: {
                        $set: e.target.value.trim()
                    }
                }));
            }
        };
    }
    (0, _react.useEffect)(()=>{
        validateReset(resetState, false);
    }, [
        resetState
    ]);
    (0, _react.useEffect)(()=>{
        validateChange(changeState, false);
    }, [
        changeState
    ]);
    (0, _react.useEffect)(()=>{
        setResetState((0, _immutabilityHelperDefault.default)(resetState, {
            email: {
                $set: modals.reset.email
            }
        }));
    }, [
        modals.reset
    ]);
    async function resetHandler() {
        if (!validateReset(resetState, true)) return;
        const response = await (0, _authService.authService).resetPassword({
            email: resetState.email
        });
        const { statusResponse: { error, message } } = response.data;
        if (error) (0, _notify.notifyError)(message);
        else {
            (0, _notify.notifySuccess)(message);
            setResetState((0, _immutabilityHelperDefault.default)(resetState, {
                codeSent: {
                    $set: true
                }
            }));
        }
    }
    async function changePasswordHandler() {
        if (!validateChange(changeState, true)) return;
        const response = await (0, _authService.authService).changePassword({
            email: resetState.email,
            code: changeState.code,
            password: changeState.password
        });
        const { success, message } = response.data;
        if (success) {
            (0, _notify.notifySuccess)(message);
            showLogin();
        } else (0, _notify.notifyError)(message);
    }
    return (0, _jsxRuntime.jsxs)("form", {
        autoComplete: 'on',
        children: [
            !resetState.codeSent && (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                        ...createFieldProps('Correo', 'email')
                    }),
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'actions_reset mt-3',
                        children: (0, _jsxRuntime.jsx)((0, _react.Button), {
                            variant: 'primary',
                            onClick: resetHandler,
                            children: "Enviar c\u00F3digo"
                        })
                    })
                ]
            }),
            resetState.codeSent && (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                        ...createChangeFieldProps("C\xf3digo", 'code')
                    }),
                    (0, _jsxRuntime.jsx)((0, _formTextfield.PasswordField), {
                        ...createChangeFieldProps("Contrase\xf1a", 'password')
                    }),
                    (0, _jsxRuntime.jsx)((0, _formTextfield.PasswordField), {
                        ...createChangeFieldProps("Confirmar contrase\xf1a", 'confirmPassword')
                    }),
                    (0, _jsxRuntime.jsxs)("div", {
                        className: 'actions_login mt-3',
                        children: [
                            (0, _jsxRuntime.jsx)((0, _react.Button), {
                                variant: 'primary',
                                onClick: changePasswordHandler,
                                children: "Cambiar contrase\u00F1a"
                            }),
                            (0, _jsxRuntime.jsx)((0, _react.Button), {
                                variant: 'secondary',
                                onClick: ()=>setResetState((0, _immutabilityHelperDefault.default)(resetState, {
                                        codeSent: {
                                            $set: false
                                        }
                                    })),
                                children: "Reenviar c\u00F3digo"
                            }),
                            (0, _jsxRuntime.jsx)((0, _react.Button), {
                                variant: 'light',
                                onClick: ()=>showLogin(),
                                children: "Iniciar Sesion"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/immutability-helper":"f8t05","external/react":"1Glst","services/auth.service":"2kjzr","utilities/form-validation":"1fpQO","components/Notify":"gZyef","components/FormTextfield":"6jQpP","context/auth-context/hook":"2UX0M","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"01DTO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FormLayout);
var _jsxRuntime = require("react/jsx-runtime");
var _assetImage = require("./AssetImage");
var _assetImageDefault = parcelHelpers.interopDefault(_assetImage);
const FormLayout = (props)=>{
    const { children } = props;
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsx)((0, _assetImageDefault.default), {
                className: 'imageContentCloud',
                src: 'login/cloud.png',
                alt: 'Illustration Cloud'
            }),
            (0, _jsxRuntime.jsx)("div", {
                className: 'contentLeft',
                children: (0, _jsxRuntime.jsx)((0, _assetImageDefault.default), {
                    className: 'contentLeftImage',
                    src: 'illustrations/information.png',
                    alt: 'Illustration Information'
                })
            }),
            (0, _jsxRuntime.jsxs)("div", {
                className: 'contentRight',
                children: [
                    (0, _jsxRuntime.jsx)((0, _assetImageDefault.default), {
                        className: 'contentRightLogo',
                        src: 'login/dreyfous.png',
                        alt: 'Dreyfous'
                    }),
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'contentForm',
                        children: children
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","./AssetImage":"ecVS5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ecVS5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssetImage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _index = require("resources/assets/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
const AssetImage = (props)=>{
    const { containerProps = {}, className, alt, imageProps = {}, imageClass = 'fill' } = props;
    const src = (0, _indexDefault.default)(`/${props.src}`);
    return (0, _jsxRuntime.jsx)("div", {
        ...containerProps,
        className: className,
        children: (0, _jsxRuntime.jsx)((0, _react.Image), {
            ...imageProps,
            src: src,
            alt: alt,
            className: imageClass
        })
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","resources/assets/index":"fdOi5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fdOi5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getImage);
var _pngJpg = require("url:./**/*.{png,jpg}");
var _pngJpgDefault = parcelHelpers.interopDefault(_pngJpg);
const splitFileName = /^(.*)\/(.*?)$/;
const imageMap = aggregatePaths((0, _pngJpgDefault.default), '', {});
function aggregatePaths(root, path, result) {
    switch(typeof root){
        case 'string':
            const pathKey = path.replace(splitFileName, '$1.$2');
            result[pathKey] = root;
            break;
        case 'object':
            Object.entries(root).forEach(([name, value])=>aggregatePaths(value, `${path}/${name}`, result));
            break;
    }
    return result;
}
function getImage(path, defaultPath) {
    const url = imageMap[path] || imageMap[defaultPath];
    switch(typeof url){
        case 'string':
            return url;
        default:
            throw new Error(`${path} ${defaultPath ? `or ${defaultPath} ` : ''}could not be found`);
    }
}

},{"url:./**/*.{png,jpg}":"guvnO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"guvnO":[function(require,module,exports,__globalThis) {
const _temp0 = require("8f8b186da05bd4d1");
const _temp1 = require("3f96623d7671c799");
const _temp2 = require("4fa851c9666a882");
const _temp3 = require("92e67bd0b9992905");
const _temp4 = require("7dadbe0ada5320db");
const _temp5 = require("a2bca85338d731c7");
const _temp6 = require("7148d712d28a3f8f");
const _temp7 = require("a2991807a7c3b30");
const _temp8 = require("b664522a0110e952");
const _temp9 = require("b78d80b312286357");
const _temp10 = require("c07133ce99233650");
const _temp11 = require("98e5f455588d87a7");
const _temp12 = require("8f356728a6d2a74d");
const _temp13 = require("c2173100871a00ce");
const _temp14 = require("29f7ee7cb2f67baa");
const _temp15 = require("2d5a29ef73277d2f");
const _temp16 = require("298a624a44c6356d");
const _temp17 = require("13effcfe0b18b3ab");
const _temp18 = require("78ac9e2673e4863a");
const _temp19 = require("c98d418bad8d39a4");
const _temp20 = require("2b74c89181cd9476");
const _temp21 = require("11ad7e6b267ad2c8");
const _temp22 = require("309dd558f915131");
const _temp23 = require("47ccb0979a609a");
const _temp24 = require("33461abb4a08b937");
const _temp25 = require("11071ae7f0883dc5");
const _temp26 = require("3bcfab84915f147a");
const _temp27 = require("195bc5d97cd2da6a");
const _temp28 = require("2c0e365181054ada");
const _temp29 = require("66e29d1b5c4df65d");
const _temp30 = require("5a65fd9e3443f0d1");
const _temp31 = require("c65aa948e1c56f29");
const _temp32 = require("c09f160ec2010b75");
const _temp33 = require("1e8e652081da806a");
const _temp34 = require("c1cafeb3c7843f7c");
const _temp35 = require("baab0ad8385bddb5");
module.exports = {
    "illustrations": {
        "default-cover": {
            "jpg": _temp0
        },
        "full-cloud": {
            "png": _temp1
        },
        "information": {
            "png": _temp2
        }
    },
    "login": {
        "cloud": {
            "png": _temp3
        },
        "dreyfous": {
            "png": _temp4
        }
    },
    "logos": {
        "dreyfous": {
            "png": _temp5
        },
        "edusystem": {
            "png": _temp6
        },
        "facebook": {
            "png": _temp7
        },
        "instagram": {
            "png": _temp8
        },
        "logodry": {
            "png": _temp9
        },
        "twitter": {
            "png": _temp10
        },
        "youtube": {
            "png": _temp11
        }
    },
    "payment-method": {
        "9": {
            "png": _temp12
        },
        "10": {
            "png": _temp13
        },
        "11": {
            "png": _temp14
        },
        "13": {
            "png": _temp15
        },
        "15": {
            "png": _temp16
        },
        "17": {
            "png": _temp17
        },
        "18": {
            "png": _temp18
        },
        "19": {
            "png": _temp19
        },
        "20": {
            "png": _temp20
        },
        "21": {
            "png": _temp21
        },
        "23": {
            "png": _temp22
        },
        "amazon": {
            "png": _temp23
        },
        "amex": {
            "png": _temp24
        },
        "default": {
            "png": _temp25
        },
        "diners": {
            "png": _temp26
        },
        "discover": {
            "png": _temp27
        },
        "jcb": {
            "png": _temp28
        },
        "maestro": {
            "png": _temp29
        },
        "mastercard": {
            "png": _temp30
        },
        "paypal": {
            "png": _temp31
        },
        "skrill": {
            "png": _temp32
        },
        "visa": {
            "png": _temp33
        },
        "westerunion": {
            "png": _temp34
        },
        "worlpay": {
            "png": _temp35
        }
    }
};

},{"8f8b186da05bd4d1":"gQPGy","3f96623d7671c799":"jbRtL","4fa851c9666a882":"aDpvd","92e67bd0b9992905":"4U6BC","7dadbe0ada5320db":"C9OkA","a2bca85338d731c7":"jW23l","7148d712d28a3f8f":"lanaW","a2991807a7c3b30":"aldHH","b664522a0110e952":"2ASX4","b78d80b312286357":"zxX0r","c07133ce99233650":"ibuTY","98e5f455588d87a7":"lg9r4","8f356728a6d2a74d":"je7kp","c2173100871a00ce":"dRYXq","29f7ee7cb2f67baa":"aDk0h","2d5a29ef73277d2f":"diMbN","298a624a44c6356d":"4w01W","13effcfe0b18b3ab":"bf7aq","78ac9e2673e4863a":"4c81J","c98d418bad8d39a4":"kDTGq","2b74c89181cd9476":"1uKCU","11ad7e6b267ad2c8":"gDuHh","309dd558f915131":"4iG15","47ccb0979a609a":"6jMb2","33461abb4a08b937":"114HG","11071ae7f0883dc5":"9zulH","3bcfab84915f147a":"lGPbv","195bc5d97cd2da6a":"lyodn","2c0e365181054ada":"27qPH","66e29d1b5c4df65d":"3EVms","5a65fd9e3443f0d1":"1w5iy","c65aa948e1c56f29":"lkXlw","c09f160ec2010b75":"g49Wk","1e8e652081da806a":"11Oxj","c1cafeb3c7843f7c":"i9lsQ","baab0ad8385bddb5":"gOLT1"}],"gQPGy":[function(require,module,exports,__globalThis) {
module.exports = require("c48d2b3c4c30e3ed").getBundleURL('eZsNI') + "default-cover.639b9f08.jpg";

},{"c48d2b3c4c30e3ed":"a2ypy"}],"jbRtL":[function(require,module,exports,__globalThis) {
module.exports = require("49b1c23abf697578").getBundleURL('eZsNI') + "full-cloud.4926cd43.png";

},{"49b1c23abf697578":"a2ypy"}],"aDpvd":[function(require,module,exports,__globalThis) {
module.exports = require("d967582a46ed1295").getBundleURL('eZsNI') + "information.47157bfb.png";

},{"d967582a46ed1295":"a2ypy"}],"4U6BC":[function(require,module,exports,__globalThis) {
module.exports = require("74b704a43f70010f").getBundleURL('eZsNI') + "cloud.5532fdb2.png";

},{"74b704a43f70010f":"a2ypy"}],"C9OkA":[function(require,module,exports,__globalThis) {
module.exports = require("ef37417115fd55bd").getBundleURL('eZsNI') + "dreyfous.3b6e8040.png";

},{"ef37417115fd55bd":"a2ypy"}],"jW23l":[function(require,module,exports,__globalThis) {
module.exports = require("4b39e6f380c684ed").getBundleURL('eZsNI') + "dreyfous.cf832047.png";

},{"4b39e6f380c684ed":"a2ypy"}],"lanaW":[function(require,module,exports,__globalThis) {
module.exports = require("40e62731c8cb13ab").getBundleURL('eZsNI') + "edusystem.b44b181b.png";

},{"40e62731c8cb13ab":"a2ypy"}],"aldHH":[function(require,module,exports,__globalThis) {
module.exports = require("a3215e4dae8d2d03").getBundleURL('eZsNI') + "facebook.24c567aa.png";

},{"a3215e4dae8d2d03":"a2ypy"}],"2ASX4":[function(require,module,exports,__globalThis) {
module.exports = require("14284085d6efe83b").getBundleURL('eZsNI') + "instagram.466c0244.png";

},{"14284085d6efe83b":"a2ypy"}],"zxX0r":[function(require,module,exports,__globalThis) {
module.exports = require("bf62f50db09778df").getBundleURL('eZsNI') + "logodry.a929e431.png";

},{"bf62f50db09778df":"a2ypy"}],"ibuTY":[function(require,module,exports,__globalThis) {
module.exports = require("99c5fe6eb8c79def").getBundleURL('eZsNI') + "twitter.ce90a851.png";

},{"99c5fe6eb8c79def":"a2ypy"}],"lg9r4":[function(require,module,exports,__globalThis) {
module.exports = require("4f3b0068e686f56").getBundleURL('eZsNI') + "youtube.8317297a.png";

},{"4f3b0068e686f56":"a2ypy"}],"je7kp":[function(require,module,exports,__globalThis) {
module.exports = require("983ea8a429920e95").getBundleURL('eZsNI') + "9.dd4ea5ca.png";

},{"983ea8a429920e95":"a2ypy"}],"dRYXq":[function(require,module,exports,__globalThis) {
module.exports = require("839e62f476966cd4").getBundleURL('eZsNI') + "10.463d3f1c.png";

},{"839e62f476966cd4":"a2ypy"}],"aDk0h":[function(require,module,exports,__globalThis) {
module.exports = require("54f9a1b8eb79ac9e").getBundleURL('eZsNI') + "11.0686b384.png";

},{"54f9a1b8eb79ac9e":"a2ypy"}],"diMbN":[function(require,module,exports,__globalThis) {
module.exports = require("338fe5af1c85d953").getBundleURL('eZsNI') + "13.5227b783.png";

},{"338fe5af1c85d953":"a2ypy"}],"4w01W":[function(require,module,exports,__globalThis) {
module.exports = require("b454e596a615e1b4").getBundleURL('eZsNI') + "15.73ab16a8.png";

},{"b454e596a615e1b4":"a2ypy"}],"bf7aq":[function(require,module,exports,__globalThis) {
module.exports = require("8f8ec1dfef03dbe7").getBundleURL('eZsNI') + "17.ae198b2f.png";

},{"8f8ec1dfef03dbe7":"a2ypy"}],"4c81J":[function(require,module,exports,__globalThis) {
module.exports = require("4c0228a8ad5568f").getBundleURL('eZsNI') + "18.0942d5b1.png";

},{"4c0228a8ad5568f":"a2ypy"}],"kDTGq":[function(require,module,exports,__globalThis) {
module.exports = require("d75744e58ac4a166").getBundleURL('eZsNI') + "19.45dd38e9.png";

},{"d75744e58ac4a166":"a2ypy"}],"1uKCU":[function(require,module,exports,__globalThis) {
module.exports = require("e7b5221e58de6a2f").getBundleURL('eZsNI') + "20.0fdf34fe.png";

},{"e7b5221e58de6a2f":"a2ypy"}],"gDuHh":[function(require,module,exports,__globalThis) {
module.exports = require("b16bb370d777c917").getBundleURL('eZsNI') + "21.5f2123d1.png";

},{"b16bb370d777c917":"a2ypy"}],"4iG15":[function(require,module,exports,__globalThis) {
module.exports = require("7d1c38b9766e5855").getBundleURL('eZsNI') + "23.6355f364.png";

},{"7d1c38b9766e5855":"a2ypy"}],"6jMb2":[function(require,module,exports,__globalThis) {
module.exports = require("aacf7da504c75c95").getBundleURL('eZsNI') + "amazon.e03d8aa1.png";

},{"aacf7da504c75c95":"a2ypy"}],"114HG":[function(require,module,exports,__globalThis) {
module.exports = require("190127b91bcb4f").getBundleURL('eZsNI') + "amex.58ffc81b.png";

},{"190127b91bcb4f":"a2ypy"}],"9zulH":[function(require,module,exports,__globalThis) {
module.exports = require("9fd6fb5e51d737c6").getBundleURL('eZsNI') + "default.0f9f8e6b.png";

},{"9fd6fb5e51d737c6":"a2ypy"}],"lGPbv":[function(require,module,exports,__globalThis) {
module.exports = require("30809575fb4be3ff").getBundleURL('eZsNI') + "diners.8c175fc1.png";

},{"30809575fb4be3ff":"a2ypy"}],"lyodn":[function(require,module,exports,__globalThis) {
module.exports = require("ae1d243fbf3a0c3").getBundleURL('eZsNI') + "discover.100d93af.png";

},{"ae1d243fbf3a0c3":"a2ypy"}],"27qPH":[function(require,module,exports,__globalThis) {
module.exports = require("17d9b444856f93d5").getBundleURL('eZsNI') + "jcb.a33c4daa.png";

},{"17d9b444856f93d5":"a2ypy"}],"3EVms":[function(require,module,exports,__globalThis) {
module.exports = require("426a9142baaeec54").getBundleURL('eZsNI') + "maestro.88bc6e46.png";

},{"426a9142baaeec54":"a2ypy"}],"1w5iy":[function(require,module,exports,__globalThis) {
module.exports = require("d6b415662d0153bc").getBundleURL('eZsNI') + "mastercard.025dbb2b.png";

},{"d6b415662d0153bc":"a2ypy"}],"lkXlw":[function(require,module,exports,__globalThis) {
module.exports = require("e42bb02288f0b74c").getBundleURL('eZsNI') + "paypal.43d67671.png";

},{"e42bb02288f0b74c":"a2ypy"}],"g49Wk":[function(require,module,exports,__globalThis) {
module.exports = require("af519a411f4d5877").getBundleURL('eZsNI') + "skrill.01ca4556.png";

},{"af519a411f4d5877":"a2ypy"}],"11Oxj":[function(require,module,exports,__globalThis) {
module.exports = require("72667ab48e76d06d").getBundleURL('eZsNI') + "visa.73b8ee7e.png";

},{"72667ab48e76d06d":"a2ypy"}],"i9lsQ":[function(require,module,exports,__globalThis) {
module.exports = require("b3a7b55ecf82d20f").getBundleURL('eZsNI') + "westerunion.f3e63f2f.png";

},{"b3a7b55ecf82d20f":"a2ypy"}],"gOLT1":[function(require,module,exports,__globalThis) {
module.exports = require("68c2c365cf08c759").getBundleURL('eZsNI') + "worlpay.0cb47f2b.png";

},{"68c2c365cf08c759":"a2ypy"}],"4MKBu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("external/clsx");
var _hook = require("context/auth-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const LoginButton = ()=>{
    const { showLogin, role } = (0, _hookDefault.default)();
    return (0, _jsxRuntime.jsx)("li", {
        className: (0, _clsx.clsx)('nav-item', 'me-4', {
            'd-none': !!role
        }),
        children: (0, _jsxRuntime.jsx)("button", {
            className: 'btn btn-purple',
            onClick: ()=>showLogin(),
            children: "Login"
        })
    });
};
exports.default = LoginButton;

},{"react/jsx-runtime":"1dlk8","external/clsx":"012R0","context/auth-context/hook":"2UX0M","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4XYmV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _clsx = require("external/clsx");
var _hook = require("context/public-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _hook1 = require("context/payment-context/hook");
var _hookDefault1 = parcelHelpers.interopDefault(_hook1);
const ContinueButton = ()=>{
    const { basicCoursesInCart } = (0, _hookDefault1.default)();
    const { navigation } = (0, _hookDefault.default)();
    const [hide, disabled, to] = (0, _react.useMemo)(()=>{
        const disabled = basicCoursesInCart.length < 5 ? true : undefined;
        const hide = navigation.offers.active || navigation.summary.active;
        const to = navigation.summary.link();
        return [
            hide,
            disabled,
            to
        ];
    }, [
        navigation,
        basicCoursesInCart
    ]);
    return (0, _jsxRuntime.jsx)("li", {
        className: (0, _clsx.clsx)('nav-item', 'me-4', {
            'd-none': hide
        }),
        children: (0, _jsxRuntime.jsx)((0, _react.Button), {
            disabled: disabled,
            className: 'btn btn-purple',
            href: to,
            children: "Continuar"
        })
    });
};
exports.default = ContinueButton;

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/clsx":"012R0","context/public-context/hook":"ccqgY","context/payment-context/hook":"h0PVX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ccqgY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePublic);
var _react = require("external/react");
var _publicContext = require("context/public-context");
var _publicContextDefault = parcelHelpers.interopDefault(_publicContext);
function usePublic() {
    const { state, update } = (0, _react.useContext)((0, _publicContextDefault.default).Context);
    const { props: { navigation, params, query }, offers: { loading: loadingOffers, items: offers }, offersData } = state;
    const offerData = (0, _react.useMemo)(()=>offersData[params.offerId] || {}, [
        params.offerId,
        offersData
    ]);
    const courseInDetails = (0, _react.useMemo)(()=>params.courseId && state.courseDetails[params.courseId] ? state.courseDetails[params.courseId] : {}, [
        params.courseId,
        state.courseDetails
    ]);
    return {
        state,
        navigation,
        params,
        query,
        loadingOffers,
        offers,
        offerData,
        offersData,
        courseInDetails,
        update
    };
}

},{"external/react":"1Glst","context/public-context":"3QiGy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1vpiP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("external/clsx");
var _react = require("external/react");
const CancelButton = ()=>{
    const location = (0, _react.useLocation)();
    const [hide, label] = (0, _react.useMemo)(()=>{
        if ([
            '/',
            '/offers'
        ].indexOf(location.pathname) >= 0) return [
            true,
            ''
        ];
        return [
            false,
            location.pathname === '/summary' ? 'Salir' : 'Cancelar'
        ];
    }, [
        location.pathname
    ]);
    return (0, _jsxRuntime.jsx)("li", {
        className: (0, _clsx.clsx)('nav-item', 'me-4', {
            'd-none': hide
        }),
        children: (0, _jsxRuntime.jsx)((0, _react.Link), {
            className: 'btn btn-outline-purple',
            to: '/',
            children: label
        })
    });
};
exports.default = CancelButton;

},{"react/jsx-runtime":"1dlk8","external/clsx":"012R0","external/react":"1Glst","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8XFfs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Adminmenu);
var _jsxRuntime = require("react/jsx-runtime");
var _menu = require("./Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
function Adminmenu() {
    return (0, _jsxRuntime.jsx)((0, _menuDefault.default), {
        items: [
            [
                '/admin/offers',
                'faBox',
                'Ofertas'
            ],
            [
                '/admin/clients',
                'faUsers',
                'Clientes'
            ],
            [
                '/admin/transactions',
                'faHandHoldingDollar',
                'Transacciones'
            ]
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","./Menu":"baGSI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"baGSI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Menu);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _menuItem = require("./MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
const Menu = (props)=>{
    const { label = "Men\xfa", items } = props;
    return (0, _jsxRuntime.jsx)("li", {
        className: 'nav-item me-4',
        children: (0, _jsxRuntime.jsxs)((0, _react.Dropdown), {
            children: [
                (0, _jsxRuntime.jsxs)((0, _react.Dropdown).Toggle, {
                    variant: 'light',
                    id: 'dropdown-basic',
                    children: [
                        " ",
                        label,
                        " "
                    ]
                }),
                (0, _jsxRuntime.jsx)((0, _react.Dropdown).Menu, {
                    children: items.map(([to, icon, label], index)=>(0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                            to: to,
                            icon: icon,
                            label: label
                        }, index))
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","./MenuItem":"80kAK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"80kAK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MenuItem);
var _jsxRuntime = require("react/jsx-runtime");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _react = require("external/react");
const MenuItem = (props)=>{
    const { icon, label, to } = props;
    return (0, _jsxRuntime.jsx)((0, _react.Dropdown).Item, {
        as: (0, _react.Link),
        to: to,
        children: (0, _jsxRuntime.jsxs)("span", {
            children: [
                (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                    style: {
                        width: '17px'
                    },
                    name: icon
                }),
                " ",
                label
            ]
        })
    });
};

},{"react/jsx-runtime":"1dlk8","external/fortawesome":"7JvBl","external/react":"1Glst","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1JoP7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ParentMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _menu = require("./Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
function ParentMenu() {
    return (0, _jsxRuntime.jsx)((0, _menuDefault.default), {
        items: [
            [
                '/home',
                'faHouse',
                'Home'
            ],
            [
                '/home/packages',
                'faBox',
                'Paquetes'
            ],
            [
                '/home/users/student',
                'faUsers',
                'Usuarios'
            ],
            [
                '/home/payment',
                'faHandHoldingDollar',
                'Pagos'
            ],
            [
                '/home/support',
                'faHeadset',
                'Apoyo'
            ]
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","./Menu":"baGSI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"12ePZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AccountingMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _menu = require("./Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
function AccountingMenu() {
    return (0, _jsxRuntime.jsx)((0, _menuDefault.default), {
        items: [
            [
                '/accounting/payouts',
                'faDollar',
                'Pagos'
            ]
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","./Menu":"baGSI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"QPS7J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/auth-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _iconProfile = require("components/IconProfile");
var _iconProfileDefault = parcelHelpers.interopDefault(_iconProfile);
var _adminMenu = require("layout/Menus/AdminMenu");
var _adminMenuDefault = parcelHelpers.interopDefault(_adminMenu);
var _index = require("context/index");
const AdminLayout = ()=>{
    const { user } = (0, _hookDefault.default)();
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsxs)("div", {
                className: 'navbar navbar-light navbar-expand justify-content-between bg-white shadow header--navbar sticky-top',
                children: [
                    (0, _jsxRuntime.jsx)("span", {
                        className: 'navbar-brand',
                        children: (0, _jsxRuntime.jsx)((0, _react.Link), {
                            to: '/admin',
                            className: 'navbar-brand fw-bold',
                            style: {
                                color: '#42C3DB'
                            },
                            children: "EduSystem"
                        })
                    }),
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'navbar-collapse principal-menu',
                        style: {
                            justifyContent: 'flex-end'
                        },
                        id: 'navbar-collapse',
                        children: (0, _jsxRuntime.jsxs)("ul", {
                            className: 'nav navbar-nav ml-auto',
                            children: [
                                (0, _jsxRuntime.jsx)((0, _adminMenuDefault.default), {}),
                                (0, _jsxRuntime.jsx)((0, _iconProfileDefault.default), {
                                    path: 'admin'
                                })
                            ]
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _react.Outlet), {})
        ]
    });
};
exports.default = (0, _index.withContext)(AdminLayout, 'admin');

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/auth-context/hook":"2UX0M","components/IconProfile":"6SPYe","layout/Menus/AdminMenu":"8XFfs","context/index":"VKWtn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cm0bI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/auth-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _iconProfile = require("components/IconProfile");
var _iconProfileDefault = parcelHelpers.interopDefault(_iconProfile);
var _parentMenu = require("layout/Menus/ParentMenu");
var _parentMenuDefault = parcelHelpers.interopDefault(_parentMenu);
var _index = require("context/index");
const ParentLayout = ()=>{
    const { user } = (0, _hookDefault.default)();
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsxs)("div", {
                className: 'navbar navbar-light navbar-expand justify-content-between bg-white shadow header--navbar sticky-top',
                children: [
                    (0, _jsxRuntime.jsx)("span", {
                        className: 'navbar-brand',
                        children: (0, _jsxRuntime.jsx)((0, _react.Link), {
                            to: '/home',
                            className: 'navbar-brand fw-bold',
                            style: {
                                color: '#42C3DB'
                            },
                            children: "EduSystem"
                        })
                    }),
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'navbar-collapse principal-menu',
                        style: {
                            justifyContent: 'flex-end'
                        },
                        id: 'navbar-collapse',
                        children: (0, _jsxRuntime.jsxs)("ul", {
                            className: 'nav navbar-nav ml-auto',
                            children: [
                                (0, _jsxRuntime.jsxs)("div", {
                                    className: 'navbar-text mr-3',
                                    children: [
                                        (0, _jsxRuntime.jsx)("span", {
                                            className: 'fw-bold align-middle',
                                            children: "Dominio:"
                                        }),
                                        (0, _jsxRuntime.jsx)("span", {
                                            className: 'align-middle pl-2',
                                            children: user.domain
                                        })
                                    ]
                                }),
                                (0, _jsxRuntime.jsx)((0, _parentMenuDefault.default), {}),
                                (0, _jsxRuntime.jsx)("li", {
                                    className: 'nav-item mr-4',
                                    children: (0, _jsxRuntime.jsx)((0, _react.Button), {
                                        className: 'btn btn-purple ml-1',
                                        href: '/offers',
                                        children: "Comprar"
                                    })
                                }),
                                (0, _jsxRuntime.jsx)((0, _iconProfileDefault.default), {})
                            ]
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _react.Outlet), {})
        ]
    });
};
exports.default = (0, _index.withContext)(ParentLayout, 'parent');

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/auth-context/hook":"2UX0M","components/IconProfile":"6SPYe","layout/Menus/ParentMenu":"1JoP7","context/index":"VKWtn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7pJwb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _iconProfile = require("components/IconProfile");
var _iconProfileDefault = parcelHelpers.interopDefault(_iconProfile);
var _accountingMenu = require("layout/Menus/AccountingMenu");
var _accountingMenuDefault = parcelHelpers.interopDefault(_accountingMenu);
var _index = require("context/index");
const AccountingLayout = ()=>{
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsxs)("div", {
                className: 'navbar navbar-light navbar-expand justify-content-between bg-white shadow header--navbar sticky-top',
                children: [
                    (0, _jsxRuntime.jsx)("span", {
                        className: 'navbar-brand',
                        children: (0, _jsxRuntime.jsx)((0, _react.Link), {
                            to: '/acoounting',
                            className: 'navbar-brand fw-bold',
                            style: {
                                color: '#42C3DB'
                            },
                            children: "EduSystem"
                        })
                    }),
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'navbar-collapse principal-menu',
                        style: {
                            justifyContent: 'flex-end'
                        },
                        id: 'navbar-collapse',
                        children: (0, _jsxRuntime.jsxs)("ul", {
                            className: 'nav navbar-nav ml-auto',
                            children: [
                                (0, _jsxRuntime.jsx)((0, _accountingMenuDefault.default), {}),
                                (0, _jsxRuntime.jsx)((0, _iconProfileDefault.default), {
                                    path: 'accounting'
                                })
                            ]
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _react.Outlet), {})
        ]
    });
};
exports.default = (0, _index.withContext)(AccountingLayout, 'accounting');

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","components/IconProfile":"6SPYe","layout/Menus/AccountingMenu":"12ePZ","context/index":"VKWtn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ajHca":[function(require,module,exports,__globalThis) {
// Pages Without Layout
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Page", ()=>Page);
parcelHelpers.export(exports, "AdminPage", ()=>AdminPage);
parcelHelpers.export(exports, "AccountingPage", ()=>AccountingPage);
var _success = require("pages/success");
var _successDefault = parcelHelpers.interopDefault(_success);
// Public Pages
var _offer = require("pages/offers/offer");
var _offerDefault = parcelHelpers.interopDefault(_offer);
var _offerList = require("pages/offers/offer-list");
var _offerListDefault = parcelHelpers.interopDefault(_offerList);
var _subjects = require("pages/subjects");
var _subjectsDefault = parcelHelpers.interopDefault(_subjects);
var _courses = require("pages/courses");
var _coursesDefault = parcelHelpers.interopDefault(_courses);
var _courseDetail = require("pages/course-detail");
var _courseDetailDefault = parcelHelpers.interopDefault(_courseDetail);
var _summary = require("pages/summary");
var _summaryDefault = parcelHelpers.interopDefault(_summary);
// Parent Pages
var _dashboard = require("pages/home/dashboard");
var _dashboardDefault = parcelHelpers.interopDefault(_dashboard);
var _support = require("pages/home/support");
var _supportDefault = parcelHelpers.interopDefault(_support);
var _packageList = require("pages/home/packages/package-list");
var _packageListDefault = parcelHelpers.interopDefault(_packageList);
var _package = require("pages/home/packages/package");
var _packageDefault = parcelHelpers.interopDefault(_package);
var _users = require("./home/users");
var _usersDefault = parcelHelpers.interopDefault(_users);
var _newUser = require("./home/users/NewUser");
var _newUserDefault = parcelHelpers.interopDefault(_newUser);
var _payment = require("./home/payment");
var _paymentDefault = parcelHelpers.interopDefault(_payment);
var _history = require("./home/payment/history");
var _historyDefault = parcelHelpers.interopDefault(_history);
var _profile = require("./home/profile");
var _profileDefault = parcelHelpers.interopDefault(_profile);
var _packages = require("./home/users/Packages");
var _packagesDefault = parcelHelpers.interopDefault(_packages);
var _containers = require("layout/containers");
// AdminPages
var _dashboard1 = require("pages/admin/dashboard");
var _dashboardDefault1 = parcelHelpers.interopDefault(_dashboard1);
var _offers = require("./admin/offers");
var _offersDefault = parcelHelpers.interopDefault(_offers);
var _configuration = require("./admin/offers/Configuration");
var _configurationDefault = parcelHelpers.interopDefault(_configuration);
var _clients = require("./admin/clients");
var _clientsDefault = parcelHelpers.interopDefault(_clients);
var _client = require("./admin/client");
var _clientDefault = parcelHelpers.interopDefault(_client);
// AccountingPages
//
var _dashboard2 = require("pages/accounting/dashboard");
var _dashboardDefault2 = parcelHelpers.interopDefault(_dashboard2);
var _payouts = require("pages/accounting/payouts");
var _payoutsDefault = parcelHelpers.interopDefault(_payouts);
var _payout = require("pages/accounting/payout");
var _payoutDefault = parcelHelpers.interopDefault(_payout);
const pages = {
    Offer: (0, _offerDefault.default),
    Offers: (0, _offerListDefault.default),
    Subjects: (0, _subjectsDefault.default),
    Courses: (0, _coursesDefault.default),
    CourseDetail: (0, _courseDetailDefault.default),
    Summary: (0, _summaryDefault.default),
    Success: (0, _successDefault.default),
    Profile: (0, _containers.wrapParentContainer)('Profile', (0, _profileDefault.default)),
    Home: (0, _containers.wrapParentContainer)('Home', (0, _dashboardDefault.default)),
    Support: (0, _containers.wrapParentContainer)('Home', (0, _supportDefault.default)),
    Packages: (0, _containers.wrapParentContainer)('Home', (0, _packageListDefault.default)),
    Package: (0, _containers.wrapParentContainer)('Package', (0, _packageDefault.default)),
    Users: (0, _containers.wrapParentContainer)('Users', (0, _usersDefault.default)),
    NewUser: (0, _containers.wrapParentContainer)('NewUser', (0, _newUserDefault.default)),
    UserPackages: (0, _containers.wrapParentContainer)('UserPackage', (0, _packagesDefault.default)),
    Payment: (0, _containers.wrapParentContainer)('Payment', (0, _paymentDefault.default)),
    PaymentHistory: (0, _containers.wrapParentContainer)('PaymentHistory', (0, _historyDefault.default))
};
const adminPages = {
    Home: (0, _containers.wrapAdminContainer)('Home', (0, _dashboardDefault1.default)),
    Offers: (0, _containers.wrapAdminContainer)('Offers', (0, _offersDefault.default)),
    OfferConfiguration: (0, _containers.wrapAdminContainer)('OfferConfiguration', (0, _configurationDefault.default)),
    Clients: (0, _containers.wrapAdminContainer)('Clients', (0, _clientsDefault.default)),
    Client: (0, _containers.wrapAdminContainer)('Client', (0, _clientDefault.default))
};
const accountingPages = {
    Home: (0, _containers.wrapAccountingContainer)('Home', (0, _dashboardDefault2.default)),
    Payouts: (0, _containers.wrapAccountingContainer)('Payouts', (0, _payoutsDefault.default)),
    Payout: (0, _containers.wrapAccountingContainer)('Payout', (0, _payoutDefault.default)),
    Clients: (0, _containers.wrapAdminContainer)('Clients', (0, _clientsDefault.default)),
    Client: (0, _containers.wrapAdminContainer)('Client', (0, _clientDefault.default))
};
function Page(name) {
    return pages[name];
}
function AdminPage(name) {
    return adminPages[name];
}
function AccountingPage(name) {
    return accountingPages[name];
}

},{"pages/success":"5YPRO","pages/offers/offer":"lfwof","pages/offers/offer-list":"bxd4D","pages/subjects":"jeqky","pages/courses":"7Wxlc","pages/course-detail":"67dhD","pages/summary":"jwpF6","pages/home/dashboard":"dvu5P","pages/home/support":"1HXXH","pages/home/packages/package-list":"f3jvn","pages/home/packages/package":"1TgX6","./home/users":"9Msrx","./home/users/NewUser":"81ZJd","./home/payment":"38HKR","./home/payment/history":"ev6ez","./home/profile":"hdz4X","./home/users/Packages":"c5UL9","layout/containers":"dcFYX","pages/admin/dashboard":"gOPkE","./admin/offers":"jWMG5","./admin/offers/Configuration":"kaCXR","./admin/clients":"3jcAT","./admin/client":"ckXRJ","pages/accounting/dashboard":"cfVeb","pages/accounting/payouts":"ez0xu","pages/accounting/payout":"50J7d","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5YPRO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SuccessPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _text = require("utilities/text");
var _paymentService = require("services/payment.service");
const SuccessPage = ()=>{
    const [params] = (0, _react.useSearchParams)();
    const getSessionRetriveById = async (session_id)=>{
        const response = await (0, _paymentService.paymentService).getSessionRetriveById(session_id);
        if (response.data.data.payment_status === 'paid') localStorage.removeItem('packages');
    };
    (0, _react.useEffect)(()=>{
        const session_id = params.get('session_id');
        if (!(0, _text.isEmpty)(session_id)) getSessionRetriveById(session_id);
    }, [
        params
    ]);
    return (0, _jsxRuntime.jsx)("div", {
        style: {
            textAlign: 'center',
            display: 'flex',
            height: '100vh'
        },
        children: (0, _jsxRuntime.jsx)("div", {
            className: 'card',
            style: {
                margin: 'auto'
            },
            children: (0, _jsxRuntime.jsxs)("div", {
                className: 'card-body',
                children: [
                    (0, _jsxRuntime.jsx)("span", {
                        style: {
                            fontSize: '80px'
                        },
                        children: (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                            name: 'faHandshake'
                        })
                    }),
                    (0, _jsxRuntime.jsx)("h5", {
                        className: 'card-title',
                        style: {
                            fontSize: '30px'
                        },
                        children: "\u00A1Compra finalizada!"
                    }),
                    (0, _jsxRuntime.jsxs)("p", {
                        className: 'card-text mt-3 mb-4',
                        style: {
                            fontSize: '15px'
                        },
                        children: [
                            "Gracias por realizar el pago, puede terminar de configurar el ",
                            (0, _jsxRuntime.jsx)("br", {}),
                            "paquete adquirido."
                        ]
                    }),
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'd-flex justify-content-between',
                        children: (0, _jsxRuntime.jsx)((0, _react.Button), {
                            variant: 'primary',
                            className: 'w-100',
                            href: '/home/packages',
                            children: "Ir a mis paquetes"
                        })
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/fortawesome":"7JvBl","utilities/text":"aKcMC","services/payment.service":"gDcUl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lfwof":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Offer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _containerLayout = require("components/ContainerLayout");
var _containerLayoutDefault = parcelHelpers.interopDefault(_containerLayout);
var _hook = require("context/payment-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _hook1 = require("context/public-context/hook");
var _hookDefault1 = parcelHelpers.interopDefault(_hook1);
var _selectedCourse = require("./SelectedCourses/SelectedCourse");
var _selectedCourseDefault = parcelHelpers.interopDefault(_selectedCourse);
var _addCourse = require("./SelectedCourses/AddCourse");
var _addCourseDefault = parcelHelpers.interopDefault(_addCourse);
function Offer() {
    const { offerData: { elective }, params: { offerId } } = (0, _hookDefault1.default)();
    const { selectedBasic, selectedElective, updateCart } = (0, _hookDefault.default)();
    const hasElectives = (0, _react.useMemo)(()=>elective && elective.length > 0, [
        elective
    ]);
    const description = (0, _react.useMemo)(()=>hasElectives > 0 ? "Selecciona hasta cinco cursos b\xe1sicos, su oferta incluye electivas gratis." : "Selecciona hasta cinco cursos b\xe1sicos.", [
        hasElectives
    ]);
    return (0, _jsxRuntime.jsxs)((0, _containerLayoutDefault.default), {
        title: "Personaliza tu experiencia de aprendizaje seg\u00FAn tus preferencias",
        description: description,
        className: "selectCourse",
        children: [
            (0, _jsxRuntime.jsx)("div", {
                className: 'bodyTitle',
                children: "Materias B\u00E1sicas"
            }),
            (0, _jsxRuntime.jsx)("div", {
                className: 'bodyList_Course',
                children: selectedBasic.map((id, index)=>{
                    if (id === false) return (0, _jsxRuntime.jsx)((0, _addCourseDefault.default), {
                        typeSubject: 'basic',
                        idSelectCourse: index
                    }, index);
                    return (0, _jsxRuntime.jsx)((0, _selectedCourseDefault.default), {
                        id: id,
                        index: index,
                        type: 'basic',
                        subject: id.substring(0, 2),
                        offer: offerId,
                        language: 'es',
                        onRemoveCourse: ()=>updateCart('basic', index, id, 'delete')
                    }, index);
                })
            }),
            hasElectives && (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'bodyTitle',
                        children: "Electivas"
                    }),
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'bodyList_Course',
                        children: selectedElective.map((id, index)=>{
                            if (id === false) return (0, _jsxRuntime.jsx)((0, _addCourseDefault.default), {
                                typeSubject: 'elective',
                                idSelectCourse: index
                            }, index);
                            return (0, _jsxRuntime.jsx)((0, _selectedCourseDefault.default), {
                                id: id,
                                index: index,
                                type: 'elective',
                                subject: id.substring(0, 2),
                                offer: offerId,
                                language: 'es',
                                onRemoveCourse: ()=>updateCart('elective', index, id, 'delete')
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","components/ContainerLayout":"9Dhze","context/payment-context/hook":"h0PVX","context/public-context/hook":"ccqgY","./SelectedCourses/SelectedCourse":"ezumS","./SelectedCourses/AddCourse":"hrsLu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Dhze":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ContainerLayout);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _clsx = require("external/clsx");
var _loader = require("components/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
const containerClasses = [
    'title',
    'description',
    'body'
];
function ContainerLayout(props) {
    const { title, description, children, loading } = props;
    const classes = (0, _react.useMemo)(()=>{
        return containerClasses.reduce((classes, key)=>{
            classes[key] = (0, _clsx.clsx)(key, props.className);
            return classes;
        }, {});
    }, [
        props.className
    ]);
    return (0, _jsxRuntime.jsxs)("div", {
        className: 'container_container',
        children: [
            (0, _jsxRuntime.jsx)("h2", {
                className: classes.title,
                children: title
            }),
            (0, _jsxRuntime.jsx)("p", {
                className: (0, _clsx.clsx)(classes.description, {
                    'd-none': !description
                }),
                children: description
            }),
            (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                loading: loading
            }),
            (0, _jsxRuntime.jsx)("div", {
                className: classes.body,
                children: children
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/clsx":"012R0","components/Loader":"4KLsk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4KLsk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Loader);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("external/clsx");
const Loader = (props)=>{
    const { loading } = props;
    return (0, _jsxRuntime.jsx)("div", {
        className: (0, _clsx.clsx)('loader', {
            'd-none': !loading
        })
    });
};

},{"react/jsx-runtime":"1dlk8","external/clsx":"012R0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ezumS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectedCourse);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _courseCover = require("components/CourseCover");
var _courseCoverDefault = parcelHelpers.interopDefault(_courseCover);
const SelectedCourse = (props)=>{
    const { id, index, type, language, subject, offer, onRemoveCourse } = props;
    return (0, _jsxRuntime.jsxs)("div", {
        className: 'course',
        children: [
            (0, _jsxRuntime.jsx)((0, _react.Link), {
                to: `/course-detail/${id}`,
                children: (0, _jsxRuntime.jsx)("div", {
                    className: 'courseContent',
                    children: (0, _jsxRuntime.jsx)((0, _courseCoverDefault.default), {
                        id: id
                    })
                })
            }),
            (0, _jsxRuntime.jsx)("div", {
                className: 'containerSelectedFooter',
                children: (0, _jsxRuntime.jsxs)("div", {
                    className: 'actions',
                    children: [
                        (0, _jsxRuntime.jsx)("span", {
                            children: (0, _jsxRuntime.jsx)((0, _react.Link), {
                                to: {
                                    pathname: `/courses/${subject}/${offer}/${index}/${type}`,
                                    search: `?languageId=${language}`
                                },
                                children: (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                    name: 'faPenToSquare',
                                    color: '#1797D0',
                                    className: 'px-1',
                                    title: 'editar'
                                })
                            })
                        }),
                        (0, _jsxRuntime.jsx)("span", {
                            onClick: onRemoveCourse,
                            children: (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                name: 'faTrashCan',
                                color: '#FF5E5E',
                                className: 'px-1',
                                title: 'eliminar'
                            })
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/fortawesome":"7JvBl","components/CourseCover":"bllJU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bllJU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CourseCover);
var _jsxRuntime = require("react/jsx-runtime");
var _assets = require("resources/assets");
var _assetsDefault = parcelHelpers.interopDefault(_assets);
const defaultCover = (0, _assetsDefault.default)('/illustrations/default-cover.jpg');
const CourseCover = (props)=>{
    const { id, name, className, style } = props;
    return (0, _jsxRuntime.jsx)("img", {
        className: className,
        style: style,
        src: `https://static.edufile.net/covers/${id}.jpg`,
        alt: name,
        onError: (e)=>{
            e.target.src = defaultCover;
        }
    });
};

},{"react/jsx-runtime":"1dlk8","resources/assets":"fdOi5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hrsLu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AddCourse);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _hook = require("context/public-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _clsx = require("external/clsx");
var _hook1 = require("context/payment-context/hook");
var _hookDefault1 = parcelHelpers.interopDefault(_hook1);
const AddCourse = (props)=>{
    const { typeSubject, idSelectCourse } = props;
    const { navigation, offerData } = (0, _hookDefault.default)();
    const { cart } = (0, _hookDefault1.default)();
    // Add Logic to switch to english if no spanish course is available
    const languageId = (0, _react.useMemo)(()=>{
        if (typeSubject === 'basic') {
            const selectedSubjects = cart.properties.basic.filter((i)=>i).map((c)=>c.substring(0, 2));
            if (selectedSubjects.length < 4) return 'es';
            if (selectedSubjects.indexOf('C1') >= 0) return 'en';
            return 'es';
        } else return 'es';
    }, [
        typeSubject,
        cart,
        offerData
    ]);
    const to = (0, _react.useMemo)(()=>navigation.offer.active && navigation.offerSubjects.linkWithQuery({
            languageId
        }, false, {
            idSelectCourse,
            typeSubject
        }), [
        navigation
    ]);
    return (0, _jsxRuntime.jsx)((0, _react.Link), {
        to: to,
        className: 'text-decoration-none hfc',
        children: (0, _jsxRuntime.jsxs)("div", {
            className: (0, _clsx.clsx)('container__selectedCourse', 'offer'),
            children: [
                (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                    name: 'faCirclePlus',
                    color: '#CCCCCC',
                    className: 'plus-rounded-default fa-3x'
                }),
                (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                    name: 'faCirclePlus',
                    color: '#1797D0',
                    className: 'plus-rounded-active fa-3x'
                }),
                (0, _jsxRuntime.jsx)("span", {
                    children: "Agrega tu curso"
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/fortawesome":"7JvBl","context/public-context/hook":"ccqgY","external/clsx":"012R0","context/payment-context/hook":"h0PVX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bxd4D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Offers);
var _jsxRuntime = require("react/jsx-runtime");
var _containerLayout = require("components/ContainerLayout");
var _containerLayoutDefault = parcelHelpers.interopDefault(_containerLayout);
var _hook = require("context/public-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _offerSummary = require("./OfferSummary");
var _offerSummaryDefault = parcelHelpers.interopDefault(_offerSummary);
function Offers() {
    const { loadingOffers, offers } = (0, _hookDefault.default)();
    return (0, _jsxRuntime.jsx)((0, _containerLayoutDefault.default), {
        title: "Ad\u00E9ntrate a un universo educativo lleno de infinitas posibilidades",
        description: "Ofrecemos planes que se adaptan a tus necesidades",
        loading: loadingOffers,
        children: offers.map((offer)=>(0, _jsxRuntime.jsx)((0, _offerSummaryDefault.default), {
                offer: offer
            }, offer.id))
    });
}

},{"react/jsx-runtime":"1dlk8","components/ContainerLayout":"9Dhze","context/public-context/hook":"ccqgY","./OfferSummary":"gMLIO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gMLIO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OfferSummary);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _offer = require("../../../types/offer");
var _offerDiscountHeader = require("./OfferDiscountHeader");
var _offerDiscountHeaderDefault = parcelHelpers.interopDefault(_offerDiscountHeader);
var _offerHeader = require("./OfferHeader");
var _offerHeaderDefault = parcelHelpers.interopDefault(_offerHeader);
var _notify = require("components/Notify");
var _hook = require("context/payment-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _hook1 = require("context/public-context/hook");
var _hookDefault1 = parcelHelpers.interopDefault(_hook1);
const OfferSummary = (props)=>{
    const { offer } = props;
    const { emptyCart, packageStatus } = (0, _hookDefault.default)();
    const { navigation } = (0, _hookDefault1.default)();
    const [Header, listing] = (0, _react.useMemo)(()=>{
        const Header = (0, _offer.isDiscounted)(offer) ? (0, _offerDiscountHeaderDefault.default) : (0, _offerHeaderDefault.default);
        return [
            Header,
            (0, _jsxRuntime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: offer.content.html
                }
            })
        ];
    }, [
        offer
    ]);
    async function handleOfferSelection() {
        if (!packageStatus.notFound && packageStatus.coursesCount > 0) {
            const { isConfirmed } = await (0, _notify.showConfirmDialog)("\xbfYa tiene un paquete en el carrito, desea reemplazarlo?");
            if (!isConfirmed) return;
            await emptyCart();
            (0, _notify.notifySuccess)('Se vacio el carrito.');
        }
        navigation.offer.go({
            offerId: offer.id
        });
    }
    return (0, _jsxRuntime.jsxs)("div", {
        className: 'card',
        children: [
            (0, _jsxRuntime.jsx)("div", {
                className: 'cardHeader',
                style: {
                    height: '110px'
                },
                children: (0, _jsxRuntime.jsx)(Header, {
                    offer: offer
                })
            }),
            (0, _jsxRuntime.jsx)("div", {
                className: 'cardBody',
                children: (0, _jsxRuntime.jsx)("div", {
                    className: 'offerList',
                    children: listing
                })
            }),
            (0, _jsxRuntime.jsx)("div", {
                className: 'cardFooter',
                children: (0, _jsxRuntime.jsx)((0, _react.Button), {
                    variant: 'outline-primary w-100',
                    onClick: handleOfferSelection,
                    children: "Escoger"
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","../../../types/offer":"99sVx","./OfferDiscountHeader":"trlM7","./OfferHeader":"4jt5f","components/Notify":"gZyef","context/payment-context/hook":"h0PVX","context/public-context/hook":"ccqgY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"trlM7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OfferDiscountHeader);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _offer = require("../../../types/offer");
const OfferDiscountHeader = (props)=>{
    const { offer } = props;
    const { name, plan, price } = offer;
    const [discountedPrice, discountedAmount] = (0, _react.useMemo)(()=>(0, _offer.calculateDiscounts)(offer), [
        offer
    ]);
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsxs)("p", {
                style: {
                    margin: '0'
                },
                children: [
                    "$",
                    discountedPrice,
                    ' ',
                    (0, _jsxRuntime.jsxs)("span", {
                        className: 'span_plan text-capitalize',
                        children: [
                            "/",
                            plan
                        ]
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)("div", {
                className: 'programLevel text-capitalize',
                children: name
            }),
            (0, _jsxRuntime.jsxs)("p", {
                className: 'span_plan m-auto text-red',
                style: {
                    fontWeight: '500'
                },
                children: [
                    discountedAmount,
                    " de descuento",
                    ' ',
                    (0, _jsxRuntime.jsx)("b", {
                        style: {
                            textDecoration: 'line-through'
                        },
                        children: price
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","../../../types/offer":"99sVx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4jt5f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OfferHeader);
var _jsxRuntime = require("react/jsx-runtime");
const OfferHeader = (props)=>{
    const { offer } = props;
    const { name, plan, price } = offer;
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsxs)("p", {
                style: {
                    margin: '0'
                },
                children: [
                    price,
                    ' ',
                    (0, _jsxRuntime.jsxs)("span", {
                        className: 'span_plan text-capitalize',
                        children: [
                            "/",
                            plan
                        ]
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)("div", {
                className: 'programLevel text-capitalize',
                children: name
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jeqky":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Subjects);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/payment-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _languageBar = require("./LanguageBar");
var _languageBarDefault = parcelHelpers.interopDefault(_languageBar);
var _subject = require("./Subject");
var _subjectDefault = parcelHelpers.interopDefault(_subject);
var _hook1 = require("context/public-context/hook");
var _hookDefault1 = parcelHelpers.interopDefault(_hook1);
function Subjects() {
    const { cart } = (0, _hookDefault.default)();
    const { offerData: { basic, elective }, params: { typeSubject, offerId }, query } = (0, _hookDefault1.default)();
    const languageId = (0, _react.useMemo)(()=>query.languageId || 'es', [
        query.languageId
    ]);
    const subjects = (0, _react.useMemo)(()=>{
        const selectedSubjects = (cart.properties[typeSubject] || []).filter((id)=>id).map((id)=>id.substring(0, 2));
        const target = (typeSubject === 'basic' ? basic : elective) || [];
        return target.map((subject)=>{
            const { id, color } = subject;
            const name = subject.name[languageId];
            const courses = subject[`units_${languageId}`] || 0;
            const selected = typeSubject === 'basic' ? selectedSubjects.indexOf(id) >= 0 : selectedSubjects.length === 3;
            return {
                idSubject: id,
                languageId,
                color,
                name,
                courses,
                selected,
                offerId
            };
        }).filter(({ courses })=>courses > 0);
    }, [
        cart.properties,
        languageId,
        typeSubject,
        basic,
        elective,
        offerId
    ]);
    return (0, _jsxRuntime.jsxs)("div", {
        className: 'container_container',
        children: [
            (0, _jsxRuntime.jsx)("h2", {
                className: 'title_subject',
                children: "Selecciona una materia en ingl\u00E9s o espa\u00F1ol para elegir un curso"
            }),
            (0, _jsxRuntime.jsxs)("div", {
                className: 'body_subject',
                children: [
                    (0, _jsxRuntime.jsx)((0, _languageBarDefault.default), {}),
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'body_list',
                        children: subjects.map((subject, index)=>(0, _jsxRuntime.jsx)((0, _subjectDefault.default), {
                                ...subject
                            }, index))
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/payment-context/hook":"h0PVX","./LanguageBar":"7db6j","./Subject":"hbsRH","context/public-context/hook":"ccqgY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7db6j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LanguageBar);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("external/clsx");
var _react = require("external/react");
var _buttonBack = require("components/ButtonBack");
var _buttonBackDefault = parcelHelpers.interopDefault(_buttonBack);
var _hook = require("context/payment-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _hook1 = require("context/public-context/hook");
var _hookDefault1 = parcelHelpers.interopDefault(_hook1);
function LanguageBar() {
    const { cart } = (0, _hookDefault.default)();
    const { navigation, params, query: { languageId }, offerData: { courses = [] } } = (0, _hookDefault1.default)();
    const backLink = (0, _react.useMemo)(()=>navigation.offer.link(), [
        navigation
    ]);
    const [toES, toEN] = (0, _react.useMemo)(()=>navigation.offerSubjects.active ? [
            navigation.offerSubjects.linkWithQuery({
                languageId: 'es'
            }),
            navigation.offerSubjects.linkWithQuery({
                languageId: 'en'
            })
        ] : [], [
        navigation
    ]);
    const [englishCount, spanishCount] = (0, _react.useMemo)(()=>{
        const selectedSubjects = (cart.properties[params.typeSubject] || []).filter((id)=>id);
        const english = courses.filter(({ language, subject })=>language === 'en' && selectedSubjects.indexOf(subject) < 0).length;
        const spanish = courses.filter(({ subject, language })=>language == 'es' && selectedSubjects.indexOf(subject) < 0).length;
        return [
            english,
            spanish
        ];
    }, [
        cart.properties,
        courses,
        params.typeSubject
    ]);
    return (0, _jsxRuntime.jsxs)("div", {
        className: 'bodyHeader_subject',
        children: [
            (0, _jsxRuntime.jsx)((0, _buttonBackDefault.default), {
                path: backLink
            }),
            (0, _jsxRuntime.jsxs)("div", {
                children: [
                    spanishCount > 0 && (0, _jsxRuntime.jsx)((0, _react.Link), {
                        to: toES,
                        className: (0, _clsx.clsx)('language__filter', 'mx-1', {
                            selected: languageId === 'es'
                        }),
                        children: "Espa\u00F1ol"
                    }),
                    englishCount > 0 && (0, _jsxRuntime.jsx)((0, _react.Link), {
                        to: toEN,
                        className: (0, _clsx.clsx)('language__filter', 'mx-1', {
                            selected: languageId === 'en'
                        }),
                        children: "Ingl\u00E9s"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/clsx":"012R0","external/react":"1Glst","components/ButtonBack":"3nJVT","context/payment-context/hook":"h0PVX","context/public-context/hook":"ccqgY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3nJVT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("external/lodash");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
const ButtonBack = (props)=>{
    const { path } = props;
    const navigate = (0, _react.useNavigate)();
    const buttonProps = (0, _lodash.omit)(props, [
        'path'
    ]);
    return (0, _jsxRuntime.jsx)((0, _react.Button), {
        variant: 'outline-secondary',
        size: 'sm',
        style: {
            marginBottom: '5px',
            width: '32px',
            marginRight: '10px'
        },
        onClick: ()=>navigate(path),
        ...buttonProps,
        children: (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
            name: "faChevronLeft"
        })
    });
};
exports.default = ButtonBack;

},{"react/jsx-runtime":"1dlk8","external/lodash":"h4nD2","external/react":"1Glst","external/fortawesome":"7JvBl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hbsRH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Subject);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("external/clsx");
var _react = require("external/react");
var _hook = require("context/public-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const Subject = (props)=>{
    const { selected, idSubject, name, courses, color, languageId } = props;
    const { navigation } = (0, _hookDefault.default)();
    const linkToCourses = (0, _react.useMemo)(()=>navigation.offerSubjects.active && navigation.offerCourses.linkWithQuery({
            languageId
        }, true, {
            idSubject
        }), [
        navigation,
        idSubject
    ]);
    return (0, _jsxRuntime.jsx)((0, _react.Link), {
        to: linkToCourses,
        className: (0, _clsx.clsx)({
            disabled__subject: selected
        }),
        style: {
            textDecoration: 'none'
        },
        children: (0, _jsxRuntime.jsxs)("div", {
            color: color,
            className: (0, _clsx.clsx)('bodyListItem', {
                disabled__subject_color: selected
            }),
            children: [
                (0, _jsxRuntime.jsx)("h4", {
                    children: name
                }),
                (0, _jsxRuntime.jsxs)("p", {
                    children: [
                        courses,
                        " Cursos"
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"1dlk8","external/clsx":"012R0","external/react":"1Glst","context/public-context/hook":"ccqgY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Wxlc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Courses);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _languageBar = require("./LanguageBar");
var _languageBarDefault = parcelHelpers.interopDefault(_languageBar);
var _course = require("./Course");
var _courseDefault = parcelHelpers.interopDefault(_course);
var _hook = require("context/payment-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _hook1 = require("context/public-context/hook");
var _hookDefault1 = parcelHelpers.interopDefault(_hook1);
function Courses() {
    const { updateCart, cart } = (0, _hookDefault.default)();
    const { offerData: { courses: offerCourses = [] }, params, query: { languageId, fromCart, extra }, navigation } = (0, _hookDefault1.default)();
    const { idSubject, idSelectCourse, typeSubject } = params;
    const courses = (0, _react.useMemo)(()=>{
        return offerCourses.filter(({ subject, language })=>subject == idSubject && language === languageId);
    }, [
        offerCourses,
        languageId,
        idSubject
    ]);
    const courseSelected = (0, _react.useMemo)(()=>{
        const target = typeSubject === 'basic' ? cart.properties.basic : cart.properties.elective;
        if (!target) return;
        const index = target.findIndex((id)=>id && id.startsWith(idSubject));
        if (index != idSelectCourse) return;
        return target[index];
    }, [
        cart.properties,
        idSubject,
        typeSubject
    ]);
    const extraCourseSelected = (0, _react.useMemo)(()=>{
        const target = typeSubject === 'basic' ? cart.properties.basicExtra : cart.properties.electiveExtra;
        if (!target) return;
        const index = target.findIndex((id)=>id && id.startsWith(idSubject));
        if (index != idSelectCourse) return;
        return target[index];
    }, [
        cart.properties,
        idSubject,
        typeSubject,
        extra
    ]);
    async function handleSelectCourse(id, remove, extra) {
        const action = remove ? 'delete' : 'update';
        await updateCart(extra === 'true' ? `${typeSubject}Extra` : typeSubject, idSelectCourse, id, action);
        if (action == 'update') {
            if (fromCart) navigation.summary.go();
            else navigation.offer.go();
        }
    }
    const electivesInCart = (0, _react.useMemo)(()=>(cart.properties.elective || []).filter((c)=>c), [
        cart.properties
    ]);
    return (0, _jsxRuntime.jsxs)("div", {
        className: 'container_container',
        children: [
            (0, _jsxRuntime.jsx)("h2", {
                className: 'title_subject',
                children: "Elija un curso para continuar."
            }),
            (0, _jsxRuntime.jsxs)("div", {
                className: 'body_subject',
                children: [
                    (0, _jsxRuntime.jsx)((0, _languageBarDefault.default), {}),
                    courses.length > 0 && (0, _jsxRuntime.jsx)("div", {
                        className: 'bodyList_Course',
                        children: courses.map((course, index)=>{
                            return (0, _jsxRuntime.jsx)((0, _courseDefault.default), {
                                id: course.id,
                                electivesInCart: electivesInCart,
                                elective: course.subject === 'C7',
                                name: course.name,
                                fromCart: fromCart,
                                courseSelected: courseSelected,
                                extra: extra,
                                extraCourseSelected: extraCourseSelected,
                                handleSelectCourse: handleSelectCourse
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","./LanguageBar":"alfgD","./Course":"1SGdt","context/payment-context/hook":"h0PVX","context/public-context/hook":"ccqgY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"alfgD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LanguageBar);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("external/clsx");
var _react = require("external/react");
var _buttonBack = require("components/ButtonBack");
var _buttonBackDefault = parcelHelpers.interopDefault(_buttonBack);
var _hook = require("context/public-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
function LanguageBar() {
    const { navigation, offerData: { courses: offerCourses = [] }, query: { languageId, fromCart }, params } = (0, _hookDefault.default)();
    const backLink = (0, _react.useMemo)(()=>navigation.offerCourses.active && navigation.offerSubjects.linkWithQuery({
            languageId
        }, true), [
        navigation
    ]);
    const [toES, toEN] = (0, _react.useMemo)(()=>navigation.offerCourses.active ? [
            navigation.offerCourses.linkWithQuery({
                languageId: 'es'
            }),
            navigation.offerCourses.linkWithQuery({
                languageId: 'en'
            })
        ] : [], [
        navigation
    ]);
    const [englishCount, spanishCount] = (0, _react.useMemo)(()=>{
        const english = offerCourses.filter(({ subject, language })=>subject == params.idSubject && language === 'en').length;
        const spanish = offerCourses.filter(({ subject, language })=>subject == params.idSubject && language === 'es').length;
        return [
            english,
            spanish
        ];
    }, [
        offerCourses,
        params.idSubject
    ]);
    return (0, _jsxRuntime.jsxs)("div", {
        className: 'bodyHeader_subject',
        children: [
            !fromCart && (0, _jsxRuntime.jsx)((0, _buttonBackDefault.default), {
                path: backLink
            }),
            fromCart && (0, _jsxRuntime.jsx)("div", {}),
            (0, _jsxRuntime.jsxs)("div", {
                children: [
                    spanishCount > 0 && (0, _jsxRuntime.jsx)((0, _react.Link), {
                        to: toES,
                        className: (0, _clsx.clsx)('language__filter', 'mx-1', {
                            selected: languageId === 'es'
                        }),
                        children: "Espa\u00F1ol"
                    }),
                    englishCount > 0 && (0, _jsxRuntime.jsx)((0, _react.Link), {
                        to: toEN,
                        className: (0, _clsx.clsx)('language__filter', 'mx-1', {
                            selected: languageId === 'en'
                        }),
                        children: "Ingl\u00E9s"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/clsx":"012R0","external/react":"1Glst","components/ButtonBack":"3nJVT","context/public-context/hook":"ccqgY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1SGdt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Course);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("external/clsx");
var _react = require("external/react");
var _courseLink = require("./CourseLink");
var _courseLinkDefault = parcelHelpers.interopDefault(_courseLink);
const Course = (props)=>{
    const { courseSelected, id, name, handleSelectCourse, fromCart, extra, extraCourseSelected, elective, electivesInCart } = props;
    const selected = courseSelected === id;
    const extraSelected = extraCourseSelected === id;
    const disabledCourse = (0, _react.useMemo)(()=>{
        if (fromCart) return false;
        return courseSelected && !selected && !extraSelected;
    }, [
        selected,
        fromCart,
        courseSelected
    ]);
    const [variant, actionLabel] = (0, _react.useMemo)(()=>{
        if (selected && fromCart) return [
            'success',
            'Seleccionado'
        ];
        if (extra && extraSelected) return [
            'success',
            'Complementario'
        ];
        if (!elective) return selected ? [
            'danger',
            'Quitar'
        ] : [
            'primary',
            'Seleccionar'
        ];
        if (selected) return [
            'danger',
            'Quitar'
        ];
        if (electivesInCart.indexOf(id) >= 0) return [
            'success',
            'Seleccionado'
        ];
        return [
            'primary',
            'Seleccionar'
        ];
    }, [
        selected,
        fromCart,
        elective,
        electivesInCart
    ]);
    return (0, _jsxRuntime.jsxs)("div", {
        className: (0, _clsx.clsx)('course', {
            disabled__course: disabledCourse
        }),
        children: [
            (0, _jsxRuntime.jsx)((0, _courseLinkDefault.default), {
                id: id,
                name: name,
                selected: selected
            }),
            (0, _jsxRuntime.jsxs)("div", {
                className: 'courseBody',
                children: [
                    (0, _jsxRuntime.jsx)("p", {
                        children: name
                    }),
                    (0, _jsxRuntime.jsx)((0, _react.Button), {
                        disabled: variant === 'success',
                        className: 'w-100',
                        variant: variant,
                        size: 'sm',
                        onClick: ()=>handleSelectCourse(id, selected, extra),
                        children: actionLabel
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/clsx":"012R0","external/react":"1Glst","./CourseLink":"iudb9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iudb9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CourseLink);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _courseCover = require("components/CourseCover");
var _courseCoverDefault = parcelHelpers.interopDefault(_courseCover);
const CourseLink = (props)=>{
    const { id, selected, name } = props;
    return (0, _jsxRuntime.jsx)((0, _react.Link), {
        to: `/course-detail/${id}`,
        children: (0, _jsxRuntime.jsxs)("div", {
            className: 'courseContent',
            children: [
                selected && (0, _jsxRuntime.jsx)("div", {
                    className: 'courseTag',
                    children: (0, _jsxRuntime.jsxs)("span", {
                        className: 'badge badge-success',
                        children: [
                            (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                name: 'faCircleCheck',
                                className: 'mr-1'
                            }),
                            "Seleccionado"
                        ]
                    })
                }),
                (0, _jsxRuntime.jsx)((0, _courseCoverDefault.default), {
                    id: id,
                    name: name
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/fortawesome":"7JvBl","components/CourseCover":"bllJU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"67dhD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CourseDetail);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _buttonBack = require("components/ButtonBack");
var _buttonBackDefault = parcelHelpers.interopDefault(_buttonBack);
var _hook = require("context/public-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
function CourseDetail() {
    const { courseInDetails: course } = (0, _hookDefault.default)();
    const units = (0, _react.useMemo)(()=>course.units || [], [
        course.units
    ]);
    return (0, _jsxRuntime.jsx)("div", {
        className: 'container_course_detail',
        children: (0, _jsxRuntime.jsxs)("div", {
            className: 'body_course_detail',
            children: [
                (0, _jsxRuntime.jsxs)("div", {
                    className: 'bodyHeader_course_detail',
                    children: [
                        (0, _jsxRuntime.jsxs)("div", {
                            className: 'bodyHeaderTitle_course_detail',
                            children: [
                                (0, _jsxRuntime.jsx)((0, _buttonBackDefault.default), {
                                    path: -1
                                }),
                                (0, _jsxRuntime.jsx)("p", {
                                    style: {
                                        margin: '0'
                                    },
                                    children: course.name
                                })
                            ]
                        }),
                        (0, _jsxRuntime.jsx)("div", {
                            className: 'bodyHeaderActions_course_detail',
                            children: (0, _jsxRuntime.jsxs)("span", {
                                className: 'badge text-bg-primary d-flex justify-content-center align-items-center',
                                style: {
                                    height: '40px',
                                    width: '100px',
                                    fontSize: '14px'
                                },
                                children: [
                                    course.number_lessons,
                                    " lecciones"
                                ]
                            })
                        })
                    ]
                }),
                (0, _jsxRuntime.jsx)("div", {
                    className: 'bodyList_course_detail',
                    children: (0, _jsxRuntime.jsx)((0, _react.Accordion), {
                        defaultActiveKey: '0',
                        children: units.map((course, index)=>{
                            return (0, _jsxRuntime.jsxs)((0, _react.Accordion).Item, {
                                eventKey: index.toString(),
                                children: [
                                    (0, _jsxRuntime.jsxs)((0, _react.Accordion).Header, {
                                        children: [
                                            "Unidad ",
                                            index + 1,
                                            ": ",
                                            course.name
                                        ]
                                    }),
                                    (0, _jsxRuntime.jsx)((0, _react.Accordion).Body, {
                                        children: (0, _jsxRuntime.jsx)("div", {
                                            className: 'bodyListItem_course_detail',
                                            children: course.lessons.map((lesson)=>(0, _jsxRuntime.jsxs)("p", {
                                                    children: [
                                                        lesson.id,
                                                        ": ",
                                                        lesson.name
                                                    ]
                                                }, lesson.id))
                                        })
                                    })
                                ]
                            }, index);
                        })
                    })
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","components/ButtonBack":"3nJVT","context/public-context/hook":"ccqgY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jwpF6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ShoppingCartSummary);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/payment-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _summaries = require("./Summaries");
var _summariesDefault = parcelHelpers.interopDefault(_summaries);
var _packageItem = require("./PackageItem");
var _packageItemDefault = parcelHelpers.interopDefault(_packageItem);
var _hook1 = require("context/public-context/hook");
var _hookDefault1 = parcelHelpers.interopDefault(_hook1);
function ShoppingCartSummary() {
    const { packageItem, packageStatus } = (0, _hookDefault.default)();
    const { navigation } = (0, _hookDefault1.default)();
    (0, _react.useEffect)(()=>{
        if (!packageItem) return;
        if (packageStatus.notFound) navigation.offers.go();
        else if (packageStatus.missingCourses) navigation.offer.go({
            offerId: packageItem.offerId
        });
    }, [
        packageStatus,
        navigation
    ]);
    return (0, _jsxRuntime.jsx)("div", {
        className: 'container',
        children: (0, _jsxRuntime.jsx)("div", {
            className: 'row mt-5 mb-5',
            children: (0, _jsxRuntime.jsx)("div", {
                className: 'col-md-12',
                children: (0, _jsxRuntime.jsx)("div", {
                    className: 'shadow card text-center',
                    children: (0, _jsxRuntime.jsx)("div", {
                        className: 'card-body',
                        children: (0, _jsxRuntime.jsxs)("div", {
                            className: 'row',
                            children: [
                                (0, _jsxRuntime.jsx)("div", {
                                    className: 'col-md-12',
                                    children: (0, _jsxRuntime.jsx)("div", {
                                        className: 'd-flex justify-content-between mb-2',
                                        children: (0, _jsxRuntime.jsx)("div", {
                                            children: (0, _jsxRuntime.jsx)("span", {
                                                className: 'fw-bold mr-3',
                                                children: "Carrito de Compras"
                                            })
                                        })
                                    })
                                }),
                                (0, _jsxRuntime.jsx)((0, _packageItemDefault.default), {}),
                                (0, _jsxRuntime.jsx)((0, _summariesDefault.default), {})
                            ]
                        })
                    })
                })
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/payment-context/hook":"h0PVX","./Summaries":"4GZK4","./PackageItem":"4oi75","context/public-context/hook":"ccqgY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4GZK4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Summaries);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/payment-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _workbooksSummary = require("./WorkbooksSummary");
var _workbooksSummaryDefault = parcelHelpers.interopDefault(_workbooksSummary);
var _paymentButton = require("./PaymentButton");
var _paymentButtonDefault = parcelHelpers.interopDefault(_paymentButton);
function Summaries() {
    const { packageItem } = (0, _hookDefault.default)();
    const [hasPackage, item] = (0, _react.useMemo)(()=>[
            !!packageItem,
            packageItem || {}
        ], [
        packageItem
    ]);
    const { subTotal, discounted, discountAmountText } = item;
    return (0, _jsxRuntime.jsx)("div", {
        className: 'col-md-4',
        children: hasPackage && (0, _jsxRuntime.jsxs)("div", {
            className: 'card text-center',
            children: [
                (0, _jsxRuntime.jsx)("div", {
                    className: 'card-header bg-white fw-bold',
                    children: "Resumen de la compra"
                }),
                (0, _jsxRuntime.jsxs)("div", {
                    className: 'card-body',
                    children: [
                        (0, _jsxRuntime.jsxs)("div", {
                            className: 'd-flex justify-content-between',
                            children: [
                                (0, _jsxRuntime.jsxs)("p", {
                                    className: 'card-text fw-bold',
                                    children: [
                                        (0, _jsxRuntime.jsx)("label", {
                                            className: 'text-capitalize',
                                            children: item.offerName
                                        }),
                                        ' ',
                                        (0, _jsxRuntime.jsxs)("small", {
                                            style: {
                                                fontSize: '12px'
                                            },
                                            children: [
                                                "(",
                                                item.frequency,
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                (0, _jsxRuntime.jsxs)("p", {
                                    className: 'card-text',
                                    children: [
                                        "$ ",
                                        item.price.toFixed(2)
                                    ]
                                })
                            ]
                        }),
                        item.workbooksCount > 0 && (0, _jsxRuntime.jsx)((0, _workbooksSummaryDefault.default), {}),
                        (0, _jsxRuntime.jsx)("hr", {}),
                        (0, _jsxRuntime.jsxs)("div", {
                            className: 'd-flex justify-content-end',
                            children: [
                                (0, _jsxRuntime.jsxs)("p", {
                                    className: 'card-text fw-bold',
                                    children: [
                                        (0, _jsxRuntime.jsx)("label", {
                                            className: 'text-capitalize mr-3',
                                            children: "Subtotal:"
                                        }),
                                        ' '
                                    ]
                                }),
                                (0, _jsxRuntime.jsxs)("p", {
                                    className: 'card-text',
                                    children: [
                                        "$ ",
                                        subTotal.toFixed(2)
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                discounted && (0, _jsxRuntime.jsxs)("div", {
                    className: 'd-flex justify-content-end',
                    children: [
                        (0, _jsxRuntime.jsxs)("p", {
                            className: 'card-text fw-bold',
                            style: {
                                marginRight: '50px'
                            },
                            children: [
                                "Descuento:-",
                                discountAmountText
                            ]
                        }),
                        (0, _jsxRuntime.jsxs)("p", {
                            className: 'card-text',
                            children: [
                                "- ",
                                discountAmountText
                            ]
                        })
                    ]
                }),
                (0, _jsxRuntime.jsx)((0, _paymentButtonDefault.default), {})
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/payment-context/hook":"h0PVX","./WorkbooksSummary":"gV3LY","./PaymentButton":"kHhlt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gV3LY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>WorkbooksSummary);
var _jsxRuntime = require("react/jsx-runtime");
var _hook = require("context/payment-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
function WorkbooksSummary() {
    const { packageItem } = (0, _hookDefault.default)();
    const { workbooksCount, workbooksAmount } = packageItem;
    return (0, _jsxRuntime.jsxs)("div", {
        className: 'd-flex justify-content-between',
        children: [
            (0, _jsxRuntime.jsxs)("p", {
                className: 'card-text fw-bold',
                children: [
                    "Cuadernos ",
                    (0, _jsxRuntime.jsxs)("small", {
                        style: {
                            fontSize: '12px'
                        },
                        children: [
                            "(",
                            workbooksCount,
                            ")"
                        ]
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)("p", {
                className: 'card-text',
                children: [
                    "$ ",
                    Number(workbooksAmount).toFixed(2)
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","context/payment-context/hook":"h0PVX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kHhlt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PaymentButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/auth-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _hook1 = require("context/payment-context/hook");
var _hookDefault1 = parcelHelpers.interopDefault(_hook1);
var _paymentService = require("services/payment.service");
var _notify = require("components/Notify");
var _modalAcceptCancelFooter = require("components/ModalAcceptCancelFooter");
var _modalAcceptCancelFooterDefault = parcelHelpers.interopDefault(_modalAcceptCancelFooter);
function PaymentButton() {
    const { showLogin, user } = (0, _hookDefault.default)();
    const { packageItem, cart } = (0, _hookDefault1.default)();
    const [confirmationOpened, setConfirmationShow] = (0, _react.useState)(false);
    const [hasPackage, item] = (0, _react.useMemo)(()=>[
            !!packageItem,
            packageItem || {}
        ], [
        packageItem
    ]);
    const { paymentTotal } = item;
    async function handlePayment() {
        if (!user) showLogin();
        else //handlePaymentStripe(cart, paymentTotal)
        setConfirmationShow(true);
    }
    async function handleConfirmation() {
        handlePaymentStripe(cart, paymentTotal);
    }
    async function handleCloseConfirmation() {
        setConfirmationShow(false);
    }
    const disabled = (0, _react.useMemo)(()=>{
        if (paymentTotal <= 0) return true;
        if (cart.properties.basicExtra.findIndex((b)=>b === false) >= 0) return true;
        return false;
    }, [
        paymentTotal,
        cart.properties
    ]);
    return (0, _jsxRuntime.jsxs)("div", {
        className: 'card-footer text-muted bg-white',
        children: [
            hasPackage && (0, _jsxRuntime.jsxs)("button", {
                className: 'btn btn-primary w-100',
                onClick: handlePayment,
                disabled: disabled,
                children: [
                    "Pagar $ ",
                    paymentTotal.toFixed(2)
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _react.Modal), {
                show: confirmationOpened,
                onHide: handleCloseConfirmation,
                size: 'lg',
                centered: true,
                children: [
                    (0, _jsxRuntime.jsx)((0, _react.Modal).Header, {
                        closeButton: true,
                        children: (0, _jsxRuntime.jsx)("h5", {
                            className: 'text-capitalize',
                            style: {
                                fontFamily: 'Arial, sans-serif',
                                margin: '0'
                            },
                            children: "Atenci\u00F3n"
                        })
                    }),
                    (0, _jsxRuntime.jsxs)((0, _react.Modal).Body, {
                        children: [
                            (0, _jsxRuntime.jsx)("p", {
                                style: {
                                    marginBottom: "16px; line-height: 1.5;"
                                },
                                children: "Todos los pagos de suscripci\u00F3n son finales y no reembolsables."
                            }),
                            (0, _jsxRuntime.jsx)("p", {
                                style: {
                                    marginBottom: "5px; line-height: 1.5;"
                                },
                                children: "No se conceder\u00E1n reembolsos ni cr\u00E9ditos por per\u00EDodos parciales, servicios no utilizados o cancelaciones anticipadas."
                            }),
                            (0, _jsxRuntime.jsx)("p", {
                                style: {
                                    marginBottom: "5px; line-height: 1.5;"
                                },
                                children: "Al completar su compra, usted acepta estos t\u00E9rminos."
                            })
                        ]
                    }),
                    (0, _jsxRuntime.jsx)((0, _modalAcceptCancelFooterDefault.default), {
                        onCancel: handleCloseConfirmation,
                        onAccept: handleConfirmation
                    })
                ]
            })
        ]
    });
}
async function handlePaymentStripe({ id, client }, displayedTotal) {
    const purchase = {
        id,
        client,
        displayedTotal
    };
    const response = await (0, _paymentService.paymentService).completePurchase(purchase);
    if (response.data.data.url) window.location.href = response.data.data.url;
    else (0, _notify.notifyError)("Ocurri\xf3 un error durante el comienzo del pago.");
}

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/auth-context/hook":"2UX0M","context/payment-context/hook":"h0PVX","services/payment.service":"gDcUl","components/Notify":"gZyef","components/ModalAcceptCancelFooter":"buHx2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"buHx2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ModalAcceptCancelFooter);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
const ModalAcceptCancelFooter = (props)=>{
    const { className, style, onCancel, onAccept, labels = {} } = props;
    const { accept: acceptLabel = 'Aceptar', cancel: cancelLabel = 'Cancelar' } = labels;
    return (0, _jsxRuntime.jsxs)((0, _react.Modal).Footer, {
        className: className,
        style: style,
        children: [
            (0, _jsxRuntime.jsx)((0, _react.Button), {
                variant: 'light',
                onClick: onCancel,
                children: cancelLabel
            }),
            (0, _jsxRuntime.jsx)((0, _react.Button), {
                variant: 'primary',
                className: 'ml-2',
                onClick: onAccept,
                children: acceptLabel
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4oi75":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Packages);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/payment-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _packageCourse = require("./PackageCourse");
var _packageCourseDefault = parcelHelpers.interopDefault(_packageCourse);
var _removePackage = require("./RemovePackage");
var _removePackageDefault = parcelHelpers.interopDefault(_removePackage);
function Packages() {
    const { packageItem } = (0, _hookDefault.default)();
    const [hasPackage, { offerName, courses }] = (0, _react.useMemo)(()=>[
            !!packageItem,
            packageItem || {}
        ], [
        packageItem
    ]);
    return (0, _jsxRuntime.jsx)("div", {
        className: 'col-md-8',
        children: hasPackage && (0, _jsxRuntime.jsx)("div", {
            className: 'accordion mb-2',
            id: 'accordionPanelsStayOpenExample',
            children: (0, _jsxRuntime.jsxs)("div", {
                children: [
                    (0, _jsxRuntime.jsxs)("div", {
                        className: 'd-flex justify-content-between ml-2 mr-2',
                        children: [
                            (0, _jsxRuntime.jsx)("span", {
                                className: 'text-capitalize',
                                style: {
                                    fontSize: '18px',
                                    color: '#1797D0',
                                    fontWeight: 'bold'
                                },
                                children: offerName
                            }),
                            (0, _jsxRuntime.jsx)((0, _removePackageDefault.default), {})
                        ]
                    }),
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'accordion-body',
                        children: courses.map((course, index)=>(0, _jsxRuntime.jsx)((0, _packageCourseDefault.default), {
                                course: course
                            }, index))
                    })
                ]
            })
        }, offerName)
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/payment-context/hook":"h0PVX","./PackageCourse":"lTPga","./RemovePackage":"aYvbn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lTPga":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PackageCourse);
var _jsxRuntime = require("react/jsx-runtime");
var _labeledValue = require("components/LabeledValue");
var _labeledValueDefault = parcelHelpers.interopDefault(_labeledValue);
var _courseCover = require("components/CourseCover");
var _courseCoverDefault = parcelHelpers.interopDefault(_courseCover);
var _packageEditCourse = require("./PackageEditCourse");
var _packageEditCourseDefault = parcelHelpers.interopDefault(_packageEditCourse);
var _packageWorkbookSwitch = require("./PackageWorkbookSwitch");
var _packageWorkbookSwitchDefault = parcelHelpers.interopDefault(_packageWorkbookSwitch);
const PackageCourse = (props)=>{
    const { course } = props;
    const { courseId, courseName, subjectName, gradeName, workbook, extraCourse } = course;
    return (0, _jsxRuntime.jsx)("div", {
        className: 'row d-flex justify-content-center align-items-center h-100',
        children: (0, _jsxRuntime.jsx)("div", {
            className: 'card mb-2',
            style: {
                borderRadius: '10px'
            },
            children: (0, _jsxRuntime.jsxs)("div", {
                className: 'card-body px-0',
                children: [
                    (0, _jsxRuntime.jsxs)("div", {
                        className: 'd-flex text-black',
                        children: [
                            (0, _jsxRuntime.jsx)("div", {
                                className: 'flex-shrink-0',
                                children: (0, _jsxRuntime.jsx)((0, _courseCoverDefault.default), {
                                    className: 'img-fluid',
                                    style: {
                                        width: '90px',
                                        borderRadius: '10px',
                                        "border": "outset 1px #cacacaff"
                                    },
                                    id: courseId,
                                    name: courseName
                                })
                            }),
                            (0, _jsxRuntime.jsxs)("div", {
                                className: 'flex-grow-1 ms-3',
                                style: {
                                    textAlign: 'left'
                                },
                                children: [
                                    (0, _jsxRuntime.jsx)((0, _labeledValueDefault.default), {
                                        label: 'Materia',
                                        value: subjectName
                                    }),
                                    (0, _jsxRuntime.jsx)((0, _labeledValueDefault.default), {
                                        label: 'Curso',
                                        value: courseName
                                    }),
                                    (0, _jsxRuntime.jsx)((0, _labeledValueDefault.default), {
                                        label: 'Grado',
                                        value: gradeName
                                    }),
                                    (0, _jsxRuntime.jsxs)("div", {
                                        className: 'd-flex justify-content-between',
                                        style: {
                                            alignItems: 'center'
                                        },
                                        children: [
                                            workbook && (0, _jsxRuntime.jsx)((0, _packageWorkbookSwitchDefault.default), {
                                                course: course
                                            }),
                                            (0, _jsxRuntime.jsx)((0, _packageEditCourseDefault.default), {
                                                course: course,
                                                extra: false
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    course.type === 'basic' && (0, _jsxRuntime.jsx)("div", {
                        className: 'extra-card px-0',
                        children: (0, _jsxRuntime.jsxs)("div", {
                            className: 'd-flex flex-column text-black mt-3 pt-2',
                            style: {
                                "borderTop": "solid 1px #dee2e6"
                            },
                            children: [
                                (0, _jsxRuntime.jsx)("div", {
                                    className: 'extra-label d-flex justify-content-start',
                                    style: {
                                        fontSize: '1.15rem'
                                    },
                                    children: "Curso complementario"
                                }),
                                !course.extraCourse.course && (0, _jsxRuntime.jsx)("div", {
                                    className: 'flex-shrink-0 d-flex',
                                    children: (0, _jsxRuntime.jsx)((0, _packageEditCourse.PackageSelectComplementaryCourse), {
                                        course: course,
                                        extra: true
                                    })
                                }),
                                course.extraCourse.course && (0, _jsxRuntime.jsxs)("div", {
                                    className: 'extra-course d-flex p-2',
                                    children: [
                                        (0, _jsxRuntime.jsx)("div", {
                                            className: 'flex-shrink-0',
                                            children: (0, _jsxRuntime.jsx)((0, _courseCoverDefault.default), {
                                                className: 'img-fluid',
                                                style: {
                                                    width: '90px',
                                                    borderRadius: '10px',
                                                    "border": "outset 1px #cacacaff"
                                                },
                                                id: extraCourse.course,
                                                name: extraCourse.name_course
                                            })
                                        }),
                                        (0, _jsxRuntime.jsxs)("div", {
                                            className: 'flex-grow-1 ms-3',
                                            style: {
                                                textAlign: 'left'
                                            },
                                            children: [
                                                (0, _jsxRuntime.jsx)((0, _labeledValueDefault.default), {
                                                    label: 'Curso',
                                                    value: extraCourse.name_course
                                                }),
                                                (0, _jsxRuntime.jsx)((0, _labeledValueDefault.default), {
                                                    label: 'Grado',
                                                    value: extraCourse.gradeName[extraCourse.language]
                                                }),
                                                (0, _jsxRuntime.jsx)("div", {
                                                    className: 'd-flex justify-content-end',
                                                    style: {
                                                        alignItems: 'center'
                                                    },
                                                    children: (0, _jsxRuntime.jsx)((0, _packageEditCourseDefault.default), {
                                                        course: course,
                                                        extra: true
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","components/LabeledValue":"d8wzX","components/CourseCover":"bllJU","./PackageEditCourse":"3oHAX","./PackageWorkbookSwitch":"kfAyI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d8wzX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LabeledValue);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("external/lodash");
const LabeledValue = (props)=>{
    const { className = 'mb-2', label, value } = props;
    const attr = (0, _lodash.omit)(props, [
        'className',
        'label',
        'value'
    ]);
    return (0, _jsxRuntime.jsxs)("h6", {
        className: className,
        ...attr,
        children: [
            label ? `${label}: ` : ' ',
            (0, _jsxRuntime.jsx)("span", {
                children: value
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/lodash":"h4nD2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3oHAX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PackageSelectComplementaryCourse", ()=>PackageSelectComplementaryCourse);
parcelHelpers.export(exports, "default", ()=>PackageEditCourse);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
const PackageEditCourse = (props)=>{
    const { offerId, subjectId, cartIndex, type, language } = props.course;
    const to = {
        pathname: `/courses/${subjectId}/${offerId}/${cartIndex}/${type}`,
        search: (0, _react.stringifyQueryString)({
            languageId: language,
            fromCart: true,
            extra: props.extra
        })
    };
    return (0, _jsxRuntime.jsx)((0, _react.Link), {
        style: {
            padding: '8px',
            borderRadius: '100%',
            background: '#ececec',
            cursor: 'pointer'
        },
        to: to,
        children: (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
            name: 'faPenToSquare',
            color: '#1797D0',
            className: 'px-1',
            title: 'editar'
        })
    });
};
const PackageSelectComplementaryCourse = (props)=>{
    const { offerId, subjectId, cartIndex, type, language } = props.course;
    const to = {
        pathname: `/courses/${subjectId}/${offerId}/${cartIndex}/${type}`,
        search: (0, _react.stringifyQueryString)({
            languageId: language,
            fromCart: true,
            extra: true
        })
    };
    return (0, _jsxRuntime.jsx)((0, _react.Link), {
        to: to,
        className: 'd-flex text-decoration-none mt-2',
        children: (0, _jsxRuntime.jsx)("div", {
            className: 'd-flex flex-column justify-content-center',
            style: {
                width: '90px',
                height: '113px',
                borderRadius: '10px',
                "border": "outset 1px #cacacaff"
            },
            children: (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                name: 'faCirclePlus',
                color: '#1797D0',
                className: 'plus-rounded-active fa-2x'
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/fortawesome":"7JvBl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kfAyI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PackageWorkbookSwitch);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("external/clsx");
var _react = require("external/react");
var _switch = require("components/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _labeledValue = require("components/LabeledValue");
var _labeledValueDefault = parcelHelpers.interopDefault(_labeledValue);
var _hook = require("context/payment-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const PackageWorkbookSwitch = (props)=>{
    const { course } = props;
    const { courseId, workbookPrice } = course;
    const { cart, toggleWorkbook } = (0, _hookDefault.default)();
    const checked = (0, _react.useMemo)(()=>cart.properties.workbooks && cart.properties.workbooks[courseId], [
        courseId,
        cart.properties.workbooks
    ]);
    return (0, _jsxRuntime.jsx)("div", {
        className: (0, _clsx.clsx)('d-flex', 'flex-direction-column'),
        children: (0, _jsxRuntime.jsx)((0, _switchDefault.default), {
            defaultChecked: checked,
            style: {
                paddingLeft: '10pc'
            },
            onChange: (e)=>toggleWorkbook(courseId, e.target.checked),
            children: (0, _jsxRuntime.jsx)((0, _labeledValueDefault.default), {
                className: 'd-inline ml-1',
                style: {
                    cursor: 'default'
                },
                value: `A\xf1adir cuaderno de trabajo ($ ${workbookPrice})`
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","external/clsx":"012R0","external/react":"1Glst","components/Switch":"b7rv9","components/LabeledValue":"d8wzX","context/payment-context/hook":"h0PVX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b7rv9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Switch);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("external/clsx");
const Switch = (props)=>{
    const { className, onChange, defaultChecked, children, checked } = props;
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsxs)("label", {
                className: (0, _clsx.clsx)('switch', className),
                children: [
                    (0, _jsxRuntime.jsx)("input", {
                        type: 'checkbox',
                        onChange: onChange,
                        defaultChecked: defaultChecked,
                        checked: checked
                    }),
                    (0, _jsxRuntime.jsx)("span", {
                        className: 'slider round'
                    })
                ]
            }),
            children
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/clsx":"012R0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aYvbn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RemovePackage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _notify = require("components/Notify");
var _hook = require("context/payment-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
function RemovePackage() {
    const { emptyCart } = (0, _hookDefault.default)();
    const navigate = (0, _react.useNavigate)();
    async function handleClick() {
        const { isConfirmed } = await (0, _notify.showConfirmDialog)("\xbfDesea vaciar el carrito?");
        if (!isConfirmed) return;
        await emptyCart();
        (0, _notify.notifySuccess)("Se vaci\xf3 el carrito.");
        navigate('/offers');
    }
    return (0, _jsxRuntime.jsx)("button", {
        className: 'btn btn-danger py-0',
        onClick: handleClick,
        children: "Eliminar"
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","components/Notify":"gZyef","context/payment-context/hook":"h0PVX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dvu5P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _clsx = require("external/clsx");
var _hook = require("context/parent-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _badgeCounter = require("components/BadgeCounter");
var _badgeCounterDefault = parcelHelpers.interopDefault(_badgeCounter);
var _homeItem = require("components/HomeItem");
var _homeItemDefault = parcelHelpers.interopDefault(_homeItem);
const HomePage = ()=>{
    const { homeData, navigation } = (0, _hookDefault.default)();
    const home = homeData;
    const [showPackagesBadges, showUsersBadges] = (0, _react.useMemo)(()=>[
            !!(Number(home.num_packages_not_assigned) || Number(home.num_packages_assigned)),
            !!(Number(home.student_count) || Number(home.tutor_count))
        ], [
        home
    ]);
    return (0, _jsxRuntime.jsx)((0, _react.Card).Body, {
        className: 'mt-2',
        children: (0, _jsxRuntime.jsxs)("div", {
            className: "row mt-3 mb-3",
            children: [
                (0, _jsxRuntime.jsxs)((0, _homeItemDefault.default), {
                    icon: 'faBox',
                    label: 'Paquetes',
                    to: '/home/packages',
                    children: [
                        showPackagesBadges && (0, _jsxRuntime.jsxs)("div", {
                            className: 'text-muted mb-2',
                            children: [
                                (0, _jsxRuntime.jsx)((0, _badgeCounterDefault.default), {
                                    count: Number(home.num_packages_not_assigned),
                                    label: 'paquete'
                                }),
                                (0, _jsxRuntime.jsx)((0, _badgeCounterDefault.default), {
                                    count: Number(home.num_packages_assigned),
                                    label: 'paquete asignado',
                                    plural: 'paquetes asignados'
                                })
                            ]
                        }),
                        (0, _jsxRuntime.jsx)(BottomPadding, {
                            visible: !showPackagesBadges
                        })
                    ]
                }),
                (0, _jsxRuntime.jsxs)((0, _homeItemDefault.default), {
                    icon: 'faUsers',
                    label: 'Usuarios',
                    to: navigation.users.link({
                        role: 'student'
                    }),
                    children: [
                        showUsersBadges && (0, _jsxRuntime.jsxs)("div", {
                            className: 'text-muted mb-2',
                            children: [
                                (0, _jsxRuntime.jsx)((0, _badgeCounterDefault.default), {
                                    count: Number(home.student_count),
                                    label: 'estudiante'
                                }),
                                (0, _jsxRuntime.jsx)((0, _badgeCounterDefault.default), {
                                    count: Number(home.tutor_count),
                                    label: 'tutor',
                                    plural: 'tutores'
                                })
                            ]
                        }),
                        (0, _jsxRuntime.jsx)(BottomPadding, {
                            visible: !showUsersBadges
                        })
                    ]
                }),
                (0, _jsxRuntime.jsx)((0, _homeItemDefault.default), {
                    icon: 'faHandHoldingDollar',
                    label: 'Pagos',
                    to: '/home/payment',
                    children: (0, _jsxRuntime.jsx)(BottomPadding, {})
                }),
                (0, _jsxRuntime.jsx)((0, _homeItemDefault.default), {
                    icon: 'faHeadset',
                    label: 'Apoyo',
                    to: '/home/support',
                    children: (0, _jsxRuntime.jsx)(BottomPadding, {})
                })
            ]
        })
    });
};
const BottomPadding = (props)=>{
    const { visible = true, className = 'text-muted mb-2' } = props;
    return (0, _jsxRuntime.jsx)("div", {
        className: (0, _clsx.clsx)(className, {
            'd-none': !visible
        }),
        children: (0, _jsxRuntime.jsx)("span", {
            className: 'text-white',
            children: "."
        })
    });
};
exports.default = HomePage;

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/clsx":"012R0","context/parent-context/hook":"4wX3K","components/BadgeCounter":"cDM7c","components/HomeItem":"lDz6Y","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4wX3K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useParent);
var _react = require("external/react");
var _clientService = require("services/client.service");
var _userService = require("services/user.service");
var _parentContext = require("context/parent-context");
var _parentContextDefault = parcelHelpers.interopDefault(_parentContext);
var _hook = require("context/auth-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
function useParent() {
    const { user } = (0, _hookDefault.default)();
    const { state, update } = (0, _react.useContext)((0, _parentContextDefault.default).Context);
    const { homeData, supportForm, props: { navigation, params, query } } = state;
    async function deleteUser(userId) {
        const userIndex = state.users.items.findIndex(({ id })=>userId === id);
        if (userIndex < 0) return 'Usuario no encontrado';
        const { data: deletionResponse } = await (0, _userService.userService).delete(userId, user.id);
        if (deletionResponse.user_assigned) return deletionResponse.statusResponse.message;
        update({
            users: {
                items: {
                    $splice: [
                        [
                            userIndex,
                            1
                        ]
                    ]
                }
            }
        });
        return true;
    }
    async function addUser(newUser) {
        await (0, _userService.userService).create({
            ...newUser,
            client_id: user.id,
            role: params.role
        });
        update({
            users: {
                refreshes: {
                    $apply: (i)=>i + 1
                }
            }
        });
    }
    async function editUser(changedUser) {
        changedUser.name = `${changedUser.first_name} ${changedUser.last_name}`;
        update({
            users: {
                items: {
                    [changedUser.index]: {
                        $set: changedUser
                    }
                }
            }
        });
        const editResponse = await (0, _userService.userService).update({
            ...changedUser,
            profile_id: changedUser.id,
            client_id: user.id,
            credentials: {
                password: changedUser.password
            }
        });
        return editResponse;
    }
    async function updateProfile(updatedProfile) {
        const updateResponse = await (0, _clientService.clientService).updateProfile(updatedProfile);
        return updateResponse;
    }
    async function updatePassword(updatedPasswords) {
        const updateResponse = await (0, _clientService.clientService).updatePassword({
            id: user.id,
            oldPassword: updatedPasswords.oldPassword,
            password: updatedPasswords.password
        });
        return updateResponse;
    }
    return {
        homeData,
        updateProfile,
        updatePassword,
        addUser,
        editUser,
        deleteUser,
        supportForm,
        state,
        params,
        query,
        navigation,
        update
    };
}

},{"external/react":"1Glst","services/client.service":"dQ0II","services/user.service":"81Nwf","context/parent-context":"go6YH","context/auth-context/hook":"2UX0M","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cDM7c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BadgeCounter);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("external/clsx");
const BadgeCounter = (props)=>{
    const { count, label, hideAtZero = true } = props;
    const plural = props.plural || `${label}s`;
    return (0, _jsxRuntime.jsxs)("span", {
        className: (0, _clsx.clsx)('badge', 'text-bg-light', 'border mr-1', {
            'd-none': hideAtZero && count == 0
        }),
        style: {
            fontSize: '10px'
        },
        children: [
            count,
            ` ${count === 1 ? label : plural}`
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/clsx":"012R0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lDz6Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HomeItem);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _clsx = require("external/clsx");
const HomeItem = (props)=>{
    const { to, icon, label, children, className } = props;
    return (0, _jsxRuntime.jsx)("div", {
        className: (0, _clsx.clsx)('col-xl-3 col-md-6 col-sm-6 mb-3', className),
        children: (0, _jsxRuntime.jsx)((0, _react.Link), {
            to: to,
            className: 'text-decoration-none',
            children: (0, _jsxRuntime.jsx)((0, _react.Card), {
                className: 'shadow-sm text-center',
                children: (0, _jsxRuntime.jsxs)((0, _react.Card).Body, {
                    className: 'mt-3',
                    children: [
                        (0, _jsxRuntime.jsx)((0, _react.Card).Title, {
                            children: (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                name: icon,
                                className: 'c-default fa-3x'
                            })
                        }),
                        (0, _jsxRuntime.jsx)((0, _react.Card).Text, {
                            className: 'c-default fs-3',
                            children: label
                        }),
                        children
                    ]
                })
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/fortawesome":"7JvBl","external/clsx":"012R0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1HXXH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Support);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _text = require("utilities/text");
var _hook = require("context/auth-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _formValidation = require("utilities/form-validation");
var _formValidationDefault = parcelHelpers.interopDefault(_formValidation);
var _hook1 = require("context/parent-context/hook");
var _hookDefault1 = parcelHelpers.interopDefault(_hook1);
var _supportService = require("services/support.service");
var _notify = require("components/Notify");
var _dreyfousLocation = require("./DreyfousLocation");
var _dreyfousLocationDefault = parcelHelpers.interopDefault(_dreyfousLocation);
var _supportRequestButton = require("./SupportRequestButton");
var _supportRequestButtonDefault = parcelHelpers.interopDefault(_supportRequestButton);
var _supportForm = require("./SupportForm");
var _supportFormDefault = parcelHelpers.interopDefault(_supportForm);
const { createEmailValidation, createRequiredFieldValidation, createPhoneValidation } = (0, _formValidation.validators);
const supportValidations = {
    name: [
        createRequiredFieldValidation('name')
    ],
    email: [
        createRequiredFieldValidation('email'),
        createEmailValidation('email')
    ],
    phone: [
        createRequiredFieldValidation('phone'),
        createPhoneValidation('phone')
    ],
    message: [
        createRequiredFieldValidation('message')
    ]
};
function Support() {
    const { user } = (0, _hookDefault.default)();
    const { supportForm: support, update } = (0, _hookDefault1.default)();
    const [errors, validate, resetErrors] = (0, _formValidationDefault.default)(supportValidations);
    const cleanEntity = ()=>{
        const { id, first_name, last_name, email } = user;
        const name = `${(0, _text.capitalizeFirstLetter)(first_name)} ${(0, _text.capitalizeFirstLetter)(last_name)}`;
        const cleanedForm = {
            id,
            name,
            first_name,
            last_name,
            email,
            message: ''
        };
        resetErrors();
        update({
            supportForm: {
                $shallow: cleanedForm
            }
        });
    };
    async function handleSubmitRequestClick(e) {
        e.preventDefault();
        if (!validate(support, true)) return;
        const response = await (0, _supportService.supportService).sendEmail(support);
        if (response.data.success) {
            (0, _notify.notifySuccess)('Mensaje enviado exitosamente.');
            cleanEntity();
        } else (0, _notify.notifyError)('Error al enviar el correo.');
    }
    (0, _react.useEffect)(()=>{
        validate(support, false);
    }, [
        support
    ]);
    (0, _react.useEffect)(()=>{
        if (user.id) cleanEntity();
    }, [
        user
    ]);
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsx)((0, _react.Card).Body, {
                className: 'd-flex flex-column',
                children: (0, _jsxRuntime.jsxs)("div", {
                    className: 'd-flex flex-grow-1 gap-4',
                    children: [
                        (0, _jsxRuntime.jsx)("div", {
                            className: 'd-flex flex-grow-1 flex-column',
                            children: (0, _jsxRuntime.jsx)((0, _supportFormDefault.default), {
                                errors: errors
                            })
                        }),
                        (0, _jsxRuntime.jsx)("div", {
                            className: 'd-flex flex-grow-1 pb-4 flex-column',
                            children: (0, _jsxRuntime.jsx)((0, _dreyfousLocationDefault.default), {})
                        })
                    ]
                })
            }),
            (0, _jsxRuntime.jsx)((0, _react.Card).Footer, {
                className: 'text-muted bg-white text-right',
                children: (0, _jsxRuntime.jsx)((0, _supportRequestButtonDefault.default), {
                    onClick: handleSubmitRequestClick
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","utilities/text":"aKcMC","context/auth-context/hook":"2UX0M","utilities/form-validation":"1fpQO","context/parent-context/hook":"4wX3K","services/support.service":"hPTIM","components/Notify":"gZyef","./DreyfousLocation":"4fZqh","./SupportRequestButton":"2bc1U","./SupportForm":"iTLOK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hPTIM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SupportService", ()=>SupportService);
parcelHelpers.export(exports, "supportService", ()=>supportService);
var _axios = require("external/axios");
class SupportService {
    async sendEmail(response) {
        return (0, _axios.post)('/homeschooler/send-email', response);
    }
}
const supportService = new SupportService();

},{"external/axios":"3m9lf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4fZqh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DreyfousLocation);
var _jsxRuntime = require("react/jsx-runtime");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
function DreyfousLocation() {
    return (0, _jsxRuntime.jsxs)("div", {
        className: 'flex-grow-1 d-flex flex-column form-control',
        children: [
            (0, _jsxRuntime.jsx)("div", {
                className: 'col-md-12 mb-3',
                children: (0, _jsxRuntime.jsxs)("span", {
                    className: 'fn-s-20 fw-bold',
                    children: [
                        (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                            name: 'faLocationDot'
                        }),
                        " Localizaci\u00F3n"
                    ]
                })
            }),
            (0, _jsxRuntime.jsx)("div", {
                className: 'd-flex flex-grow-1 mb-3',
                children: (0, _jsxRuntime.jsx)("iframe", {
                    className: "flex-grow-1",
                    src: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3787.70929204833!2d-66.08467082397537!3d18.314897975422692!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8c0342fd49b7820d%3A0x8573d2f4d1f2303f!2sDreyfous%20%26%20Associates!5e0!3m2!1ses!2spe!4v1700096369136!5m2!1ses!2spe',
                    style: {
                        border: '0'
                    },
                    loading: 'lazy',
                    referrerPolicy: 'no-referrer-when-downgrade'
                })
            }),
            (0, _jsxRuntime.jsxs)("div", {
                className: 'mb-3 d-grid',
                children: [
                    (0, _jsxRuntime.jsxs)("span", {
                        className: 'fn-s-20 fw-bold',
                        children: [
                            (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                name: 'faEnvelope'
                            }),
                            " Direcci\u00F3n postal"
                        ]
                    }),
                    (0, _jsxRuntime.jsx)("span", {
                        children: " HC-1 Box 29030 PMB 641 Caguas, PR 00725-8900"
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)("div", {
                className: 'mb-3 d-grid',
                children: [
                    (0, _jsxRuntime.jsxs)("span", {
                        className: 'fn-s-20 fw-bold',
                        children: [
                            (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                name: 'faPhone'
                            }),
                            " Tel\u00E9fono"
                        ]
                    }),
                    (0, _jsxRuntime.jsx)("span", {
                        children: " Oficina (787) 706-2700"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/fortawesome":"7JvBl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2bc1U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
const SupportRequestButton = (props)=>{
    const { onClick } = props;
    return (0, _jsxRuntime.jsx)("button", {
        className: 'btn btn-primary mt-2 w-100',
        onClick: onClick,
        children: "Enviar"
    });
};
exports.default = SupportRequestButton;

},{"react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iTLOK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _hook = require("context/parent-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _formTextfield = require("components/FormTextfield");
var _formTextfieldDefault = parcelHelpers.interopDefault(_formTextfield);
var _formTextArea = require("components/FormTextArea");
var _formTextAreaDefault = parcelHelpers.interopDefault(_formTextArea);
const SupportForm = (props)=>{
    const { errors } = props;
    const { supportForm: support, update } = (0, _hookDefault.default)();
    function createFieldProps(placeholder, fieldName, maxLength) {
        return {
            placeholder,
            maxLength,
            fieldName,
            value: support[fieldName],
            submitted: errors.submitted,
            error: errors[fieldName],
            onChange: (e)=>{
                update({
                    supportForm: {
                        [fieldName]: {
                            $set: e.target.value
                        }
                    }
                });
            }
        };
    }
    return (0, _jsxRuntime.jsxs)("form", {
        className: 'd-flex flex-column flex-grow-1',
        autoComplete: 'on',
        children: [
            (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                controlProps: {
                    autoComplete: 'name'
                },
                ...createFieldProps('Nombre', 'name', 25)
            }),
            (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                controlProps: {
                    autoComplete: 'email'
                },
                ...createFieldProps('Correo', 'email', 25)
            }),
            (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                controlProps: {
                    autoComplete: 'phone'
                },
                ...createFieldProps("Tel\xe9fono", 'phone', 15)
            }),
            (0, _jsxRuntime.jsx)((0, _formTextAreaDefault.default), {
                className: 'd-flex flex-grow-1 flex-column',
                controlProps: {
                    rows: 16,
                    className: 'form-control flex-grow-1',
                    style: {
                        resize: 'none'
                    }
                },
                ...createFieldProps('Mensaje', 'message')
            })
        ]
    });
};
exports.default = SupportForm;

},{"react/jsx-runtime":"1dlk8","context/parent-context/hook":"4wX3K","components/FormTextfield":"6jQpP","components/FormTextArea":"7h6vH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7h6vH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FormTextArea);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("external/clsx");
var _react = require("external/react");
function FormTextArea(props) {
    const { fieldName, error, defaultValue, value, placeholder, onChange, rows, maxLength, className, children, submitted, controlProps } = props;
    const errorType = (0, _react.useMemo)(()=>Array.isArray(error) ? 'multiple' : error && 'simple', [
        error
    ]);
    const errorClass = (0, _react.useMemo)(()=>errorType === 'simple' && submitted ? 'visible' : 'invisible', [
        errorType,
        submitted
    ]);
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsxs)("div", {
                className: (0, _clsx.clsx)('form-group', 'mt-2', 'mb-1', className),
                children: [
                    (0, _jsxRuntime.jsx)("textarea", {
                        defaultValue: defaultValue,
                        value: value,
                        placeholder: placeholder,
                        name: fieldName,
                        rows: rows,
                        maxLength: maxLength,
                        onChange: onChange,
                        ...controlProps
                    }),
                    children
                ]
            }),
            errorType !== 'multiple' && (0, _jsxRuntime.jsx)("small", {
                className: (0, _clsx.clsx)('text-danger', errorClass),
                children: error || '&nbsp;'
            }),
            submitted && errorType === 'multiple' && error.length > 0 && (0, _jsxRuntime.jsx)("div", {
                children: (0, _jsxRuntime.jsx)("ul", {
                    className: 'text-danger',
                    style: {
                        fontSize: '12px',
                        margin: 'auto'
                    },
                    children: error.map((text, key)=>(0, _jsxRuntime.jsx)("li", {
                            children: text
                        }, key))
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/clsx":"012R0","external/react":"1Glst","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f3jvn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Packages);
var _jsxRuntime = require("react/jsx-runtime");
var _hook = require("context/package-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _react = require("external/react");
var _packageItem = require("./PackageItem");
var _packageItemDefault = parcelHelpers.interopDefault(_packageItem);
var _selectUserModal = require("pages/home/packages/dialogs/SelectUserModal");
var _selectUserModalDefault = parcelHelpers.interopDefault(_selectUserModal);
var _studentAssignmentWarning = require("pages/home/packages/dialogs/StudentAssignmentWarning");
var _changePackageAliasModal = require("./ChangePackageAliasModal");
var _changePackageAliasModalDefault = parcelHelpers.interopDefault(_changePackageAliasModal);
var _purchasePackage = require("./PackageItem/PurchasePackage");
var _purchasePackageDefault = parcelHelpers.interopDefault(_purchasePackage);
function Packages() {
    const { update, state: { packages }, assignUserToPackage } = (0, _hookDefault.default)();
    async function handleUserSelection(role, selectedUser, purchase) {
        if (selectedUser && purchase) {
            const isConfirmed = role === 'Student' && await (0, _studentAssignmentWarning.studentAssignmentWarning)() || role === 'Tutor';
            if (isConfirmed) {
                await assignUserToPackage(role, selectedUser?.id, purchase?.id);
                update({
                    packages: {
                        items: {
                            [purchase.index]: {
                                [role.toLowerCase()]: {
                                    $set: {
                                        id: selectedUser.id,
                                        name: selectedUser.name
                                    }
                                }
                            }
                        }
                    }
                });
            }
        }
    }
    return (0, _jsxRuntime.jsxs)((0, _react.Card).Body, {
        className: 'mt-2',
        children: [
            (0, _jsxRuntime.jsx)((0, _changePackageAliasModalDefault.default), {}),
            (0, _jsxRuntime.jsx)((0, _selectUserModalDefault.default), {
                onSelectUser: handleUserSelection,
                role: 'Student'
            }),
            (0, _jsxRuntime.jsx)((0, _selectUserModalDefault.default), {
                onSelectUser: handleUserSelection,
                role: 'Tutor'
            }),
            (0, _jsxRuntime.jsxs)("div", {
                className: 'row',
                children: [
                    packages.items.map((item, index)=>(0, _jsxRuntime.jsx)((0, _packageItemDefault.default), {
                            index: index,
                            item: item
                        }, index)),
                    (0, _jsxRuntime.jsx)((0, _purchasePackageDefault.default), {})
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","context/package-context/hook":"cOTE3","external/react":"1Glst","./PackageItem":"knCO5","pages/home/packages/dialogs/SelectUserModal":"23ocH","pages/home/packages/dialogs/StudentAssignmentWarning":"l9Crh","./ChangePackageAliasModal":"fgD3b","./PackageItem/PurchasePackage":"cQIGz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cOTE3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePackage);
var _react = require("external/react");
var _purchaseService = require("services/purchase.service");
var _userService = require("services/user.service");
var _packageContext = require("context/package-context");
var _packageContextDefault = parcelHelpers.interopDefault(_packageContext);
var _hook = require("context/auth-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
function usePackage() {
    const { user } = (0, _hookDefault.default)();
    const { state, update } = (0, _react.useContext)((0, _packageContextDefault.default).Context);
    function setSavingStatus(id, delay, status, ...names) {
        const statusName = names.join('_');
        setTimeout(()=>{
            update({
                saving: {
                    [id]: {
                        $auto: {
                            [statusName]: {
                                $set: status
                            }
                        }
                    }
                }
            });
        }, delay);
    }
    async function assignUserToPackage(role, profileId, purchaseItemId) {
        setSavingStatus(purchaseItemId, 0, true, 'assigning', role.toLowerCase());
        await (0, _purchaseService.purchaseService).assignPurchaseItemUser({
            role: role.toLowerCase(),
            purchaseItemId,
            profileId,
            clientId: user.id
        });
        setSavingStatus(purchaseItemId, 100, false, 'assigning', role.toLowerCase());
    }
    async function addUser(role, newUser) {
        return (0, _userService.userService).create({
            ...newUser,
            client_id: user.id,
            role
        });
    }
    async function savePackage() {
        const purchaseItemUser = {
            purchaseItemId: state.packageItem.data?.id,
            studentId: state.packageItem.data?.student?.id,
            tutorId: state.packageItem.data?.tutor?.id,
            clientId: user.id
        };
        return state.packageItem.data?.assigned ? (0, _purchaseService.purchaseService).updatePurchaseItemUser(purchaseItemUser) : (0, _purchaseService.purchaseService).createPurchaseItemUser(purchaseItemUser);
    }
    const selectedTutor = state.packageItem.data?.tutor;
    const selectedStudent = state.packageItem.data?.student;
    const isAssigned = state.packageItem.data?.assigned;
    const basic = state.packageItem.courses.basic;
    const elective = state.packageItem.courses.elective;
    return {
        state,
        update,
        addUser,
        savePackage,
        assignUserToPackage,
        basic,
        elective,
        isAssigned,
        selectedTutor,
        selectedStudent
    };
}

},{"external/react":"1Glst","services/purchase.service":"gVdre","services/user.service":"81Nwf","context/package-context":"8XRXi","context/auth-context/hook":"2UX0M","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"knCO5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PackageItem);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("external/moment");
var _react = require("external/react");
var _packageItemHeader = require("./PackageItemHeader");
var _packageItemHeaderDefault = parcelHelpers.interopDefault(_packageItemHeader);
var _subscriptionStatus = require("components/SubscriptionStatus");
var _subscriptionStatusDefault = parcelHelpers.interopDefault(_subscriptionStatus);
var _packageField = require("./PackageField");
var _packageFieldDefault = parcelHelpers.interopDefault(_packageField);
var _selectUserButton = require("./SelectUserButton");
var _selectUserButtonDefault = parcelHelpers.interopDefault(_selectUserButton);
var _hook = require("context/package-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const PackageItem = (props)=>{
    const { index, item } = props;
    const { update, state: { saving } } = (0, _hookDefault.default)();
    const missingStudent = (0, _react.useMemo)(()=>item.student === null, [
        item.student
    ]);
    const missingTutor = (0, _react.useMemo)(()=>item.tutor === null, [
        item.tutor
    ]);
    const savingStatus = (0, _react.useMemo)(()=>saving[item.id] || {}, [
        saving,
        item.id
    ]);
    function handleSelectStudent() {
        update({
            modals: {
                selectStudent: {
                    $shallow: {
                        open: true,
                        purchase: {
                            ...item,
                            index
                        },
                        selectedUser: item.student
                    }
                }
            }
        });
    }
    function handleSelectTutor() {
        update({
            modals: {
                selectTutor: {
                    $shallow: {
                        open: true,
                        purchase: {
                            ...item,
                            index
                        },
                        selectedUser: item.tutor
                    }
                }
            }
        });
    }
    return (0, _jsxRuntime.jsx)("div", {
        className: 'col-lg-4 col-md-6 mb-3',
        style: {
            minWidth: 393
        },
        children: (0, _jsxRuntime.jsxs)((0, _react.Card), {
            children: [
                (0, _jsxRuntime.jsx)((0, _packageItemHeaderDefault.default), {
                    id: item.id,
                    alias: item.plan_alias,
                    index: index
                }),
                (0, _jsxRuntime.jsxs)((0, _react.Card).Body, {
                    children: [
                        (0, _jsxRuntime.jsx)("div", {
                            className: 'form-group row mb-2',
                            children: (0, _jsxRuntime.jsxs)("div", {
                                className: 'row col-12',
                                children: [
                                    (0, _jsxRuntime.jsx)("div", {
                                        className: 'col-lg-3 col-md-3 col-sm-3 col-form-label-sm',
                                        children: (0, _jsxRuntime.jsx)("span", {
                                            children: "Plan"
                                        })
                                    }),
                                    (0, _jsxRuntime.jsx)("div", {
                                        className: 'col-lg-3 col-md-9 col-sm-3',
                                        children: (0, _jsxRuntime.jsx)("span", {
                                            children: (0, _jsxRuntime.jsx)((0, _react.Badge), {
                                                pill: true,
                                                bg: 'light',
                                                text: 'dark',
                                                style: {
                                                    border: '1px solid #ccc'
                                                },
                                                className: 'text-capitalize',
                                                children: item.offerName
                                            })
                                        })
                                    }),
                                    (0, _jsxRuntime.jsx)("div", {
                                        className: 'col-lg-3 col-md-3 col-sm-3 col-form-label-sm',
                                        children: (0, _jsxRuntime.jsx)("span", {
                                            children: "Estado"
                                        })
                                    }),
                                    (0, _jsxRuntime.jsx)("div", {
                                        className: 'col-lg-3 col-md-9 col-sm-3',
                                        children: (0, _jsxRuntime.jsx)((0, _subscriptionStatusDefault.default), {
                                            status: item.subscriptionStatus,
                                            subscription: item.subscription
                                        })
                                    })
                                ]
                            })
                        }),
                        (0, _jsxRuntime.jsx)((0, _packageFieldDefault.default), {
                            label: 'Fecha',
                            value: (0, _moment.moment)(item.purchaseDate).format('YYYY-MM-DD'),
                            valueClasses: {
                                configured: true
                            }
                        }),
                        (0, _jsxRuntime.jsx)((0, _packageFieldDefault.default), {
                            label: 'Tutor',
                            value: item.tutor?.name.toUpperCase() ?? 'usuario no asignado',
                            valueClasses: {
                                configured: !missingTutor,
                                "missing-config": missingTutor,
                                "has-embedded-right": true
                            },
                            children: (0, _jsxRuntime.jsx)((0, _selectUserButtonDefault.default), {
                                type: 'tutor',
                                id: item.id,
                                assigned: !missingTutor,
                                assigning: savingStatus.assigning_tutor,
                                onClick: handleSelectTutor
                            })
                        }),
                        (0, _jsxRuntime.jsx)((0, _packageFieldDefault.default), {
                            label: 'Estudiante',
                            value: item.student?.name ?? 'usuario no asignado',
                            valueClasses: {
                                configured: !missingStudent,
                                "missing-config": missingStudent,
                                "has-embedded-right": true
                            },
                            children: (0, _jsxRuntime.jsx)((0, _selectUserButtonDefault.default), {
                                type: 'student',
                                id: item.id,
                                assigned: !missingStudent,
                                assigning: savingStatus.assigning_student,
                                onClick: handleSelectStudent
                            })
                        }),
                        (0, _jsxRuntime.jsx)("div", {
                            className: 'row px-2',
                            children: (0, _jsxRuntime.jsx)((0, _react.Link), {
                                className: 'text-center btn btn-light',
                                to: `/home/packages/${item.id}`,
                                children: "Ver Detalle"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"1dlk8","external/moment":"fMWlp","external/react":"1Glst","./PackageItemHeader":"3Cnuw","components/SubscriptionStatus":"gnl1p","./PackageField":"LTROr","./SelectUserButton":"b9TGm","context/package-context/hook":"cOTE3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3Cnuw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PackageItemHeader);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _hook = require("context/package-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const PackageItemHeader = (props)=>{
    const { alias, id, index } = props;
    const { update } = (0, _hookDefault.default)();
    function handleEditClick() {
        update({
            modals: {
                changePackageAlias: {
                    open: {
                        $set: true
                    },
                    index: {
                        $set: index
                    },
                    id: {
                        $set: id
                    },
                    plan_alias: {
                        $set: alias
                    }
                }
            }
        });
    }
    return (0, _jsxRuntime.jsxs)((0, _react.Card).Header, {
        className: 'bg-white d-flex justify-content-between',
        children: [
            (0, _jsxRuntime.jsx)("span", {
                className: 'fw-bold',
                children: alias
            }),
            (0, _jsxRuntime.jsx)("span", {
                className: 'span--edit',
                title: 'editar',
                onClick: handleEditClick,
                children: (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                    name: 'faPenToSquare'
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/fortawesome":"7JvBl","context/package-context/hook":"cOTE3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gnl1p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
const statusHandlers = {
    active: [
        'success',
        'Activo'
    ],
    canceled: [
        'dark',
        'Cancelado'
    ],
    expired: [
        'dark',
        'Expirada'
    ],
    pending: [
        'success',
        'Pendiente'
    ],
    past_due: [
        'danger',
        'Inactivo'
    ]
};
const SubscriptionStatusBadge = (props)=>{
    const { status, subscription } = props;
    const badge = (0, _react.useMemo)(()=>{
        const [bg, label] = statusHandlers[status];
        return status === 'past_due' ? (0, _jsxRuntime.jsx)((0, _react.Badge), {
            pill: true,
            bg: bg,
            as: (0, _react.Link),
            style: {
                fontSize: '13px',
                cursor: 'pointer'
            },
            to: `/home/payment/history?subscription=${subscription}`,
            title: 'Tienes una deuda pendiente. Haz click aqui!',
            children: label
        }) : (0, _jsxRuntime.jsx)((0, _react.Badge), {
            pill: true,
            bg: bg,
            style: {
                fontSize: '13px',
                cursor: 'default'
            },
            children: label
        });
    }, [
        status,
        subscription
    ]);
    return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: badge
    });
};
exports.default = SubscriptionStatusBadge;

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"LTROr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PackageField);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("external/clsx");
const PackageField = (props)=>{
    const { label, value, valueClasses = {}, children } = props;
    return (0, _jsxRuntime.jsxs)("div", {
        className: 'form-group row',
        style: {
            marginBottom: '1rem'
        },
        children: [
            (0, _jsxRuntime.jsx)("span", {
                className: 'col-sm-3 col-form-label-sm pr-0 ',
                style: {
                    fontSize: '13px'
                },
                children: label
            }),
            (0, _jsxRuntime.jsxs)("div", {
                className: 'col-sm-9 flex d-flex',
                children: [
                    (0, _jsxRuntime.jsx)("input", {
                        type: 'text',
                        className: (0, _clsx.clsx)('form-control', 'form-control-sm', 'd-inline-flex', {
                            ...valueClasses
                        }),
                        value: value,
                        disabled: true
                    }),
                    children
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/clsx":"012R0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b9TGm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectUserButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
const SelectUserButton = (props)=>{
    const { id, type, assigning, assigned, onClick } = props;
    const buttonIcon = (0, _react.useMemo)(()=>{
        if (assigning) return (0, _jsxRuntime.jsx)("span", {
            className: "spinner-border spinner-border-sm",
            role: "status",
            "aria-hidden": "true"
        });
        const icon = type === 'student' ? assigned ? 'faCheck' : 'faUser' : 'faUserTie';
        return (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
            name: icon
        });
    }, [
        type,
        assigning,
        assigned,
        id
    ]);
    const disabled = (0, _react.useMemo)(()=>type == 'student' && assigned ? true : undefined, [
        type,
        assigned
    ]);
    return (0, _jsxRuntime.jsx)((0, _react.Button), {
        variant: "outline-primary",
        size: "sm",
        className: "embedded-button-right",
        disabled: disabled,
        onClick: onClick,
        children: buttonIcon
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/fortawesome":"7JvBl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"23ocH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectUserModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _modalAcceptCancelFooter = require("components/ModalAcceptCancelFooter");
var _modalAcceptCancelFooterDefault = parcelHelpers.interopDefault(_modalAcceptCancelFooter);
var _package = require("types/context/package");
var _hook = require("context/package-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _searchUser = require("./SearchUser");
var _searchUserDefault = parcelHelpers.interopDefault(_searchUser);
var _addUserButton = require("./AddUserButton");
var _addUserButtonDefault = parcelHelpers.interopDefault(_addUserButton);
var _selectUserTable = require("./SelectUserTable");
var _selectUserTableDefault = parcelHelpers.interopDefault(_selectUserTable);
var _addUser = require("../AddUser");
var _addUserDefault = parcelHelpers.interopDefault(_addUser);
var _lodash = require("external/lodash");
var _notify = require("components/Notify");
const SelectUserModal = (props)=>{
    const { role, onSelectUser } = props;
    const { update, state: { modals }, addUser } = (0, _hookDefault.default)();
    const modal = (0, _react.useMemo)(()=>modals[`select${role}`], [
        modals,
        role
    ]);
    const { open, users, search, selectedUser, purchase } = modal;
    function handleUserSelected() {
        if (purchase && purchase[role.toLowerCase()] !== selectedUser) onSelectUser(role, selectedUser, purchase);
        handleClose();
    }
    function handleClose() {
        update({
            modals: {
                [`select${role}`]: {
                    $shallow: (0, _package.clearedSelectUser)
                }
            }
        });
    }
    function handleSelectUser(user) {
        update({
            modals: {
                [`select${role}`]: {
                    selectedUser: {
                        $set: user
                    }
                }
            }
        });
    }
    async function handleUserCreation(role, modal) {
        const { first_name, last_name, phone, email } = modal;
        const user = {
            first_name,
            last_name,
            phone,
            email
        };
        const response = await addUser(role, user);
        const newUser = response.data || {};
        if ((0, _lodash.isUUID)(newUser.id)) update({
            modals: {
                [`select${role}`]: {
                    selectedUser: {
                        $set: newUser
                    },
                    users: {
                        $splice: [
                            [
                                0,
                                0,
                                newUser
                            ]
                        ]
                    }
                }
            }
        });
        (0, _notify.notifySuccess)(`${role === 'Student' ? 'Estudiante' : 'Tutor'} a\xf1adido exitosamente.`);
    }
    const roleName = (0, _react.useMemo)(()=>role === 'Student' ? 'estudiante' : 'tutor', [
        role
    ]);
    return (0, _jsxRuntime.jsxs)((0, _react.Modal), {
        show: open,
        onHide: handleClose,
        size: 'lg',
        centered: true,
        children: [
            (0, _jsxRuntime.jsx)((0, _react.Modal).Header, {
                closeButton: true,
                children: (0, _jsxRuntime.jsxs)("h5", {
                    className: 'text-capitalize',
                    style: {
                        fontFamily: 'Arial, sans-serif',
                        margin: '0'
                    },
                    children: [
                        "Seleccione ",
                        roleName
                    ]
                })
            }),
            (0, _jsxRuntime.jsxs)((0, _react.Modal).Body, {
                children: [
                    (0, _jsxRuntime.jsxs)("div", {
                        className: 'row',
                        children: [
                            (0, _jsxRuntime.jsx)((0, _searchUserDefault.default), {
                                role: role,
                                search: search
                            }),
                            (0, _jsxRuntime.jsx)((0, _addUserButtonDefault.default), {
                                role: role
                            }),
                            (0, _jsxRuntime.jsx)((0, _addUserDefault.default), {
                                onAddUser: handleUserCreation,
                                role: role
                            })
                        ]
                    }),
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'row',
                        children: (0, _jsxRuntime.jsx)("div", {
                            className: 'col-md-12 mt-3',
                            children: (0, _jsxRuntime.jsx)((0, _selectUserTableDefault.default), {
                                role: role,
                                selectedUser: selectedUser,
                                onUserSelected: handleSelectUser,
                                search: search,
                                users: users
                            })
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _modalAcceptCancelFooterDefault.default), {
                onCancel: handleClose,
                onAccept: handleUserSelected
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","components/ModalAcceptCancelFooter":"buHx2","types/context/package":"chkXs","context/package-context/hook":"cOTE3","./SearchUser":"lrK9s","./AddUserButton":"KBOuO","./SelectUserTable":"5xRrH","../AddUser":"3Eiug","external/lodash":"h4nD2","components/Notify":"gZyef","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lrK9s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SearchUser);
var _jsxRuntime = require("react/jsx-runtime");
var _hook = require("context/package-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const SearchUser = (props)=>{
    const { role, search } = props;
    const { update } = (0, _hookDefault.default)();
    function handleSearchChange(e) {
        update({
            modals: {
                [`select${role}`]: {
                    search: {
                        $set: e.target.value
                    }
                }
            }
        });
    }
    return (0, _jsxRuntime.jsx)("div", {
        className: 'col-lg-10 col-md-10 col-10',
        children: (0, _jsxRuntime.jsx)("input", {
            type: 'text',
            className: 'form-control',
            value: search,
            onChange: handleSearchChange
        })
    });
};

},{"react/jsx-runtime":"1dlk8","context/package-context/hook":"cOTE3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"KBOuO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AddUserButton);
var _jsxRuntime = require("react/jsx-runtime");
var _hook = require("context/package-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
const AddUserButton = (props)=>{
    const { role } = props;
    const { update } = (0, _hookDefault.default)();
    function handleAdduser() {
        update({
            modals: {
                [`add${role}`]: {
                    open: {
                        $set: true
                    }
                }
            }
        });
    }
    return (0, _jsxRuntime.jsx)("div", {
        className: 'col-lg-2 col-md-2 col-2',
        children: (0, _jsxRuntime.jsx)("button", {
            className: 'btn btn-primary w-100',
            onClick: handleAdduser,
            children: (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                name: 'faUserPlus'
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","context/package-context/hook":"cOTE3","external/fortawesome":"7JvBl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5xRrH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectUserTable);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _text = require("utilities/text");
var _clsx = require("external/clsx");
const SelectUserTable = (props)=>{
    const { role, search, users, selectedUser, onUserSelected } = props;
    const rolePlural = (0, _react.useMemo)(()=>role === 'Student' ? 'estudiantes' : 'tutores', [
        role
    ]);
    const filterUsers = (0, _react.useMemo)(()=>({ name })=>(0, _text.searchInStrings)(search)(name), [
        search
    ]);
    const filteredUsers = (0, _react.useMemo)(()=>users.filter(filterUsers), [
        filterUsers,
        users
    ]);
    return (0, _jsxRuntime.jsx)("table", {
        className: 'table table-bordered table-hover',
        children: (0, _jsxRuntime.jsxs)("tbody", {
            children: [
                filteredUsers.map((user, index)=>{
                    const selected = selectedUser?.id == user.id;
                    const style = {
                        cursor: selected ? 'default' : 'pointer'
                    };
                    return (0, _jsxRuntime.jsx)("tr", {
                        children: (0, _jsxRuntime.jsxs)("td", {
                            className: (0, _clsx.clsx)('d-flex', 'p-0'),
                            children: [
                                (0, _jsxRuntime.jsx)("input", {
                                    className: 'mx-2 py-1',
                                    type: 'radio',
                                    style: style,
                                    name: 'status',
                                    value: user.id,
                                    checked: selected,
                                    id: 'user_' + index,
                                    onChange: ()=>onUserSelected(user)
                                }),
                                (0, _jsxRuntime.jsx)("label", {
                                    className: 'py-1 ps-1 text-capitalize flex-grow-1',
                                    style: style,
                                    htmlFor: 'user_' + index,
                                    children: user.name
                                })
                            ]
                        })
                    }, index);
                }),
                filteredUsers.length === 0 && (0, _jsxRuntime.jsx)("tr", {
                    children: (0, _jsxRuntime.jsxs)("td", {
                        children: [
                            "No se encontraron ",
                            rolePlural
                        ]
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","utilities/text":"aKcMC","external/clsx":"012R0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3Eiug":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AddUserModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/package-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _formValidation = require("utilities/form-validation");
var _formValidationDefault = parcelHelpers.interopDefault(_formValidation);
var _modalAcceptCancelFooter = require("components/ModalAcceptCancelFooter");
var _modalAcceptCancelFooterDefault = parcelHelpers.interopDefault(_modalAcceptCancelFooter);
var _package = require("types/context/package");
var _addUserForm = require("./AddUserForm");
var _addUserFormDefault = parcelHelpers.interopDefault(_addUserForm);
const { createRequiredFieldValidation, createEmailValidation } = (0, _formValidation.validators);
const addUserValidations = {
    first_name: [
        createRequiredFieldValidation('first_name')
    ],
    last_name: [
        createRequiredFieldValidation('last_name')
    ],
    email: [
        createRequiredFieldValidation('email'),
        createEmailValidation('email')
    ]
};
const AddUserModal = (props)=>{
    const { role, onAddUser } = props;
    const { update, state: { modals } } = (0, _hookDefault.default)();
    const [errors, validate, resetValidations] = (0, _formValidationDefault.default)(addUserValidations);
    const modal = (0, _react.useMemo)(()=>modals[`add${role}`], [
        modals,
        role
    ]);
    function handleAddUser() {
        if (!validate(modal, true)) return;
        onAddUser(role, modal);
        handleClose();
    }
    function handleClose() {
        resetValidations();
        update({
            modals: {
                [`add${role}`]: {
                    $shallow: (0, _package.clearedUserState)
                }
            }
        });
    }
    (0, _react.useEffect)(()=>{
        validate(modal, false);
    }, [
        modal
    ]);
    const roleName = (0, _react.useMemo)(()=>role === 'Student' ? 'Esudiante' : 'Tutor', [
        role
    ]);
    return (0, _jsxRuntime.jsxs)((0, _react.Modal), {
        show: modal.open,
        onHide: handleClose,
        size: 'lg',
        centered: true,
        children: [
            (0, _jsxRuntime.jsx)((0, _react.Modal).Header, {
                closeButton: true,
                children: (0, _jsxRuntime.jsxs)("h5", {
                    className: 'text-capitalize',
                    style: {
                        fontFamily: 'Arial, sans-serif',
                        margin: '0'
                    },
                    children: [
                        "Agregar ",
                        roleName
                    ]
                })
            }),
            (0, _jsxRuntime.jsx)((0, _react.Modal).Body, {
                children: (0, _jsxRuntime.jsx)((0, _react.Row), {
                    children: (0, _jsxRuntime.jsx)((0, _react.Col), {
                        children: (0, _jsxRuntime.jsx)((0, _addUserFormDefault.default), {
                            role: role,
                            errors: errors
                        })
                    })
                })
            }),
            (0, _jsxRuntime.jsx)((0, _modalAcceptCancelFooterDefault.default), {
                onCancel: handleClose,
                onAccept: handleAddUser
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/package-context/hook":"cOTE3","utilities/form-validation":"1fpQO","components/ModalAcceptCancelFooter":"buHx2","types/context/package":"chkXs","./AddUserForm":"lwtnW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lwtnW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AddUserForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/package-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _formTextfield = require("components/FormTextfield");
var _formTextfieldDefault = parcelHelpers.interopDefault(_formTextfield);
const AddUserForm = (props)=>{
    const { role, errors } = props;
    const { update, state: { modals } } = (0, _hookDefault.default)();
    const modal = (0, _react.useMemo)(()=>modals[`add${role}`], [
        modals,
        role
    ]);
    function createFieldProps(placeholder, fieldName, maxLength) {
        return {
            placeholder,
            maxLength,
            fieldName,
            value: modal[fieldName],
            submitted: errors.submitted,
            error: errors[fieldName],
            onChange: (e)=>{
                update({
                    modals: {
                        [`add${role}`]: {
                            [fieldName]: {
                                $set: e.target.value.trim()
                            }
                        }
                    }
                });
            }
        };
    }
    return (0, _jsxRuntime.jsxs)((0, _react.Form), {
        children: [
            (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                ...createFieldProps('Nombre', 'first_name', 25)
            }),
            (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                ...createFieldProps('Apellido', 'last_name', 25)
            }),
            (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                ...createFieldProps('Correo', 'email')
            }),
            (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                ...createFieldProps("T\xe9lefono", 'phone')
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/package-context/hook":"cOTE3","components/FormTextfield":"6jQpP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l9Crh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "studentAssignmentWarning", ()=>studentAssignmentWarning);
parcelHelpers.export(exports, "StudentAssignmentWarning", ()=>StudentAssignmentWarning);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/package-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
async function studentAssignmentWarning() {
    const { isConfirmed } = await (0, _react.Swal).fire({
        text: "La asignaci\xf3n del estudiante es irreversible, si est\xe1s seguro de aplicar esta asignaci\xf3n puedes continuar.",
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#1797D0',
        cancelButtonColor: '#e9e9e9',
        confirmButtonText: "Confirmar Asignaci\xf3n",
        showCloseButton: true,
        reverseButtons: true
    });
    return isConfirmed;
}
const StudentAssignmentWarning = ()=>{
    const { update, state: { modals } } = (0, _hookDefault.default)();
    return (0, _jsxRuntime.jsx)((0, _react.Alert), {
        show: modals.studentAssignmentWarning.open,
        variant: 'warning',
        onClose: ()=>update({
                modals: {
                    studentAssignmentWarning: {
                        open: {
                            $set: false
                        }
                    }
                }
            }),
        className: 'alert--alert',
        dismissible: true,
        children: (0, _jsxRuntime.jsx)((0, _react.Alert).Heading, {
            children: (0, _jsxRuntime.jsxs)("span", {
                style: {
                    fontSize: '14px'
                },
                children: [
                    (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                        name: 'faCircleExclamation'
                    }),
                    "Recuerda, la asignaci\u00F3n del estudiante es irrevocable, ante alg\u00FAn error deber\u00E1 comunicarse con el equipo de soporte. "
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/package-context/hook":"cOTE3","external/fortawesome":"7JvBl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fgD3b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ChangePackageAlias);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/package-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _formTextfield = require("components/FormTextfield");
var _formTextfieldDefault = parcelHelpers.interopDefault(_formTextfield);
var _formValidation = require("utilities/form-validation");
var _formValidationDefault = parcelHelpers.interopDefault(_formValidation);
var _offerService = require("services/offer.service");
var _notify = require("components/Notify");
var _modalAcceptCancelFooter = require("components/ModalAcceptCancelFooter");
var _modalAcceptCancelFooterDefault = parcelHelpers.interopDefault(_modalAcceptCancelFooter);
var _package = require("types/context/package");
const { createRequiredFieldValidation } = (0, _formValidation.validators);
const planAliasValidations = {
    plan_alias: [
        createRequiredFieldValidation('plan_alias')
    ]
};
function ChangePackageAlias() {
    const { state: { modals: { changePackageAlias: modal } }, update } = (0, _hookDefault.default)();
    const [errors, validate] = (0, _formValidationDefault.default)(planAliasValidations);
    function handleClose() {
        update({
            modals: {
                changePackageAlias: {
                    $shallow: (0, _package.clearedChangedPackageAlias)
                }
            }
        });
    }
    function createFieldProps(placeholder, fieldName, maxLength) {
        return {
            placeholder,
            maxLength,
            fieldName,
            value: modal[fieldName],
            submitted: errors.submitted,
            error: errors[fieldName],
            onChange: (e)=>{
                update({
                    modals: {
                        changePackageAlias: {
                            [fieldName]: {
                                $set: e.target.value
                            }
                        }
                    }
                });
            }
        };
    }
    async function handleChangeAlias(e) {
        e.preventDefault();
        if (!validate(modal, true)) return;
        const request = {
            purchaseitemid: modal.id,
            plan_alias: modal.plan_alias
        };
        const response = await (0, _offerService.offerService).updateCustomNameOffer(request);
        update({
            packages: {
                items: {
                    [modal.index]: {
                        plan_alias: {
                            $set: modal.plan_alias
                        }
                    }
                }
            }
        });
        (0, _notify.notifySuccess)("Se actualiz\xf3 el alias correctamente.");
        handleClose();
    }
    (0, _react.useEffect)(()=>{
        validate(modal, false);
    }, [
        modal
    ]);
    return (0, _jsxRuntime.jsxs)((0, _react.Modal), {
        show: modal.open,
        onHide: handleClose,
        size: 'lg',
        centered: true,
        children: [
            (0, _jsxRuntime.jsx)((0, _react.Modal).Header, {
                closeButton: true,
                children: (0, _jsxRuntime.jsx)("h5", {
                    className: 'text-capitalize',
                    style: {
                        fontFamily: 'Arial, sans-serif',
                        margin: '0'
                    },
                    children: "Editar"
                })
            }),
            (0, _jsxRuntime.jsx)((0, _react.Modal).Body, {
                children: (0, _jsxRuntime.jsx)("div", {
                    className: 'row mb-3',
                    children: (0, _jsxRuntime.jsx)("div", {
                        className: 'col-12',
                        children: (0, _jsxRuntime.jsx)((0, _react.Form), {
                            children: (0, _jsxRuntime.jsxs)((0, _react.Form).Group, {
                                children: [
                                    (0, _jsxRuntime.jsx)((0, _react.Form).Label, {
                                        children: "Ingrese un alias para identificar su plan"
                                    }),
                                    (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                                        ...createFieldProps('Nombre', 'plan_alias', 35)
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            (0, _jsxRuntime.jsx)((0, _modalAcceptCancelFooterDefault.default), {
                onCancel: handleClose,
                onAccept: handleChangeAlias
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/package-context/hook":"cOTE3","components/FormTextfield":"6jQpP","utilities/form-validation":"1fpQO","services/offer.service":"luCvD","components/Notify":"gZyef","components/ModalAcceptCancelFooter":"buHx2","types/context/package":"chkXs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cQIGz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PurchasePackage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _clsx = require("external/clsx");
function PurchasePackage() {
    return (0, _jsxRuntime.jsx)("div", {
        className: 'col-lg-4 col-md-6 d-flex pb-3',
        children: (0, _jsxRuntime.jsx)((0, _react.Link), {
            to: '/offers',
            className: 'd-inline-block text-decoration-none w-100',
            children: (0, _jsxRuntime.jsxs)("div", {
                className: (0, _clsx.clsx)('container__selectedCourse', 'buy-package'),
                children: [
                    (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                        name: 'faCirclePlus',
                        color: '#CCCCCC',
                        className: 'plus-rounded-default fa-3x'
                    }),
                    (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                        name: 'faCirclePlus',
                        color: '#1797D0',
                        className: 'plus-rounded-active fa-3x'
                    }),
                    (0, _jsxRuntime.jsxs)("span", {
                        children: [
                            "Compra un ",
                            (0, _jsxRuntime.jsx)("br", {}),
                            " nuevo paquete"
                        ]
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/fortawesome":"7JvBl","external/clsx":"012R0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1TgX6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PackagePage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _selectUserModal = require("pages/home/packages/dialogs/SelectUserModal");
var _selectUserModalDefault = parcelHelpers.interopDefault(_selectUserModal);
var _hook = require("context/package-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _savePackageButton = require("./SavePackageButton");
var _savePackageButtonDefault = parcelHelpers.interopDefault(_savePackageButton);
var _planInfo = require("components/PlanInfo");
var _planInfoDefault = parcelHelpers.interopDefault(_planInfo);
var _courseList = require("components/CourseList");
var _courseListDefault = parcelHelpers.interopDefault(_courseList);
var _selectTutor = require("components/SelectTutor");
var _selectTutorDefault = parcelHelpers.interopDefault(_selectTutor);
var _selectStudent = require("components/SelectStudent");
var _selectStudentDefault = parcelHelpers.interopDefault(_selectStudent);
var _lodash = require("external/lodash");
const PackagePage = ()=>{
    const { update, state: { packageItem }, selectedStudent, selectedTutor } = (0, _hookDefault.default)();
    const [clean, updateClean] = (0, _react.useState)(true);
    const saveDisabled = (0, _react.useMemo)(()=>clean || !((0, _lodash.isUUID)(selectedStudent?.id) && (0, _lodash.isUUID)(selectedTutor?.id)), [
        selectedStudent,
        selectedTutor,
        clean
    ]);
    async function handleUserSelection(role, selectedUser, purchase) {
        if (selectedUser !== null) {
            const updateUser = {
                [role.toLowerCase()]: selectedUser
            };
            update({
                packageItem: {
                    data: {
                        $shallow: updateUser
                    }
                }
            });
        }
    }
    return (0, _jsxRuntime.jsxs)((0, _react.Card).Body, {
        className: 'd-flex flex-column',
        children: [
            (0, _jsxRuntime.jsx)((0, _selectUserModalDefault.default), {
                onSelectUser: handleUserSelection,
                role: 'Student'
            }),
            (0, _jsxRuntime.jsx)((0, _selectUserModalDefault.default), {
                onSelectUser: handleUserSelection,
                role: 'Tutor'
            }),
            (0, _jsxRuntime.jsx)((0, _planInfoDefault.default), {
                packageItem: packageItem.data
            }),
            (0, _jsxRuntime.jsxs)("div", {
                className: 'd-flex mt-3 gap-3',
                children: [
                    (0, _jsxRuntime.jsx)((0, _selectStudentDefault.default), {
                        packageItem: packageItem.data,
                        update: update,
                        changed: ()=>updateClean(false)
                    }),
                    (0, _jsxRuntime.jsx)((0, _selectTutorDefault.default), {
                        packageItem: packageItem.data,
                        update: update,
                        changed: ()=>updateClean(false)
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _courseListDefault.default), {
                courses: packageItem.courses.basic || [],
                source: 'basic'
            }),
            (0, _jsxRuntime.jsx)((0, _courseListDefault.default), {
                courses: packageItem.courses.elective || [],
                source: 'elective'
            }),
            (0, _jsxRuntime.jsx)("div", {
                className: 'flex-grow-1'
            }),
            (0, _jsxRuntime.jsx)("div", {
                className: 'mt-3',
                children: (0, _jsxRuntime.jsx)("div", {
                    className: 'col-md-12',
                    children: (0, _jsxRuntime.jsx)((0, _savePackageButtonDefault.default), {
                        saveDisabled: saveDisabled
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","pages/home/packages/dialogs/SelectUserModal":"23ocH","context/package-context/hook":"cOTE3","./SavePackageButton":"4Mkx9","components/PlanInfo":"3FPyp","components/CourseList":"1GGij","components/SelectTutor":"2lMLI","components/SelectStudent":"8D7ey","external/lodash":"h4nD2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Mkx9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("external/clsx");
var _react = require("external/react");
var _hook = require("context/package-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _studentAssignmentWarning = require("pages/home/packages/dialogs/StudentAssignmentWarning");
var _notify = require("components/Notify");
const SavePackageButton = (props)=>{
    const { saveDisabled } = props;
    const navigate = (0, _react.useNavigate)();
    const { isAssigned, savePackage } = (0, _hookDefault.default)();
    const label = (0, _react.useMemo)(()=>isAssigned ? 'Guardar' : 'Asignar', [
        isAssigned
    ]);
    async function handleClick(e) {
        e.preventDefault();
        const successMessage = isAssigned ? 'Se actualizo el registro satisfactoriamente.' : "Asignaci\xf3n realizada, recibir\xe1s en tu correo la informaci\xf3n del paquete.";
        const isConfirmed = await (isAssigned ? Promise.resolve(true) : (0, _studentAssignmentWarning.studentAssignmentWarning)());
        if (!isConfirmed) return;
        await savePackage();
        await (0, _notify.showConfirmDialog)(successMessage, {
            icon: 'success',
            showCancelButton: false
        });
        navigate('/home/packages');
    }
    return (0, _jsxRuntime.jsx)((0, _react.Link), {
        className: (0, _clsx.clsx)('btn', 'btn-secondary', 'btn-lg', 'd-flex', 'justify-content-center', 'flex-column', 'w-100', {
            disabled: saveDisabled
        }),
        style: {
            height: '86px'
        },
        onClick: handleClick,
        to: '/home/packages',
        children: label
    });
};
exports.default = SavePackageButton;

},{"react/jsx-runtime":"1dlk8","external/clsx":"012R0","external/react":"1Glst","context/package-context/hook":"cOTE3","pages/home/packages/dialogs/StudentAssignmentWarning":"l9Crh","components/Notify":"gZyef","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3FPyp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PlanInfo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _text = require("utilities/text");
var _subscriptionStatus = require("components/SubscriptionStatus");
var _subscriptionStatusDefault = parcelHelpers.interopDefault(_subscriptionStatus);
const PlanInfo = (props)=>{
    const { packageItem, className } = props;
    return (0, _jsxRuntime.jsxs)((0, _react.Card), {
        className: className,
        style: {
            borderRadius: '10px'
        },
        children: [
            (0, _jsxRuntime.jsx)((0, _react.Card).Header, {
                className: 'header-card-color'
            }),
            (0, _jsxRuntime.jsx)((0, _react.Card).Body, {
                children: packageItem?.id && (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        (0, _jsxRuntime.jsxs)("div", {
                            className: 'd-flex justify-content-between mb-2',
                            children: [
                                (0, _jsxRuntime.jsxs)("p", {
                                    className: 'text-capitalize',
                                    style: {
                                        fontWeight: '500',
                                        margin: '0'
                                    },
                                    children: [
                                        "Plan ",
                                        packageItem?.offerName
                                    ]
                                }),
                                packageItem?.subscriptionStatus !== null && (0, _jsxRuntime.jsx)((0, _subscriptionStatusDefault.default), {
                                    status: packageItem?.subscriptionStatus,
                                    subscription: packageItem?.subscription
                                })
                            ]
                        }),
                        (0, _jsxRuntime.jsx)("p", {
                            style: {
                                margin: '0'
                            },
                            children: (0, _jsxRuntime.jsxs)("span", {
                                children: [
                                    "Miembro desde ",
                                    (0, _jsxRuntime.jsx)("b", {
                                        children: (0, _text.convertDateToText)(packageItem?.purchaseDate)
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","utilities/text":"aKcMC","components/SubscriptionStatus":"gnl1p","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1GGij":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CourseList);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _clsx = require("external/clsx");
var _course = require("./Course");
var _courseDefault = parcelHelpers.interopDefault(_course);
const sourceTextMap = {
    basic: 'Principales',
    elective: 'Electivos',
    extra: 'Complementarios'
};
const CourseList = (props)=>{
    const { source, courses } = props;
    const sourceLabel = (0, _react.useMemo)(()=>sourceTextMap[source], [
        source
    ]);
    const hasCourses = (0, _react.useMemo)(()=>courses.length > 0, [
        courses
    ]);
    return (0, _jsxRuntime.jsxs)((0, _react.Card), {
        className: (0, _clsx.clsx)('mt-3', {
            'd-none': !hasCourses
        }),
        children: [
            (0, _jsxRuntime.jsx)((0, _react.Card).Header, {
                className: 'bg-white d-flex justify-content-between',
                children: (0, _jsxRuntime.jsxs)("h6", {
                    style: {
                        margin: '0'
                    },
                    children: [
                        "Cursos ",
                        sourceLabel
                    ]
                })
            }),
            (0, _jsxRuntime.jsx)("div", {
                className: (0, _clsx.clsx)('bodySubjects', {
                    'd-none': !hasCourses
                }),
                children: courses.map((course)=>(0, _jsxRuntime.jsx)((0, _courseDefault.default), {
                        ...course
                    }, course.id))
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/clsx":"012R0","./Course":"cOWRP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cOWRP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Course);
var _jsxRuntime = require("react/jsx-runtime");
var _courseCover = require("components/CourseCover");
var _courseCoverDefault = parcelHelpers.interopDefault(_courseCover);
const Course = (props)=>{
    const { id, name } = props;
    return (0, _jsxRuntime.jsxs)("div", {
        className: 'containerSelected',
        children: [
            (0, _jsxRuntime.jsx)("div", {
                className: 'containerSelectedBody package-courses-detail',
                children: (0, _jsxRuntime.jsx)((0, _courseCoverDefault.default), {
                    id: id,
                    name: name
                })
            }),
            (0, _jsxRuntime.jsx)("div", {
                className: 'containerSelectedFooter',
                children: (0, _jsxRuntime.jsx)("p", {
                    children: name
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","components/CourseCover":"bllJU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2lMLI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectTutor);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("external/clsx");
var _lodash = require("external/lodash");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _avatar = require("components/Avatar");
var _avatarDefault = parcelHelpers.interopDefault(_avatar);
const SelectTutor = (props)=>{
    const { changed, update, packageItem, className = 'card flex-grow-1 mb-3 d-flex flex-column justify-content-center' } = props;
    const selectedTutor = packageItem?.tutor;
    const hasTutor = (0, _react.useMemo)(()=>(0, _lodash.isUUID)(selectedTutor?.id), [
        selectedTutor
    ]);
    function handleSelectTutorClick() {
        const selectTutorModal = {
            open: true,
            selectedUser: selectedTutor,
            purchase: packageItem
        };
        update && update({
            modals: {
                selectTutor: {
                    $shallow: selectTutorModal
                }
            }
        });
        changed && changed();
    }
    function handleRemoveTutorClick() {
        update && update({
            packageItem: {
                data: {
                    tutor: {
                        $set: null
                    }
                }
            }
        });
        changed && changed();
    }
    return (0, _jsxRuntime.jsxs)("div", {
        className: className,
        children: [
            (0, _jsxRuntime.jsxs)((0, _react.Button), {
                variant: 'outline-primary',
                size: 'lg',
                className: (0, _clsx.clsx)('w-100', {
                    'd-none': hasTutor || !update
                }),
                style: {
                    height: '86px'
                },
                onClick: handleSelectTutorClick,
                children: [
                    (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                        name: 'faUserTie'
                    }),
                    " Selecciona un tutor"
                ]
            }),
            (0, _jsxRuntime.jsx)("div", {
                className: (0, _clsx.clsx)({
                    'd-none': !hasTutor
                }),
                children: (0, _jsxRuntime.jsx)("div", {
                    className: 'card-body px-0',
                    children: (0, _jsxRuntime.jsxs)("div", {
                        className: 'd-flex text-black',
                        style: {
                            padding: '0px 10px'
                        },
                        children: [
                            (0, _jsxRuntime.jsx)((0, _avatarDefault.default), {
                                name: selectedTutor?.first_name,
                                lastname: selectedTutor?.last_name,
                                size: 'sm'
                            }),
                            (0, _jsxRuntime.jsxs)("div", {
                                className: 'flex-grow-1 ms-3 fn-s-14 justify-content-between',
                                style: {
                                    textAlign: 'left',
                                    display: 'grid',
                                    borderRight: !update ? 'none' : '1px solid #ccc'
                                },
                                children: [
                                    (0, _jsxRuntime.jsxs)("span", {
                                        className: 'text-capitalize',
                                        children: [
                                            " Tutor: ",
                                            selectedTutor?.first_name,
                                            ' ',
                                            " ",
                                            selectedTutor?.last_name,
                                            " "
                                        ]
                                    }),
                                    (0, _jsxRuntime.jsxs)("span", {
                                        children: [
                                            "Email: ",
                                            selectedTutor?.email
                                        ]
                                    })
                                ]
                            }),
                            (0, _jsxRuntime.jsx)("div", {
                                className: (0, _clsx.clsx)({
                                    'd-none': !update
                                }),
                                children: (0, _jsxRuntime.jsxs)("span", {
                                    className: 'span--close',
                                    style: {
                                        fontSize: '34px',
                                        marginLeft: '15px',
                                        marginRight: '5px'
                                    },
                                    onClick: handleRemoveTutorClick,
                                    children: [
                                        " ",
                                        (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                            name: 'faXmark'
                                        }),
                                        " "
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/clsx":"012R0","external/lodash":"h4nD2","external/react":"1Glst","external/fortawesome":"7JvBl","components/Avatar":"fqaJ2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fqaJ2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
const classNameBySize = {
    'sm': 'circle-avatar-sm text-center mx-auto',
    'md': 'circle-avatar-md text-center mx-auto',
    'lg': 'circle-avatar-lg text-center mx-auto mb-1 mt-1'
};
const Avatar = (props)=>{
    const { name = '', lastname = '', size = 'lg' } = props;
    const initials = (0, _react.useMemo)(()=>`${name.charAt(0)}${lastname.charAt(0)}`.toUpperCase(), [
        name,
        lastname
    ]);
    const className = (0, _react.useMemo)(()=>classNameBySize[size], [
        size
    ]);
    return (0, _jsxRuntime.jsx)("div", {
        className: className,
        children: (0, _jsxRuntime.jsx)("span", {
            children: initials
        })
    });
};
exports.default = Avatar;

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8D7ey":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectStudent);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("external/lodash");
var _clsx = require("external/clsx");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _avatar = require("components/Avatar");
var _avatarDefault = parcelHelpers.interopDefault(_avatar);
var _notify = require("components/Notify");
const SelectStudent = (props)=>{
    const { changed, update, packageItem, className = 'card flex-grow-1 mb-3 d-flex flex-column justify-content-center' } = props;
    const selectedStudent = packageItem?.student;
    const hasStudent = (0, _react.useMemo)(()=>(0, _lodash.isUUID)(selectedStudent?.id), [
        selectedStudent
    ]);
    function handleSelectStudentClick() {
        const selectStudentModal = {
            open: true,
            selectedUser: selectedStudent,
            purchase: packageItem
        };
        update && update({
            modals: {
                selectStudent: {
                    $shallow: selectStudentModal
                }
            }
        });
        changed && changed();
    }
    function handleRemoveStudentClick() {
        if (packageItem?.assigned) (0, _notify.notifyWarning)("Para cambiar el estudiante deber\xe1 comunicarse con el equipo de soporte.");
        else {
            update && update({
                packageItem: {
                    data: {
                        student: {
                            $set: null
                        }
                    }
                }
            });
            changed && changed();
        }
    }
    return (0, _jsxRuntime.jsxs)("div", {
        className: className,
        children: [
            (0, _jsxRuntime.jsxs)((0, _react.Button), {
                variant: 'outline-primary',
                size: 'lg',
                className: (0, _clsx.clsx)('w-100', {
                    'd-none': hasStudent || !update
                }),
                style: {
                    height: '86px'
                },
                onClick: handleSelectStudentClick,
                children: [
                    (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                        name: 'faUser'
                    }),
                    " Selecciona un estudiante"
                ]
            }),
            (0, _jsxRuntime.jsx)("div", {
                className: (0, _clsx.clsx)({
                    'd-none': !hasStudent
                }),
                children: (0, _jsxRuntime.jsx)("div", {
                    className: 'card-body px-0',
                    children: (0, _jsxRuntime.jsxs)("div", {
                        className: 'd-flex text-black',
                        style: {
                            padding: '0px 10px'
                        },
                        children: [
                            (0, _jsxRuntime.jsx)((0, _avatarDefault.default), {
                                name: selectedStudent?.first_name,
                                lastname: selectedStudent?.last_name,
                                size: 'sm'
                            }),
                            (0, _jsxRuntime.jsxs)("div", {
                                className: 'flex-grow-1 ms-3 fn-s-14 justify-content-between',
                                style: {
                                    textAlign: 'left',
                                    display: 'grid',
                                    borderRight: !update ? 'none' : '1px solid #ccc'
                                },
                                children: [
                                    (0, _jsxRuntime.jsxs)("span", {
                                        className: 'text-capitalize',
                                        children: [
                                            " Estudiante: ",
                                            selectedStudent?.first_name,
                                            ' ',
                                            " ",
                                            selectedStudent?.last_name,
                                            " "
                                        ]
                                    }),
                                    (0, _jsxRuntime.jsxs)("span", {
                                        children: [
                                            "Email: ",
                                            selectedStudent?.email
                                        ]
                                    })
                                ]
                            }),
                            (0, _jsxRuntime.jsx)("div", {
                                className: (0, _clsx.clsx)({
                                    'd-none': !update
                                }),
                                children: (0, _jsxRuntime.jsxs)("span", {
                                    className: 'span--close',
                                    style: {
                                        fontSize: '34px',
                                        marginLeft: '15px',
                                        marginRight: '5px'
                                    },
                                    onClick: handleRemoveStudentClick,
                                    children: [
                                        " ",
                                        (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                            name: 'faXmark'
                                        }),
                                        " "
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/lodash":"h4nD2","external/clsx":"012R0","external/react":"1Glst","external/fortawesome":"7JvBl","components/Avatar":"fqaJ2","components/Notify":"gZyef","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Msrx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UsersPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/parent-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _userCard = require("./UserCard");
var _userCardDefault = parcelHelpers.interopDefault(_userCard);
var _editUser = require("./EditUser");
var _editUserDefault = parcelHelpers.interopDefault(_editUser);
var _notify = require("components/Notify");
var _text = require("utilities/text");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _clsx = require("external/clsx");
const UsersPage = ()=>{
    const { update, state: { users }, params: { role }, deleteUser, navigation } = (0, _hookDefault.default)();
    function handleEditUser(index, user) {
        user.index = index;
        update({
            modals: {
                editUser: {
                    open: {
                        $set: true
                    },
                    user: {
                        $set: user
                    }
                }
            }
        });
    }
    const [roleText, roleIcon, newUserLink] = (0, _react.useMemo)(()=>role === 'student' ? [
            'Estudiante',
            'faGraduationCap',
            navigation.newUser.link({
                role: 'student'
            })
        ] : [
            'Tutor',
            'faPersonChalkboard',
            navigation.newUser.link({
                role: 'tutor'
            })
        ], [
        role
    ]);
    async function handleDeleteUser(user) {
        if (user.packages > 0) return (0, _notify.notifyError)(`No se puede eliminar el ${role === 'student' ? 'estudiante' : 'tutor'}: ${user.name}, si desea hacerlo deber\xe1 comunicarse con el equipo de soporte.`);
        const { isConfirmed } = await (0, _notify.showConfirmDialog)(`\xbfEst\xe1 seguro que desea eliminar este ${roleText}?`);
        if (!isConfirmed) return;
        const deletionResult = await deleteUser(user.id);
        if (deletionResult !== true) return (0, _notify.notifyError)(deletionResult);
        return (0, _notify.notifySuccess)(`${(0, _text.capitalizeFirstLetter)(roleText)} eliminado exitosamente.`);
    }
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsxs)((0, _react.Card).Body, {
                className: 'mt-2',
                children: [
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'row',
                        children: users.items.map((user, index)=>(0, _jsxRuntime.jsx)((0, _userCardDefault.default), {
                                user: user,
                                onEditUserClick: (user)=>handleEditUser(index, user),
                                onDeleteClick: handleDeleteUser
                            }, index))
                    }),
                    (0, _jsxRuntime.jsx)((0, _editUserDefault.default), {})
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _react.Card).Footer, {
                className: 'py-2 d-flex justify-content-end pl-0',
                children: (0, _jsxRuntime.jsxs)((0, _react.Link), {
                    to: newUserLink,
                    style: {
                        width: '170px'
                    },
                    className: (0, _clsx.clsx)('language__filter p-2 mt-2 button'),
                    children: [
                        (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                            name: roleIcon
                        }),
                        " Nuevo ",
                        roleText
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/parent-context/hook":"4wX3K","./UserCard":"cI0EF","./EditUser":"71rig","components/Notify":"gZyef","utilities/text":"aKcMC","external/fortawesome":"7JvBl","external/clsx":"012R0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cI0EF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UserCard);
var _jsxRuntime = require("react/jsx-runtime");
var _userCardFooter = require("./UserCardFooter");
var _userCardFooterDefault = parcelHelpers.interopDefault(_userCardFooter);
var _userCardContent = require("./UserCardContent");
var _userCardContentDefault = parcelHelpers.interopDefault(_userCardContent);
const UserCard = (props)=>{
    const { user, onEditUserClick, onDeleteClick } = props;
    return (0, _jsxRuntime.jsx)("div", {
        className: 'col-lg-4 col-md-6 mb-3',
        children: (0, _jsxRuntime.jsx)("div", {
            className: 'card',
            style: {
                borderRadius: '10px'
            },
            children: (0, _jsxRuntime.jsxs)("div", {
                className: 'card-body px-0',
                children: [
                    (0, _jsxRuntime.jsx)((0, _userCardContentDefault.default), {
                        user: user,
                        onEditUserClick: onEditUserClick
                    }),
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'row',
                        style: {
                            padding: '0px 10px'
                        },
                        children: (0, _jsxRuntime.jsx)("span", {
                            children: (0, _jsxRuntime.jsx)("hr", {})
                        })
                    }),
                    (0, _jsxRuntime.jsx)((0, _userCardFooterDefault.default), {
                        user: user,
                        onDeleteClick: onDeleteClick
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","./UserCardFooter":"c4gxv","./UserCardContent":"keDiO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c4gxv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UserCardFooter);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _hook = require("context/parent-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _clsx = require("external/clsx");
const UserCardFooter = (props)=>{
    const { navigation, params: { role } } = (0, _hookDefault.default)();
    const { user, onDeleteClick } = props;
    const detailsDisabled = (0, _react.useMemo)(()=>user.packages === 0, [
        user.packages
    ]);
    return (0, _jsxRuntime.jsxs)("div", {
        className: 'row',
        style: {
            padding: '0px 10px'
        },
        children: [
            (0, _jsxRuntime.jsx)("div", {
                className: 'col-md-10 col-sm-10 col-10',
                children: (0, _jsxRuntime.jsx)((0, _react.Link), {
                    "aria-disabled": detailsDisabled,
                    to: navigation.userPackages.link({
                        role: role || '',
                        userId: user.id
                    }),
                    className: (0, _clsx.clsx)('btn btn-outline-primary w-100 btn-sm', {
                        'disabled': detailsDisabled
                    }),
                    children: "Detalles"
                })
            }),
            (0, _jsxRuntime.jsx)("div", {
                className: 'col-md-2 col-sm-2 col-2 m-auto text-center',
                children: (0, _jsxRuntime.jsx)("span", {
                    className: 'span--delete',
                    title: 'eliminar',
                    children: (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                        name: 'faTrashCan',
                        onClick: ()=>onDeleteClick && onDeleteClick(user)
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/fortawesome":"7JvBl","context/parent-context/hook":"4wX3K","external/clsx":"012R0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"keDiO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UserCardContent);
var _jsxRuntime = require("react/jsx-runtime");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _avatar = require("components/Avatar");
var _avatarDefault = parcelHelpers.interopDefault(_avatar);
var _labeledIcon = require("components/LabeledIcon");
var _labeledIconDefault = parcelHelpers.interopDefault(_labeledIcon);
const UserCardContent = (props)=>{
    const { user, onEditUserClick } = props;
    return (0, _jsxRuntime.jsxs)("div", {
        className: 'd-flex text-black',
        style: {
            padding: '0px 10px'
        },
        children: [
            (0, _jsxRuntime.jsx)("div", {
                className: 'flex-shrink-0',
                children: (0, _jsxRuntime.jsx)((0, _avatarDefault.default), {
                    name: user.first_name,
                    lastname: user.last_name,
                    size: 'lg'
                })
            }),
            (0, _jsxRuntime.jsxs)("div", {
                className: 'flex-grow-1 ms-3',
                style: {
                    textAlign: 'left',
                    display: 'grid'
                },
                children: [
                    (0, _jsxRuntime.jsx)((0, _labeledIconDefault.default), {
                        label: user.name,
                        icon: 'faUser'
                    }),
                    (0, _jsxRuntime.jsx)((0, _labeledIconDefault.default), {
                        label: user.phone,
                        icon: 'faPhone',
                        hiddenIfEmpty: true
                    }),
                    (0, _jsxRuntime.jsx)((0, _labeledIconDefault.default), {
                        label: user.email,
                        icon: 'faEnvelope',
                        textOverflow: 'ellipsis'
                    }),
                    (0, _jsxRuntime.jsx)((0, _labeledIconDefault.default), {
                        label: `Paquetes: ${user.packages}`,
                        icon: 'faBox',
                        hiddenIfEmpty: true
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)("div", {
                className: 'flex-shrink-0 d-flex',
                children: (0, _jsxRuntime.jsx)("span", {
                    className: 'span--edit',
                    title: 'editar',
                    onClick: ()=>onEditUserClick && onEditUserClick(user),
                    children: (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                        name: 'faPenToSquare'
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/fortawesome":"7JvBl","components/Avatar":"fqaJ2","components/LabeledIcon":"axsKB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"axsKB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LabeledIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("external/clsx");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _react = require("external/react");
var _text = require("utilities/text");
const LabeledIcon = (props)=>{
    const { label, icon, style, className, hiddenIfEmpty = false, textOverflow, ref } = props;
    const [componentClassName, labelStyle] = (0, _react.useMemo)(()=>[
            (0, _clsx.clsx)('d-inline-flex', {
                'd-none': hiddenIfEmpty && (0, _text.isEmpty)(label),
                'flex-nowrap': !!textOverflow,
                'text-nowrap': !!textOverflow,
                'overflow-hidden': !!textOverflow
            }),
            textOverflow ? {
                textOverflow,
                overflow: 'hidden'
            } : {}
        ], [
        textOverflow,
        className,
        hiddenIfEmpty
    ]);
    return (0, _jsxRuntime.jsxs)("span", {
        ref: ref,
        className: componentClassName,
        style: style,
        children: [
            (0, _jsxRuntime.jsx)("span", {
                className: (0, _clsx.clsx)('icon', 'mr-1'),
                children: (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                    name: icon
                })
            }),
            (0, _jsxRuntime.jsx)("span", {
                className: (0, _clsx.clsx)('label', 'pl-1'),
                style: labelStyle,
                title: label,
                children: label
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/clsx":"012R0","external/fortawesome":"7JvBl","external/react":"1Glst","utilities/text":"aKcMC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"71rig":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EditUserModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _modalAcceptCancelFooter = require("components/ModalAcceptCancelFooter");
var _modalAcceptCancelFooterDefault = parcelHelpers.interopDefault(_modalAcceptCancelFooter);
var _parent = require("types/context/parent");
var _hook = require("context/parent-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _formValidation = require("utilities/form-validation");
var _formValidationDefault = parcelHelpers.interopDefault(_formValidation);
var _editUserForm = require("./EditUserForm");
var _editUserFormDefault = parcelHelpers.interopDefault(_editUserForm);
var _notify = require("components/Notify");
const { createRequiredFieldValidation, createEmailValidation } = (0, _formValidation.validators);
const editUserValidations = {
    first_name: [
        createRequiredFieldValidation('first_name')
    ],
    last_name: [
        createRequiredFieldValidation('last_name')
    ],
    email: [
        createRequiredFieldValidation('email'),
        createEmailValidation('email')
    ],
    password: [
        createRequiredFieldValidation('password')
    ]
};
const EditUserModal = ()=>{
    const { update, state: { modals }, params: { role }, editUser } = (0, _hookDefault.default)();
    const [errors, validate, resetValidations] = (0, _formValidationDefault.default)(editUserValidations);
    const roleName = (0, _react.useMemo)(()=>role === 'student' ? 'estudiante' : 'tutor', [
        role
    ]);
    function handleClose() {
        resetValidations();
        update({
            modals: {
                editUser: {
                    open: {
                        $set: false
                    },
                    user: {
                        $shallow: (0, _parent.clearedEditUser)
                    }
                }
            }
        });
    }
    async function handleUserSave() {
        if (!validate(modals.editUser.user, true)) return;
        editUser(modals.editUser.user);
        (0, _notify.notifySuccess)('Usuario actualizado exitosamente.');
        handleClose();
    }
    (0, _react.useEffect)(()=>{
        validate(modals.editUser.user, false);
    }, [
        modals.editUser.user
    ]);
    return (0, _jsxRuntime.jsxs)((0, _react.Modal), {
        show: modals.editUser.open,
        onHide: handleClose,
        size: 'lg',
        centered: true,
        children: [
            (0, _jsxRuntime.jsx)((0, _react.Modal).Header, {
                closeButton: true,
                children: (0, _jsxRuntime.jsxs)("h5", {
                    className: 'text-capitalize',
                    style: {
                        fontFamily: 'Arial, sans-serif',
                        margin: '0'
                    },
                    children: [
                        "Editar ",
                        roleName
                    ]
                })
            }),
            (0, _jsxRuntime.jsx)((0, _react.Modal).Body, {
                children: (0, _jsxRuntime.jsx)((0, _editUserFormDefault.default), {
                    errors: errors
                })
            }),
            (0, _jsxRuntime.jsx)((0, _modalAcceptCancelFooterDefault.default), {
                onCancel: handleClose,
                onAccept: handleUserSave
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","components/ModalAcceptCancelFooter":"buHx2","types/context/parent":"5MNF8","context/parent-context/hook":"4wX3K","utilities/form-validation":"1fpQO","./EditUserForm":"9eCO6","components/Notify":"gZyef","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9eCO6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EditUserForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _formTextfield = require("components/FormTextfield");
var _formTextfieldDefault = parcelHelpers.interopDefault(_formTextfield);
var _hook = require("context/parent-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const EditUserForm = (props)=>{
    const { errors } = props;
    const { update, state: { modals: { editUser: { user } } } } = (0, _hookDefault.default)();
    function createFieldProps(placeholder, fieldName, maxLength) {
        return {
            placeholder,
            maxLength,
            fieldName,
            value: user[fieldName],
            submitted: errors.submitted,
            error: errors[fieldName],
            onChange: (e)=>{
                update({
                    modals: {
                        editUser: {
                            user: {
                                [fieldName]: {
                                    $set: e.target.value.trim()
                                }
                            }
                        }
                    }
                });
            }
        };
    }
    return (0, _jsxRuntime.jsxs)((0, _react.Form), {
        children: [
            (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                ...createFieldProps('Nombre', 'first_name', 25)
            }),
            (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                ...createFieldProps('Apellido', 'last_name', 25)
            }),
            (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                ...createFieldProps('Correo', 'email')
            }),
            (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                ...createFieldProps("T\xe9lefono", 'phone')
            }),
            (0, _jsxRuntime.jsx)((0, _react.Card), {
                children: (0, _jsxRuntime.jsxs)((0, _react.Card).Body, {
                    children: [
                        (0, _jsxRuntime.jsxs)("div", {
                            className: 'd-flex',
                            children: [
                                (0, _jsxRuntime.jsx)((0, _react.Form).Label, {
                                    className: 'd-flex flex-column justify-content-center col-sm-2',
                                    children: "Usuario"
                                }),
                                (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                                    className: 'col-sm-4',
                                    ...createFieldProps('Usuario', 'username'),
                                    controlProps: {
                                        disabled: true
                                    }
                                })
                            ]
                        }),
                        (0, _jsxRuntime.jsxs)("div", {
                            className: 'd-flex',
                            children: [
                                (0, _jsxRuntime.jsx)((0, _react.Form).Label, {
                                    className: 'd-flex flex-column justify-content-center col-sm-2',
                                    children: "Contrase\u00F1a"
                                }),
                                (0, _jsxRuntime.jsx)((0, _formTextfield.PasswordField), {
                                    className: 'col-sm-4',
                                    controlProps: {
                                        autoComplete: 'new-password'
                                    },
                                    ...createFieldProps("Contrase\xf1a", 'password')
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","components/FormTextfield":"6jQpP","context/parent-context/hook":"4wX3K","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"81ZJd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>NewUser);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/parent-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _clsx = require("external/clsx");
var _selectUserRole = require("./SelectUserRole");
var _selectUserRoleDefault = parcelHelpers.interopDefault(_selectUserRole);
var _formValidation = require("utilities/form-validation");
var _formValidationDefault = parcelHelpers.interopDefault(_formValidation);
var _parent = require("types/context/parent");
var _newUserForm = require("./NewUserForm");
var _newUserFormDefault = parcelHelpers.interopDefault(_newUserForm);
const { createRequiredFieldValidation, createEmailValidation } = (0, _formValidation.validators);
const addUserValidations = {
    first_name: [
        createRequiredFieldValidation('first_name')
    ],
    last_name: [
        createRequiredFieldValidation('last_name')
    ],
    email: [
        createRequiredFieldValidation('email'),
        createEmailValidation('email')
    ]
};
const NewUser = ()=>{
    const { navigation, update, state: { modals }, params: { role }, addUser } = (0, _hookDefault.default)();
    const [errors, validate, resetValidations] = (0, _formValidationDefault.default)(addUserValidations);
    const [roleText, roleIcon] = (0, _react.useMemo)(()=>role === 'student' ? [
            'Estudiante',
            'faGraduationCap'
        ] : [
            'Tutor',
            'faPersonChalkboard'
        ], [
        role
    ]);
    function handleAddUser(e) {
        if (!validate(modals.addUser, true)) {
            e.preventDefault();
            return;
        }
        addUser(modals.addUser);
    }
    (0, _react.useEffect)(()=>{
        if (!navigation.newUser.active) {
            resetValidations();
            update({
                modals: {
                    addUser: {
                        $shallow: (0, _parent.emptyUser)
                    }
                }
            });
        }
    }, [
        navigation.newUser.active
    ]);
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsxs)((0, _react.Card).Body, {
                className: 'd-flex',
                children: [
                    (0, _jsxRuntime.jsx)((0, _newUserFormDefault.default), {
                        errors: errors
                    }),
                    (0, _jsxRuntime.jsx)((0, _selectUserRoleDefault.default), {})
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _react.Card).Footer, {
                className: 'py-2 d-flex justify-content-end pl-0',
                children: (0, _jsxRuntime.jsxs)((0, _react.Link), {
                    to: navigation.users.link(),
                    onClick: handleAddUser,
                    style: {
                        width: '200px'
                    },
                    className: (0, _clsx.clsx)('language__filter p-2 mt-2 button'),
                    children: [
                        (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                            name: roleIcon
                        }),
                        " A\u00F1adir ",
                        roleText
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/parent-context/hook":"4wX3K","external/fortawesome":"7JvBl","external/clsx":"012R0","./SelectUserRole":"8owqK","utilities/form-validation":"1fpQO","types/context/parent":"5MNF8","./NewUserForm":"fPWV7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8owqK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectUserRole);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/parent-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _clsx = require("external/clsx");
const SelectUserRole = ()=>{
    const { navigation, params: { role } } = (0, _hookDefault.default)();
    return (0, _jsxRuntime.jsxs)("fieldset", {
        className: 'border rounded-3 p-3',
        style: {
            minWidth: '600px'
        },
        children: [
            (0, _jsxRuntime.jsx)("legend", {
                className: 'float-none w-auto px-2 fs-6',
                children: "Rol del usuario"
            }),
            (0, _jsxRuntime.jsx)((0, _react.Row), {
                style: {
                    fontSize: '16px'
                },
                className: 'd-flex justify-content-center align-items-center',
                children: (0, _jsxRuntime.jsxs)((0, _react.Link), {
                    to: navigation.newUser.link({
                        role: 'student'
                    }),
                    style: {
                        width: '260px'
                    },
                    className: (0, _clsx.clsx)('user-rol__filter d-flex justify-content-center align-items-center mb-3 fa-2x mb-3', {
                        selected: role === 'student'
                    }),
                    children: [
                        (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                            name: 'faGraduationCap'
                        }),
                        " Estudiante"
                    ]
                })
            }),
            (0, _jsxRuntime.jsx)((0, _react.Row), {
                style: {
                    fontSize: '16px'
                },
                className: 'd-flex justify-content-center align-items-center',
                children: (0, _jsxRuntime.jsxs)((0, _react.Link), {
                    to: navigation.newUser.link({
                        role: 'tutor'
                    }),
                    style: {
                        width: '260px'
                    },
                    className: (0, _clsx.clsx)('user-rol__filter d-flex justify-content-center align-items-center mb-3 fa-2x mb-3', {
                        selected: role === 'tutor'
                    }),
                    children: [
                        (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                            name: 'faPersonChalkboard'
                        }),
                        " Tutor"
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/parent-context/hook":"4wX3K","external/fortawesome":"7JvBl","external/clsx":"012R0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fPWV7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>NewUserForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _formTextfield = require("components/FormTextfield");
var _formTextfieldDefault = parcelHelpers.interopDefault(_formTextfield);
var _hook = require("context/parent-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const NewUserForm = (props)=>{
    const { errors } = props;
    const { update, state: { modals: { addUser } } } = (0, _hookDefault.default)();
    function createFieldProps(placeholder, fieldName, maxLength) {
        return {
            placeholder,
            maxLength,
            fieldName,
            value: addUser[fieldName],
            submitted: errors.submitted,
            error: errors[fieldName],
            onChange: (e)=>{
                update({
                    modals: {
                        addUser: {
                            [fieldName]: {
                                $set: e.target.value.trim()
                            }
                        }
                    }
                });
            }
        };
    }
    return (0, _jsxRuntime.jsxs)("fieldset", {
        className: 'border rounded-3 p-3 flex-grow-1 mr-2',
        children: [
            (0, _jsxRuntime.jsx)("legend", {
                className: 'float-none w-auto px-2 fs-6',
                children: "Informaci\u00F3n de usuario"
            }),
            (0, _jsxRuntime.jsxs)((0, _react.Form), {
                children: [
                    (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                        ...createFieldProps('Nombre', 'first_name', 25)
                    }),
                    (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                        ...createFieldProps('Apellido', 'last_name', 25)
                    }),
                    (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                        ...createFieldProps('Correo', 'email')
                    }),
                    (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                        ...createFieldProps("T\xe9lefono", 'phone')
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","components/FormTextfield":"6jQpP","context/parent-context/hook":"4wX3K","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"38HKR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PaymentPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/parent-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _paymentItem = require("./PaymentItem");
var _paymentItemDefault = parcelHelpers.interopDefault(_paymentItem);
var _showPaymentDetail = require("./modals/ShowPaymentDetail");
var _showPaymentDetailDefault = parcelHelpers.interopDefault(_showPaymentDetail);
var _notify = require("components/Notify");
var _paymentService = require("services/payment.service");
var _changePaymentMethod = require("./modals/ChangePaymentMethod");
var _changePaymentMethodDefault = parcelHelpers.interopDefault(_changePaymentMethod);
const PaymentPage = ()=>{
    const { update, state: { payments } } = (0, _hookDefault.default)();
    const navigate = (0, _react.useNavigate)();
    function handleModalEvent(indexProp, index) {
        update({
            [indexProp]: {
                $set: index
            }
        });
    }
    async function handleItemAction(index, status) {
        const subscription = payments.items[index];
        switch(status){
            case 'active':
                const { isConfirmed: cancelationConfirmed } = await (0, _notify.showConfirmCancelSubscription)(subscription.subscriptionEnds || new Date());
                if (cancelationConfirmed) {
                    const response = await (0, _paymentService.paymentService).cancelSubscription(subscription);
                    (0, _notify.notifyWarning)(`Tu suscripci\xf3n: Plan ${subscription.offerName} ha sido cancelada.`);
                    update({
                        payments: {
                            refreshes: {
                                $apply: (i)=>i + 1
                            }
                        }
                    });
                }
                break;
            case 'pending':
                await (0, _paymentService.paymentService).reactiveSubscription(subscription);
                (0, _notify.notifySuccess)(`Tu suscripci\xf3n Plan ${subscription.offerName} ha sido reactivada.`);
                update({
                    payments: {
                        refreshes: {
                            $apply: (i)=>i + 1
                        }
                    }
                });
                break;
            case 'past_due':
                navigate(`/home/payment/history?subscription=${subscription.subscription}`);
                break;
            default:
                console.log(`unhandled: ${subscription}`);
                break;
        }
    }
    return (0, _jsxRuntime.jsxs)((0, _react.Card).Body, {
        className: 'mt-2',
        children: [
            (0, _jsxRuntime.jsx)("div", {
                className: 'row',
                children: payments.items.map((p, i)=>(0, _jsxRuntime.jsx)((0, _paymentItemDefault.default), {
                        index: i,
                        handleOpenDetail: (i)=>handleModalEvent('paymentDetailIndex', i),
                        handleChangePaymentMethod: (i)=>handleModalEvent('changePaymentMethodIndex', i),
                        handleItemAction: handleItemAction,
                        payment: p
                    }, i))
            }),
            (0, _jsxRuntime.jsx)((0, _showPaymentDetailDefault.default), {
                handleClose: ()=>handleModalEvent('paymentDetailIndex', false)
            }),
            (0, _jsxRuntime.jsx)((0, _changePaymentMethodDefault.default), {
                handleClose: ()=>handleModalEvent('changePaymentMethodIndex', false)
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/parent-context/hook":"4wX3K","./PaymentItem":"1iA95","./modals/ShowPaymentDetail":"dgl5Q","components/Notify":"gZyef","services/payment.service":"gDcUl","./modals/ChangePaymentMethod":"fPCWw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1iA95":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PaymentItem);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _paymentMethod = require("./PaymentMethod");
var _paymentMethodDefault = parcelHelpers.interopDefault(_paymentMethod);
var _subscriptionStatus = require("./SubscriptionStatus");
var _subscriptionStatusDefault = parcelHelpers.interopDefault(_subscriptionStatus);
var _subscriptionAction = require("./SubscriptionAction");
var _subscriptionActionDefault = parcelHelpers.interopDefault(_subscriptionAction);
var _paymentItemOptions = require("./PaymentItemOptions");
const PaymentItem = (props)=>{
    const { payment, index, handleOpenDetail, handleItemAction, handleChangePaymentMethod } = props;
    const { offerName, plan_alias, price, frequencyUnit } = payment;
    const frequency = (0, _react.useMemo)(()=>frequencyUnit == 'month' ? 'mensual' : 'anual', [
        frequencyUnit
    ]);
    return (0, _jsxRuntime.jsx)("div", {
        className: 'shadow-sm card mb-3',
        style: {
            borderRadius: '10px'
        },
        children: (0, _jsxRuntime.jsx)("div", {
            className: 'card-body px-0',
            children: (0, _jsxRuntime.jsxs)("div", {
                className: 'text-black d-flex',
                style: {
                    padding: '0px 10px'
                },
                children: [
                    (0, _jsxRuntime.jsxs)("div", {
                        className: 'col-md-3',
                        children: [
                            (0, _jsxRuntime.jsxs)("p", {
                                className: 'text-capitalize fn-s-18 fw-bold-500 m-auto',
                                children: [
                                    offerName,
                                    ' ',
                                    " ",
                                    (0, _jsxRuntime.jsxs)("span", {
                                        className: 'fn-s-14',
                                        children: [
                                            " (",
                                            plan_alias,
                                            ") "
                                        ]
                                    })
                                ]
                            }),
                            (0, _jsxRuntime.jsxs)("span", {
                                className: 'fn-s-14',
                                children: [
                                    price,
                                    " / ",
                                    frequency,
                                    ' '
                                ]
                            })
                        ]
                    }),
                    (0, _jsxRuntime.jsx)((0, _paymentMethodDefault.default), {
                        className: 'col-md-3 flex-column',
                        card: payment.card,
                        last4: payment.last4
                    }),
                    (0, _jsxRuntime.jsx)((0, _subscriptionStatusDefault.default), {
                        className: 'col-md-3',
                        paymentMode: payment.paymentMode,
                        periondEnds: payment.subscriptionEnds,
                        status: payment.subscriptionStatus
                    }),
                    payment.paymentMode === 'subscription' && (0, _jsxRuntime.jsx)((0, _subscriptionActionDefault.default), {
                        index: index,
                        onClick: handleItemAction,
                        status: payment.subscriptionStatus
                    }),
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'flex-grow-1'
                    }),
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'd-flex flex-column justify-content-center',
                        children: (0, _jsxRuntime.jsx)((0, _paymentItemOptions.PaymentItemOptions), {
                            index: index,
                            handleOpenDetail: handleOpenDetail,
                            payment: payment,
                            handleChangePaymentMethod: handleChangePaymentMethod
                        })
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","./PaymentMethod":"3AYnI","./SubscriptionStatus":"hPKnH","./SubscriptionAction":"ahLiJ","./PaymentItemOptions":"2TiXa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3AYnI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PaymentMethod);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("external/clsx");
var _react = require("external/react");
var _assets = require("resources/assets");
var _assetsDefault = parcelHelpers.interopDefault(_assets);
const PaymentMethod = (props)=>{
    const { className, card, last4, showLabel = true } = props;
    const src = (0, _react.useMemo)(()=>(0, _assetsDefault.default)(`/payment-method/${card}.png`, `/payment-method/default.png`), [
        card
    ]);
    return (0, _jsxRuntime.jsxs)("div", {
        className: (0, _clsx.clsx)('d-flex', className),
        children: [
            showLabel && (0, _jsxRuntime.jsx)("div", {
                className: 'text-capitalize fw-bold-500 mb-1',
                children: "M\u00E9todo de pago"
            }),
            (0, _jsxRuntime.jsxs)("div", {
                className: 'd-flex',
                children: [
                    (0, _jsxRuntime.jsx)("img", {
                        src: src,
                        alt: card,
                        title: card,
                        className: 'img-fluid mr-1',
                        style: {
                            width: '40px'
                        }
                    }),
                    (0, _jsxRuntime.jsx)("span", {
                        className: 'fn-s-14',
                        children: last4
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/clsx":"012R0","external/react":"1Glst","resources/assets":"fdOi5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hPKnH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SubscriptionStatus);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _text = require("utilities/text");
const subscriptionStatusText = {
    'active': "Pr\xf3ximo pago",
    'pending': "Suscripci\xf3n vigente hasta el",
    'canceled': "Suscripci\xf3n cancelada",
    'past_due': 'Pago no realizado'
};
const paymentStatusText = {
    'active': "Suscripci\xf3n vigente hasta el",
    'expired': "Suscripci\xf3n expir\xf3 el"
};
const SubscriptionStatus = (props)=>{
    const { status, periondEnds, className, paymentMode } = props;
    const statusText = (0, _react.useMemo)(()=>(paymentMode === 'subscription' ? subscriptionStatusText : paymentStatusText)[status], [
        status,
        paymentMode
    ]);
    const periodEndsText = (0, _react.useMemo)(()=>(0, _text.convertDateToText)(periondEnds, true), [
        periondEnds
    ]);
    return (0, _jsxRuntime.jsxs)("div", {
        className: className,
        children: [
            (0, _jsxRuntime.jsx)("p", {
                className: 'fw-bold-500 m-auto',
                children: statusText
            }),
            (0, _jsxRuntime.jsx)("span", {
                className: 'fn-s-14',
                children: periodEndsText
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","utilities/text":"aKcMC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ahLiJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SubscriptionAction);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("external/clsx");
var _react = require("external/react");
const btnClasses = {
    'active': 'btn-danger',
    'pending': 'btn-success',
    'canceled': 'btn-dark',
    'past_due': 'btn-warning'
};
const btnLabels = {
    'active': 'Cancelar',
    'pending': 'Reactivar',
    'canceled': "Subscripci\xf3n cancelada",
    'past_due': 'Ver detalles'
};
const SubscriptionAction = (props)=>{
    const { index, status, label, onClick } = props;
    const btnClass = (0, _react.useMemo)(()=>btnClasses[status], [
        status
    ]);
    const btnLabel = (0, _react.useMemo)(()=>label || btnLabels[status], [
        status,
        label
    ]);
    const disabled = (0, _react.useMemo)(()=>props.disabled !== undefined ? props.disabled : status === 'canceled', [
        props.disabled,
        status
    ]);
    return (0, _jsxRuntime.jsx)("div", {
        className: 'col-md-2 d-flex subscription-action',
        style: {
            cursor: 'pointer'
        },
        children: (0, _jsxRuntime.jsx)("button", {
            className: (0, _clsx.clsx)('btn', btnClass, 'w-100', {
                disabled
            }),
            onClick: ()=>onClick(index, status),
            children: btnLabel
        })
    });
};

},{"react/jsx-runtime":"1dlk8","external/clsx":"012R0","external/react":"1Glst","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2TiXa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PaymentItemOptions", ()=>PaymentItemOptions);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
const PaymentItemOptions = (props)=>{
    const { index, payment, handleOpenDetail, handleChangePaymentMethod } = props;
    const { lastInvoiceUrl } = payment;
    return (0, _jsxRuntime.jsxs)((0, _react.Dropdown), {
        children: [
            (0, _jsxRuntime.jsx)((0, _react.Dropdown).Toggle, {
                variant: 'link',
                id: 'dropdown-basic',
                className: 'dropdown-style',
                style: {
                    color: '#575151'
                },
                children: (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                    name: 'faEllipsisVertical',
                    style: {
                        fontSize: '25px'
                    }
                })
            }),
            (0, _jsxRuntime.jsxs)((0, _react.Dropdown).Menu, {
                children: [
                    (0, _jsxRuntime.jsx)((0, _react.Dropdown).Item, {
                        as: 'button',
                        onClick: ()=>handleOpenDetail(index),
                        children: (0, _jsxRuntime.jsx)("span", {
                            children: "Detalle"
                        })
                    }),
                    lastInvoiceUrl && (0, _jsxRuntime.jsx)((0, _react.Dropdown).Item, {
                        href: lastInvoiceUrl,
                        target: '_blank',
                        children: (0, _jsxRuntime.jsx)("span", {
                            children: "Ver recibo de \u00FAltimo pago"
                        })
                    }),
                    payment.paymentMode === 'subscription' && (0, _jsxRuntime.jsx)((0, _react.Dropdown).Item, {
                        href: `/home/payment/history?subscription=${payment.subscription}`,
                        children: (0, _jsxRuntime.jsx)("span", {
                            children: "Historial de pagos"
                        })
                    }),
                    payment.paymentMode === 'subscription' && (0, _jsxRuntime.jsx)((0, _react.Dropdown).Item, {
                        as: 'button',
                        onClick: ()=>handleChangePaymentMethod(index),
                        children: (0, _jsxRuntime.jsx)("span", {
                            children: "Cambiar m\u00E9todo de pago"
                        })
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/fortawesome":"7JvBl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dgl5Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PaymentDetails);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/parent-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _subscriptionStatus = require("components/SubscriptionStatus");
var _subscriptionStatusDefault = parcelHelpers.interopDefault(_subscriptionStatus);
var _text = require("utilities/text");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _packageModalHeader = require("./PackageModalHeader");
var _packageModalHeaderDefault = parcelHelpers.interopDefault(_packageModalHeader);
const DetailItem = (props)=>{
    const { children, label, icon } = props;
    return (0, _jsxRuntime.jsxs)("div", {
        className: 'col-lg-12 col-md-12 col-12 px-4 mb-3',
        children: [
            (0, _jsxRuntime.jsx)("span", {
                className: 'fw-500 mr-1',
                children: icon ? (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                            name: icon,
                            className: 'mr-1'
                        }),
                        label
                    ]
                }) : label
            }),
            children
        ]
    });
};
const PaymentDetails = (props)=>{
    const { state: { payments, paymentDetailIndex } } = (0, _hookDefault.default)();
    const { handleClose } = props;
    const [show, payment] = (0, _react.useMemo)(()=>paymentDetailIndex === false ? [
            false,
            {}
        ] : [
            true,
            payments.items[paymentDetailIndex]
        ], [
        paymentDetailIndex
    ]);
    const { purchaseDate, subscriptionStatus, subscriptionEnds, paymentMode, card, last4 } = payment;
    const statusLabel = (0, _react.useMemo)(()=>{
        if (paymentMode === 'payment') return "Fecha de expiraci\xf3n:";
        switch(subscriptionStatus){
            case 'active':
                return "Pr\xf3ximo pago:";
            case 'pending':
                return "Suscripci\xf3n vigente hasta el:";
            case 'canceled':
                return "Suscripci\xf3n cancelada:";
            case 'past_due':
                return 'Pago no realizado:';
            default:
                return "Pr\xf3ximo pago:";
        }
    }, [
        paymentMode,
        subscriptionStatus
    ]);
    const [courses, electives] = (0, _react.useMemo)(()=>Array.isArray(payment.courses) ? [
            payment.courses.filter((id)=>!/^C7/.test(id)),
            payment.courses.filter((id)=>/^C7/.test(id))
        ] : [
            [],
            []
        ], [
        payment.courses
    ]);
    return (0, _jsxRuntime.jsxs)((0, _react.Modal), {
        show: show,
        onHide: handleClose,
        size: 'lg',
        centered: true,
        children: [
            (0, _jsxRuntime.jsx)((0, _packageModalHeaderDefault.default), {
                index: paymentDetailIndex
            }),
            (0, _jsxRuntime.jsxs)((0, _react.Modal).Body, {
                children: [
                    (0, _jsxRuntime.jsx)(DetailItem, {
                        label: 'Estado',
                        children: payment.paymentMode === 'subscription' && (0, _jsxRuntime.jsx)((0, _subscriptionStatusDefault.default), {
                            status: payment.subscriptionStatus,
                            subscription: payment.subscription
                        })
                    }),
                    (0, _jsxRuntime.jsx)(DetailItem, {
                        label: 'Miembro desde:',
                        icon: 'faCalendarDays',
                        children: (0, _text.convertDateToText)(purchaseDate, true)
                    }),
                    (0, _jsxRuntime.jsx)(DetailItem, {
                        label: statusLabel,
                        icon: 'faCalendarDays',
                        children: (0, _text.convertDateToText)(subscriptionEnds, true)
                    }),
                    (0, _jsxRuntime.jsx)(DetailItem, {
                        label: "Cursos principales:",
                        icon: 'faPuzzlePiece',
                        children: courses.length
                    }),
                    (0, _jsxRuntime.jsx)(DetailItem, {
                        label: "Electivas:",
                        icon: 'faPuzzlePiece',
                        children: electives.length
                    }),
                    (0, _jsxRuntime.jsx)(DetailItem, {
                        label: "Tipo de tarjeta:",
                        icon: 'faCreditCard',
                        children: card
                    }),
                    (0, _jsxRuntime.jsx)(DetailItem, {
                        label: "Tarjeta:",
                        icon: 'faCreditCard',
                        children: last4
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/parent-context/hook":"4wX3K","components/SubscriptionStatus":"gnl1p","utilities/text":"aKcMC","external/fortawesome":"7JvBl","./PackageModalHeader":"gVWgD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gVWgD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PackageModalHeader);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/parent-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const PackageModalHeader = (props)=>{
    const { index } = props;
    const { state: { payments } } = (0, _hookDefault.default)();
    const payment = (0, _react.useMemo)(()=>index === false ? {} : payments.items[index], [
        index
    ]);
    const { offerName, plan_alias } = payment;
    return (0, _jsxRuntime.jsx)((0, _react.Modal).Header, {
        closeButton: true,
        children: (0, _jsxRuntime.jsxs)("h5", {
            className: 'text-capitalize',
            style: {
                fontFamily: 'Arial, sans-serif',
                margin: '0'
            },
            children: [
                `Plan ${offerName}`,
                (0, _jsxRuntime.jsx)("span", {
                    className: 'fn-s-14 ml-1',
                    children: `(${plan_alias})`
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/parent-context/hook":"4wX3K","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fPCWw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ChangePaymentMethod);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/parent-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _packageModalHeader = require("./PackageModalHeader");
var _packageModalHeaderDefault = parcelHelpers.interopDefault(_packageModalHeader);
var _stripe = require("external/stripe");
var _text = require("utilities/text");
var _clsx = require("external/clsx");
var _notify = require("components/Notify");
var _paymentService = require("services/payment.service");
const stripePromise = (0, _stripe.loadStripe)();
const UpdatePaymentMethod = (props)=>{
    const { handleClose, index, subscription } = props;
    const stripe = (0, _stripe.useStripe)();
    const elements = (0, _stripe.useElements)();
    const { update, state: { modals: { changePaymentMethod: { error } } } } = (0, _hookDefault.default)();
    async function handleSubmit(event) {
        event.preventDefault();
        if (!stripe || !elements) return;
        const card = elements.getElement((0, _stripe.CardElement));
        if (card === null) return;
        const { error, paymentMethod } = await stripe.createPaymentMethod({
            type: 'card',
            card
        });
        if (error && !(0, _text.isEmpty)(error)) {
            update({
                modals: {
                    changePaymentMethod: {
                        error: {
                            $set: error.message || ''
                        }
                    }
                }
            });
            return;
        }
        try {
            const response = await (0, _paymentService.paymentService).updatePaymentMethod({
                paymentMethod,
                subscription
            });
            if (response.data.success) {
                (0, _notify.notifySuccess)("M\xe9todo de pago actualizado exitosamente");
                update({
                    payments: {
                        refreshes: {
                            $apply: (i)=>i + 1
                        }
                    }
                });
                handleClose(index);
            } else (0, _notify.notifyError)("Error al actualizar el m\xe9todo de pago, intentalo mas tarde o con otro m\xe9todo de pago.");
        } catch (error) {
            console.log(error);
        }
    }
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsx)((0, _stripe.CardElement), {
                className: 'stripe-input'
            }),
            (0, _jsxRuntime.jsx)("div", {
                className: (0, _clsx.clsx)('d-none', {
                    'd-block': !(0, _text.isEmpty)(error)
                }),
                style: {
                    color: 'red'
                },
                children: error
            }),
            (0, _jsxRuntime.jsx)("br", {}),
            (0, _jsxRuntime.jsxs)("div", {
                className: 'text-right',
                children: [
                    (0, _jsxRuntime.jsx)("button", {
                        className: 'btn btn-light',
                        onClick: ()=>handleClose(index),
                        children: "Cancelar"
                    }),
                    (0, _jsxRuntime.jsx)("button", {
                        className: 'btn btn-primary ml-2',
                        onClick: (e)=>handleSubmit(e),
                        disabled: !stripe,
                        children: "A\u00F1adir tarjeta"
                    })
                ]
            })
        ]
    });
};
const ChangePaymentMethod = (props)=>{
    const { handleClose } = props;
    const { state: { payments, changePaymentMethodIndex: index } } = (0, _hookDefault.default)();
    const [show, payment] = (0, _react.useMemo)(()=>index === false ? [
            false,
            {}
        ] : [
            true,
            payments.items[index]
        ], [
        index
    ]);
    const { subscription } = payment;
    return (0, _jsxRuntime.jsxs)((0, _react.Modal), {
        show: show,
        onHide: handleClose,
        size: 'lg',
        centered: true,
        children: [
            (0, _jsxRuntime.jsx)((0, _packageModalHeaderDefault.default), {
                index: index
            }),
            (0, _jsxRuntime.jsxs)((0, _react.Modal).Body, {
                children: [
                    (0, _jsxRuntime.jsx)("label", {
                        children: "Reemplazar m\u00E9todo de pago"
                    }),
                    (0, _jsxRuntime.jsx)((0, _stripe.Elements), {
                        stripe: stripePromise,
                        options: (0, _stripe.stripeOptions),
                        children: (0, _jsxRuntime.jsx)(UpdatePaymentMethod, {
                            index: index,
                            subscription: subscription,
                            handleClose: handleClose
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _react.Modal).Footer, {})
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/parent-context/hook":"4wX3K","./PackageModalHeader":"gVWgD","external/stripe":"5lHU4","utilities/text":"aKcMC","external/clsx":"012R0","components/Notify":"gZyef","services/payment.service":"gDcUl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5lHU4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Elements", ()=>(0, _reactStripeJs.Elements));
parcelHelpers.export(exports, "CardElement", ()=>(0, _reactStripeJs.CardElement));
parcelHelpers.export(exports, "useStripe", ()=>(0, _reactStripeJs.useStripe));
parcelHelpers.export(exports, "useElements", ()=>(0, _reactStripeJs.useElements));
parcelHelpers.export(exports, "stripeOptions", ()=>stripeOptions);
parcelHelpers.export(exports, "loadStripe", ()=>loadStripe);
var _reactStripeJs = require("@stripe/react-stripe-js");
var _stripeJs = require("@stripe/stripe-js");
var _environment = require("external/environment");
const stripeOptions = {
    appearance: {
        theme: 'stripe',
        variables: {
            colorPrimary: '#0570de',
            colorBackground: '#ffffff',
            colorText: '#30313d',
            colorDanger: '#df1b41',
            fontFamily: 'Ideal Sans, system-ui, sans-serif',
            spacingUnit: '2px',
            borderRadius: '4px'
        }
    }
};
const loadStripe = (key)=>(0, _stripeJs.loadStripe)(key || (0, _environment.API_KEY_STRIPE));

},{"@stripe/react-stripe-js":"98uVm","@stripe/stripe-js":"kOzFY","external/environment":"lOlfZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"98uVm":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    factory(exports, require("d99b0077bf8bdf43"));
})(this, function(exports1, React) {
    'use strict';
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
            return typeof obj;
        };
        else _typeof = function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArrayLimit(arr, i) {
        var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _s, _e;
        try {
            for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function getDefaultExportFromCjs(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }
    var propTypes = {
        exports: {}
    };
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var ReactPropTypesSecret_1;
    var hasRequiredReactPropTypesSecret;
    function requireReactPropTypesSecret() {
        if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
        hasRequiredReactPropTypesSecret = 1;
        var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
        ReactPropTypesSecret_1 = ReactPropTypesSecret;
        return ReactPropTypesSecret_1;
    }
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var factoryWithThrowingShims;
    var hasRequiredFactoryWithThrowingShims;
    function requireFactoryWithThrowingShims() {
        if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
        hasRequiredFactoryWithThrowingShims = 1;
        var ReactPropTypesSecret = requireReactPropTypesSecret();
        function emptyFunction() {}
        function emptyFunctionWithReset() {}
        emptyFunctionWithReset.resetWarningCache = emptyFunction;
        factoryWithThrowingShims = function() {
            function shim(props, propName, componentName, location, propFullName, secret) {
                if (secret === ReactPropTypesSecret) // It is still safe when called from React.
                return;
                var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                err.name = 'Invariant Violation';
                throw err;
            }
            shim.isRequired = shim;
            function getShim() {
                return shim;
            }
            // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
            var ReactPropTypes = {
                array: shim,
                bool: shim,
                func: shim,
                number: shim,
                object: shim,
                string: shim,
                symbol: shim,
                any: shim,
                arrayOf: getShim,
                element: shim,
                elementType: shim,
                instanceOf: getShim,
                node: shim,
                objectOf: getShim,
                oneOf: getShim,
                oneOfType: getShim,
                shape: getShim,
                exact: getShim,
                checkPropTypes: emptyFunctionWithReset,
                resetWarningCache: emptyFunction
            };
            ReactPropTypes.PropTypes = ReactPropTypes;
            return ReactPropTypes;
        };
        return factoryWithThrowingShims;
    }
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    propTypes.exports = requireFactoryWithThrowingShims()();
    var propTypesExports = propTypes.exports;
    var PropTypes = /*@__PURE__*/ getDefaultExportFromCjs(propTypesExports);
    var useAttachEvent = function useAttachEvent(element, event, cb) {
        var cbDefined = !!cb;
        var cbRef = React.useRef(cb); // In many integrations the callback prop changes on each render.
        // Using a ref saves us from calling element.on/.off every render.
        React.useEffect(function() {
            cbRef.current = cb;
        }, [
            cb
        ]);
        React.useEffect(function() {
            if (!cbDefined || !element) return function() {};
            var decoratedCb = function decoratedCb() {
                if (cbRef.current) cbRef.current.apply(cbRef, arguments);
            };
            element.on(event, decoratedCb);
            return function() {
                element.off(event, decoratedCb);
            };
        }, [
            cbDefined,
            event,
            element,
            cbRef
        ]);
    };
    var usePrevious = function usePrevious(value) {
        var ref = React.useRef(value);
        React.useEffect(function() {
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
    var isUnknownObject = function isUnknownObject(raw) {
        return raw !== null && _typeof(raw) === 'object';
    };
    var isPromise = function isPromise(raw) {
        return isUnknownObject(raw) && typeof raw.then === 'function';
    }; // We are using types to enforce the `stripe` prop in this lib,
    // but in an untyped integration `stripe` could be anything, so we need
    // to do some sanity validation to prevent type errors.
    var isStripe = function isStripe(raw) {
        return isUnknownObject(raw) && typeof raw.elements === 'function' && typeof raw.createToken === 'function' && typeof raw.createPaymentMethod === 'function' && typeof raw.confirmCardPayment === 'function';
    };
    var PLAIN_OBJECT_STR = '[object Object]';
    var isEqual = function isEqual(left, right) {
        if (!isUnknownObject(left) || !isUnknownObject(right)) return left === right;
        var leftArray = Array.isArray(left);
        var rightArray = Array.isArray(right);
        if (leftArray !== rightArray) return false;
        var leftPlainObject = Object.prototype.toString.call(left) === PLAIN_OBJECT_STR;
        var rightPlainObject = Object.prototype.toString.call(right) === PLAIN_OBJECT_STR;
        if (leftPlainObject !== rightPlainObject) return false; // not sure what sort of special object this is (regexp is one option), so
        // fallback to reference check.
        if (!leftPlainObject && !leftArray) return left === right;
        var leftKeys = Object.keys(left);
        var rightKeys = Object.keys(right);
        if (leftKeys.length !== rightKeys.length) return false;
        var keySet = {};
        for(var i = 0; i < leftKeys.length; i += 1)keySet[leftKeys[i]] = true;
        for(var _i = 0; _i < rightKeys.length; _i += 1)keySet[rightKeys[_i]] = true;
        var allKeys = Object.keys(keySet);
        if (allKeys.length !== leftKeys.length) return false;
        var l = left;
        var r = right;
        var pred = function pred(key) {
            return isEqual(l[key], r[key]);
        };
        return allKeys.every(pred);
    };
    var extractAllowedOptionsUpdates = function extractAllowedOptionsUpdates(options, prevOptions, immutableKeys) {
        if (!isUnknownObject(options)) return null;
        return Object.keys(options).reduce(function(newOptions, key) {
            var isUpdated = !isUnknownObject(prevOptions) || !isEqual(options[key], prevOptions[key]);
            if (immutableKeys.includes(key)) {
                if (isUpdated) console.warn("Unsupported prop change: options.".concat(key, " is not a mutable property."));
                return newOptions;
            }
            if (!isUpdated) return newOptions;
            return _objectSpread2(_objectSpread2({}, newOptions || {}), {}, _defineProperty({}, key, options[key]));
        }, null);
    };
    var INVALID_STRIPE_ERROR$2 = 'Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.'; // We are using types to enforce the `stripe` prop in this lib, but in a real
    // integration `stripe` could be anything, so we need to do some sanity
    // validation to prevent type errors.
    var validateStripe = function validateStripe(maybeStripe) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$2;
        if (maybeStripe === null || isStripe(maybeStripe)) return maybeStripe;
        throw new Error(errorMsg);
    };
    var parseStripeProp = function parseStripeProp(raw) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$2;
        if (isPromise(raw)) return {
            tag: 'async',
            stripePromise: Promise.resolve(raw).then(function(result) {
                return validateStripe(result, errorMsg);
            })
        };
        var stripe = validateStripe(raw, errorMsg);
        if (stripe === null) return {
            tag: 'empty'
        };
        return {
            tag: 'sync',
            stripe: stripe
        };
    };
    var registerWithStripeJs = function registerWithStripeJs(stripe) {
        if (!stripe || !stripe._registerWrapper || !stripe.registerAppInfo) return;
        stripe._registerWrapper({
            name: 'react-stripe-js',
            version: "3.7.0"
        });
        stripe.registerAppInfo({
            name: 'react-stripe-js',
            version: "3.7.0",
            url: 'https://stripe.com/docs/stripe-js/react'
        });
    };
    var ElementsContext = /*#__PURE__*/ React.createContext(null);
    ElementsContext.displayName = 'ElementsContext';
    var parseElementsContext = function parseElementsContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(useCase, " in an <Elements> provider."));
        return ctx;
    };
    /**
   * The `Elements` provider allows you to use [Element components](https://stripe.com/docs/stripe-js/react#element-components) and access the [Stripe object](https://stripe.com/docs/js/initializing) in any nested component.
   * Render an `Elements` provider at the root of your React app so that it is available everywhere you need it.
   *
   * To use the `Elements` provider, call `loadStripe` from `@stripe/stripe-js` with your publishable key.
   * The `loadStripe` function will asynchronously load the Stripe.js script and initialize a `Stripe` object.
   * Pass the returned `Promise` to `Elements`.
   *
   * @docs https://stripe.com/docs/stripe-js/react#elements-provider
   */ var Elements = function Elements(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp);
        }, [
            rawStripeProp
        ]); // For a sync stripe instance, initialize into context
        var _React$useState = React.useState(function() {
            return {
                stripe: parsed.tag === 'sync' ? parsed.stripe : null,
                elements: parsed.tag === 'sync' ? parsed.stripe.elements(options) : null
            };
        }), _React$useState2 = _slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
        React.useEffect(function() {
            var isMounted = true;
            var safeSetContext = function safeSetContext(stripe) {
                setContext(function(ctx) {
                    // no-op if we already have a stripe instance (https://github.com/stripe/react-stripe-js/issues/296)
                    if (ctx.stripe) return ctx;
                    return {
                        stripe: stripe,
                        elements: stripe.elements(options)
                    };
                });
            }; // For an async stripePromise, store it in context once resolved
            if (parsed.tag === 'async' && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted) // Only update Elements context if the component is still mounted
                // and stripe is not null. We allow stripe to be null to make
                // handling SSR easier.
                safeSetContext(stripe);
            });
            else if (parsed.tag === 'sync' && !ctx.stripe) // Or, handle a sync stripe instance going from null -> populated
            safeSetContext(parsed.stripe);
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (!ctx.elements) return;
            var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                'clientSecret',
                'fonts'
            ]);
            if (updates) ctx.elements.update(updates);
        }, [
            options,
            prevOptions,
            ctx.elements
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(ctx.stripe);
        }, [
            ctx.stripe
        ]);
        return /*#__PURE__*/ React.createElement(ElementsContext.Provider, {
            value: ctx
        }, children);
    };
    Elements.propTypes = {
        stripe: PropTypes.any,
        options: PropTypes.object
    };
    var useElementsContextWithUseCase = function useElementsContextWithUseCase(useCaseMessage) {
        var ctx = React.useContext(ElementsContext);
        return parseElementsContext(ctx, useCaseMessage);
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#useelements-hook
   */ var useElements = function useElements() {
        var _useElementsContextWi = useElementsContextWithUseCase('calls useElements()'), elements = _useElementsContextWi.elements;
        return elements;
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#elements-consumer
   */ var ElementsConsumer = function ElementsConsumer(_ref2) {
        var children = _ref2.children;
        var ctx = useElementsContextWithUseCase('mounts <ElementsConsumer>'); // Assert to satisfy the busted React.FC return type (it should be ReactNode)
        return children(ctx);
    };
    ElementsConsumer.propTypes = {
        children: PropTypes.func.isRequired
    };
    var _excluded$1 = [
        "on",
        "session"
    ];
    var CheckoutSdkContext = /*#__PURE__*/ React.createContext(null);
    CheckoutSdkContext.displayName = 'CheckoutSdkContext';
    var parseCheckoutSdkContext = function parseCheckoutSdkContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find CheckoutProvider context; You need to wrap the part of your app that ".concat(useCase, " in an <CheckoutProvider> provider."));
        return ctx;
    };
    var CheckoutContext = /*#__PURE__*/ React.createContext(null);
    CheckoutContext.displayName = 'CheckoutContext';
    var extractCheckoutContextValue = function extractCheckoutContextValue(checkoutSdk, sessionState) {
        if (!checkoutSdk) return null;
        checkoutSdk.on;
        checkoutSdk.session;
        var actions = _objectWithoutProperties(checkoutSdk, _excluded$1);
        if (!sessionState) return Object.assign(checkoutSdk.session(), actions);
        return Object.assign(sessionState, actions);
    };
    var INVALID_STRIPE_ERROR$1 = 'Invalid prop `stripe` supplied to `CheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.';
    var CheckoutProvider = function CheckoutProvider(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp, INVALID_STRIPE_ERROR$1);
        }, [
            rawStripeProp
        ]); // State used to trigger a re-render when sdk.session is updated
        var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), session = _React$useState2[0], setSession = _React$useState2[1];
        var _React$useState3 = React.useState(function() {
            return {
                stripe: parsed.tag === 'sync' ? parsed.stripe : null,
                checkoutSdk: null
            };
        }), _React$useState4 = _slicedToArray(_React$useState3, 2), ctx = _React$useState4[0], setContext = _React$useState4[1];
        var safeSetContext = function safeSetContext(stripe, checkoutSdk) {
            setContext(function(ctx) {
                if (ctx.stripe && ctx.checkoutSdk) return ctx;
                return {
                    stripe: stripe,
                    checkoutSdk: checkoutSdk
                };
            });
        }; // Ref used to avoid calling initCheckout multiple times when options changes
        var initCheckoutCalledRef = React.useRef(false);
        React.useEffect(function() {
            var isMounted = true;
            if (parsed.tag === 'async' && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted && !initCheckoutCalledRef.current) {
                    // Only update context if the component is still mounted
                    // and stripe is not null. We allow stripe to be null to make
                    // handling SSR easier.
                    initCheckoutCalledRef.current = true;
                    stripe.initCheckout(options).then(function(checkoutSdk) {
                        if (checkoutSdk) {
                            safeSetContext(stripe, checkoutSdk);
                            checkoutSdk.on('change', setSession);
                        }
                    });
                }
            });
            else if (parsed.tag === 'sync' && parsed.stripe && !initCheckoutCalledRef.current) {
                initCheckoutCalledRef.current = true;
                parsed.stripe.initCheckout(options).then(function(checkoutSdk) {
                    if (checkoutSdk) {
                        safeSetContext(parsed.stripe, checkoutSdk);
                        checkoutSdk.on('change', setSession);
                    }
                });
            }
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options,
            setSession
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on CheckoutProvider: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        var prevCheckoutSdk = usePrevious(ctx.checkoutSdk);
        React.useEffect(function() {
            var _prevOptions$elements, _options$elementsOpti;
            // Ignore changes while checkout sdk is not initialized.
            if (!ctx.checkoutSdk) return;
            var previousAppearance = prevOptions === null || prevOptions === void 0 ? void 0 : (_prevOptions$elements = prevOptions.elementsOptions) === null || _prevOptions$elements === void 0 ? void 0 : _prevOptions$elements.appearance;
            var currentAppearance = options === null || options === void 0 ? void 0 : (_options$elementsOpti = options.elementsOptions) === null || _options$elementsOpti === void 0 ? void 0 : _options$elementsOpti.appearance;
            var hasAppearanceChanged = !isEqual(currentAppearance, previousAppearance);
            var hasSdkLoaded = !prevCheckoutSdk && ctx.checkoutSdk;
            if (currentAppearance && (hasAppearanceChanged || hasSdkLoaded)) ctx.checkoutSdk.changeAppearance(currentAppearance);
        }, [
            options,
            prevOptions,
            ctx.checkoutSdk,
            prevCheckoutSdk
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(ctx.stripe);
        }, [
            ctx.stripe
        ]);
        var checkoutContextValue = React.useMemo(function() {
            return extractCheckoutContextValue(ctx.checkoutSdk, session);
        }, [
            ctx.checkoutSdk,
            session
        ]);
        if (!ctx.checkoutSdk) return null;
        return /*#__PURE__*/ React.createElement(CheckoutSdkContext.Provider, {
            value: ctx
        }, /*#__PURE__*/ React.createElement(CheckoutContext.Provider, {
            value: checkoutContextValue
        }, children));
    };
    CheckoutProvider.propTypes = {
        stripe: PropTypes.any,
        options: PropTypes.shape({
            fetchClientSecret: PropTypes.func.isRequired,
            elementsOptions: PropTypes.object
        }).isRequired
    };
    var useCheckoutSdkContextWithUseCase = function useCheckoutSdkContextWithUseCase(useCaseString) {
        var ctx = React.useContext(CheckoutSdkContext);
        return parseCheckoutSdkContext(ctx, useCaseString);
    };
    var useElementsOrCheckoutSdkContextWithUseCase = function useElementsOrCheckoutSdkContextWithUseCase(useCaseString) {
        var checkoutSdkContext = React.useContext(CheckoutSdkContext);
        var elementsContext = React.useContext(ElementsContext);
        if (checkoutSdkContext && elementsContext) throw new Error("You cannot wrap the part of your app that ".concat(useCaseString, " in both <CheckoutProvider> and <Elements> providers."));
        if (checkoutSdkContext) return parseCheckoutSdkContext(checkoutSdkContext, useCaseString);
        return parseElementsContext(elementsContext, useCaseString);
    };
    var useCheckout = function useCheckout() {
        // ensure it's in CheckoutProvider
        useCheckoutSdkContextWithUseCase('calls useCheckout()');
        var ctx = React.useContext(CheckoutContext);
        if (!ctx) throw new Error('Could not find Checkout Context; You need to wrap the part of your app that calls useCheckout() in an <CheckoutProvider> provider.');
        return ctx;
    };
    var _excluded = [
        "mode"
    ];
    var capitalized = function capitalized(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var createElementComponent = function createElementComponent(type, isServer) {
        var displayName = "".concat(capitalized(type), "Element");
        var ClientElement = function ClientElement(_ref) {
            var id = _ref.id, className = _ref.className, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, onBlur = _ref.onBlur, onFocus = _ref.onFocus, onReady = _ref.onReady, onChange = _ref.onChange, onEscape = _ref.onEscape, onClick = _ref.onClick, onLoadError = _ref.onLoadError, onLoaderStart = _ref.onLoaderStart, onNetworksChange = _ref.onNetworksChange, onConfirm = _ref.onConfirm, onCancel = _ref.onCancel, onShippingAddressChange = _ref.onShippingAddressChange, onShippingRateChange = _ref.onShippingRateChange;
            var ctx = useElementsOrCheckoutSdkContextWithUseCase("mounts <".concat(displayName, ">"));
            var elements = 'elements' in ctx ? ctx.elements : null;
            var checkoutSdk = 'checkoutSdk' in ctx ? ctx.checkoutSdk : null;
            var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
            var elementRef = React.useRef(null);
            var domNode = React.useRef(null); // For every event where the merchant provides a callback, call element.on
            // with that callback. If the merchant ever changes the callback, removes
            // the old callback with element.off and then call element.on with the new one.
            useAttachEvent(element, 'blur', onBlur);
            useAttachEvent(element, 'focus', onFocus);
            useAttachEvent(element, 'escape', onEscape);
            useAttachEvent(element, 'click', onClick);
            useAttachEvent(element, 'loaderror', onLoadError);
            useAttachEvent(element, 'loaderstart', onLoaderStart);
            useAttachEvent(element, 'networkschange', onNetworksChange);
            useAttachEvent(element, 'confirm', onConfirm);
            useAttachEvent(element, 'cancel', onCancel);
            useAttachEvent(element, 'shippingaddresschange', onShippingAddressChange);
            useAttachEvent(element, 'shippingratechange', onShippingRateChange);
            useAttachEvent(element, 'change', onChange);
            var readyCallback;
            if (onReady) {
                if (type === 'expressCheckout') // Passes through the event, which includes visible PM types
                readyCallback = onReady;
                else // For other Elements, pass through the Element itself.
                readyCallback = function readyCallback() {
                    onReady(element);
                };
            }
            useAttachEvent(element, 'ready', readyCallback);
            React.useLayoutEffect(function() {
                if (elementRef.current === null && domNode.current !== null && (elements || checkoutSdk)) {
                    var newElement = null;
                    if (checkoutSdk) switch(type){
                        case 'payment':
                            newElement = checkoutSdk.createPaymentElement(options);
                            break;
                        case 'address':
                            if ('mode' in options) {
                                var mode = options.mode, restOptions = _objectWithoutProperties(options, _excluded);
                                if (mode === 'shipping') newElement = checkoutSdk.createShippingAddressElement(restOptions);
                                else if (mode === 'billing') newElement = checkoutSdk.createBillingAddressElement(restOptions);
                                else throw new Error("Invalid options.mode. mode must be 'billing' or 'shipping'.");
                            } else throw new Error("You must supply options.mode. mode must be 'billing' or 'shipping'.");
                            break;
                        case 'expressCheckout':
                            newElement = checkoutSdk.createExpressCheckoutElement(options);
                            break;
                        case 'currencySelector':
                            newElement = checkoutSdk.createCurrencySelectorElement();
                            break;
                        default:
                            throw new Error("Invalid Element type ".concat(displayName, ". You must use either the <PaymentElement />, <AddressElement options={{mode: 'shipping'}} />, <AddressElement options={{mode: 'billing'}} />, or <ExpressCheckoutElement />."));
                    }
                    else if (elements) newElement = elements.create(type, options);
                     // Store element in a ref to ensure it's _immediately_ available in cleanup hooks in StrictMode
                    elementRef.current = newElement; // Store element in state to facilitate event listener attachment
                    setElement(newElement);
                    if (newElement) newElement.mount(domNode.current);
                }
            }, [
                elements,
                checkoutSdk,
                options
            ]);
            var prevOptions = usePrevious(options);
            React.useEffect(function() {
                if (!elementRef.current) return;
                var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                    'paymentRequest'
                ]);
                if (updates && 'update' in elementRef.current) elementRef.current.update(updates);
            }, [
                options,
                prevOptions
            ]);
            React.useLayoutEffect(function() {
                return function() {
                    if (elementRef.current && typeof elementRef.current.destroy === 'function') try {
                        elementRef.current.destroy();
                        elementRef.current = null;
                    } catch (error) {}
                };
            }, []);
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className,
                ref: domNode
            });
        }; // Only render the Element wrapper in a server environment.
        var ServerElement = function ServerElement(props) {
            useElementsOrCheckoutSdkContextWithUseCase("mounts <".concat(displayName, ">"));
            var id = props.id, className = props.className;
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className
            });
        };
        var Element = isServer ? ServerElement : ClientElement;
        Element.propTypes = {
            id: PropTypes.string,
            className: PropTypes.string,
            onChange: PropTypes.func,
            onBlur: PropTypes.func,
            onFocus: PropTypes.func,
            onReady: PropTypes.func,
            onEscape: PropTypes.func,
            onClick: PropTypes.func,
            onLoadError: PropTypes.func,
            onLoaderStart: PropTypes.func,
            onNetworksChange: PropTypes.func,
            onConfirm: PropTypes.func,
            onCancel: PropTypes.func,
            onShippingAddressChange: PropTypes.func,
            onShippingRateChange: PropTypes.func,
            options: PropTypes.object
        };
        Element.displayName = displayName;
        Element.__elementType = type;
        return Element;
    };
    var isServer = typeof window === 'undefined';
    var EmbeddedCheckoutContext = /*#__PURE__*/ React.createContext(null);
    EmbeddedCheckoutContext.displayName = 'EmbeddedCheckoutProviderContext';
    var useEmbeddedCheckoutContext = function useEmbeddedCheckoutContext() {
        var ctx = React.useContext(EmbeddedCheckoutContext);
        if (!ctx) throw new Error('<EmbeddedCheckout> must be used within <EmbeddedCheckoutProvider>');
        return ctx;
    };
    var INVALID_STRIPE_ERROR = 'Invalid prop `stripe` supplied to `EmbeddedCheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.';
    var EmbeddedCheckoutProvider = function EmbeddedCheckoutProvider(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp, INVALID_STRIPE_ERROR);
        }, [
            rawStripeProp
        ]);
        var embeddedCheckoutPromise = React.useRef(null);
        var loadedStripe = React.useRef(null);
        var _React$useState = React.useState({
            embeddedCheckout: null
        }), _React$useState2 = _slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
        React.useEffect(function() {
            // Don't support any ctx updates once embeddedCheckout or stripe is set.
            if (loadedStripe.current || embeddedCheckoutPromise.current) return;
            var setStripeAndInitEmbeddedCheckout = function setStripeAndInitEmbeddedCheckout(stripe) {
                if (loadedStripe.current || embeddedCheckoutPromise.current) return;
                loadedStripe.current = stripe;
                embeddedCheckoutPromise.current = loadedStripe.current.initEmbeddedCheckout(options).then(function(embeddedCheckout) {
                    setContext({
                        embeddedCheckout: embeddedCheckout
                    });
                });
            }; // For an async stripePromise, store it once resolved
            if (parsed.tag === 'async' && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) parsed.stripePromise.then(function(stripe) {
                if (stripe) setStripeAndInitEmbeddedCheckout(stripe);
            });
            else if (parsed.tag === 'sync' && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) // Or, handle a sync stripe instance going from null -> populated
            setStripeAndInitEmbeddedCheckout(parsed.stripe);
        }, [
            parsed,
            options,
            ctx,
            loadedStripe
        ]);
        React.useEffect(function() {
            // cleanup on unmount
            return function() {
                // If embedded checkout is fully initialized, destroy it.
                if (ctx.embeddedCheckout) {
                    embeddedCheckoutPromise.current = null;
                    ctx.embeddedCheckout.destroy();
                } else if (embeddedCheckoutPromise.current) // If embedded checkout is still initializing, destroy it once
                // it's done. This could be caused by unmounting very quickly
                // after mounting.
                embeddedCheckoutPromise.current.then(function() {
                    embeddedCheckoutPromise.current = null;
                    if (ctx.embeddedCheckout) ctx.embeddedCheckout.destroy();
                });
            };
        }, [
            ctx.embeddedCheckout
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(loadedStripe);
        }, [
            loadedStripe
        ]); // Warn on changes to stripe prop.
        // The stripe prop value can only go from null to non-null once and
        // can't be changed after that.
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Warn on changes to options.
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (prevOptions == null) return;
            if (options == null) {
                console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot unset options after setting them.');
                return;
            }
            if (options.clientSecret === undefined && options.fetchClientSecret === undefined) console.warn('Invalid props passed to EmbeddedCheckoutProvider: You must provide one of either `options.fetchClientSecret` or `options.clientSecret`.');
            if (prevOptions.clientSecret != null && options.clientSecret !== prevOptions.clientSecret) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the client secret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.');
            if (prevOptions.fetchClientSecret != null && options.fetchClientSecret !== prevOptions.fetchClientSecret) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change fetchClientSecret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.');
            if (prevOptions.onComplete != null && options.onComplete !== prevOptions.onComplete) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onComplete option after setting it.');
            if (prevOptions.onShippingDetailsChange != null && options.onShippingDetailsChange !== prevOptions.onShippingDetailsChange) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onShippingDetailsChange option after setting it.');
            if (prevOptions.onLineItemsChange != null && options.onLineItemsChange !== prevOptions.onLineItemsChange) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onLineItemsChange option after setting it.');
        }, [
            prevOptions,
            options
        ]);
        return /*#__PURE__*/ React.createElement(EmbeddedCheckoutContext.Provider, {
            value: ctx
        }, children);
    };
    var EmbeddedCheckoutClientElement = function EmbeddedCheckoutClientElement(_ref) {
        var id = _ref.id, className = _ref.className;
        var _useEmbeddedCheckoutC = useEmbeddedCheckoutContext(), embeddedCheckout = _useEmbeddedCheckoutC.embeddedCheckout;
        var isMounted = React.useRef(false);
        var domNode = React.useRef(null);
        React.useLayoutEffect(function() {
            if (!isMounted.current && embeddedCheckout && domNode.current !== null) {
                embeddedCheckout.mount(domNode.current);
                isMounted.current = true;
            } // Clean up on unmount
            return function() {
                if (isMounted.current && embeddedCheckout) try {
                    embeddedCheckout.unmount();
                    isMounted.current = false;
                } catch (e) {
                // Parent effects are destroyed before child effects, so
                // in cases where both the EmbeddedCheckoutProvider and
                // the EmbeddedCheckout component are removed at the same
                // time, the embeddedCheckout instance will be destroyed,
                // which causes an error when calling unmount.
                }
            };
        }, [
            embeddedCheckout
        ]);
        return /*#__PURE__*/ React.createElement("div", {
            ref: domNode,
            id: id,
            className: className
        });
    }; // Only render the wrapper in a server environment.
    var EmbeddedCheckoutServerElement = function EmbeddedCheckoutServerElement(_ref2) {
        var id = _ref2.id, className = _ref2.className;
        // Validate that we are in the right context by calling useEmbeddedCheckoutContext.
        useEmbeddedCheckoutContext();
        return /*#__PURE__*/ React.createElement("div", {
            id: id,
            className: className
        });
    };
    var EmbeddedCheckout = isServer ? EmbeddedCheckoutServerElement : EmbeddedCheckoutClientElement;
    /**
   * @docs https://stripe.com/docs/stripe-js/react#usestripe-hook
   */ var useStripe = function useStripe() {
        var _useElementsOrCheckou = useElementsOrCheckoutSdkContextWithUseCase('calls useStripe()'), stripe = _useElementsOrCheckou.stripe;
        return stripe;
    };
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AuBankAccountElement = createElementComponent('auBankAccount', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardElement = createElementComponent('card', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardNumberElement = createElementComponent('cardNumber', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardExpiryElement = createElementComponent('cardExpiry', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardCvcElement = createElementComponent('cardCvc', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var FpxBankElement = createElementComponent('fpxBank', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IbanElement = createElementComponent('iban', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IdealBankElement = createElementComponent('idealBank', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var P24BankElement = createElementComponent('p24Bank', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var EpsBankElement = createElementComponent('epsBank', isServer);
    var PaymentElement = createElementComponent('payment', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ExpressCheckoutElement = createElementComponent('expressCheckout', isServer);
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   */ var CurrencySelectorElement = createElementComponent('currencySelector', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentRequestButtonElement = createElementComponent('paymentRequestButton', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var LinkAuthenticationElement = createElementComponent('linkAuthentication', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AddressElement = createElementComponent('address', isServer);
    /**
   * @deprecated
   * Use `AddressElement` instead.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ShippingAddressElement = createElementComponent('shippingAddress', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentMethodMessagingElement = createElementComponent('paymentMethodMessaging', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AffirmMessageElement = createElementComponent('affirmMessage', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AfterpayClearpayMessageElement = createElementComponent('afterpayClearpayMessage', isServer);
    exports1.AddressElement = AddressElement;
    exports1.AffirmMessageElement = AffirmMessageElement;
    exports1.AfterpayClearpayMessageElement = AfterpayClearpayMessageElement;
    exports1.AuBankAccountElement = AuBankAccountElement;
    exports1.CardCvcElement = CardCvcElement;
    exports1.CardElement = CardElement;
    exports1.CardExpiryElement = CardExpiryElement;
    exports1.CardNumberElement = CardNumberElement;
    exports1.CheckoutProvider = CheckoutProvider;
    exports1.CurrencySelectorElement = CurrencySelectorElement;
    exports1.Elements = Elements;
    exports1.ElementsConsumer = ElementsConsumer;
    exports1.EmbeddedCheckout = EmbeddedCheckout;
    exports1.EmbeddedCheckoutProvider = EmbeddedCheckoutProvider;
    exports1.EpsBankElement = EpsBankElement;
    exports1.ExpressCheckoutElement = ExpressCheckoutElement;
    exports1.FpxBankElement = FpxBankElement;
    exports1.IbanElement = IbanElement;
    exports1.IdealBankElement = IdealBankElement;
    exports1.LinkAuthenticationElement = LinkAuthenticationElement;
    exports1.P24BankElement = P24BankElement;
    exports1.PaymentElement = PaymentElement;
    exports1.PaymentMethodMessagingElement = PaymentMethodMessagingElement;
    exports1.PaymentRequestButtonElement = PaymentRequestButtonElement;
    exports1.ShippingAddressElement = ShippingAddressElement;
    exports1.useCheckout = useCheckout;
    exports1.useElements = useElements;
    exports1.useStripe = useStripe;
});

},{"d99b0077bf8bdf43":"9njXz"}],"kOzFY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexMjs = require("../dist/index.mjs");
parcelHelpers.exportAll(_indexMjs, exports);

},{"../dist/index.mjs":"byChS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"byChS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadStripe", ()=>loadStripe);
var RELEASE_TRAIN = 'basil';
var runtimeVersionToUrlVersion = function runtimeVersionToUrlVersion(version) {
    return version === 3 ? 'v3' : version;
};
var ORIGIN = 'https://js.stripe.com';
var STRIPE_JS_URL = "".concat(ORIGIN, "/").concat(RELEASE_TRAIN, "/stripe.js");
var V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var STRIPE_JS_URL_REGEX = /^https:\/\/js\.stripe\.com\/(v3|[a-z]+)\/stripe\.js(\?.*)?$/;
var EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';
var isStripeJSURL = function isStripeJSURL(url) {
    return V3_URL_REGEX.test(url) || STRIPE_JS_URL_REGEX.test(url);
};
var findScript = function findScript() {
    var scripts = document.querySelectorAll("script[src^=\"".concat(ORIGIN, "\"]"));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!isStripeJSURL(script.src)) continue;
        return script;
    }
    return null;
};
var injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
    var script = document.createElement('script');
    script.src = "".concat(STRIPE_JS_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
    headOrBody.appendChild(script);
    return script;
};
var registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: 'stripe-js',
        version: "7.3.0",
        startTime: startTime
    });
};
var stripePromise$1 = null;
var onErrorListener = null;
var onLoadListener = null;
var onError = function onError(reject) {
    return function(cause) {
        reject(new Error('Failed to load Stripe.js', {
            cause: cause
        }));
    };
};
var onLoad = function onLoad(resolve, reject) {
    return function() {
        if (window.Stripe) resolve(window.Stripe);
        else reject(new Error('Stripe.js not available'));
    };
};
var loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if (stripePromise$1 !== null) return stripePromise$1;
    stripePromise$1 = new Promise(function(resolve, reject) {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn(EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = findScript();
            if (script && params) console.warn(EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = injectScript(params);
            else if (script && onLoadListener !== null && onErrorListener !== null) {
                var _script$parentNode;
                // remove event listeners
                script.removeEventListener('load', onLoadListener);
                script.removeEventListener('error', onErrorListener); // if script exists, but we are reloading due to an error,
                // reload script to trigger 'load' event
                (_script$parentNode = script.parentNode) === null || _script$parentNode === void 0 || _script$parentNode.removeChild(script);
                script = injectScript(params);
            }
            onLoadListener = onLoad(resolve, reject);
            onErrorListener = onError(reject);
            script.addEventListener('load', onLoadListener);
            script.addEventListener('error', onErrorListener);
        } catch (error) {
            reject(error);
            return;
        }
    }); // Resets stripePromise on error
    return stripePromise$1["catch"](function(error) {
        stripePromise$1 = null;
        return Promise.reject(error);
    });
};
var initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var pk = args[0];
    var isTestKey = pk.match(/^pk_test/); // @ts-expect-error this is not publicly typed
    var version = runtimeVersionToUrlVersion(maybeStripe.version);
    var expectedVersion = RELEASE_TRAIN;
    if (isTestKey && version !== expectedVersion) console.warn("Stripe.js@".concat(version, " was loaded on the page, but @stripe/stripe-js@").concat("7.3.0", " expected Stripe.js@").concat(expectedVersion, ". This may result in unexpected behavior. For more information, see https://docs.stripe.com/sdks/stripejs-versioning"));
    var stripe = maybeStripe.apply(undefined, args);
    registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var stripePromise;
var loadCalled = false;
var getStripePromise = function getStripePromise() {
    if (stripePromise) return stripePromise;
    stripePromise = loadScript(null)["catch"](function(error) {
        // clear cache on error
        stripePromise = null;
        return Promise.reject(error);
    });
    return stripePromise;
}; // Execute our own script injection after a tick to give users time to do their
// own script injection.
Promise.resolve().then(function() {
    return getStripePromise();
})["catch"](function(error) {
    if (!loadCalled) console.warn(error);
});
var loadStripe = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    loadCalled = true;
    var startTime = Date.now(); // if previous attempts are unsuccessful, will re-load script
    return getStripePromise().then(function(maybeStripe) {
        return initStripe(maybeStripe, args, startTime);
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ev6ez":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PaymentHistoryPage);
var _jsxRuntime = require("react/jsx-runtime");
var _hook = require("context/parent-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _planInfo = require("./PlanInfo");
var _planInfoDefault = parcelHelpers.interopDefault(_planInfo);
var _react = require("external/react");
var _historyTable = require("./HistoryTable");
var _historyTableDefault = parcelHelpers.interopDefault(_historyTable);
const PaymentHistoryPage = ()=>{
    const { state: { paymentHistory, paymentHistorySubscription: subscription } } = (0, _hookDefault.default)();
    const lastInvoice = (0, _react.useMemo)(()=>paymentHistory.items[0] || false, [
        paymentHistory.items
    ]);
    return (0, _jsxRuntime.jsxs)((0, _react.Card).Body, {
        children: [
            (0, _jsxRuntime.jsx)((0, _planInfoDefault.default), {
                subscription: subscription,
                lastInvoice: lastInvoice
            }),
            (0, _jsxRuntime.jsx)("div", {
                className: 'mt-2',
                children: (0, _jsxRuntime.jsx)("p", {
                    className: 'm-auto',
                    children: "Historial de pagos"
                })
            }),
            (0, _jsxRuntime.jsx)((0, _react.Card).Body, {
                children: (0, _jsxRuntime.jsx)("div", {
                    className: 'row',
                    children: (0, _jsxRuntime.jsx)((0, _historyTableDefault.default), {
                        invoices: paymentHistory.items
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","context/parent-context/hook":"4wX3K","./PlanInfo":"8yUvX","external/react":"1Glst","./HistoryTable":"40phA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8yUvX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PlanInfo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _formatDate = require("utilities/format-date");
const PlanInfo = (props)=>{
    const { subscription, lastInvoice } = props;
    const { offer_name, plan_alias, price } = subscription;
    const nextBillingDate = (0, _react.useMemo)(()=>lastInvoice === false ? false : (0, _formatDate.convertTimeStampToString)(lastInvoice.lines.data[0].period.end), [
        lastInvoice
    ]);
    return (0, _jsxRuntime.jsxs)("div", {
        className: 'mt-4',
        children: [
            (0, _jsxRuntime.jsx)("div", {
                children: (0, _jsxRuntime.jsx)("p", {
                    children: "Tu pago mensual"
                })
            }),
            (0, _jsxRuntime.jsxs)((0, _react.Card), {
                className: 'mb-3',
                children: [
                    (0, _jsxRuntime.jsx)((0, _react.Card).Header, {
                        className: 'header-card-color'
                    }),
                    (0, _jsxRuntime.jsxs)((0, _react.Card).Body, {
                        children: [
                            (0, _jsxRuntime.jsxs)("div", {
                                className: 'd-flex justify-content-between mb-2',
                                children: [
                                    (0, _jsxRuntime.jsxs)("p", {
                                        style: {
                                            fontWeight: '500',
                                            margin: '0'
                                        },
                                        children: [
                                            `Plan ${offer_name}`,
                                            ' ',
                                            " ",
                                            (0, _jsxRuntime.jsx)("span", {
                                                className: 'fn-s-14 ml-1',
                                                children: `(${plan_alias})`
                                            })
                                        ]
                                    }),
                                    (0, _jsxRuntime.jsx)("p", {
                                        style: {
                                            fontWeight: '500',
                                            margin: '0'
                                        },
                                        children: price
                                    })
                                ]
                            }),
                            (0, _jsxRuntime.jsx)("p", {
                                style: {
                                    margin: '0'
                                },
                                children: (0, _jsxRuntime.jsxs)("span", {
                                    children: [
                                        " Tu pr\u00F3xima fecha de facturaci\u00F3n es el",
                                        ' ',
                                        " ",
                                        (0, _jsxRuntime.jsx)("b", {
                                            children: nextBillingDate
                                        }),
                                        "."
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","utilities/format-date":"fsetK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fsetK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatDate", ()=>formatDate);
parcelHelpers.export(exports, "currentDate", ()=>currentDate);
parcelHelpers.export(exports, "addMinutesFromCurrentDate", ()=>addMinutesFromCurrentDate);
parcelHelpers.export(exports, "convertTimeStampToString", ()=>convertTimeStampToString);
parcelHelpers.export(exports, "convertDateToString", ()=>convertDateToString);
var _moment = require("moment/moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
const formatDate = (date)=>{
    const parseDate = new Date(Date.parse(date));
    const stringDate = parseDate.toLocaleDateString();
    return stringDate;
};
const currentDate = ()=>{
    let stringDate = '';
    const date = new Date();
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    if (month < 10) stringDate = `${year}-0${month}-${day}`;
    else stringDate = `${year}-${month}-${day}`;
    return stringDate;
};
const addMinutesFromCurrentDate = (minutes)=>{
    const currentDate = (0, _momentDefault.default)();
    const newDate = currentDate.add(minutes, 'minutes');
    const currentNewDate = newDate.format();
    return currentNewDate;
};
const convertTimeStampToString = (timeStamp)=>{
    const date = new Date(timeStamp * 1000);
    const formattedDate = date.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
    return formattedDate;
};
const convertDateToString = (_date)=>{
    const date = new Date(_date);
    const formattedDate = date.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
    return formattedDate;
};

},{"moment/moment":"1e4qG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"40phA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HistoryTable);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _paymentHistoryItem = require("./PaymentHistoryItem");
var _paymentHistoryItemDefault = parcelHelpers.interopDefault(_paymentHistoryItem);
const HistoryTable = (props)=>{
    const { invoices } = props;
    return (0, _jsxRuntime.jsxs)((0, _react.Table), {
        striped: true,
        bordered: true,
        hover: true,
        size: 'sm',
        children: [
            (0, _jsxRuntime.jsx)("thead", {
                children: (0, _jsxRuntime.jsxs)("tr", {
                    children: [
                        (0, _jsxRuntime.jsx)("th", {
                            className: 'font-cell-text',
                            children: "Fecha"
                        }),
                        (0, _jsxRuntime.jsx)("th", {
                            className: 'font-cell-text',
                            children: "Descripci\u00F3n"
                        }),
                        (0, _jsxRuntime.jsx)("th", {
                            className: 'font-cell-text',
                            children: "Periodo del servicio"
                        }),
                        (0, _jsxRuntime.jsx)("th", {
                            className: 'font-cell-text',
                            children: "M\u00E9todo de pago"
                        }),
                        (0, _jsxRuntime.jsx)("th", {
                            className: 'font-cell-text',
                            children: "Estado de pago"
                        }),
                        (0, _jsxRuntime.jsx)("th", {
                            className: 'font-cell-text',
                            children: "Total"
                        })
                    ]
                })
            }),
            (0, _jsxRuntime.jsx)("tbody", {
                children: invoices.map((item, index)=>(0, _jsxRuntime.jsx)((0, _paymentHistoryItemDefault.default), {
                        invoice: item
                    }, index))
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","./PaymentHistoryItem":"8OiYy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8OiYy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PaymentHistoryItem);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _moment = require("external/moment");
var _paymentMethod = require("../PaymentMethod");
var _paymentMethodDefault = parcelHelpers.interopDefault(_paymentMethod);
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
const PaymentHistoryItem = (props)=>{
    const { invoice } = props;
    const { hosted_invoice_url } = invoice;
    const period = (0, _react.useMemo)(()=>invoice.lines.data[0].period, [
        invoice.lines
    ]);
    const cardDetails = invoice.charge_object?.payment_method_details?.card;
    const card = cardDetails?.brand;
    const last4 = cardDetails?.last4;
    return (0, _jsxRuntime.jsxs)("tr", {
        children: [
            (0, _jsxRuntime.jsx)("td", {
                children: (0, _jsxRuntime.jsx)("a", {
                    href: hosted_invoice_url,
                    target: '_blank',
                    children: (0, _moment.formatUnix)(period.start)
                })
            }),
            (0, _jsxRuntime.jsx)("td", {
                children: "suscripci\u00F3n"
            }),
            (0, _jsxRuntime.jsx)("td", {
                children: `${(0, _moment.formatUnix)(period.start)} - ${(0, _moment.formatUnix)(period.end)}`
            }),
            (0, _jsxRuntime.jsx)("td", {
                align: 'center',
                children: (0, _jsxRuntime.jsx)((0, _paymentMethodDefault.default), {
                    className: 'm-auto',
                    card: card,
                    last4: last4,
                    showLabel: false
                })
            }),
            invoice.status == 'paid' && (0, _jsxRuntime.jsxs)("td", {
                children: [
                    " ",
                    (0, _jsxRuntime.jsx)((0, _react.Badge), {
                        pill: true,
                        bg: 'primary',
                        children: "Completado"
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)("td", {
                children: [
                    "$",
                    (invoice.total / 100).toFixed(2)
                ]
            }),
            invoice.status == 'open' && (0, _jsxRuntime.jsxs)("td", {
                children: [
                    (0, _jsxRuntime.jsx)((0, _react.Badge), {
                        pill: true,
                        bg: 'danger',
                        children: "Declinada"
                    }),
                    (0, _jsxRuntime.jsx)("a", {
                        href: invoice.hosted_invoice_url,
                        children: (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                            name: 'faHandHoldingDollar',
                            className: 'ml-3',
                            title: 'Haz click para pagar!',
                            style: {
                                fontSize: '18px',
                                color: '#2d1a1a'
                            }
                        })
                    }),
                    (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                        name: 'faExclamationTriangle',
                        className: 'ml-3',
                        title: invoice.charge_object?.outcome?.reason
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/moment":"fMWlp","../PaymentMethod":"3AYnI","external/fortawesome":"7JvBl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hdz4X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UserProfileModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/parent-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _formValidation = require("utilities/form-validation");
var _formValidationDefault = parcelHelpers.interopDefault(_formValidation);
var _userProfileForm = require("./UserProfileForm");
var _userProfileFormDefault = parcelHelpers.interopDefault(_userProfileForm);
var _notify = require("components/Notify");
var _updatePassword = require("./UpdatePassword");
var _updatePasswordDefault = parcelHelpers.interopDefault(_updatePassword);
var _validators = require("utilities/form-validation/validators");
const { createRequiredFieldValidation } = (0, _formValidation.validators);
const userProfileValidations = {
    email: [
        createRequiredFieldValidation('email'),
        (0, _validators.createEmailValidation)('email')
    ],
    first_name: [
        createRequiredFieldValidation('first_name')
    ],
    last_name: [
        createRequiredFieldValidation('last_name')
    ]
};
const UserProfileModal = ()=>{
    const { update, state: { userProfile }, updateProfile } = (0, _hookDefault.default)();
    const [errors, validate] = (0, _formValidationDefault.default)(userProfileValidations);
    async function handleProfileSave() {
        if (!validate(userProfile, true)) return;
        const response = await updateProfile(userProfile);
        const { data: updated, statusResponse: { message } } = response.data;
        if (updated) (0, _notify.notifySuccess)(message);
        else (0, _notify.notifyError)(message);
    }
    function handleOpenChangePassword() {
        update({
            modals: {
                updatePassword: {
                    open: {
                        $set: true
                    }
                }
            }
        });
    }
    (0, _react.useEffect)(()=>{
        validate(userProfile, false);
    }, [
        userProfile
    ]);
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsxs)((0, _react.Card).Body, {
                children: [
                    (0, _jsxRuntime.jsx)((0, _userProfileFormDefault.default), {
                        errors: errors
                    }),
                    (0, _jsxRuntime.jsx)((0, _react.Button), {
                        variant: 'secondary',
                        className: 'mt-2 mr-0 px-4',
                        onClick: handleOpenChangePassword,
                        children: "Cambiar contrase\u00F1a"
                    }),
                    (0, _jsxRuntime.jsx)((0, _updatePasswordDefault.default), {})
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _react.Card).Footer, {
                className: 'd-flex justify-content-end px-0',
                children: (0, _jsxRuntime.jsx)((0, _react.Button), {
                    variant: 'primary',
                    className: 'mt-2 mr-0 px-4',
                    onClick: handleProfileSave,
                    children: "Guardar"
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/parent-context/hook":"4wX3K","utilities/form-validation":"1fpQO","./UserProfileForm":"3e0WD","components/Notify":"gZyef","./UpdatePassword":"ewx2f","utilities/form-validation/validators":"jQctS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3e0WD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UserProfileForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _formTextfield = require("components/FormTextfield");
var _formTextfieldDefault = parcelHelpers.interopDefault(_formTextfield);
var _hook = require("context/parent-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const UserProfileForm = (props)=>{
    const { errors } = props;
    const { update, state: { userProfile } } = (0, _hookDefault.default)();
    function createFieldProps(placeholder, fieldName, maxLength) {
        return {
            placeholder,
            maxLength,
            fieldName,
            value: userProfile[fieldName],
            submitted: errors.submitted,
            error: errors[fieldName],
            onChange: (e)=>{
                update({
                    userProfile: {
                        [fieldName]: {
                            $set: e.target.value
                        }
                    }
                });
            }
        };
    }
    return (0, _jsxRuntime.jsxs)((0, _react.Form), {
        children: [
            (0, _jsxRuntime.jsx)(LabeledTextField, {
                label: 'Correo electr\u00F3nico',
                ...createFieldProps('Email', 'email', 255),
                controlProps: {
                    readOnly: true
                }
            }),
            (0, _jsxRuntime.jsx)(LabeledTextField, {
                label: 'Nombre',
                ...createFieldProps('Nombre', 'first_name', 25)
            }),
            (0, _jsxRuntime.jsx)(LabeledTextField, {
                label: 'Apellido',
                ...createFieldProps('Apellido', 'last_name', 25)
            }),
            (0, _jsxRuntime.jsx)(LabeledTextField, {
                label: 'Tel\u00E9fono',
                ...createFieldProps("T\xe9lefono", 'phone')
            })
        ]
    });
};
function LabeledTextField(props) {
    const { label } = props;
    return (0, _jsxRuntime.jsxs)("div", {
        className: 'col-md-6 mt-2',
        children: [
            (0, _jsxRuntime.jsx)((0, _react.Form).Label, {
                className: 'd-flex flex-column justify-content-center col-sm-6',
                children: label
            }),
            (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                ...props
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","components/FormTextfield":"6jQpP","context/parent-context/hook":"4wX3K","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ewx2f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UpdatePasswordModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _modalAcceptCancelFooter = require("components/ModalAcceptCancelFooter");
var _modalAcceptCancelFooterDefault = parcelHelpers.interopDefault(_modalAcceptCancelFooter);
var _parent = require("types/context/parent");
var _hook = require("context/parent-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _formValidation = require("utilities/form-validation");
var _formValidationDefault = parcelHelpers.interopDefault(_formValidation);
var _updatePasswordForm = require("./UpdatePasswordForm");
var _updatePasswordFormDefault = parcelHelpers.interopDefault(_updatePasswordForm);
var _notify = require("components/Notify");
var _validators = require("utilities/form-validation/validators");
const { createRequiredFieldValidation } = (0, _formValidation.validators);
const passwordValidations = {
    oldPassword: [
        createRequiredFieldValidation('oldPassword')
    ],
    password: [
        createRequiredFieldValidation('password'),
        (0, _validators.createStrongPaswordValidation)('password')
    ],
    confirmPassword: [
        createRequiredFieldValidation('confirmPassword'),
        (0, _validators.createPasswordMatchValidation)('confirmPassword', 'password')
    ]
};
const UpdatePasswordModal = ()=>{
    const { update, state: { modals }, params: { role }, updatePassword } = (0, _hookDefault.default)();
    const [errors, validate, resetValidations] = (0, _formValidationDefault.default)(passwordValidations);
    function handleClose() {
        resetValidations();
        update({
            modals: {
                updatePassword: {
                    $set: (0, _parent.clearedProfilePasswords)
                }
            }
        });
    }
    async function handleChangePassword() {
        if (!validate(modals.updatePassword.passwords, true)) return;
        const response = await updatePassword(modals.updatePassword.passwords);
        const { data: updated, statusResponse: { message } } = response.data;
        if (updated) (0, _notify.notifySuccess)(message);
        else (0, _notify.notifyError)(message);
        handleClose();
    }
    (0, _react.useEffect)(()=>{
        validate(modals.updatePassword.passwords, false);
    }, [
        modals.updatePassword.passwords
    ]);
    return (0, _jsxRuntime.jsxs)((0, _react.Modal), {
        show: modals.updatePassword.open,
        onHide: handleClose,
        size: 'lg',
        centered: true,
        children: [
            (0, _jsxRuntime.jsx)((0, _react.Modal).Header, {
                closeButton: true,
                children: (0, _jsxRuntime.jsx)("h5", {
                    className: 'text-capitalize',
                    style: {
                        fontFamily: 'Arial, sans-serif',
                        margin: '0'
                    },
                    children: "Cambiar Contrase\u00F1a"
                })
            }),
            (0, _jsxRuntime.jsx)((0, _react.Modal).Body, {
                children: (0, _jsxRuntime.jsx)((0, _updatePasswordFormDefault.default), {
                    errors: errors
                })
            }),
            (0, _jsxRuntime.jsx)((0, _modalAcceptCancelFooterDefault.default), {
                onCancel: handleClose,
                onAccept: handleChangePassword,
                labels: {
                    accept: 'Guardar'
                }
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","components/ModalAcceptCancelFooter":"buHx2","types/context/parent":"5MNF8","context/parent-context/hook":"4wX3K","utilities/form-validation":"1fpQO","./UpdatePasswordForm":"8WfgU","components/Notify":"gZyef","utilities/form-validation/validators":"jQctS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8WfgU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UpdatePasswordForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _formTextfield = require("components/FormTextfield");
var _hook = require("context/parent-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const UpdatePasswordForm = (props)=>{
    const { errors } = props;
    const { update, state: { modals: { updatePassword: { passwords } } } } = (0, _hookDefault.default)();
    function createFieldProps(placeholder, fieldName, maxLength) {
        return {
            placeholder,
            maxLength,
            fieldName,
            value: passwords[fieldName],
            submitted: errors.submitted,
            error: errors[fieldName],
            onChange: (e)=>{
                update({
                    modals: {
                        updatePassword: {
                            passwords: {
                                [fieldName]: {
                                    $set: e.target.value
                                }
                            }
                        }
                    }
                });
            }
        };
    }
    return (0, _jsxRuntime.jsxs)((0, _react.Form), {
        children: [
            (0, _jsxRuntime.jsx)((0, _formTextfield.PasswordField), {
                className: 'col-sm-6',
                controlProps: {
                    autoComplete: 'current-password'
                },
                ...createFieldProps("Contrase\xf1a actual", 'oldPassword')
            }),
            (0, _jsxRuntime.jsx)((0, _formTextfield.PasswordField), {
                className: 'col-sm-6 mt-3',
                controlProps: {
                    autoComplete: 'new-password'
                },
                ...createFieldProps("Contrase\xf1a nueva", 'password')
            }),
            (0, _jsxRuntime.jsx)((0, _formTextfield.PasswordField), {
                className: 'col-sm-6 mt-3',
                controlProps: {
                    autoComplete: 'new-password'
                },
                ...createFieldProps("Confirmar Contrase\xf1a", 'confirmPassword')
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","components/FormTextfield":"6jQpP","context/parent-context/hook":"4wX3K","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c5UL9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UserPackages);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/parent-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _packageTab = require("./PackageTab");
var _packageTabDefault = parcelHelpers.interopDefault(_packageTab);
const UserPackages = ()=>{
    const { state: { userPackageDetails: { items: packages } }, params: { role } } = (0, _hookDefault.default)();
    return (0, _jsxRuntime.jsx)((0, _react.Tabs), {
        defaultActiveKey: 0,
        className: 'mt-3',
        children: packages.map((p, i)=>(0, _jsxRuntime.jsx)((0, _react.Tab), {
                eventKey: i,
                title: `Plan ${p.offerName} (${p.plan_alias})`,
                children: (0, _jsxRuntime.jsx)((0, _packageTabDefault.default), {
                    role: role,
                    packageItem: p
                })
            }, i))
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/parent-context/hook":"4wX3K","./PackageTab":"3quFC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3quFC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PackageTab);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _planInfo = require("components/PlanInfo");
var _planInfoDefault = parcelHelpers.interopDefault(_planInfo);
var _selectTutor = require("components/SelectTutor");
var _selectTutorDefault = parcelHelpers.interopDefault(_selectTutor);
var _selectStudent = require("components/SelectStudent");
var _selectStudentDefault = parcelHelpers.interopDefault(_selectStudent);
var _courseList = require("components/CourseList");
var _courseListDefault = parcelHelpers.interopDefault(_courseList);
const PackageTab = (props)=>{
    const { packageItem, role } = props;
    const [courses, elective] = (0, _react.useMemo)(()=>[
            packageItem.courses.filter((c)=>!c.id.startsWith('C7')),
            packageItem.courses.filter((c)=>c.id.startsWith('C7'))
        ], [
        packageItem.courses
    ]);
    return (0, _jsxRuntime.jsxs)("div", {
        className: 'py-3',
        children: [
            (0, _jsxRuntime.jsxs)("div", {
                className: 'd-flex gap-3',
                children: [
                    (0, _jsxRuntime.jsx)((0, _planInfoDefault.default), {
                        className: 'p-0 flex-grow-1 mb-3',
                        packageItem: packageItem
                    }),
                    role === 'student' && (0, _jsxRuntime.jsx)((0, _selectTutorDefault.default), {
                        packageItem: packageItem
                    }),
                    role === 'tutor' && (0, _jsxRuntime.jsx)((0, _selectStudentDefault.default), {
                        packageItem: packageItem
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _courseListDefault.default), {
                courses: courses,
                source: 'basic'
            }),
            (0, _jsxRuntime.jsx)((0, _courseListDefault.default), {
                courses: elective,
                source: 'elective'
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","components/PlanInfo":"3FPyp","components/SelectTutor":"2lMLI","components/SelectStudent":"8D7ey","components/CourseList":"1GGij","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dcFYX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wrapParentContainer", ()=>wrapParentContainer);
parcelHelpers.export(exports, "wrapAdminContainer", ()=>wrapAdminContainer);
parcelHelpers.export(exports, "wrapAccountingContainer", ()=>wrapAccountingContainer);
var _react = require("external/react");
var _homeContainer = require("./parent/HomeContainer");
var _homeContainerDefault = parcelHelpers.interopDefault(_homeContainer);
var _packageContainer = require("./parent/PackageContainer");
var _packageContainerDefault = parcelHelpers.interopDefault(_packageContainer);
var _usersContainer = require("./parent/UsersContainer");
var _usersContainerDefault = parcelHelpers.interopDefault(_usersContainer);
var _newUserContainer = require("./parent/NewUserContainer");
var _newUserContainerDefault = parcelHelpers.interopDefault(_newUserContainer);
var _userPackageContainer = require("./parent/UserPackageContainer");
var _userPackageContainerDefault = parcelHelpers.interopDefault(_userPackageContainer);
var _paymentContainer = require("./parent/PaymentContainer");
var _paymentContainerDefault = parcelHelpers.interopDefault(_paymentContainer);
var _paymentHistory = require("./parent/PaymentHistory");
var _paymentHistoryDefault = parcelHelpers.interopDefault(_paymentHistory);
var _profileContainer = require("./parent/ProfileContainer");
var _profileContainerDefault = parcelHelpers.interopDefault(_profileContainer);
var _homeContainer1 = require("./admin/HomeContainer");
var _homeContainerDefault1 = parcelHelpers.interopDefault(_homeContainer1);
var _offersContainer = require("./admin/OffersContainer");
var _offersContainerDefault = parcelHelpers.interopDefault(_offersContainer);
var _offerConfigurationContainer = require("./admin/OfferConfigurationContainer");
var _offerConfigurationContainerDefault = parcelHelpers.interopDefault(_offerConfigurationContainer);
var _clientsContainer = require("./admin/ClientsContainer");
var _clientsContainerDefault = parcelHelpers.interopDefault(_clientsContainer);
var _clientContainer = require("./admin/ClientContainer");
var _clientContainerDefault = parcelHelpers.interopDefault(_clientContainer);
var _homeContainer2 = require("./accounting/HomeContainer");
var _homeContainerDefault2 = parcelHelpers.interopDefault(_homeContainer2);
var _payoutsContainer = require("./accounting/PayoutsContainer");
var _payoutsContainerDefault = parcelHelpers.interopDefault(_payoutsContainer);
var _payoutContainer = require("./accounting/PayoutContainer");
var _payoutContainerDefault = parcelHelpers.interopDefault(_payoutContainer);
const parentContainers = {
    Home: (0, _homeContainerDefault.default),
    Package: (0, _packageContainerDefault.default),
    Users: (0, _usersContainerDefault.default),
    NewUser: (0, _newUserContainerDefault.default),
    UserPackage: (0, _userPackageContainerDefault.default),
    Payment: (0, _paymentContainerDefault.default),
    PaymentHistory: (0, _paymentHistoryDefault.default),
    Profile: (0, _profileContainerDefault.default)
};
const adminContainers = {
    Home: (0, _homeContainerDefault1.default),
    Offers: (0, _offersContainerDefault.default),
    OfferConfiguration: (0, _offerConfigurationContainerDefault.default),
    Clients: (0, _clientsContainerDefault.default),
    Client: (0, _clientContainerDefault.default)
};
const accountingContainers = {
    Home: (0, _homeContainerDefault2.default),
    Payouts: (0, _payoutsContainerDefault.default),
    Payout: (0, _payoutContainerDefault.default)
};
function wrapParentContainer(containerName, Page) {
    return ()=>(0, _react.createElement)(parentContainers[containerName], {}, (0, _react.createElement)(Page));
}
function wrapAdminContainer(containerName, Page) {
    return ()=>(0, _react.createElement)(adminContainers[containerName], {}, (0, _react.createElement)(Page));
}
function wrapAccountingContainer(containerName, Page) {
    return ()=>(0, _react.createElement)(accountingContainers[containerName], {}, (0, _react.createElement)(Page));
}

},{"external/react":"1Glst","./parent/HomeContainer":"6r1iZ","./parent/PackageContainer":"5JaQa","./parent/UsersContainer":"lkNUH","./parent/NewUserContainer":"ksr0J","./parent/UserPackageContainer":"bKE36","./parent/PaymentContainer":"iwA7M","./parent/PaymentHistory":"cPFze","./parent/ProfileContainer":"l05lg","./admin/HomeContainer":"aFpIl","./admin/OffersContainer":"hgmFW","./admin/OfferConfigurationContainer":"9HXHR","./admin/ClientsContainer":"4i5RE","./admin/ClientContainer":"aBD74","./accounting/HomeContainer":"7nX1f","./accounting/PayoutsContainer":"jywdz","./accounting/PayoutContainer":"9Ntz3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6r1iZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HomeContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("external/clsx");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _buttonBack = require("components/ButtonBack");
var _buttonBackDefault = parcelHelpers.interopDefault(_buttonBack);
var _hook = require("context/parent-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _basicLayout = require("./BasicLayout");
var _basicLayoutDefault = parcelHelpers.interopDefault(_basicLayout);
const parentContainerHeadings = {
    home: [
        'faHouse',
        'Home'
    ],
    support: [
        'faHeadset',
        'Apoyo'
    ],
    packages: [
        'faBox',
        'Mis Paquetes'
    ],
    payment: [
        'faHandHoldingDollar',
        'Pagos'
    ]
};
const HomeContainer = (props)=>{
    const { children } = props;
    const { params } = (0, _hookDefault.default)();
    const [icon, label] = (0, _react.useMemo)(()=>parentContainerHeadings[params.pageName || 'home'] || parentContainerHeadings.home, [
        params.pageName
    ]);
    return (0, _jsxRuntime.jsxs)((0, _basicLayoutDefault.default), {
        children: [
            (0, _jsxRuntime.jsxs)((0, _react.Card).Header, {
                style: {
                    fontSize: '31px'
                },
                className: 'card--header',
                children: [
                    (0, _jsxRuntime.jsx)((0, _buttonBackDefault.default), {
                        path: '/home',
                        className: (0, _clsx.clsx)({
                            'd-none': label === 'Home'
                        })
                    }),
                    (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                        name: icon
                    }),
                    " ",
                    label
                ]
            }),
            children
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/clsx":"012R0","external/react":"1Glst","external/fortawesome":"7JvBl","components/ButtonBack":"3nJVT","context/parent-context/hook":"4wX3K","./BasicLayout":"5Uhzc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Uhzc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BasicLayout);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
const BasicLayout = (props)=>{
    const { children } = props;
    return (0, _jsxRuntime.jsx)("div", {
        className: 'container',
        children: (0, _jsxRuntime.jsx)("div", {
            className: 'row mt-5 mb-5',
            children: (0, _jsxRuntime.jsx)("div", {
                className: 'col-12-md',
                children: (0, _jsxRuntime.jsx)((0, _react.Card), {
                    className: 'shadow card--card',
                    children: children
                })
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5JaQa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PackageContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _buttonBack = require("components/ButtonBack");
var _buttonBackDefault = parcelHelpers.interopDefault(_buttonBack);
var _hook = require("context/package-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _basicLayout = require("./BasicLayout");
var _basicLayoutDefault = parcelHelpers.interopDefault(_basicLayout);
var _subscriptionAction = require("pages/home/payment/SubscriptionAction");
var _subscriptionActionDefault = parcelHelpers.interopDefault(_subscriptionAction);
var _notify = require("components/Notify");
var _paymentService = require("services/payment.service");
const PackageContainer = (props)=>{
    const { children } = props;
    const [params, setSearchParams] = (0, _react.useSearchParams)();
    const { state: { packageItem }, update } = (0, _hookDefault.default)();
    const id = packageItem.data?.id;
    const offerName = packageItem.data?.offerName;
    const plan_alias = packageItem.data?.plan_alias;
    const paymentMode = packageItem.data?.paymentMode;
    const subscriptionStatus = packageItem.data?.subscriptionStatus || 'canceled';
    async function handleItemAction(index, status) {
        const subscription = packageItem.data;
        if (!subscription) return;
        switch(status){
            case 'active':
                console.log(subscription);
                const { isConfirmed: cancelationConfirmed } = await (0, _notify.showConfirmCancelSubscription)(subscription.subscriptionEnds || new Date());
                if (cancelationConfirmed) {
                    const response = await (0, _paymentService.paymentService).cancelSubscription(subscription);
                    (0, _notify.notifyWarning)(`Tu suscripci\xf3n: Plan ${subscription.offerName} ha sido cancelada.`);
                    update({
                        packageRefreshes: {
                            '$apply': (i)=>i + 1
                        }
                    });
                }
                break;
            case 'pending':
                await (0, _paymentService.paymentService).reactiveSubscription(subscription);
                (0, _notify.notifySuccess)(`Tu suscripci\xf3n Plan ${subscription.offerName} ha sido reactivada.`);
                update({
                    packageRefreshes: {
                        '$apply': (i)=>i + 1
                    }
                });
                break;
            case 'canceled':
                const { data: reactivateSession } = await (0, _paymentService.paymentService).activateCanceledSubscription({
                    ...subscription,
                    source: `/home/packages/${id}`
                });
                if (reactivateSession.success) location.replace(reactivateSession.data.url);
                break;
            default:
                console.log(`unhandled: ${subscription}`);
                break;
        }
    }
    (0, _react.useEffect)(()=>{
        const subscription = packageItem.data;
        if (!subscription) return;
        if (params.has('reactivated')) {
            const newParams = new URLSearchParams(params);
            newParams.delete('reactivated');
            (0, _notify.notifySuccess)(`Tu suscripci\xf3n Plan ${subscription.offerName} ha sido reactivada.`);
            setSearchParams(newParams);
        }
    }, [
        params,
        packageItem
    ]);
    return (0, _jsxRuntime.jsxs)((0, _basicLayoutDefault.default), {
        children: [
            (0, _jsxRuntime.jsxs)((0, _react.Card).Header, {
                className: 'card--header d-flex package-detail',
                children: [
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'd-flex flex-column justify-content-center',
                        children: (0, _jsxRuntime.jsx)((0, _buttonBackDefault.default), {
                            path: '/home/packages'
                        })
                    }),
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'tex-capitalize ms-2',
                        style: {
                            fontSize: '31px'
                        },
                        children: (0, _jsxRuntime.jsxs)("span", {
                            className: 'text-capitalize fw-bold',
                            children: [
                                "Plan ",
                                offerName,
                                (0, _jsxRuntime.jsxs)("span", {
                                    className: 'fn-s-14 ml-1',
                                    children: [
                                        "(",
                                        plan_alias,
                                        ")"
                                    ]
                                })
                            ]
                        })
                    }),
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'flex-grow-1'
                    }),
                    paymentMode === 'subscription' && (0, _jsxRuntime.jsx)((0, _subscriptionActionDefault.default), {
                        index: -1,
                        onClick: handleItemAction,
                        status: subscriptionStatus,
                        disabled: false,
                        label: subscriptionStatus == 'canceled' ? 'Reactivar' : undefined
                    })
                ]
            }),
            children
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","components/ButtonBack":"3nJVT","context/package-context/hook":"cOTE3","./BasicLayout":"5Uhzc","pages/home/payment/SubscriptionAction":"ahLiJ","components/Notify":"gZyef","services/payment.service":"gDcUl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lkNUH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UsersContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("external/clsx");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _buttonBack = require("components/ButtonBack");
var _buttonBackDefault = parcelHelpers.interopDefault(_buttonBack);
var _hook = require("context/parent-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _basicLayout = require("./BasicLayout");
var _basicLayoutDefault = parcelHelpers.interopDefault(_basicLayout);
const UsersContainer = (props)=>{
    const { children } = props;
    const { params, navigation } = (0, _hookDefault.default)();
    return (0, _jsxRuntime.jsxs)((0, _basicLayoutDefault.default), {
        children: [
            (0, _jsxRuntime.jsxs)((0, _react.Card).Header, {
                className: 'card--header d-flex',
                children: [
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'd-flex flex-column justify-content-center',
                        children: (0, _jsxRuntime.jsx)((0, _buttonBackDefault.default), {
                            path: '/home'
                        })
                    }),
                    (0, _jsxRuntime.jsxs)("div", {
                        className: 'ms-2',
                        style: {
                            fontSize: '31px'
                        },
                        children: [
                            (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                name: 'faUsers'
                            }),
                            " Usuarios"
                        ]
                    }),
                    (0, _jsxRuntime.jsxs)("div", {
                        style: {
                            fontSize: '16px'
                        },
                        className: 'd-flex flex-grow-1 justify-content-end align-items-center',
                        children: [
                            (0, _jsxRuntime.jsxs)((0, _react.Link), {
                                to: navigation.users.link({
                                    role: 'student'
                                }),
                                style: {
                                    width: '160px'
                                },
                                className: (0, _clsx.clsx)('language__filter mx-1', {
                                    selected: params.role === 'student'
                                }),
                                children: [
                                    (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                        name: 'faGraduationCap'
                                    }),
                                    " Estudiante"
                                ]
                            }),
                            (0, _jsxRuntime.jsxs)((0, _react.Link), {
                                to: navigation.users.link({
                                    role: 'tutor'
                                }),
                                style: {
                                    width: '160px'
                                },
                                className: (0, _clsx.clsx)('language__filter mx-1', {
                                    selected: params.role === 'tutor'
                                }),
                                children: [
                                    (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                        name: 'faPersonChalkboard'
                                    }),
                                    " Tutor"
                                ]
                            })
                        ]
                    })
                ]
            }),
            children
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/clsx":"012R0","external/react":"1Glst","external/fortawesome":"7JvBl","components/ButtonBack":"3nJVT","context/parent-context/hook":"4wX3K","./BasicLayout":"5Uhzc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ksr0J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>NewUserContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _buttonBack = require("components/ButtonBack");
var _buttonBackDefault = parcelHelpers.interopDefault(_buttonBack);
var _hook = require("context/parent-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _basicLayout = require("./BasicLayout");
var _basicLayoutDefault = parcelHelpers.interopDefault(_basicLayout);
const NewUserContainer = (props)=>{
    const { children } = props;
    const { params, navigation } = (0, _hookDefault.default)();
    const [iconName, roleText, backLink] = (0, _react.useMemo)(()=>[
            params.role === 'student' ? 'faGraduationCap' : 'faPersonChalkboard',
            params.role === 'student' ? 'estudiante' : 'tutor',
            navigation.users.link()
        ], [
        params.role
    ]);
    return (0, _jsxRuntime.jsxs)((0, _basicLayoutDefault.default), {
        children: [
            (0, _jsxRuntime.jsxs)((0, _react.Card).Header, {
                className: 'card--header d-flex',
                children: [
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'd-flex flex-column justify-content-center',
                        children: (0, _jsxRuntime.jsx)((0, _buttonBackDefault.default), {
                            path: backLink
                        })
                    }),
                    (0, _jsxRuntime.jsxs)("div", {
                        className: 'ms-2',
                        style: {
                            fontSize: '31px'
                        },
                        children: [
                            (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                name: iconName
                            }),
                            " Nuevo ",
                            roleText
                        ]
                    })
                ]
            }),
            children
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/fortawesome":"7JvBl","components/ButtonBack":"3nJVT","context/parent-context/hook":"4wX3K","./BasicLayout":"5Uhzc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bKE36":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UserPackageContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _buttonBack = require("components/ButtonBack");
var _buttonBackDefault = parcelHelpers.interopDefault(_buttonBack);
var _basicLayout = require("./BasicLayout");
var _basicLayoutDefault = parcelHelpers.interopDefault(_basicLayout);
var _hook = require("context/parent-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
const UserPackageContainer = (props)=>{
    const { children } = props;
    const { state: { userPackageDetailsProfile }, params: { role, userId }, navigation } = (0, _hookDefault.default)();
    const name = (0, _react.useMemo)(()=>userPackageDetailsProfile && `${userPackageDetailsProfile.first_name} ${userPackageDetailsProfile.last_name}`, [
        userPackageDetailsProfile
    ]);
    return (0, _jsxRuntime.jsxs)((0, _basicLayoutDefault.default), {
        children: [
            (0, _jsxRuntime.jsxs)((0, _react.Card).Header, {
                style: {
                    fontSize: '31px'
                },
                className: 'card--header d-flex',
                children: [
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'd-flex flex-column justify-content-center',
                        children: (0, _jsxRuntime.jsx)((0, _buttonBackDefault.default), {
                            path: navigation.users.link({
                                role
                            })
                        })
                    }),
                    (0, _jsxRuntime.jsxs)("div", {
                        className: 'ms-2',
                        style: {
                            fontSize: '31px'
                        },
                        children: [
                            (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                name: 'faBox'
                            }),
                            (0, _jsxRuntime.jsxs)("span", {
                                className: 'ml-1',
                                children: [
                                    "Detalle de paquetes: ",
                                    name
                                ]
                            })
                        ]
                    })
                ]
            }),
            children
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","components/ButtonBack":"3nJVT","./BasicLayout":"5Uhzc","context/parent-context/hook":"4wX3K","external/fortawesome":"7JvBl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iwA7M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PaymentContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _buttonBackContainer = require("./ButtonBackContainer");
var _buttonBackContainerDefault = parcelHelpers.interopDefault(_buttonBackContainer);
const PaymentContainer = (props)=>{
    const { children } = props;
    return (0, _jsxRuntime.jsx)((0, _buttonBackContainerDefault.default), {
        iconName: 'faHandHoldingDollar',
        label: 'Pagos',
        children: children
    });
};

},{"react/jsx-runtime":"1dlk8","./ButtonBackContainer":"lvHko","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lvHko":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ButtonBackContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _buttonBack = require("components/ButtonBack");
var _buttonBackDefault = parcelHelpers.interopDefault(_buttonBack);
var _basicLayout = require("./BasicLayout");
var _basicLayoutDefault = parcelHelpers.interopDefault(_basicLayout);
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
const ButtonBackContainer = (props)=>{
    const { iconName, backTo = '/home', label, children } = props;
    return (0, _jsxRuntime.jsxs)((0, _basicLayoutDefault.default), {
        children: [
            (0, _jsxRuntime.jsxs)((0, _react.Card).Header, {
                className: 'card--header d-flex',
                children: [
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'd-flex flex-column justify-content-center',
                        children: (0, _jsxRuntime.jsx)((0, _buttonBackDefault.default), {
                            path: backTo
                        })
                    }),
                    (0, _jsxRuntime.jsxs)("div", {
                        className: 'ms-2',
                        style: {
                            fontSize: '31px'
                        },
                        children: [
                            (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                name: iconName
                            }),
                            " ",
                            label
                        ]
                    })
                ]
            }),
            children
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","components/ButtonBack":"3nJVT","./BasicLayout":"5Uhzc","external/fortawesome":"7JvBl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cPFze":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PaymentHistoryContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _buttonBackContainer = require("./ButtonBackContainer");
var _buttonBackContainerDefault = parcelHelpers.interopDefault(_buttonBackContainer);
const PaymentHistoryContainer = (props)=>{
    const { children } = props;
    return (0, _jsxRuntime.jsx)((0, _buttonBackContainerDefault.default), {
        backTo: '/home/payment',
        iconName: 'faClockRotateLeft',
        label: 'Historial de Pagos',
        children: children
    });
};

},{"react/jsx-runtime":"1dlk8","./ButtonBackContainer":"lvHko","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l05lg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ProfileContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _basicLayout = require("./BasicLayout");
var _basicLayoutDefault = parcelHelpers.interopDefault(_basicLayout);
const ProfileContainer = (props)=>{
    const { children } = props;
    return (0, _jsxRuntime.jsxs)((0, _basicLayoutDefault.default), {
        children: [
            (0, _jsxRuntime.jsxs)((0, _react.Card).Header, {
                style: {
                    fontSize: '31px'
                },
                className: 'card--header',
                children: [
                    (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                        name: "faUser"
                    }),
                    "Perfil"
                ]
            }),
            children
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/fortawesome":"7JvBl","./BasicLayout":"5Uhzc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aFpIl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HomeContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("external/clsx");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _buttonBack = require("components/ButtonBack");
var _buttonBackDefault = parcelHelpers.interopDefault(_buttonBack);
var _basicLayout = require("./BasicLayout");
var _basicLayoutDefault = parcelHelpers.interopDefault(_basicLayout);
var _hook = require("context/admin-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const parentContainerHeadings = {
    home: [
        'faHouse',
        'Home'
    ],
    support: [
        'faHeadset',
        'Apoyo'
    ],
    packages: [
        'faBox',
        'Mis Paquetes'
    ],
    payment: [
        'faHandHoldingDollar',
        'Pagos'
    ]
};
const HomeContainer = (props)=>{
    const { children } = props;
    const { params } = (0, _hookDefault.default)();
    const [icon, label] = (0, _react.useMemo)(()=>parentContainerHeadings[params.pageName || 'home'] || parentContainerHeadings.home, [
        params.pageName
    ]);
    return (0, _jsxRuntime.jsxs)((0, _basicLayoutDefault.default), {
        children: [
            (0, _jsxRuntime.jsxs)((0, _react.Card).Header, {
                style: {
                    fontSize: '31px'
                },
                className: 'card--header',
                children: [
                    (0, _jsxRuntime.jsx)((0, _buttonBackDefault.default), {
                        path: '/home',
                        className: (0, _clsx.clsx)({
                            'd-none': label === 'Home'
                        })
                    }),
                    (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                        name: icon
                    }),
                    " ",
                    label
                ]
            }),
            children
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/clsx":"012R0","external/react":"1Glst","external/fortawesome":"7JvBl","components/ButtonBack":"3nJVT","./BasicLayout":"e9cbX","context/admin-context/hook":"lWmPL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e9cbX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BasicLayout);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
const BasicLayout = (props)=>{
    const { children } = props;
    return (0, _jsxRuntime.jsx)("div", {
        className: 'container',
        children: (0, _jsxRuntime.jsx)("div", {
            className: 'row mt-5 mb-5',
            children: (0, _jsxRuntime.jsx)("div", {
                className: 'col-12-md',
                children: (0, _jsxRuntime.jsx)((0, _react.Card), {
                    className: 'shadow card--card',
                    children: children
                })
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lWmPL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useAdmin);
var _offerService = require("services/offer.service");
var _react = require("external/react");
var _adminContext = require("context/admin-context");
var _adminContextDefault = parcelHelpers.interopDefault(_adminContext);
var _formValidation = require("utilities/form-validation");
var _formValidationDefault = parcelHelpers.interopDefault(_formValidation);
var _hook = require("context/auth-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _adminService = require("services/admin.service");
var _enum = require("utilities/enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
const { createRequiredFieldValidation, createConditionallyRequiredFieldValidation } = (0, _formValidation.validators);
const changeValidations = {
    name: [
        createRequiredFieldValidation('name')
    ],
    price: [
        createRequiredFieldValidation('price')
    ],
    discount_name: [
        createRequiredFieldValidation('discount_name')
    ],
    discount_amount: [
        createRequiredFieldValidation('discount_amount')
    ],
    month_number: [
        createConditionallyRequiredFieldValidation('month_number', (offer)=>offer.duration === 'repeating')
    ]
};
function useAdmin() {
    const { user } = (0, _hookDefault.default)();
    const { state, update } = (0, _react.useContext)((0, _adminContextDefault.default).Context);
    const { currentOffer, offers: { initialized: initializedOffers, items: offers }, props: { navigation, params, query }, changeCourseModal } = state;
    const [errors, validate, resetValidations] = (0, _formValidationDefault.default)(changeValidations);
    const toggleOfferStatus = (offer)=>{
        const offerIndex = state.offers.items.findIndex((item)=>item.id === offer.id);
        if (offerIndex >= 0) update({
            offers: {
                items: {
                    [offerIndex]: {
                        active: {
                            $apply: (current)=>{
                                const active = !current;
                                (0, _offerService.offerService).updateOfferActive({
                                    ...offer,
                                    active
                                });
                                return active;
                            }
                        }
                    }
                }
            }
        });
    };
    const updateChangeCourseModal = async (open, purchaseIndex, originalCourse, { subject, grade, course, source }, cb)=>{
        await update({
            changeCourseModal: {
                open: {
                    $set: open
                },
                purchaseIndex: {
                    $set: purchaseIndex
                },
                originalCourse: {
                    $set: originalCourse
                },
                source: {
                    $set: source
                },
                selected: {
                    subject: {
                        $set: subject
                    },
                    grade: {
                        $set: grade
                    },
                    course: {
                        $set: course
                    }
                }
            }
        });
        cb && cb(open, purchaseIndex, {
            subject,
            grade,
            course
        });
    };
    const changeClientCourse = async (params)=>{
        try {
            const resp = await (0, _adminService.adminService).updateClientCourse(user.id, params);
            console.log(resp);
        //window.location.reload()
        } catch (err) {
            console.log(err);
        }
    };
    const getStripeInfo = async (clientId)=>{
        return (0, _adminService.adminService).getStripeInfo(user.id, clientId);
    };
    const roleName = (0, _react.useMemo)(()=>(user ? (0, _enumDefault.default)('role', user.role) : '')?.toLowerCase(), [
        user.role
    ]);
    return {
        offers,
        roleName,
        currentOffer,
        toggleOfferStatus,
        initializedOffers,
        state,
        update,
        params,
        query,
        navigation,
        errors,
        validate,
        changeCourseModal,
        updateChangeCourseModal,
        changeClientCourse,
        getStripeInfo,
        resetValidations
    };
}

},{"services/offer.service":"luCvD","external/react":"1Glst","context/admin-context":"kK0ry","utilities/form-validation":"1fpQO","context/auth-context/hook":"2UX0M","services/admin.service":"jdp6E","utilities/enum":"bEPnh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hgmFW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AdminOffersContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _buttonBack = require("components/ButtonBack");
var _buttonBackDefault = parcelHelpers.interopDefault(_buttonBack);
var _basicLayout = require("./BasicLayout");
var _basicLayoutDefault = parcelHelpers.interopDefault(_basicLayout);
const AdminOffersContainer = (props)=>{
    const { children } = props;
    return (0, _jsxRuntime.jsxs)((0, _basicLayoutDefault.default), {
        children: [
            (0, _jsxRuntime.jsxs)((0, _react.Card).Header, {
                className: 'card--header d-flex',
                children: [
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'd-flex flex-column justify-content-center',
                        children: (0, _jsxRuntime.jsx)((0, _buttonBackDefault.default), {
                            path: '/admin'
                        })
                    }),
                    (0, _jsxRuntime.jsxs)("div", {
                        className: 'ms-2',
                        style: {
                            fontSize: '31px'
                        },
                        children: [
                            (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                name: 'faBox'
                            }),
                            " Ofertas"
                        ]
                    }),
                    (0, _jsxRuntime.jsx)("div", {
                        style: {
                            fontSize: '16px'
                        },
                        className: 'd-flex flex-grow-1 justify-content-end align-items-center',
                        children: (0, _jsxRuntime.jsx)((0, _react.Button), {
                            href: '/admin/offers/configuration/create',
                            children: "Crear Oferta"
                        })
                    })
                ]
            }),
            children
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/fortawesome":"7JvBl","components/ButtonBack":"3nJVT","./BasicLayout":"e9cbX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9HXHR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AdminOfferConfigurationContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _offerService = require("services/offer.service");
var _notify = require("components/Notify");
var _hook = require("context/admin-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _buttonBack = require("components/ButtonBack");
var _buttonBackDefault = parcelHelpers.interopDefault(_buttonBack);
var _basicLayout = require("./BasicLayout");
var _basicLayoutDefault = parcelHelpers.interopDefault(_basicLayout);
const AdminOfferConfigurationContainer = (props)=>{
    const { children } = props;
    const { currentOffer, validate, errors } = (0, _hookDefault.default)();
    async function handleSaveOffer() {
        console.log(validate(currentOffer, true), errors);
        if (!validate(currentOffer, true)) return;
        await (0, _offerService.offerService).updateOffer(currentOffer);
        (0, _notify.notifySuccess)('Oferta actualizada exitosamente.');
    }
    return (0, _jsxRuntime.jsxs)((0, _basicLayoutDefault.default), {
        children: [
            (0, _jsxRuntime.jsxs)((0, _react.Card).Header, {
                className: 'card--header d-flex',
                children: [
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'd-flex flex-column justify-content-center',
                        children: (0, _jsxRuntime.jsx)((0, _buttonBackDefault.default), {
                            path: '/admin/offers'
                        })
                    }),
                    (0, _jsxRuntime.jsxs)("div", {
                        className: 'ms-2',
                        style: {
                            fontSize: '31px'
                        },
                        children: [
                            (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                name: 'faBox'
                            }),
                            " Configuraci\u00F3n de oferta"
                        ]
                    }),
                    (0, _jsxRuntime.jsx)("div", {
                        style: {
                            fontSize: '16px'
                        },
                        className: 'd-flex flex-grow-1 justify-content-end align-items-center',
                        children: (0, _jsxRuntime.jsx)((0, _react.Button), {
                            onClick: handleSaveOffer,
                            children: "Guardar"
                        })
                    })
                ]
            }),
            children
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/fortawesome":"7JvBl","services/offer.service":"luCvD","components/Notify":"gZyef","context/admin-context/hook":"lWmPL","components/ButtonBack":"3nJVT","./BasicLayout":"e9cbX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4i5RE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ClientsContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _buttonBack = require("components/ButtonBack");
var _buttonBackDefault = parcelHelpers.interopDefault(_buttonBack);
var _basicLayout = require("./BasicLayout");
var _basicLayoutDefault = parcelHelpers.interopDefault(_basicLayout);
var _hook = require("context/admin-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const ClientsContainer = (props)=>{
    const { children } = props;
    const { roleName } = (0, _hookDefault.default)();
    const backPath = (0, _react.useMemo)(()=>`/${roleName?.substring(0, roleName.indexOf('_') >= 0 ? roleName.indexOf('_') : roleName.length) || 'admin'}`, [
        roleName
    ]);
    return (0, _jsxRuntime.jsxs)((0, _basicLayoutDefault.default), {
        children: [
            (0, _jsxRuntime.jsxs)((0, _react.Card).Header, {
                className: 'card--header d-flex',
                children: [
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'd-flex flex-column justify-content-center',
                        children: (0, _jsxRuntime.jsx)((0, _buttonBackDefault.default), {
                            path: backPath
                        })
                    }),
                    (0, _jsxRuntime.jsxs)("div", {
                        className: 'ms-2',
                        style: {
                            fontSize: '31px'
                        },
                        children: [
                            (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                name: 'faUsers'
                            }),
                            " Clientes"
                        ]
                    })
                ]
            }),
            children
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/fortawesome":"7JvBl","components/ButtonBack":"3nJVT","./BasicLayout":"e9cbX","context/admin-context/hook":"lWmPL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aBD74":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _buttonBack = require("components/ButtonBack");
var _buttonBackDefault = parcelHelpers.interopDefault(_buttonBack);
var _basicLayout = require("./BasicLayout");
var _basicLayoutDefault = parcelHelpers.interopDefault(_basicLayout);
var _hook = require("context/admin-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const ClientContainer = (props)=>{
    const { children } = props;
    const { state } = (0, _hookDefault.default)();
    const { profile } = state.client;
    const { roleName } = (0, _hookDefault.default)();
    const backPath = (0, _react.useMemo)(()=>`/${roleName?.substring(0, roleName.indexOf('_') >= 0 ? roleName.indexOf('_') : roleName.length) || 'admin'}/clients`, [
        roleName
    ]);
    return (0, _jsxRuntime.jsxs)((0, _basicLayoutDefault.default), {
        children: [
            (0, _jsxRuntime.jsxs)((0, _react.Card).Header, {
                className: 'card--header d-flex align-items-center',
                children: [
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'd-flex flex-column justify-content-center',
                        children: (0, _jsxRuntime.jsx)((0, _buttonBackDefault.default), {
                            path: backPath
                        })
                    }),
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'ms-2 d-flex align-items-center',
                        style: {
                            fontSize: '31px'
                        },
                        children: (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                            name: 'faUser'
                        })
                    }),
                    (0, _jsxRuntime.jsxs)("div", {
                        className: 'ms-2 d-flex flex-column justify-content-center',
                        children: [
                            (0, _jsxRuntime.jsx)("span", {
                                className: 'text-capitalize fw-semibold',
                                style: {
                                    fontSize: '1.1rem',
                                    lineHeight: 1.2
                                },
                                children: profile?.name
                            }),
                            profile?.email && (0, _jsxRuntime.jsx)("a", {
                                href: `mailto:${profile.email}`,
                                className: 'text-muted',
                                style: {
                                    fontSize: '0.8rem'
                                },
                                children: profile.email
                            })
                        ]
                    }),
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'ms-auto d-flex align-items-center gap-2',
                        children: (0, _jsxRuntime.jsx)("span", {
                            className: `badge ${profile?.purchases > 0 ? 'bg-success' : 'bg-secondary'}`,
                            style: {
                                fontSize: '0.85rem',
                                padding: '6px 12px'
                            },
                            children: profile?.domain
                        })
                    })
                ]
            }),
            children
        ]
    });
};
exports.default = ClientContainer;

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/fortawesome":"7JvBl","components/ButtonBack":"3nJVT","./BasicLayout":"e9cbX","context/admin-context/hook":"lWmPL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7nX1f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HomeContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("external/clsx");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _buttonBack = require("components/ButtonBack");
var _buttonBackDefault = parcelHelpers.interopDefault(_buttonBack);
var _basicLayout = require("./BasicLayout");
var _basicLayoutDefault = parcelHelpers.interopDefault(_basicLayout);
var _hook = require("context/accounting-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const parentContainerHeadings = {
    home: [
        'faHouse',
        'Home'
    ],
    payouts: [
        'faDollar',
        'Pagos'
    ]
};
const HomeContainer = (props)=>{
    const { children } = props;
    const { params } = (0, _hookDefault.default)();
    const [icon, label] = (0, _react.useMemo)(()=>parentContainerHeadings[params.pageName || 'home'] || parentContainerHeadings.home, [
        params.pageName
    ]);
    return (0, _jsxRuntime.jsxs)((0, _basicLayoutDefault.default), {
        children: [
            (0, _jsxRuntime.jsxs)((0, _react.Card).Header, {
                style: {
                    fontSize: '31px'
                },
                className: 'card--header',
                children: [
                    (0, _jsxRuntime.jsx)((0, _buttonBackDefault.default), {
                        path: '/accounting',
                        className: (0, _clsx.clsx)({
                            'd-none': label === 'Home'
                        })
                    }),
                    (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                        name: icon
                    }),
                    " ",
                    label
                ]
            }),
            children
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/clsx":"012R0","external/react":"1Glst","external/fortawesome":"7JvBl","components/ButtonBack":"3nJVT","./BasicLayout":"eDORv","context/accounting-context/hook":"cCF1x","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eDORv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BasicLayout);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
const BasicLayout = (props)=>{
    const { children } = props;
    return (0, _jsxRuntime.jsx)("div", {
        className: 'container',
        children: (0, _jsxRuntime.jsx)("div", {
            className: 'row mt-5 mb-5',
            children: (0, _jsxRuntime.jsx)("div", {
                className: 'col-12-md',
                children: (0, _jsxRuntime.jsx)((0, _react.Card), {
                    className: 'shadow card--card',
                    children: children
                })
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cCF1x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useAccounting);
var _react = require("external/react");
var _accountingContext = require("context/accounting-context");
var _accountingContextDefault = parcelHelpers.interopDefault(_accountingContext);
var _hook = require("context/auth-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
function useAccounting() {
    const { user } = (0, _hookDefault.default)();
    const { state, update } = (0, _react.useContext)((0, _accountingContextDefault.default).Context);
    const { props: { params, query, navigation }, payouts: { initialized: initializedPayouts, items: payouts }, payoutsPaging, payout } = state;
    return {
        state,
        update,
        params,
        query,
        navigation,
        payouts,
        initializedPayouts,
        payoutsPaging,
        payout
    };
}

},{"external/react":"1Glst","context/accounting-context":"3UV2I","context/auth-context/hook":"2UX0M","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jywdz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PayoutsContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _buttonBack = require("components/ButtonBack");
var _buttonBackDefault = parcelHelpers.interopDefault(_buttonBack);
var _basicLayout = require("./BasicLayout");
var _basicLayoutDefault = parcelHelpers.interopDefault(_basicLayout);
const PayoutsContainer = (props)=>{
    const { children } = props;
    return (0, _jsxRuntime.jsxs)((0, _basicLayoutDefault.default), {
        children: [
            (0, _jsxRuntime.jsxs)((0, _react.Card).Header, {
                className: 'card--header d-flex',
                children: [
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'd-flex flex-column justify-content-center',
                        children: (0, _jsxRuntime.jsx)((0, _buttonBackDefault.default), {
                            path: '/accounting'
                        })
                    }),
                    (0, _jsxRuntime.jsxs)("div", {
                        className: 'ms-2',
                        style: {
                            fontSize: '31px'
                        },
                        children: [
                            (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                name: 'faDollar'
                            }),
                            " Pagos"
                        ]
                    })
                ]
            }),
            children
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/fortawesome":"7JvBl","components/ButtonBack":"3nJVT","./BasicLayout":"eDORv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Ntz3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _buttonBack = require("components/ButtonBack");
var _buttonBackDefault = parcelHelpers.interopDefault(_buttonBack);
var _basicLayout = require("./BasicLayout");
var _basicLayoutDefault = parcelHelpers.interopDefault(_basicLayout);
var _hook = require("context/accounting-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const formatAmount = (amount)=>new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'usd'
    }).format(amount / 100);
const formatDate = (unixTimestamp)=>new Date(unixTimestamp * 1000).toLocaleDateString('es-PR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
const statusLabels = {
    paid: {
        label: 'Pagado',
        className: 'bg-success'
    },
    failed: {
        label: 'Fallido',
        className: 'bg-danger'
    },
    pending: {
        label: 'Pendiente',
        className: 'bg-warning'
    },
    in_transit: {
        label: "En tr\xe1nsito",
        className: 'bg-info'
    },
    canceled: {
        label: 'Cancelado',
        className: 'bg-secondary'
    }
};
const defaultStatus = {
    className: 'bg-secondary',
    label: 'Desconocido'
};
const ClientContainer = (props)=>{
    const { children } = props;
    const { payout } = (0, _hookDefault.default)();
    const p = payout?.data?.payout?.properties;
    const status = p ? statusLabels[p.status] ?? {
        label: p.status,
        className: 'bg-secondary'
    } : defaultStatus;
    return (0, _jsxRuntime.jsxs)((0, _basicLayoutDefault.default), {
        children: [
            (0, _jsxRuntime.jsxs)((0, _react.Card).Header, {
                className: 'card--header d-flex align-items-center',
                children: [
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'd-flex flex-column justify-content-center',
                        children: (0, _jsxRuntime.jsx)((0, _buttonBackDefault.default), {
                            path: '/accounting/payouts'
                        })
                    }),
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'ms-2 d-flex align-items-center',
                        style: {
                            fontSize: '31px'
                        },
                        children: (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                            name: 'faDollar'
                        })
                    }),
                    (0, _jsxRuntime.jsx)("div", {
                        className: 'ms-2 d-flex flex-column justify-content-center',
                        children: p ? (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                (0, _jsxRuntime.jsxs)("div", {
                                    className: 'd-flex align-items-center gap-2',
                                    children: [
                                        (0, _jsxRuntime.jsxs)("span", {
                                            className: 'fw-semibold',
                                            children: [
                                                formatAmount(p.amount),
                                                " USD"
                                            ]
                                        }),
                                        (0, _jsxRuntime.jsx)("span", {
                                            className: `badge ${status.className}`,
                                            children: status.label
                                        })
                                    ]
                                }),
                                (0, _jsxRuntime.jsxs)("small", {
                                    className: 'text-muted',
                                    children: [
                                        "Completado el ",
                                        formatDate(p.arrival_date)
                                    ]
                                })
                            ]
                        }) : (0, _jsxRuntime.jsx)("span", {
                            className: 'fw-semibold',
                            children: "..."
                        })
                    })
                ]
            }),
            children
        ]
    });
};
exports.default = ClientContainer;

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/fortawesome":"7JvBl","components/ButtonBack":"3nJVT","./BasicLayout":"eDORv","context/accounting-context/hook":"cCF1x","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gOPkE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _homeItem = require("components/HomeItem");
var _homeItemDefault = parcelHelpers.interopDefault(_homeItem);
const HomePage = ()=>{
    return (0, _jsxRuntime.jsx)((0, _react.Card).Body, {
        className: 'mt-2',
        children: (0, _jsxRuntime.jsx)("div", {
            className: "row mt-3 mb-3 justify-content-center",
            children: (0, _jsxRuntime.jsx)((0, _homeItemDefault.default), {
                className: 'mr-3',
                icon: 'faUsers',
                label: 'Clientes',
                to: '/admin/clients',
                children: (0, _jsxRuntime.jsx)("div", {
                    className: 'text-muted mb-0',
                    children: (0, _jsxRuntime.jsx)("span", {
                        className: 'text-white',
                        children: "."
                    })
                })
            })
        })
    });
};
exports.default = HomePage;

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","components/HomeItem":"lDz6Y","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jWMG5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OffersPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _dualBadge = require("components/DualBadge");
var _dualBadgeDefault = parcelHelpers.interopDefault(_dualBadge);
var _switch = require("components/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _hook = require("context/admin-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const OffersPage = ()=>{
    const navigate = (0, _react.useNavigate)();
    const { offers, toggleOfferStatus } = (0, _hookDefault.default)();
    return (0, _jsxRuntime.jsx)((0, _react.Card).Body, {
        children: (0, _jsxRuntime.jsxs)((0, _react.Table), {
            bordered: true,
            hover: true,
            children: [
                (0, _jsxRuntime.jsx)("thead", {
                    children: (0, _jsxRuntime.jsxs)("tr", {
                        children: [
                            (0, _jsxRuntime.jsx)("th", {
                                children: "Titulo"
                            }),
                            (0, _jsxRuntime.jsx)("th", {
                                children: "Tipo"
                            }),
                            (0, _jsxRuntime.jsx)("th", {
                                children: "Creado en"
                            }),
                            (0, _jsxRuntime.jsx)("th", {
                                children: "Estado"
                            })
                        ]
                    })
                }),
                (0, _jsxRuntime.jsx)("tbody", {
                    children: offers.map((item, index)=>{
                        return (0, _jsxRuntime.jsxs)("tr", {
                            children: [
                                (0, _jsxRuntime.jsx)("td", {
                                    className: 'text-capitalize',
                                    children: item.name
                                }),
                                (0, _jsxRuntime.jsx)("td", {
                                    children: item.frequency_unit_name
                                }),
                                (0, _jsxRuntime.jsx)("td", {
                                    children: item.start_date
                                }),
                                (0, _jsxRuntime.jsx)("td", {
                                    children: (0, _jsxRuntime.jsxs)("div", {
                                        className: 'd-flex align-items-center justify-content-between',
                                        children: [
                                            (0, _jsxRuntime.jsx)((0, _dualBadgeDefault.default), {
                                                active: item.active,
                                                labels: [
                                                    'Activo',
                                                    'Inactivo'
                                                ],
                                                badgeProps: {
                                                    style: {
                                                        width: '70px'
                                                    }
                                                }
                                            }),
                                            (0, _jsxRuntime.jsx)((0, _switchDefault.default), {
                                                onChange: ()=>toggleOfferStatus(item),
                                                defaultChecked: item.active
                                            }),
                                            (0, _jsxRuntime.jsx)("span", {
                                                className: 'span--edit',
                                                onClick: ()=>navigate(`/admin/offers/configuration/${item.id}`),
                                                children: "Editar"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, index);
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","components/DualBadge":"hGMSX","components/Switch":"b7rv9","context/admin-context/hook":"lWmPL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hGMSX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DualBadge);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
const DualBadge = (props)=>{
    const { labels, active, badgeProps = {} } = props;
    const [bg, label] = (0, _react.useMemo)(()=>active ? [
            'success',
            labels[0]
        ] : [
            'danger',
            labels[1]
        ], [
        labels,
        active
    ]);
    return (0, _jsxRuntime.jsx)((0, _react.Badge), {
        bg: bg,
        ...badgeProps,
        children: label
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kaCXR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OfferConfigurationPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/admin-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _configuration = require("./Configuration");
var _configurationDefault = parcelHelpers.interopDefault(_configuration);
function OfferConfigurationPage() {
    const { currentOffer } = (0, _hookDefault.default)();
    return (0, _jsxRuntime.jsx)((0, _react.Card).Body, {
        children: currentOffer.loaded && (0, _jsxRuntime.jsx)((0, _react.Tabs), {
            defaultActiveKey: 'configuration',
            id: 'fill-tab-example',
            className: 'mb-3',
            children: (0, _jsxRuntime.jsx)((0, _react.Tab), {
                eventKey: 'configuration',
                title: 'Configuraci\u00F3n',
                children: (0, _jsxRuntime.jsx)((0, _configurationDefault.default), {})
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/admin-context/hook":"lWmPL","./Configuration":"8FzT9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8FzT9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Configuration);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _enum = require("utilities/enum");
var _decimal = require("utilities/decimal");
var _formTextfield = require("components/FormTextfield");
var _formTextfieldDefault = parcelHelpers.interopDefault(_formTextfield);
var _fromTo = require("components/FromTo");
var _fromToDefault = parcelHelpers.interopDefault(_fromTo);
var _configurationRow = require("./ConfigurationRow");
var _configurationRowDefault = parcelHelpers.interopDefault(_configurationRow);
var _configurationCheckbox = require("./ConfigurationCheckbox");
var _configurationCheckboxDefault = parcelHelpers.interopDefault(_configurationCheckbox);
var _configurationSelect = require("./ConfigurationSelect");
var _configurationSelectDefault = parcelHelpers.interopDefault(_configurationSelect);
var _hook = require("context/admin-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
function Configuration() {
    const editor = (0, _react.useRef)(null);
    const { currentOffer, update, validate, resetValidations, errors } = (0, _hookDefault.default)();
    (0, _react.useEffect)(()=>{
        resetValidations();
    }, []);
    (0, _react.useEffect)(()=>{
        validate(currentOffer, false);
    }, [
        currentOffer
    ]);
    function textProps(placeholder, fieldName, maxLength) {
        return {
            placeholder,
            maxLength,
            fieldName,
            error: errors[fieldName],
            submitted: errors.submitted,
            onChange: (e)=>{
                update({
                    currentOffer: {
                        [fieldName]: {
                            $set: e.target.value.trim()
                        }
                    }
                });
            }
        };
    }
    function checkProps(label, name, type, fieldName) {
        return {
            label,
            name,
            type,
            value: currentOffer[fieldName || name],
            onChange: (e)=>update({
                    currentOffer: {
                        [fieldName || name]: {
                            $set: e.target[type === 'radio' ? 'value' : 'checked']
                        }
                    }
                })
        };
    }
    function selectProps(label, name, items) {
        return {
            label,
            onChange: (e)=>update({
                    currentOffer: {
                        [name]: {
                            $set: e.target.value
                        }
                    }
                }),
            items
        };
    }
    function handleHTMLChange(html) {
        update({
            currentOffer: {
                content: {
                    html: {
                        $set: html
                    }
                }
            }
        });
    }
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsx)((0, _configurationRowDefault.default), {
                label: 'Nombre de la oferta',
                children: (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                    ...textProps('', 'name'),
                    value: currentOffer.name
                })
            }),
            (0, _jsxRuntime.jsxs)((0, _configurationRowDefault.default), {
                label: 'Categor\u00EDa y t\u00E9rmino',
                children: [
                    (0, _jsxRuntime.jsx)((0, _configurationSelectDefault.default), {
                        defaultValue: currentOffer.category_unit,
                        ...selectProps("Categor\xeda", "category_unit", (0, _enum.category_unit))
                    }),
                    (0, _jsxRuntime.jsx)((0, _configurationSelectDefault.default), {
                        defaultValue: currentOffer.frequency_unit,
                        ...selectProps("T\xe9rmino", "frequency_unit", (0, _enum.frequency_unit))
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _configurationRowDefault.default), {
                label: "Precio",
                children: (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                    ...textProps('', 'price'),
                    defaultValue: currentOffer.price
                })
            }),
            (0, _jsxRuntime.jsx)((0, _configurationRowDefault.default), {
                label: "Descuento",
                children: (0, _jsxRuntime.jsx)((0, _configurationCheckboxDefault.default), {
                    checked: currentOffer.discount,
                    ...checkProps("Descuento de oferta", "discount")
                })
            }),
            currentOffer.discount && (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    (0, _jsxRuntime.jsx)((0, _configurationRowDefault.default), {
                        label: 'Descuento',
                        children: (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                            defaultValue: currentOffer.discount_name,
                            ...textProps('Descuento de la primera compra', 'discount_name')
                        })
                    }),
                    (0, _jsxRuntime.jsxs)((0, _configurationRowDefault.default), {
                        label: 'Cantidad a descontar',
                        children: [
                            (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                                onKeyDown: (e)=>(0, _decimal.decimal)(e),
                                defaultValue: currentOffer.discount_amount,
                                ...textProps('', 'discount_name')
                            }),
                            (0, _jsxRuntime.jsx)((0, _configurationCheckboxDefault.default), {
                                checked: currentOffer.discount_type === 'percent',
                                ...checkProps("Descuento de oferta", "percent", "radio", "discount_type")
                            }),
                            (0, _jsxRuntime.jsx)((0, _configurationCheckboxDefault.default), {
                                checked: currentOffer.discount_type === 'quantity',
                                ...checkProps("Cantidad fija", "quantity", "radio", "discount_type")
                            })
                        ]
                    }),
                    (0, _jsxRuntime.jsxs)((0, _configurationRowDefault.default), {
                        label: "Duraci\u00F3n",
                        children: [
                            (0, _jsxRuntime.jsx)((0, _configurationSelectDefault.default), {
                                defaultValue: currentOffer.duration,
                                ...selectProps("Duraci\xf3n", "discount", (0, _enum.duration))
                            }),
                            (0, _jsxRuntime.jsx)((0, _formTextfieldDefault.default), {
                                defaultValue: currentOffer.month_number,
                                ...textProps('Cantidad de meses', 'month_number')
                            })
                        ]
                    }),
                    (0, _jsxRuntime.jsx)((0, _configurationRowDefault.default), {
                        label: "Fechas",
                        children: (0, _jsxRuntime.jsx)((0, _fromToDefault.default), {
                            start: currentOffer.discount_startdate,
                            end: currentOffer.discount_duedate,
                            onChange: (type, value)=>{
                                update({
                                    currentOffer: {
                                        [type === 'start' ? 'discount_startdate' : 'discount_duedate']: {
                                            $set: value
                                        }
                                    }
                                });
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _configurationRowDefault.default), {
                label: "Descripcpi\u00F3n",
                children: (0, _jsxRuntime.jsx)((0, _react.JoditEditor), {
                    ref: editor,
                    value: currentOffer.content.html,
                    tabIndex: 1,
                    onBlur: handleHTMLChange
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","utilities/enum":"bEPnh","utilities/decimal":"iS8Dl","components/FormTextfield":"6jQpP","components/FromTo":"fFO0y","./ConfigurationRow":"8VXUQ","./ConfigurationCheckbox":"hbNfD","./ConfigurationSelect":"d1FBG","context/admin-context/hook":"lWmPL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iS8Dl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decimal", ()=>decimal);
const decimal = (e)=>{
    const decimalPlaces = 2;
    const validCharacters = '0123456789.';
    const allowedKeys = [
        'Backspace',
        'Tab',
        'ArrowLeft',
        'ArrowRight',
        'Shift'
    ];
    const keyPressed = e.key;
    const targetValue = e.target.value;
    if (!validCharacters.includes(keyPressed) && !allowedKeys.includes(keyPressed)) e.preventDefault();
    else {
        if (keyPressed === '.') {
            if (targetValue.includes(keyPressed)) e.preventDefault();
        } else if (targetValue.includes('.')) {
            const dotIndex = targetValue.indexOf('.');
            const afterDot = targetValue.substr(dotIndex + 1);
            if (afterDot.length === decimalPlaces && !allowedKeys.includes(keyPressed)) e.preventDefault();
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fFO0y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FromTo);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("external/moment");
var _clsx = require("external/clsx");
var _react = require("external/react");
const FromTo = (props)=>{
    const { className, start, end, onChange, startProps = {}, endProps = {} } = props;
    return (0, _jsxRuntime.jsxs)("span", {
        className: (0, _clsx.clsx)('from-to-date', className),
        children: [
            (0, _jsxRuntime.jsxs)("span", {
                className: "from-to-date-start",
                children: [
                    (0, _jsxRuntime.jsx)((0, _react.Form).Label, {
                        children: "Fecha de comienzo"
                    }),
                    (0, _jsxRuntime.jsx)((0, _react.Form).Control, {
                        type: 'date',
                        min: new Date(),
                        value: (0, _moment.moment)(start).format('YYYY-MM-DD'),
                        onChange: (e)=>onChange('start', e.target.value),
                        ...startProps
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)("span", {
                className: "from-to-date-end",
                children: [
                    (0, _jsxRuntime.jsx)((0, _react.Form).Label, {
                        children: "Fecha de culminaci\u00F3n"
                    }),
                    (0, _jsxRuntime.jsx)((0, _react.Form).Control, {
                        type: 'date',
                        min: new Date(),
                        value: (0, _moment.moment)(end).format('YYYY-MM-DD'),
                        onChange: (e)=>onChange('end', e.target.value),
                        ...endProps
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/moment":"fMWlp","external/clsx":"012R0","external/react":"1Glst","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8VXUQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ConfigurationRow);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
const ConfigurationRow = (props)=>{
    const { label, children, isLast = false } = props;
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsxs)((0, _react.Row), {
                className: 'mt-5 mb-5',
                children: [
                    (0, _jsxRuntime.jsx)((0, _react.Col), {
                        sm: 1
                    }),
                    (0, _jsxRuntime.jsx)((0, _react.Col), {
                        sm: 3,
                        children: (0, _jsxRuntime.jsx)((0, _react.Form).Label, {
                            className: 'fw-bold',
                            children: label
                        })
                    }),
                    (0, _jsxRuntime.jsx)((0, _react.Col), {
                        sm: 6,
                        children: children
                    }),
                    (0, _jsxRuntime.jsx)((0, _react.Col), {
                        sm: 2
                    })
                ]
            }),
            !isLast && (0, _jsxRuntime.jsx)("hr", {
                className: 'text-muted'
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hbNfD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ConfigurationCheckbox);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("external/clsx");
var _react = require("external/react");
const ConfigurationCheckbox = (props)=>{
    const { type, name, checked, onChange, label } = props;
    return (0, _jsxRuntime.jsxs)("span", {
        className: (0, _clsx.clsx)('configuration-checkbox', name),
        children: [
            (0, _jsxRuntime.jsx)((0, _react.Form).Check, {
                type: type,
                id: name,
                value: name,
                checked: checked,
                onChange: onChange
            }),
            (0, _jsxRuntime.jsx)((0, _react.Form).Label, {
                className: 'mx-3',
                htmlFor: name,
                children: label
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/clsx":"012R0","external/react":"1Glst","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d1FBG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ConfigurationSelect);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
const ConfigurationSelect = (props)=>{
    const { label, onChange, defaultValue, items = [] } = props;
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsx)((0, _react.Form).Label, {
                children: label
            }),
            (0, _jsxRuntime.jsx)((0, _react.Form).Select, {
                defaultValue: defaultValue,
                onChange: onChange,
                children: items.map((item, index)=>(0, _jsxRuntime.jsx)("option", {
                        value: item.cod,
                        children: item.value
                    }, index))
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3jcAT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ClientsPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _clientsTable = require("./ClientsTable");
var _clientsTableDefault = parcelHelpers.interopDefault(_clientsTable);
const ClientsPage = ()=>{
    return (0, _jsxRuntime.jsx)((0, _react.Card).Body, {
        children: (0, _jsxRuntime.jsx)((0, _clientsTableDefault.default), {})
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","./ClientsTable":"dwZg3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dwZg3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/admin-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _clientsTableProperties = require("./ClientsTableProperties");
var _clientsTableHeader = require("./ClientsTableHeader");
var _clientsTableHeaderDefault = parcelHelpers.interopDefault(_clientsTableHeader);
var _clientsTablePaging = require("./ClientsTablePaging");
var _clientsTablePagingDefault = parcelHelpers.interopDefault(_clientsTablePaging);
var _clientsTableToolbar = require("./ClientsTableToolbar");
var _clientsTableToolbarDefault = parcelHelpers.interopDefault(_clientsTableToolbar);
var _clientsTableBody = require("./ClientsTableBody");
var _clientsTableBodyDefault = parcelHelpers.interopDefault(_clientsTableBody);
const ClientsTable = ()=>{
    const [searchParams, setSearchParams] = (0, _react.useSearchParams)();
    const { state } = (0, _hookDefault.default)();
    const paging = state.clientsPaging;
    const toolbarRef = (0, _react.useRef)(null);
    const theadRef = (0, _react.useRef)(null);
    const pagingRef = (0, _react.useRef)(null);
    const cardRef = (0, _react.useRef)(null);
    const updateParams = (updates)=>{
        setSearchParams((prev)=>{
            const next = new URLSearchParams(prev);
            Object.entries(updates).forEach(([key, value])=>{
                if (value === undefined || value === '') next.delete(key);
                else next.set(key, value);
            });
            return next;
        });
    };
    const calculate = ()=>{
        const toolbarH = toolbarRef.current?.offsetHeight ?? 0;
        const theadH = theadRef.current?.offsetHeight ?? 0;
        const pagingH = pagingRef.current?.offsetHeight ?? 0;
        const cardPadding = 168; // Card.Body padding top+bottom, Navbar, Container margin (top+bottom)
        const chrome = toolbarH + theadH + pagingH + cardPadding;
        const available = window.innerHeight - (cardRef.current?.getBoundingClientRect().top ?? 0) - chrome;
        const rows = Math.max(1, Math.floor(available / (0, _clientsTableProperties.ROW_HEIGHT)));
        updateParams({
            pageSize: String(Math.min(rows, 50)),
            page: '1'
        });
    };
    (0, _react.useEffect)(()=>{
        calculate();
        window.addEventListener('resize', calculate);
        return ()=>window.removeEventListener('resize', calculate);
    }, []);
    const pattern = searchParams.get('pattern') ?? undefined;
    const sortBy = searchParams.get('sortBy') ?? undefined;
    const handleSearch = (pattern)=>updateParams({
            pattern,
            page: '1'
        });
    const handleSort = (sortBy)=>updateParams({
            sortBy: sortBy || undefined,
            page: '1'
        });
    const handlePageChange = (page)=>updateParams({
            page: String(page)
        });
    const noResults = paging && paging.recordCount === 0;
    return (0, _jsxRuntime.jsx)("div", {
        ref: cardRef,
        children: (0, _jsxRuntime.jsxs)((0, _react.Card).Body, {
            children: [
                (0, _jsxRuntime.jsx)("div", {
                    ref: toolbarRef,
                    children: (0, _jsxRuntime.jsx)((0, _clientsTableToolbarDefault.default), {
                        pattern: pattern,
                        onSearch: handleSearch
                    })
                }),
                noResults ? (0, _jsxRuntime.jsxs)("div", {
                    className: "d-flex flex-column align-items-center justify-content-center text-muted",
                    style: {
                        height: `${(0, _clientsTableProperties.ROW_HEIGHT) * 5}px`
                    },
                    children: [
                        (0, _jsxRuntime.jsx)("span", {
                            style: {
                                fontSize: '2rem'
                            },
                            children: "\uD83D\uDD0D"
                        }),
                        (0, _jsxRuntime.jsxs)("p", {
                            className: "mt-2 mb-0",
                            children: [
                                "No se encontraron clientes",
                                pattern ? ` para "${pattern}"` : '',
                                "."
                            ]
                        })
                    ]
                }) : (0, _jsxRuntime.jsxs)((0, _react.Table), {
                    bordered: true,
                    hover: true,
                    style: {
                        tableLayout: 'fixed',
                        width: '100%'
                    },
                    children: [
                        (0, _jsxRuntime.jsx)("thead", {
                            ref: theadRef,
                            children: (0, _jsxRuntime.jsx)((0, _clientsTableHeaderDefault.default), {
                                sortBy: sortBy,
                                onSort: handleSort
                            })
                        }),
                        (0, _jsxRuntime.jsx)((0, _clientsTableBodyDefault.default), {})
                    ]
                }),
                (0, _jsxRuntime.jsx)("div", {
                    ref: pagingRef,
                    children: paging && paging.recordCount > 0 && (0, _jsxRuntime.jsx)((0, _clientsTablePagingDefault.default), {
                        ...paging,
                        onPageChange: handlePageChange
                    })
                })
            ]
        })
    });
};
exports.default = ClientsTable;

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/admin-context/hook":"lWmPL","./ClientsTableProperties":"7EH0v","./ClientsTableHeader":"3vZ0k","./ClientsTablePaging":"cez2C","./ClientsTableToolbar":"2SlRI","./ClientsTableBody":"jyXMK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7EH0v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ROW_HEIGHT", ()=>ROW_HEIGHT);
parcelHelpers.export(exports, "columns", ()=>columns);
const ROW_HEIGHT = 41;
const columns = [
    {
        key: 'name',
        label: 'Nombre',
        sortable: true,
        width: '30%'
    },
    {
        key: 'email',
        label: 'Correo',
        sortable: true,
        width: '35%'
    },
    {
        key: 'domain',
        label: 'Dominio',
        sortable: true,
        width: '20%'
    },
    {
        key: 'purchases',
        label: 'Compras',
        sortable: true,
        width: '15%'
    }
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3vZ0k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _clientsTableProperties = require("./ClientsTableProperties");
const ClientsTableHeader = ({ sortBy, onSort })=>{
    const getSortIndicator = (key)=>{
        if (!sortBy) return "\u2195";
        const match = sortBy.split(',').find((f)=>f.replace(/^-/, '') === key);
        if (!match) return "\u2195";
        return match.startsWith('-') ? "\u2193" : "\u2191";
    };
    const handleSort = (key)=>{
        const fields = sortBy ? sortBy.split(',') : [];
        const match = fields.find((f)=>f.replace(/^-/, '') === key);
        const rest = fields.filter((f)=>f.replace(/^-/, '') !== key);
        let newFields;
        if (!match) newFields = [
            key,
            ...rest
        ];
        else if (!match.startsWith('-')) newFields = [
            `-${key}`,
            ...rest
        ];
        else newFields = rest;
        onSort(newFields.join(','));
    };
    return (0, _jsxRuntime.jsx)("tr", {
        children: (0, _clientsTableProperties.columns).map((col)=>(0, _jsxRuntime.jsxs)("th", {
                style: {
                    width: col.width,
                    cursor: col.sortable ? 'pointer' : 'default',
                    userSelect: 'none',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                },
                onClick: ()=>col.sortable && handleSort(col.key),
                children: [
                    col.label,
                    " ",
                    col.sortable && (0, _jsxRuntime.jsx)("span", {
                        children: getSortIndicator(col.key)
                    })
                ]
            }, col.key))
    });
};
exports.default = ClientsTableHeader;

},{"react/jsx-runtime":"1dlk8","./ClientsTableProperties":"7EH0v","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cez2C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
const ClientsTablePaging = ({ pageSize, currentPage, recordCount, onPageChange })=>{
    const totalPages = Math.ceil(recordCount / pageSize);
    return (0, _jsxRuntime.jsxs)("div", {
        className: "d-flex justify-content-between align-items-center mt-2",
        children: [
            (0, _jsxRuntime.jsxs)("span", {
                className: "text-muted small",
                children: [
                    recordCount,
                    " registros \u2014 p\u00E1gina ",
                    currentPage,
                    " de ",
                    totalPages
                ]
            }),
            (0, _jsxRuntime.jsxs)("div", {
                className: "d-flex gap-1",
                children: [
                    totalPages >= 10 && (0, _jsxRuntime.jsx)("button", {
                        className: "btn btn-sm btn-outline-secondary",
                        disabled: currentPage <= 1,
                        onClick: ()=>onPageChange(currentPage - 1),
                        children: "\u2039"
                    }),
                    Array.from({
                        length: totalPages
                    }, (_, i)=>i + 1).filter((p)=>Math.abs(p - currentPage) <= 2).map((p)=>(0, _jsxRuntime.jsx)("button", {
                            className: `btn btn-sm ${p === currentPage ? 'btn-primary' : 'btn-outline-secondary'}`,
                            onClick: ()=>onPageChange(p),
                            children: p
                        }, p)),
                    totalPages >= 10 && (0, _jsxRuntime.jsx)("button", {
                        className: "btn btn-sm btn-outline-secondary",
                        disabled: currentPage >= totalPages,
                        onClick: ()=>onPageChange(currentPage + 1),
                        children: "\u203A"
                    })
                ]
            })
        ]
    });
};
exports.default = ClientsTablePaging;

},{"react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2SlRI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
const ClientsTableToolbar = ({ pattern, onSearch })=>{
    const [searchOpen, setSearchOpen] = (0, _react.useState)(false);
    const [draft, setDraft] = (0, _react.useState)('');
    const inputRef = (0, _react.useRef)(null);
    const openSearch = ()=>{
        setSearchOpen(true);
        setDraft(pattern ?? '');
        setTimeout(()=>inputRef.current?.focus(), 50);
    };
    const commitSearch = ()=>{
        onSearch(draft || undefined);
        setSearchOpen(false);
        setDraft('');
    };
    const clearPattern = ()=>{
        onSearch(undefined);
        setSearchOpen(false);
        setDraft('');
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter') commitSearch();
        if (e.key === 'Escape') setSearchOpen(false);
    };
    return (0, _jsxRuntime.jsxs)("div", {
        className: "d-flex align-items-center gap-2 mb-3",
        children: [
            pattern && !searchOpen && (0, _jsxRuntime.jsxs)("span", {
                className: "badge bg-primary d-flex align-items-center gap-1",
                style: {
                    fontSize: '0.85rem'
                },
                children: [
                    "\uD83D\uDD0D ",
                    pattern,
                    (0, _jsxRuntime.jsx)("button", {
                        onClick: clearPattern,
                        className: "btn-close btn-close-white ms-1",
                        style: {
                            fontSize: '0.6rem'
                        },
                        "aria-label": "Limpiar b\u00FAsqueda"
                    })
                ]
            }),
            searchOpen ? (0, _jsxRuntime.jsxs)("div", {
                className: "d-flex align-items-center gap-1",
                children: [
                    (0, _jsxRuntime.jsx)("input", {
                        ref: inputRef,
                        className: "form-control form-control-sm",
                        style: {
                            width: 200
                        },
                        value: draft,
                        onChange: (e)=>setDraft(e.target.value),
                        onKeyDown: handleKeyDown,
                        placeholder: "Buscar..."
                    }),
                    (0, _jsxRuntime.jsx)("button", {
                        className: "btn btn-sm btn-primary",
                        onClick: commitSearch,
                        children: "Aplicar"
                    }),
                    (0, _jsxRuntime.jsx)("button", {
                        className: "btn btn-sm btn-outline-secondary",
                        onClick: ()=>setSearchOpen(false),
                        children: "\u2715"
                    })
                ]
            }) : (0, _jsxRuntime.jsx)("button", {
                className: "btn btn-sm btn-outline-secondary",
                onClick: openSearch,
                title: "Buscar",
                children: "\uD83D\uDD0D"
            })
        ]
    });
};
exports.default = ClientsTableToolbar;

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jyXMK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _hook = require("context/admin-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _fillerRow = require("./ClientsTableRow/FillerRow");
var _fillerRowDefault = parcelHelpers.interopDefault(_fillerRow);
var _simpleRow = require("./ClientsTableRow/SimpleRow");
var _simpleRowDefault = parcelHelpers.interopDefault(_simpleRow);
var _expandableRow = require("./ClientsTableRow/ExpandableRow");
var _expandableRowDefault = parcelHelpers.interopDefault(_expandableRow);
const ClientsTableBody = ()=>{
    const { state } = (0, _hookDefault.default)();
    const { items } = state.clients;
    return (0, _jsxRuntime.jsxs)("tbody", {
        children: [
            items.map((item)=>item.purchases > 0 ? (0, _jsxRuntime.jsx)((0, _expandableRowDefault.default), {
                    clientData: item
                }, item.id) : (0, _jsxRuntime.jsx)((0, _simpleRowDefault.default), {
                    clientData: item
                }, item.id)),
            (0, _jsxRuntime.jsx)((0, _fillerRowDefault.default), {})
        ]
    });
};
exports.default = ClientsTableBody;

},{"react/jsx-runtime":"1dlk8","context/admin-context/hook":"lWmPL","./ClientsTableRow/FillerRow":"1C19g","./ClientsTableRow/SimpleRow":"5sQdj","./ClientsTableRow/ExpandableRow":"iiKFV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1C19g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _clientsTableProperties = require("../ClientsTableProperties");
var _react = require("external/react");
var _hook = require("context/admin-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const ClientsTableFillerRow = ()=>{
    const { state } = (0, _hookDefault.default)();
    const { items } = state.clients;
    const paging = state.clientsPaging;
    const pageSize = (0, _react.useMemo)(()=>paging ? paging.pageSize : 0, [
        paging
    ]);
    if (items.length >= pageSize) return;
    return (0, _jsxRuntime.jsx)("tr", {
        style: {
            pointerEvents: 'none'
        },
        children: (0, _jsxRuntime.jsx)("td", {
            colSpan: (0, _clientsTableProperties.columns).length,
            rowSpan: Math.max(0, pageSize - items.length),
            style: {
                border: 'none',
                height: `${(pageSize - items.length) * (0, _clientsTableProperties.ROW_HEIGHT)}px`
            }
        })
    });
};
exports.default = ClientsTableFillerRow;

},{"react/jsx-runtime":"1dlk8","../ClientsTableProperties":"7EH0v","external/react":"1Glst","context/admin-context/hook":"lWmPL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5sQdj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _hook = require("context/admin-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _react = require("external/react");
const ClientsTableSimpleRow = (props)=>{
    const navigate = (0, _react.useNavigate)();
    const { clientData: item } = props;
    const { roleName } = (0, _hookDefault.default)();
    const link = (0, _react.useMemo)(()=>`/${roleName?.substring(0, roleName.indexOf('_') >= 0 ? roleName.indexOf('_') : roleName.length) || 'admin'}/clients/${item.id}`, [
        roleName
    ]);
    return (0, _jsxRuntime.jsxs)("tr", {
        children: [
            (0, _jsxRuntime.jsx)("td", {
                className: "text-capitalize",
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                },
                children: (0, _jsxRuntime.jsx)("a", {
                    href: link,
                    onClick: (e)=>{
                        e.preventDefault();
                        navigate(link);
                    },
                    style: {
                        textDecoration: 'none'
                    },
                    children: item.name
                })
            }),
            (0, _jsxRuntime.jsx)("td", {
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                },
                children: item.email
            }),
            (0, _jsxRuntime.jsx)("td", {
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                },
                children: item.domain
            }),
            (0, _jsxRuntime.jsx)("td", {
                className: "text-center",
                children: item.purchases
            })
        ]
    });
};
exports.default = ClientsTableSimpleRow;

},{"react/jsx-runtime":"1dlk8","context/admin-context/hook":"lWmPL","external/react":"1Glst","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iiKFV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _purchaseInfoRow = require("./PurchaseInfoRow");
var _purchaseInfoRowDefault = parcelHelpers.interopDefault(_purchaseInfoRow);
var _hook = require("context/admin-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const ClientsTableExpandableRow = ({ clientData: item })=>{
    const navigate = (0, _react.useNavigate)();
    const [isExpanded, setIsExpanded] = (0, _react.useState)(false);
    const { roleName } = (0, _hookDefault.default)();
    const link = (0, _react.useMemo)(()=>`/${roleName?.substring(0, roleName.indexOf('_') >= 0 ? roleName.indexOf('_') : roleName.length) || 'admin'}/clients/${item.id}`, [
        roleName
    ]);
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsxs)("tr", {
                children: [
                    (0, _jsxRuntime.jsx)("td", {
                        className: "text-capitalize",
                        style: {
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        },
                        children: (0, _jsxRuntime.jsxs)("span", {
                            style: {
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '6px'
                            },
                            children: [
                                item.purchaseData?.length > 0 && (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>setIsExpanded((prev)=>!prev),
                                    style: {
                                        background: 'none',
                                        border: '1px solid #ccc',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        padding: '0 5px',
                                        fontWeight: 'bold',
                                        lineHeight: '1.4',
                                        fontSize: '0.85em',
                                        flexShrink: 0
                                    },
                                    "aria-label": isExpanded ? 'Collapse' : 'Expand',
                                    children: isExpanded ? "\u2212" : '+'
                                }),
                                (0, _jsxRuntime.jsx)("a", {
                                    href: link,
                                    onClick: (e)=>{
                                        e.preventDefault();
                                        navigate(link);
                                    },
                                    style: {
                                        textDecoration: 'none'
                                    },
                                    children: item.name
                                })
                            ]
                        })
                    }),
                    (0, _jsxRuntime.jsx)("td", {
                        style: {
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        },
                        children: item.email
                    }),
                    (0, _jsxRuntime.jsx)("td", {
                        style: {
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        },
                        children: item.domain
                    }),
                    (0, _jsxRuntime.jsx)("td", {
                        className: "text-center",
                        children: item.purchases
                    })
                ]
            }),
            isExpanded && (0, _jsxRuntime.jsx)((0, _purchaseInfoRowDefault.default), {
                clientData: item
            })
        ]
    });
};
exports.default = ClientsTableExpandableRow;

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","./PurchaseInfoRow":"fMw9V","context/admin-context/hook":"lWmPL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fMw9V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _clientsTableProperties = require("../ClientsTableProperties");
var _hook = require("context/admin-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _lodash = require("external/lodash");
const ClientsTablePurchaseInfoRow = ({ clientData: item })=>{
    const { getStripeInfo } = (0, _hookDefault.default)();
    const [stripeInfo, setStripeInfo] = (0, _react.useState)([]);
    (0, _react.useEffect)(()=>{
        if ((0, _lodash.isUUID)(item.id)) getStripeInfo(item.id).then((v)=>{
            setStripeInfo(v.data);
        });
    }, [
        item.id
    ]);
    return (0, _jsxRuntime.jsx)("tr", {
        children: (0, _jsxRuntime.jsx)("td", {
            colSpan: (0, _clientsTableProperties.columns).length,
            style: {
                padding: '0 16px 12px 32px',
                background: '#f9f9f9'
            },
            children: (0, _jsxRuntime.jsxs)("table", {
                style: {
                    width: '100%',
                    borderCollapse: 'collapse',
                    fontSize: '0.9em'
                },
                children: [
                    (0, _jsxRuntime.jsx)("thead", {
                        children: (0, _jsxRuntime.jsxs)("tr", {
                            style: {
                                borderBottom: '2px solid #ddd',
                                color: '#555',
                                fontWeight: 600
                            },
                            children: [
                                (0, _jsxRuntime.jsx)("th", {
                                    style: {
                                        padding: '6px 10px',
                                        textAlign: 'left'
                                    },
                                    children: "Plan"
                                }),
                                (0, _jsxRuntime.jsx)("th", {
                                    style: {
                                        padding: '6px 10px',
                                        textAlign: 'left'
                                    },
                                    children: "Paquete"
                                }),
                                (0, _jsxRuntime.jsx)("th", {
                                    style: {
                                        padding: '6px 10px',
                                        textAlign: 'left'
                                    },
                                    children: "Fecha de compra"
                                }),
                                (0, _jsxRuntime.jsx)("th", {
                                    style: {
                                        padding: '6px 10px',
                                        textAlign: 'left'
                                    },
                                    children: "Precio"
                                })
                            ]
                        })
                    }),
                    (0, _jsxRuntime.jsx)("tbody", {
                        children: stripeInfo.map((purchase, index)=>(0, _jsxRuntime.jsxs)("tr", {
                                style: {
                                    borderBottom: '1px solid #eee'
                                },
                                children: [
                                    (0, _jsxRuntime.jsx)("td", {
                                        style: {
                                            padding: '6px 10px'
                                        },
                                        children: purchase.offerName
                                    }),
                                    (0, _jsxRuntime.jsx)("td", {
                                        style: {
                                            padding: '6px 10px'
                                        },
                                        children: purchase.planAlias
                                    }),
                                    (0, _jsxRuntime.jsx)("td", {
                                        style: {
                                            padding: '6px 10px'
                                        },
                                        children: new Date(purchase.purchaseDate).toLocaleDateString()
                                    }),
                                    (0, _jsxRuntime.jsx)("td", {
                                        style: {
                                            padding: '6px 10px'
                                        },
                                        children: purchase.price
                                    })
                                ]
                            }, purchase.id ?? index))
                    })
                ]
            })
        })
    });
};
exports.default = ClientsTablePurchaseInfoRow;

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","../ClientsTableProperties":"7EH0v","context/admin-context/hook":"lWmPL","external/lodash":"h4nD2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ckXRJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/admin-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _purchaseTabs = require("./PurchaseTabs");
var _purchaseTabsDefault = parcelHelpers.interopDefault(_purchaseTabs);
var _purchaseDetail = require("./PurchaseDetail");
var _purchaseDetailDefault = parcelHelpers.interopDefault(_purchaseDetail);
var _changeCourseModal = require("./PurchaseDetail/CourseList/ChangeCourseModal");
var _changeCourseModalDefault = parcelHelpers.interopDefault(_changeCourseModal);
const ClientPurchases = ()=>{
    const { state, changeClientCourse } = (0, _hookDefault.default)();
    const purchases = state.client.purchases.items;
    const [searchParams] = (0, _react.useSearchParams)();
    const selected = Math.min(Number(searchParams.get('purchaseIndex') ?? 0), purchases.length - 1);
    if (purchases.length === 0) return (0, _jsxRuntime.jsxs)("div", {
        className: "d-flex flex-column align-items-center justify-content-center text-muted",
        style: {
            height: 200
        },
        children: [
            (0, _jsxRuntime.jsx)("span", {
                style: {
                    fontSize: '2rem'
                },
                children: "\uD83D\uDED2"
            }),
            (0, _jsxRuntime.jsx)("p", {
                className: "mt-2 mb-0",
                children: "Este cliente no tiene compras registradas."
            })
        ]
    });
    return (0, _jsxRuntime.jsxs)("div", {
        className: "mt-2",
        style: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1
        },
        children: [
            (0, _jsxRuntime.jsx)((0, _changeCourseModalDefault.default), {
                onSave: async ({ originalCourse, newCourse, source })=>{
                    const clientId = state.client.id;
                    const { id: purchaseId } = purchases[selected];
                    await changeClientCourse({
                        clientId,
                        purchaseId,
                        currentCourse: originalCourse,
                        newCourse,
                        extra: source === 'extra'
                    });
                    window.location.reload();
                }
            }),
            (0, _jsxRuntime.jsx)((0, _purchaseTabsDefault.default), {}),
            (0, _jsxRuntime.jsx)("div", {
                style: {
                    flexGrow: 1,
                    border: '1px solid #dee2e6',
                    borderRadius: '0 0 0.375rem 0.375rem',
                    borderTop: 0,
                    padding: '1rem'
                },
                children: (0, _jsxRuntime.jsx)((0, _purchaseDetailDefault.default), {
                    index: selected
                })
            })
        ]
    });
};
exports.default = ClientPurchases;

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/admin-context/hook":"lWmPL","./PurchaseTabs":"33qRQ","./PurchaseDetail":"ak7TB","./PurchaseDetail/CourseList/ChangeCourseModal":"i7SCl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"33qRQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/admin-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const statusColor = (status)=>status === 'active' ? '#28a745' : '#dc3545';
const PurchaseTabs = ()=>{
    const { state } = (0, _hookDefault.default)();
    const purchases = state.client.purchases.items;
    const [searchParams, setSearchParams] = (0, _react.useSearchParams)();
    const selected = Math.min(Number(searchParams.get('purchaseIndex') ?? 0), purchases.length - 1);
    const handleSelect = (index)=>{
        setSearchParams((prev)=>{
            prev.set('purchaseIndex', String(index));
            return prev;
        }, {
            replace: true
        });
    };
    const formatDate = (dateStr)=>new Date(dateStr).toLocaleDateString('es-PR', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    if (purchases.length === 0) return null;
    // Dropdown mode for 5+ packages
    if (purchases.length >= 5) return (0, _jsxRuntime.jsxs)("div", {
        className: "d-flex align-items-center gap-2",
        children: [
            (0, _jsxRuntime.jsx)("select", {
                className: "form-select form-select-sm",
                style: {
                    maxWidth: 320
                },
                value: selected,
                onChange: (e)=>handleSelect(Number(e.target.value)),
                children: purchases.map((p, i)=>(0, _jsxRuntime.jsxs)("option", {
                        value: i,
                        children: [
                            p.planAlias,
                            " \u2014 ",
                            formatDate(p.purchaseDate)
                        ]
                    }, p.id))
            }),
            (0, _jsxRuntime.jsx)("span", {
                style: {
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    backgroundColor: statusColor(purchases[selected].subscriptionStatus),
                    display: 'inline-block',
                    flexShrink: 0
                }
            })
        ]
    });
    // Tab mode for less than 5 packages
    return (0, _jsxRuntime.jsx)("ul", {
        className: "nav nav-tabs",
        children: purchases.map((p, i)=>(0, _jsxRuntime.jsx)("li", {
                className: "nav-item",
                children: (0, _jsxRuntime.jsxs)("button", {
                    className: `nav-link d-flex align-items-center gap-2 ${i === selected ? 'active' : ''}`,
                    onClick: ()=>handleSelect(i),
                    children: [
                        (0, _jsxRuntime.jsx)("span", {
                            style: {
                                width: 8,
                                height: 8,
                                borderRadius: '50%',
                                backgroundColor: statusColor(p.subscriptionStatus),
                                display: 'inline-block',
                                flexShrink: 0
                            }
                        }),
                        (0, _jsxRuntime.jsxs)("span", {
                            className: "d-flex flex-column align-items-start",
                            children: [
                                (0, _jsxRuntime.jsx)("span", {
                                    children: p.planAlias
                                }),
                                (0, _jsxRuntime.jsx)("span", {
                                    className: "text-muted",
                                    style: {
                                        fontSize: '0.7rem'
                                    },
                                    children: formatDate(p.purchaseDate)
                                })
                            ]
                        })
                    ]
                })
            }, p.id))
    });
};
exports.default = PurchaseTabs;

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/admin-context/hook":"lWmPL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ak7TB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _courseList = require("./CourseList");
var _courseListDefault = parcelHelpers.interopDefault(_courseList);
var _planInfo = require("components/PlanInfo");
var _planInfoDefault = parcelHelpers.interopDefault(_planInfo);
var _selectStudent = require("components/SelectStudent");
var _selectStudentDefault = parcelHelpers.interopDefault(_selectStudent);
var _selectTutor = require("components/SelectTutor");
var _selectTutorDefault = parcelHelpers.interopDefault(_selectTutor);
var _hook = require("context/admin-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const PurchaseDetail = ({ index })=>{
    const { state, updateChangeCourseModal } = (0, _hookDefault.default)();
    const purchase = state.client.purchases.items[index];
    if (!purchase) return null;
    const extra = (0, _react.useMemo)(()=>state.courseMap !== false && purchase.courses.extra.length > 0 ? purchase.courses.extra.map((c)=>state.courseMap[c]) : [], [
        purchase.courses.extra,
        state.courseMap
    ]);
    const handleCourseClick = (0, _react.useCallback)(({ id, source })=>{
        updateChangeCourseModal(true, index, id, {
            course: id,
            subject: '',
            grade: '',
            source
        }, null);
    }, [
        index,
        updateChangeCourseModal
    ]);
    return (0, _jsxRuntime.jsxs)("div", {
        children: [
            (0, _jsxRuntime.jsx)((0, _planInfoDefault.default), {
                packageItem: purchase
            }),
            (0, _jsxRuntime.jsxs)("div", {
                className: 'd-flex mt-3 gap-3',
                children: [
                    (0, _jsxRuntime.jsx)((0, _selectStudentDefault.default), {
                        packageItem: purchase
                    }),
                    (0, _jsxRuntime.jsx)((0, _selectTutorDefault.default), {
                        packageItem: purchase
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _courseListDefault.default), {
                courses: purchase.courses.basic || [],
                source: 'basic',
                onCourseClick: handleCourseClick
            }),
            (0, _jsxRuntime.jsx)((0, _courseListDefault.default), {
                courses: purchase.courses.elective || [],
                source: 'elective',
                onCourseClick: handleCourseClick
            }),
            (0, _jsxRuntime.jsx)((0, _courseListDefault.default), {
                courses: extra,
                source: 'extra',
                onCourseClick: handleCourseClick
            })
        ]
    });
};
exports.default = PurchaseDetail;

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","./CourseList":"cXhUM","components/PlanInfo":"3FPyp","components/SelectStudent":"8D7ey","components/SelectTutor":"2lMLI","context/admin-context/hook":"lWmPL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cXhUM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CourseList);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _clsx = require("external/clsx");
var _course = require("./Course");
var _courseDefault = parcelHelpers.interopDefault(_course);
const sourceTextMap = {
    basic: 'Principales',
    elective: 'Electivos',
    extra: 'Complementarios'
};
const CourseList = (props)=>{
    const { source, courses, onCourseClick } = props;
    const sourceLabel = (0, _react.useMemo)(()=>sourceTextMap[source], [
        source
    ]);
    const hasCourses = (0, _react.useMemo)(()=>courses.length > 0, [
        courses
    ]);
    return (0, _jsxRuntime.jsxs)((0, _react.Card), {
        className: (0, _clsx.clsx)('mt-3', {
            'd-none': !hasCourses
        }),
        children: [
            (0, _jsxRuntime.jsx)((0, _react.Card).Header, {
                className: 'bg-white d-flex justify-content-between',
                children: (0, _jsxRuntime.jsxs)("h6", {
                    style: {
                        margin: '0'
                    },
                    children: [
                        "Cursos ",
                        sourceLabel
                    ]
                })
            }),
            (0, _jsxRuntime.jsx)("div", {
                className: (0, _clsx.clsx)('bodySubjects', {
                    'd-none': !hasCourses
                }),
                children: courses.map((course)=>(0, _jsxRuntime.jsx)((0, _courseDefault.default), {
                        ...course,
                        onCourseClick: onCourseClick,
                        source: source
                    }, course.id))
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/clsx":"012R0","./Course":"ggxq0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ggxq0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Course);
var _jsxRuntime = require("react/jsx-runtime");
var _courseCover = require("components/CourseCover");
var _courseCoverDefault = parcelHelpers.interopDefault(_courseCover);
const Course = (props)=>{
    const { id, name, onCourseClick, source } = props;
    return (0, _jsxRuntime.jsxs)("div", {
        className: 'containerSelected',
        children: [
            (0, _jsxRuntime.jsxs)("div", {
                className: 'containerSelectedBody package-courses-detail',
                style: {
                    position: 'relative'
                },
                children: [
                    (0, _jsxRuntime.jsx)((0, _courseCoverDefault.default), {
                        id: id,
                        name: name
                    }),
                    onCourseClick && (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>onCourseClick({
                                id,
                                source
                            }),
                        title: "Cambiar curso",
                        style: {
                            position: 'absolute',
                            top: 6,
                            right: 6,
                            background: 'rgba(255,255,255,0.85)',
                            border: 'none',
                            borderRadius: '50%',
                            width: 28,
                            height: 28,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            padding: 0,
                            boxShadow: '0 1px 4px rgba(0,0,0,0.2)'
                        },
                        children: (0, _jsxRuntime.jsxs)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "15",
                            height: "15",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2.5",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: [
                                (0, _jsxRuntime.jsx)("path", {
                                    d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                                }),
                                (0, _jsxRuntime.jsx)("path", {
                                    d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                                })
                            ]
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)("div", {
                className: 'containerSelectedFooter',
                children: (0, _jsxRuntime.jsx)("p", {
                    children: name
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","components/CourseCover":"bllJU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i7SCl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _hook = require("context/admin-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _header = require("./Header");
var _headerDefault = parcelHelpers.interopDefault(_header);
var _footer = require("./Footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _dropdowns = require("./Dropdowns");
var _dropdownsDefault = parcelHelpers.interopDefault(_dropdowns);
var _coursePreview = require("./CoursePreview");
var _coursePreviewDefault = parcelHelpers.interopDefault(_coursePreview);
const ChangeCourseModal = ({ onSave })=>{
    const { state, changeCourseModal, updateChangeCourseModal } = (0, _hookDefault.default)();
    const { selected } = changeCourseModal ?? {};
    const originalCourse = changeCourseModal?.originalCourse ?? '';
    const courseId = selected?.course ?? '';
    const hasChanged = !!courseId && courseId !== originalCourse;
    const canSave = hasChanged;
    const handleSave = ()=>{
        if (!courseId || !hasChanged) return;
        const { originalCourse, source } = changeCourseModal;
        updateChangeCourseModal(false, null, originalCourse, {
            subject: '',
            grade: '',
            course: '',
            source: ''
        }, ()=>onSave({
                originalCourse,
                newCourse: courseId,
                source
            }));
    };
    const handleClose = ()=>updateChangeCourseModal(false, null, undefined, {
            subject: '',
            grade: '',
            course: '',
            source: ''
        }, null);
    // ── Render ─────────────────────────────────────────────────────────────────
    if (!changeCourseModal?.open) return null;
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsx)("div", {
                onClick: handleClose,
                style: {
                    position: 'fixed',
                    inset: 0,
                    background: 'rgba(15, 23, 42, 0.45)',
                    backdropFilter: 'blur(3px)',
                    zIndex: 1040,
                    animation: 'ccmFadeIn 150ms ease'
                }
            }),
            (0, _jsxRuntime.jsxs)("div", {
                style: {
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 1050,
                    width: '100%',
                    maxWidth: 500,
                    background: '#fff',
                    borderRadius: 16,
                    boxShadow: '0 24px 60px rgba(0,0,0,0.18)',
                    overflow: 'hidden',
                    animation: 'ccmSlideUp 220ms cubic-bezier(0.16,1,0.3,1)',
                    fontFamily: "'Nunito', 'Segoe UI', sans-serif"
                },
                children: [
                    (0, _jsxRuntime.jsx)((0, _headerDefault.default), {}),
                    (0, _jsxRuntime.jsxs)("div", {
                        style: {
                            padding: '22px 24px'
                        },
                        children: [
                            (0, _jsxRuntime.jsx)((0, _coursePreviewDefault.default), {
                                originalCourse: originalCourse,
                                courseId: courseId,
                                hasChanged: hasChanged
                            }),
                            (0, _jsxRuntime.jsx)((0, _dropdownsDefault.default), {})
                        ]
                    }),
                    (0, _jsxRuntime.jsx)((0, _footerDefault.default), {
                        canSave: canSave,
                        handleSave: handleSave
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)("style", {
                children: `
        @keyframes ccmFadeIn  { from { opacity: 0 } to { opacity: 1 } }
        @keyframes ccmSlideUp {
          from { opacity: 0; transform: translate(-50%, calc(-50% + 18px)); }
          to   { opacity: 1; transform: translate(-50%, -50%); }
        }
      `
            })
        ]
    });
};
exports.default = ChangeCourseModal;

},{"react/jsx-runtime":"1dlk8","context/admin-context/hook":"lWmPL","./Header":"2ZGXq","./Footer":"9TpAn","./Dropdowns":"3nvK6","./CoursePreview":"8XhmD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ZGXq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _hook = require("context/admin-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _closeButton = require("./CloseButton");
var _closeButtonDefault = parcelHelpers.interopDefault(_closeButton);
const headerStyles = {
    padding: '20px 24px 18px',
    borderBottom: '1px solid #f1f5f9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
};
const ChangeCourseModalHeader = ()=>{
    const { updateChangeCourseModal } = (0, _hookDefault.default)();
    const handleClose = ()=>updateChangeCourseModal(false, null, undefined, {
            subject: '',
            grade: '',
            course: '',
            source: ''
        }, null);
    return (0, _jsxRuntime.jsxs)("div", {
        style: headerStyles,
        children: [
            (0, _jsxRuntime.jsxs)("div", {
                children: [
                    (0, _jsxRuntime.jsx)("h5", {
                        style: {
                            margin: 0,
                            fontWeight: 700,
                            fontSize: 17,
                            color: '#0f172a'
                        },
                        children: "Cambiar Curso"
                    }),
                    (0, _jsxRuntime.jsx)("p", {
                        style: {
                            margin: '3px 0 0',
                            fontSize: 12,
                            color: '#94a3b8'
                        },
                        children: "Selecciona materia, grado y curso"
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _closeButtonDefault.default), {
                onClick: handleClose
            })
        ]
    });
};
exports.default = ChangeCourseModalHeader;

},{"react/jsx-runtime":"1dlk8","context/admin-context/hook":"lWmPL","./CloseButton":"186Mi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"186Mi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
const closeButtonStyles = {
    background: '#f1f5f9',
    border: 'none',
    borderRadius: '50%',
    width: 32,
    height: 32,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#64748b',
    fontSize: 16,
    flexShrink: 0,
    transition: 'background 150ms'
};
const CloseButton = ({ onClick })=>(0, _jsxRuntime.jsx)("button", {
        onClick: onClick,
        style: closeButtonStyles,
        onMouseEnter: (e)=>e.currentTarget.style.background = '#e2e8f0',
        onMouseLeave: (e)=>e.currentTarget.style.background = '#f1f5f9',
        children: "\u2715"
    });
exports.default = CloseButton;

},{"react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9TpAn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
const footerStyles = (canSave)=>({
        root: {
            padding: '14px 24px 20px',
            display: 'flex',
            gap: 10,
            justifyContent: 'flex-end',
            borderTop: '1px solid #f1f5f9'
        },
        save: {
            padding: '9px 22px',
            borderRadius: 8,
            border: 'none',
            color: '#fff',
            fontSize: 14,
            fontWeight: 700,
            transition: 'background 150ms',
            background: canSave ? '#0ea5e9' : '#cbd5e1',
            cursor: canSave ? 'pointer' : 'not-allowed',
            boxShadow: canSave ? '0 2px 8px rgba(14,165,233,0.35)' : 'none'
        }
    });
const ChangeCourseModalFooter = ({ canSave, handleSave })=>{
    const styles = (0, _react.useMemo)(()=>footerStyles(canSave), [
        canSave
    ]);
    return (0, _jsxRuntime.jsx)("div", {
        style: styles.root,
        children: (0, _jsxRuntime.jsx)("button", {
            disabled: !canSave,
            onClick: handleSave,
            style: styles.save,
            onMouseEnter: (e)=>{
                if (canSave) e.currentTarget.style.background = '#0284c7';
            },
            onMouseLeave: (e)=>{
                if (canSave) e.currentTarget.style.background = '#0ea5e9';
            },
            children: "Guardar cambio"
        })
    });
};
exports.default = ChangeCourseModalFooter;

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3nvK6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/admin-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _styledSelect = require("./StyledSelect");
var _styledSelectDefault = parcelHelpers.interopDefault(_styledSelect);
const ChangeCourseModalDropdowns = ()=>{
    const { state, changeCourseModal, updateChangeCourseModal } = (0, _hookDefault.default)();
    const { purchaseIndex, selected, source } = changeCourseModal ?? {};
    // originalCourse = the course being replaced, set by caller on open, never changes
    // selected.course = tracks the current pick as user browses (starts = originalCourse)
    // selected.subject / selected.grade = cascade dropdown state
    const originalCourse = changeCourseModal?.originalCourse ?? '';
    const subjectId = selected?.subject ?? '';
    const gradeId = selected?.grade ?? '';
    const courseId = selected?.course ?? '';
    // ── Data from context ──────────────────────────────────────────────────────
    const allCourses = state.courses?.items ?? [];
    const subjects = state.subjects ?? [];
    const grades = state.grades ?? [];
    // IDs already taken by this purchase — originalCourse excluded so it stays selectable
    const takenIds = (0, _react.useMemo)(()=>{
        const all = state.client?.purchases?.items?.[purchaseIndex]?.courses?.all ?? [];
        return new Set(all.filter((id)=>id !== originalCourse));
    }, [
        state.client,
        purchaseIndex,
        originalCourse
    ]);
    const sortedGrades = (0, _react.useMemo)(()=>[
            ...grades
        ].sort((a, b)=>a.precedence - b.precedence), [
        grades
    ]);
    // When a grade is selected, narrow subjects to only those with courses for that grade
    // When no grade is selected, show all subjects that have any course
    const availableSubjects = (0, _react.useMemo)(()=>{
        const subjectSet = gradeId ? new Set(allCourses.filter((c)=>c.grade === gradeId).map((c)=>c.subject)) : new Set(allCourses.map((c)=>c.subject));
        return subjects.filter((s)=>subjectSet.has(s.id));
    }, [
        gradeId,
        allCourses,
        subjects
    ]);
    // When a subject is selected, narrow grades to only those with courses for that subject
    // When no subject is selected, show all grades that have any course
    const availableGrades = (0, _react.useMemo)(()=>{
        const gradeSet = subjectId ? new Set(allCourses.filter((c)=>c.subject === subjectId).map((c)=>c.grade)) : new Set(allCourses.map((c)=>c.grade));
        return sortedGrades.filter((g)=>gradeSet.has(g.id));
    }, [
        subjectId,
        allCourses,
        sortedGrades
    ]);
    const availableCourses = (0, _react.useMemo)(()=>{
        if (!subjectId || !gradeId) return [];
        return allCourses.filter((c)=>c.subject === subjectId && c.grade === gradeId);
    }, [
        subjectId,
        gradeId,
        allCourses
    ]);
    // ── State ──────────────────────────────────────────────────────────────────
    const set = (patch)=>updateChangeCourseModal(true, purchaseIndex, originalCourse, {
            source,
            subject: patch.subject !== undefined ? patch.subject : subjectId,
            grade: patch.grade !== undefined ? patch.grade : gradeId,
            course: patch.course !== undefined ? patch.course : courseId
        }, null);
    const handleSubjectChange = (val)=>set({
            subject: val,
            grade: '',
            course: ''
        });
    const handleGradeChange = (val)=>set({
            grade: val,
            course: ''
        });
    const handleCourseChange = (val)=>set({
            course: val
        });
    return (0, _jsxRuntime.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 14
        },
        children: [
            (0, _jsxRuntime.jsx)((0, _styledSelectDefault.default), {
                label: "Materia",
                value: subjectId,
                onChange: handleSubjectChange,
                placeholder: '\u2014 Selecciona una materia \u2014',
                children: availableSubjects.map((s)=>(0, _jsxRuntime.jsx)("option", {
                        value: s.id,
                        children: s.name.es
                    }, s.id))
            }),
            (0, _jsxRuntime.jsx)((0, _styledSelectDefault.default), {
                label: "Grado",
                value: gradeId,
                onChange: handleGradeChange,
                placeholder: '\u2014 Selecciona un grado \u2014',
                emptyMessage: subjectId && availableGrades.length === 0 ? 'No hay grados disponibles' : undefined,
                children: availableGrades.map((g)=>(0, _jsxRuntime.jsx)("option", {
                        value: g.id,
                        children: g.name.es
                    }, g.id))
            }),
            (0, _jsxRuntime.jsx)((0, _styledSelectDefault.default), {
                label: "Curso",
                value: courseId,
                onChange: handleCourseChange,
                disabled: !subjectId || !gradeId,
                placeholder: '\u2014 Selecciona un curso \u2014',
                emptyMessage: subjectId && gradeId && availableCourses.length === 0 ? 'No hay cursos disponibles' : undefined,
                children: availableCourses.map((c)=>{
                    const isTaken = takenIds.has(c.id);
                    return (0, _jsxRuntime.jsxs)("option", {
                        value: c.id,
                        disabled: isTaken,
                        children: [
                            c.name,
                            isTaken ? ' (ya seleccionado)' : ''
                        ]
                    }, c.id);
                })
            })
        ]
    });
};
exports.default = ChangeCourseModalDropdowns;

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/admin-context/hook":"lWmPL","./StyledSelect":"2YfAq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2YfAq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
const labelStyle = {
    display: 'block',
    marginBottom: 6,
    fontSize: 11,
    fontWeight: 700,
    color: '#475569',
    textTransform: 'uppercase',
    letterSpacing: '0.06em'
};
const selectStyle = {
    width: '100%',
    padding: '9px 36px 9px 12px',
    fontSize: 14,
    color: '#1e293b',
    background: '#fff',
    border: '1.5px solid #e2e8f0',
    borderRadius: 8,
    outline: 'none',
    appearance: 'none',
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2.5'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 12px center',
    transition: 'border-color 150ms'
};
const StyledSelect = ({ value, onChange, disabled, placeholder, emptyMessage, label, children })=>(0, _jsxRuntime.jsxs)("div", {
        children: [
            label && (0, _jsxRuntime.jsx)("label", {
                style: labelStyle,
                children: label
            }),
            (0, _jsxRuntime.jsxs)("select", {
                value: value,
                onChange: (e)=>onChange(e.target.value),
                disabled: disabled,
                style: {
                    ...selectStyle,
                    opacity: disabled ? 0.5 : 1,
                    cursor: disabled ? 'not-allowed' : 'pointer'
                },
                children: [
                    (0, _jsxRuntime.jsx)("option", {
                        value: '',
                        children: emptyMessage ?? placeholder
                    }),
                    children
                ]
            })
        ]
    });
exports.default = StyledSelect;

},{"react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8XhmD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _courseCover = require("components/CourseCover");
var _courseCoverDefault = parcelHelpers.interopDefault(_courseCover);
var _hook = require("context/admin-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const coursePreviewStyles = (hasChanged)=>({
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        background: '#f8fafc',
        borderRadius: 12,
        padding: '14px 16px',
        marginBottom: 22,
        border: `1.5px solid ${hasChanged ? '#bae6fd' : '#e2e8f0'}`,
        transition: 'border-color 250ms'
    });
const CoursePreview = ({ hasChanged, originalCourse, courseId })=>{
    const { state: { courseMap } } = (0, _hookDefault.default)();
    const styles = (0, _react.useMemo)(()=>coursePreviewStyles(hasChanged), [
        hasChanged
    ]);
    const [id, name] = (0, _react.useMemo)(()=>{
        if (!courseMap) return [
            "",
            ""
        ];
        const originalCourseData = courseMap[originalCourse];
        const previewCourseData = courseMap[courseId];
        const previewId = courseId || originalCourse;
        const previewName = previewCourseData?.name ?? originalCourseData?.name ?? originalCourse;
        return [
            previewId,
            previewName
        ];
    }, [
        courseMap,
        courseId,
        originalCourse
    ]);
    return (0, _jsxRuntime.jsxs)("div", {
        style: styles,
        children: [
            (0, _jsxRuntime.jsx)("div", {
                style: {
                    flexShrink: 0
                },
                children: (0, _jsxRuntime.jsx)((0, _courseCoverDefault.default), {
                    id: id,
                    name: name
                })
            }),
            (0, _jsxRuntime.jsxs)("div", {
                style: {
                    minWidth: 0
                },
                children: [
                    (0, _jsxRuntime.jsx)("p", {
                        style: {
                            margin: 0,
                            fontSize: 11,
                            fontWeight: 700,
                            color: '#94a3b8',
                            textTransform: 'uppercase',
                            letterSpacing: '0.06em'
                        },
                        children: hasChanged ? 'Nuevo curso' : 'Curso actual'
                    }),
                    (0, _jsxRuntime.jsx)("p", {
                        style: {
                            margin: '3px 0 0',
                            fontSize: 15,
                            fontWeight: 700,
                            color: hasChanged ? '#0ea5e9' : '#1e293b',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        },
                        children: name
                    }),
                    hasChanged && (0, _jsxRuntime.jsx)("span", {
                        style: {
                            display: 'inline-block',
                            marginTop: 5,
                            fontSize: 10,
                            background: '#e0f2fe',
                            color: '#0369a1',
                            padding: '2px 8px',
                            borderRadius: 999,
                            fontWeight: 700
                        },
                        children: "Cambiado"
                    })
                ]
            })
        ]
    });
};
exports.default = CoursePreview;

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","components/CourseCover":"bllJU","context/admin-context/hook":"lWmPL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cfVeb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _homeItem = require("components/HomeItem");
var _homeItemDefault = parcelHelpers.interopDefault(_homeItem);
const HomePage = ()=>{
    return (0, _jsxRuntime.jsx)((0, _react.Card).Body, {
        className: 'mt-2',
        children: (0, _jsxRuntime.jsxs)("div", {
            className: "row mt-3 mb-3 justify-content-center",
            children: [
                (0, _jsxRuntime.jsx)((0, _homeItemDefault.default), {
                    className: 'mr-3',
                    icon: 'faUsers',
                    label: 'Clientes',
                    to: '/accounting/clients',
                    children: (0, _jsxRuntime.jsx)("div", {
                        className: 'text-muted mb-0',
                        children: (0, _jsxRuntime.jsx)("span", {
                            className: 'text-white',
                            children: "."
                        })
                    })
                }),
                (0, _jsxRuntime.jsx)((0, _homeItemDefault.default), {
                    className: 'mr-3',
                    icon: 'faDollar',
                    label: 'Pagos',
                    to: '/accounting/payouts',
                    children: (0, _jsxRuntime.jsx)("div", {
                        className: 'text-muted mb-0',
                        children: (0, _jsxRuntime.jsx)("span", {
                            className: 'text-white',
                            children: "."
                        })
                    })
                })
            ]
        })
    });
};
exports.default = HomePage;

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","components/HomeItem":"lDz6Y","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ez0xu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PayoutsPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _payoutsTable = require("./PayoutsTable");
var _payoutsTableDefault = parcelHelpers.interopDefault(_payoutsTable);
const PayoutsPage = ()=>{
    return (0, _jsxRuntime.jsx)((0, _react.Card).Body, {
        children: (0, _jsxRuntime.jsx)((0, _payoutsTableDefault.default), {})
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","./PayoutsTable":"6ifNh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6ifNh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/accounting-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _payoutsTableProperties = require("./PayoutsTableProperties");
var _payoutsTableHeader = require("./PayoutsTableHeader");
var _payoutsTableHeaderDefault = parcelHelpers.interopDefault(_payoutsTableHeader);
var _payoutsTableBody = require("./PayoutsTableBody");
var _payoutsTableBodyDefault = parcelHelpers.interopDefault(_payoutsTableBody);
var _payoutsTableToolbar = require("./PayoutsTableToolbar");
var _payoutsTableToolbarDefault = parcelHelpers.interopDefault(_payoutsTableToolbar);
var _payoutsTablePaging = require("./PayoutsTablePaging");
var _payoutsTablePagingDefault = parcelHelpers.interopDefault(_payoutsTablePaging);
const PayoutsTable = ()=>{
    const [searchParams, setSearchParams] = (0, _react.useSearchParams)();
    const { payoutsPaging } = (0, _hookDefault.default)();
    const toolbarRef = (0, _react.useRef)(null);
    const theadRef = (0, _react.useRef)(null);
    const pagingRef = (0, _react.useRef)(null);
    const cardRef = (0, _react.useRef)(null);
    const updateParams = (updates)=>{
        setSearchParams((prev)=>{
            const next = new URLSearchParams(prev);
            Object.entries(updates).forEach(([key, value])=>{
                if (value === undefined || value === '') next.delete(key);
                else next.set(key, value);
            });
            return next;
        });
    };
    const calculate = ()=>{
        const toolbarH = toolbarRef.current?.offsetHeight ?? 0;
        const theadH = theadRef.current?.offsetHeight ?? 0;
        const pagingH = pagingRef.current?.offsetHeight ?? 0;
        const cardPadding = 168;
        const chrome = toolbarH + theadH + pagingH + cardPadding;
        const available = window.innerHeight - (cardRef.current?.getBoundingClientRect().top ?? 0) - chrome;
        const rows = Math.max(1, Math.floor(available / (0, _payoutsTableProperties.ROW_HEIGHT)));
        updateParams({
            pageSize: String(Math.min(rows, 50)),
            page: '1'
        });
    };
    (0, _react.useEffect)(()=>{
        calculate();
        window.addEventListener('resize', calculate);
        return ()=>window.removeEventListener('resize', calculate);
    }, []);
    const pattern = searchParams.get('pattern') ?? undefined;
    const sortBy = searchParams.get('sortBy') ?? undefined;
    const handleSearch = (pattern)=>updateParams({
            pattern,
            page: '1'
        });
    const handleSort = (sortBy)=>updateParams({
            sortBy: sortBy || undefined,
            page: '1'
        });
    const handlePageChange = (page)=>updateParams({
            page: String(page)
        });
    const noResults = payoutsPaging && payoutsPaging.recordCount === 0;
    const from = searchParams.get('from') ?? undefined;
    const to = searchParams.get('to') ?? undefined;
    const handleDateRange = (from, to)=>updateParams({
            from,
            to,
            page: '1'
        });
    return (0, _jsxRuntime.jsx)("div", {
        ref: cardRef,
        children: (0, _jsxRuntime.jsxs)((0, _react.Card).Body, {
            children: [
                (0, _jsxRuntime.jsx)("div", {
                    ref: toolbarRef,
                    children: (0, _jsxRuntime.jsx)((0, _payoutsTableToolbarDefault.default), {
                        pattern: pattern,
                        from: from,
                        to: to,
                        onSearch: handleSearch,
                        onDateRange: handleDateRange
                    })
                }),
                noResults ? (0, _jsxRuntime.jsxs)("div", {
                    className: "d-flex flex-column align-items-center justify-content-center text-muted",
                    style: {
                        height: `${(0, _payoutsTableProperties.ROW_HEIGHT) * 5}px`
                    },
                    children: [
                        (0, _jsxRuntime.jsx)("span", {
                            style: {
                                fontSize: '2rem'
                            },
                            children: "\uD83D\uDD0D"
                        }),
                        (0, _jsxRuntime.jsxs)("p", {
                            className: "mt-2 mb-0",
                            children: [
                                "No se encontraron pagos",
                                pattern ? ` para "${pattern}"` : '',
                                "."
                            ]
                        })
                    ]
                }) : (0, _jsxRuntime.jsxs)((0, _react.Table), {
                    bordered: true,
                    hover: true,
                    style: {
                        tableLayout: 'fixed',
                        width: '100%'
                    },
                    children: [
                        (0, _jsxRuntime.jsx)("thead", {
                            ref: theadRef,
                            children: (0, _jsxRuntime.jsx)((0, _payoutsTableHeaderDefault.default), {
                                sortBy: sortBy,
                                onSort: handleSort
                            })
                        }),
                        (0, _jsxRuntime.jsx)((0, _payoutsTableBodyDefault.default), {})
                    ]
                }),
                (0, _jsxRuntime.jsx)("div", {
                    ref: pagingRef,
                    children: payoutsPaging && payoutsPaging.recordCount > 0 && (0, _jsxRuntime.jsx)((0, _payoutsTablePagingDefault.default), {
                        ...payoutsPaging,
                        onPageChange: handlePageChange
                    })
                })
            ]
        })
    });
};
exports.default = PayoutsTable;

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/accounting-context/hook":"cCF1x","./PayoutsTableProperties":"ivJIC","./PayoutsTableHeader":"iawU3","./PayoutsTableBody":"5nlY5","./PayoutsTableToolbar":"jQRwC","./PayoutsTablePaging":"hedYd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ivJIC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ROW_HEIGHT", ()=>ROW_HEIGHT);
parcelHelpers.export(exports, "columns", ()=>columns);
const ROW_HEIGHT = 41;
const columns = [
    {
        key: 'amount',
        label: 'Monto',
        sortable: true,
        width: '130px'
    },
    {
        key: 'status',
        label: 'Estado',
        sortable: true,
        width: '130px'
    },
    {
        key: 'arrival_date',
        label: "Dep\xf3sito",
        sortable: true,
        width: '150px'
    },
    {
        key: 'bank',
        label: 'Banco',
        sortable: false,
        width: 'auto'
    }
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iawU3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _payoutsTableProperties = require("./PayoutsTableProperties");
const PayoutsTableHeader = ({ sortBy, onSort })=>{
    const getSortIndicator = (key)=>{
        if (!sortBy) return "\u2195";
        const match = sortBy.split(',').find((f)=>f.replace(/^-/, '') === key);
        if (!match) return "\u2195";
        return match.startsWith('-') ? "\u2193" : "\u2191";
    };
    const handleSort = (key)=>{
        const fields = sortBy ? sortBy.split(',') : [];
        const match = fields.find((f)=>f.replace(/^-/, '') === key);
        const rest = fields.filter((f)=>f.replace(/^-/, '') !== key);
        let newFields;
        if (!match) newFields = [
            key,
            ...rest
        ];
        else if (!match.startsWith('-')) newFields = [
            `-${key}`,
            ...rest
        ];
        else newFields = rest;
        onSort(newFields.join(','));
    };
    return (0, _jsxRuntime.jsx)("tr", {
        children: (0, _payoutsTableProperties.columns).map((col)=>(0, _jsxRuntime.jsxs)("th", {
                style: {
                    width: col.width,
                    cursor: col.sortable ? 'pointer' : 'default',
                    userSelect: 'none',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                },
                onClick: ()=>col.sortable && handleSort(col.key),
                children: [
                    col.label,
                    " ",
                    col.sortable && (0, _jsxRuntime.jsx)("span", {
                        children: getSortIndicator(col.key)
                    })
                ]
            }, col.key))
    });
};
exports.default = PayoutsTableHeader;

},{"react/jsx-runtime":"1dlk8","./PayoutsTableProperties":"ivJIC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5nlY5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _hook = require("context/accounting-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _payoutsTableRow = require("./PayoutsTableRow");
var _payoutsTableRowDefault = parcelHelpers.interopDefault(_payoutsTableRow);
var _payoutsTableFillerRow = require("./PayoutsTableFillerRow");
var _payoutsTableFillerRowDefault = parcelHelpers.interopDefault(_payoutsTableFillerRow);
const PayoutsTableBody = ()=>{
    const { payouts } = (0, _hookDefault.default)();
    return (0, _jsxRuntime.jsxs)("tbody", {
        children: [
            payouts.map((item)=>(0, _jsxRuntime.jsx)((0, _payoutsTableRowDefault.default), {
                    payoutData: item
                }, item.id)),
            (0, _jsxRuntime.jsx)((0, _payoutsTableFillerRowDefault.default), {})
        ]
    });
};
exports.default = PayoutsTableBody;

},{"react/jsx-runtime":"1dlk8","context/accounting-context/hook":"cCF1x","./PayoutsTableRow":"iolz1","./PayoutsTableFillerRow":"26Q5E","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iolz1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
const formatAmount = (amount, currency)=>new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency ?? 'usd'
    }).format(amount / 100);
const formatDate = (unixTimestamp)=>new Date(unixTimestamp * 1000).toLocaleDateString();
const statusConfig = {
    paid: {
        icon: 'faCircleCheck',
        className: 'text-success',
        label: 'Pagado'
    },
    failed: {
        icon: 'faCircleExclamation',
        className: 'text-danger',
        label: 'Fallido'
    },
    pending: {
        icon: 'faSpinner',
        className: 'text-warning',
        label: 'Pendiente'
    },
    in_transit: {
        icon: 'faSpinner',
        className: 'text-info',
        label: "En tr\xe1nsito"
    },
    canceled: {
        icon: 'faXmark',
        className: 'text-secondary',
        label: 'Cancelado'
    }
};
const PayoutsTableRow = ({ payoutData: item })=>{
    const navigate = (0, _react.useNavigate)();
    const p = item.properties;
    const status = statusConfig[p.status] ?? {
        icon: 'faCircleExclamation',
        className: 'text-secondary'
    };
    return (0, _jsxRuntime.jsxs)("tr", {
        style: {
            cursor: 'pointer'
        },
        onClick: ()=>navigate(`/accounting/payouts/${item.id}`),
        children: [
            (0, _jsxRuntime.jsx)("td", {
                children: formatAmount(p.amount, p.currency)
            }),
            (0, _jsxRuntime.jsx)("td", {
                children: (0, _jsxRuntime.jsxs)("span", {
                    style: {
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 6
                    },
                    children: [
                        (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                            name: status.icon,
                            className: status.className
                        }),
                        status.label
                    ]
                })
            }),
            (0, _jsxRuntime.jsx)("td", {
                children: (0, _jsxRuntime.jsxs)("span", {
                    style: {
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 6
                    },
                    children: [
                        (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                            name: "faCalendarDays",
                            className: "text-muted"
                        }),
                        formatDate(p.arrival_date)
                    ]
                })
            }),
            (0, _jsxRuntime.jsx)("td", {
                children: (0, _jsxRuntime.jsxs)("span", {
                    style: {
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 6
                    },
                    children: [
                        (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                            name: "faCreditCard",
                            className: "text-muted"
                        }),
                        item.bank_name ? `${item.bank_name} \u{2022}\u{2022}\u{2022}\u{2022} ${item.last4}` : "\u2014"
                    ]
                })
            })
        ]
    });
};
exports.default = PayoutsTableRow;

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/fortawesome":"7JvBl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"26Q5E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _hook = require("context/accounting-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _payoutsTableProperties = require("./PayoutsTableProperties");
const PayoutsTableFillerRow = ()=>{
    const { payouts, payoutsPaging } = (0, _hookDefault.default)();
    const pageSize = (0, _react.useMemo)(()=>payoutsPaging ? payoutsPaging.pageSize : 0, [
        payoutsPaging
    ]);
    if (payouts.length >= pageSize) return null;
    return (0, _jsxRuntime.jsx)("tr", {
        style: {
            pointerEvents: 'none'
        },
        children: (0, _jsxRuntime.jsx)("td", {
            colSpan: (0, _payoutsTableProperties.columns).length,
            rowSpan: Math.max(0, pageSize - payouts.length),
            style: {
                border: 'none',
                height: `${(pageSize - payouts.length) * (0, _payoutsTableProperties.ROW_HEIGHT)}px`
            }
        })
    });
};
exports.default = PayoutsTableFillerRow;

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","context/accounting-context/hook":"cCF1x","./PayoutsTableProperties":"ivJIC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jQRwC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _payoutsExportButton = require("./PayoutsExportButton");
var _payoutsExportButtonDefault = parcelHelpers.interopDefault(_payoutsExportButton);
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
const today = new Date();
const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
const toDateString = (d)=>d.toISOString().split('T')[0];
const PayoutsTableToolbar = ({ pattern, from, to, onSearch, onDateRange })=>{
    const [searchOpen, setSearchOpen] = (0, _react.useState)(false);
    const [draft, setDraft] = (0, _react.useState)('');
    const [dateOpen, setDateOpen] = (0, _react.useState)(false);
    const [fromDraft, setFromDraft] = (0, _react.useState)(from ?? toDateString(firstOfMonth));
    const [toDraft, setToDraft] = (0, _react.useState)(to ?? toDateString(today));
    const inputRef = (0, _react.useRef)(null);
    const openSearch = ()=>{
        setSearchOpen(true);
        setDraft(pattern ?? '');
        setTimeout(()=>inputRef.current?.focus(), 50);
    };
    const commitSearch = ()=>{
        onSearch(draft || undefined);
        setSearchOpen(false);
        setDraft('');
    };
    const clearPattern = ()=>{
        onSearch(undefined);
        setSearchOpen(false);
        setDraft('');
    };
    const commitDateRange = ()=>{
        onDateRange(fromDraft || undefined, toDraft || undefined);
        setDateOpen(false);
    };
    const clearDateRange = ()=>{
        setFromDraft('');
        setToDraft('');
        onDateRange(undefined, undefined);
        setDateOpen(false);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter') commitSearch();
        if (e.key === 'Escape') setSearchOpen(false);
    };
    const hasDateFilter = from || to;
    return (0, _jsxRuntime.jsxs)("div", {
        className: "d-flex align-items-center justify-content-between mb-3",
        children: [
            (0, _jsxRuntime.jsxs)("div", {
                className: "d-flex align-items-center gap-2",
                children: [
                    pattern && !searchOpen && (0, _jsxRuntime.jsxs)("span", {
                        className: "badge bg-primary d-flex align-items-center gap-1",
                        style: {
                            fontSize: '0.85rem'
                        },
                        children: [
                            "\uD83D\uDD0D ",
                            pattern,
                            (0, _jsxRuntime.jsx)("button", {
                                onClick: clearPattern,
                                className: "btn-close btn-close-white ms-1",
                                style: {
                                    fontSize: '0.6rem'
                                }
                            })
                        ]
                    }),
                    searchOpen ? (0, _jsxRuntime.jsxs)("div", {
                        className: "d-flex align-items-center gap-1",
                        children: [
                            (0, _jsxRuntime.jsx)("input", {
                                ref: inputRef,
                                className: "form-control form-control-sm",
                                style: {
                                    width: 200
                                },
                                value: draft,
                                onChange: (e)=>setDraft(e.target.value),
                                onKeyDown: handleKeyDown,
                                placeholder: "Buscar..."
                            }),
                            (0, _jsxRuntime.jsx)("button", {
                                className: "btn btn-sm btn-primary",
                                onClick: commitSearch,
                                children: "Aplicar"
                            }),
                            (0, _jsxRuntime.jsx)("button", {
                                className: "btn btn-sm btn-outline-secondary",
                                onClick: ()=>setSearchOpen(false),
                                children: "\u2715"
                            })
                        ]
                    }) : (0, _jsxRuntime.jsx)("button", {
                        className: "btn btn-sm btn-outline-secondary",
                        onClick: openSearch,
                        title: "Buscar",
                        children: "\uD83D\uDD0D"
                    }),
                    (0, _jsxRuntime.jsxs)("div", {
                        style: {
                            position: 'relative'
                        },
                        children: [
                            (0, _jsxRuntime.jsxs)("button", {
                                className: `btn btn-sm ${hasDateFilter ? 'btn-primary' : 'btn-outline-secondary'}`,
                                onClick: ()=>setDateOpen((o)=>!o),
                                title: "Filtrar por fecha",
                                children: [
                                    (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                        name: "faCalendarDays"
                                    }),
                                    hasDateFilter && (0, _jsxRuntime.jsxs)("span", {
                                        className: "ms-1",
                                        style: {
                                            fontSize: '0.8rem'
                                        },
                                        children: [
                                            from ?? '...',
                                            " \u2014 ",
                                            to ?? '...'
                                        ]
                                    })
                                ]
                            }),
                            dateOpen && (0, _jsxRuntime.jsxs)("div", {
                                style: {
                                    position: 'absolute',
                                    left: 0,
                                    top: '110%',
                                    zIndex: 100,
                                    background: 'white',
                                    border: '1px solid #dee2e6',
                                    borderRadius: 6,
                                    padding: '12px 16px',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                    minWidth: 260
                                },
                                children: [
                                    (0, _jsxRuntime.jsxs)("div", {
                                        className: "mb-2",
                                        children: [
                                            (0, _jsxRuntime.jsx)("label", {
                                                className: "form-label small mb-1",
                                                children: "Desde"
                                            }),
                                            (0, _jsxRuntime.jsx)("input", {
                                                type: "date",
                                                className: "form-control form-control-sm",
                                                value: fromDraft,
                                                onChange: (e)=>setFromDraft(e.target.value)
                                            })
                                        ]
                                    }),
                                    (0, _jsxRuntime.jsxs)("div", {
                                        className: "mb-3",
                                        children: [
                                            (0, _jsxRuntime.jsx)("label", {
                                                className: "form-label small mb-1",
                                                children: "Hasta"
                                            }),
                                            (0, _jsxRuntime.jsx)("input", {
                                                type: "date",
                                                className: "form-control form-control-sm",
                                                value: toDraft,
                                                onChange: (e)=>setToDraft(e.target.value)
                                            })
                                        ]
                                    }),
                                    (0, _jsxRuntime.jsxs)("div", {
                                        className: "d-flex gap-2",
                                        children: [
                                            (0, _jsxRuntime.jsx)("button", {
                                                className: "btn btn-sm btn-primary w-100",
                                                onClick: commitDateRange,
                                                children: "Aplicar"
                                            }),
                                            (0, _jsxRuntime.jsx)("button", {
                                                className: "btn btn-sm btn-outline-secondary",
                                                onClick: clearDateRange,
                                                children: "Limpiar"
                                            }),
                                            (0, _jsxRuntime.jsx)("button", {
                                                className: "btn btn-sm btn-outline-secondary",
                                                onClick: ()=>setDateOpen(false),
                                                children: "\u2715"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _payoutsExportButtonDefault.default), {})
        ]
    });
};
exports.default = PayoutsTableToolbar;

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","./PayoutsExportButton":"RW06U","external/fortawesome":"7JvBl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"RW06U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _xlsx = require("external/xlsx");
var _accountingService = require("services/accounting.service");
var _hook = require("context/auth-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const formatAmount = (amount, currency)=>new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency ?? 'usd'
    }).format(amount / 100);
const formatDate = (unixTimestamp)=>new Date(unixTimestamp * 1000).toLocaleDateString();
const statusLabels = {
    paid: 'Pagado',
    failed: 'Fallido',
    pending: 'Pendiente',
    in_transit: "En tr\xe1nsito",
    canceled: 'Cancelado'
};
const txnTypeLabels = {
    charge: 'Cargos',
    refund: 'Reembolsos',
    adjustment: 'Ajustes',
    stripe_fee: 'Comisiones Stripe',
    payout_failure: 'Fallo de pago'
};
const today = new Date();
const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
const toDateString = (d)=>d.toISOString().split('T')[0];
const PayoutsExportButton = ()=>{
    const { user } = (0, _hookDefault.default)();
    const [open, setOpen] = (0, _react.useState)(false);
    const [from, setFrom] = (0, _react.useState)(toDateString(firstOfMonth));
    const [to, setTo] = (0, _react.useState)(toDateString(today));
    const [includeDetail, setIncludeDetail] = (0, _react.useState)(false);
    const [loading, setLoading] = (0, _react.useState)(false);
    const [progress, setProgress] = (0, _react.useState)('');
    const ref = (0, _react.useRef)(null);
    const handleExport = async ()=>{
        setLoading(true);
        setProgress('Obteniendo pagos...');
        try {
            const { data: payouts } = await (0, _accountingService.accountingService).exportPayouts(user.id, {
                from: from || undefined,
                to: to || undefined
            });
            // Sheet 1: payout summary rows
            const summaryRows = payouts.map((item)=>({
                    'Pago ID': item.id,
                    'Monto': formatAmount(item.properties.amount, item.properties.currency),
                    'Estado': statusLabels[item.properties.status] ?? item.properties.status,
                    "Dep\xf3sito": formatDate(item.properties.arrival_date),
                    'Banco': item.bank_name ? `${item.bank_name} \u{2022}\u{2022}\u{2022}\u{2022} ${item.last4}` : "\u2014"
                }));
            const wb = (0, _xlsx.bookNew)();
            (0, _xlsx.bookAppendSheet)(wb, (0, _xlsx.jsonToSheet)(summaryRows), 'Pagos');
            if (includeDetail) {
                const detailRows = [];
                for(let i = 0; i < payouts.length; i++){
                    const payout = payouts[i];
                    setProgress(`Obteniendo detalle ${i + 1} de ${payouts.length}...`);
                    const { data: detail } = await (0, _accountingService.accountingService).getPayoutDetail(user.id, payout.id);
                    const { transactions, payout: payoutRow } = detail;
                    const visibleTxns = transactions.filter((txn)=>(txn._type ?? txn.type) !== 'payout');
                    visibleTxns.forEach((txn)=>{
                        detailRows.push({
                            'Pago ID': payoutRow.id,
                            "Dep\xf3sito": formatDate(payout.properties.arrival_date),
                            'Banco': payout.bank_name ? `${payout.bank_name} \u{2022}\u{2022}\u{2022}\u{2022} ${payout.last4}` : "\u2014",
                            'Tipo': txnTypeLabels[txn._type ?? txn.type] ?? txn.type,
                            'Bruto': formatAmount(txn.amount, 'usd'),
                            "Comisi\xf3n": txn.fee === 0 ? '$0.00' : formatAmount(-txn.fee, 'usd'),
                            'Total': formatAmount(txn.net, 'usd'),
                            "Descripci\xf3n": txn._description ?? txn.description ?? "\u2014",
                            'Fecha': formatDate(txn.created)
                        });
                    });
                }
                (0, _xlsx.bookAppendSheet)(wb, (0, _xlsx.jsonToSheet)(detailRows), 'Transacciones');
            }
            setProgress('Generando archivo...');
            (0, _xlsx.writeFile)(wb, `pagos_${from || 'inicio'}_${to || 'hoy'}.xlsx`);
            setOpen(false);
        } finally{
            setLoading(false);
            setProgress('');
        }
    };
    return (0, _jsxRuntime.jsxs)("div", {
        style: {
            position: 'relative'
        },
        ref: ref,
        children: [
            (0, _jsxRuntime.jsx)("button", {
                className: "btn btn-sm btn-outline-secondary",
                onClick: ()=>setOpen((o)=>!o),
                title: "Exportar",
                children: (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                    name: "faHandHoldingDollar"
                })
            }),
            open && (0, _jsxRuntime.jsxs)("div", {
                style: {
                    position: 'absolute',
                    right: 0,
                    top: '110%',
                    zIndex: 100,
                    background: 'white',
                    border: '1px solid #dee2e6',
                    borderRadius: 6,
                    padding: '12px 16px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                    minWidth: 280
                },
                children: [
                    (0, _jsxRuntime.jsxs)("div", {
                        className: "mb-2",
                        children: [
                            (0, _jsxRuntime.jsx)("label", {
                                className: "form-label small mb-1",
                                children: "Desde"
                            }),
                            (0, _jsxRuntime.jsx)("input", {
                                type: "date",
                                className: "form-control form-control-sm",
                                value: from,
                                onChange: (e)=>setFrom(e.target.value)
                            })
                        ]
                    }),
                    (0, _jsxRuntime.jsxs)("div", {
                        className: "mb-3",
                        children: [
                            (0, _jsxRuntime.jsx)("label", {
                                className: "form-label small mb-1",
                                children: "Hasta"
                            }),
                            (0, _jsxRuntime.jsx)("input", {
                                type: "date",
                                className: "form-control form-control-sm",
                                value: to,
                                onChange: (e)=>setTo(e.target.value)
                            })
                        ]
                    }),
                    (0, _jsxRuntime.jsxs)("div", {
                        className: "mb-3 d-flex align-items-start gap-2",
                        children: [
                            (0, _jsxRuntime.jsx)("input", {
                                type: "checkbox",
                                id: "includeDetail",
                                className: "form-check-input mt-1",
                                checked: includeDetail,
                                onChange: (e)=>setIncludeDetail(e.target.checked)
                            }),
                            (0, _jsxRuntime.jsxs)("label", {
                                htmlFor: "includeDetail",
                                className: "form-check-label small",
                                style: {
                                    cursor: 'pointer'
                                },
                                children: [
                                    "Incluir detalle de transacciones",
                                    includeDetail && (0, _jsxRuntime.jsx)("span", {
                                        className: "d-block text-muted",
                                        style: {
                                            fontSize: '0.75rem'
                                        },
                                        children: "Puede tomar m\u00E1s tiempo si los detalles a\u00FAn no han sido consultados."
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, _jsxRuntime.jsxs)("div", {
                        className: "d-flex gap-2",
                        children: [
                            (0, _jsxRuntime.jsx)("button", {
                                className: "btn btn-sm btn-primary w-100",
                                onClick: handleExport,
                                disabled: loading,
                                children: loading ? (0, _jsxRuntime.jsxs)("span", {
                                    className: "d-flex align-items-center justify-content-center gap-2",
                                    children: [
                                        (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                            name: "faSpinner",
                                            spin: true
                                        }),
                                        (0, _jsxRuntime.jsx)("span", {
                                            style: {
                                                fontSize: '0.8rem'
                                            },
                                            children: progress
                                        })
                                    ]
                                }) : (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                            name: "faHandHoldingDollar"
                                        }),
                                        " Exportar"
                                    ]
                                })
                            }),
                            (0, _jsxRuntime.jsx)("button", {
                                className: "btn btn-sm btn-outline-secondary",
                                onClick: ()=>setOpen(false),
                                disabled: loading,
                                children: (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                    name: "faXmark"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = PayoutsExportButton;

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/fortawesome":"7JvBl","external/xlsx":"l0QOJ","services/accounting.service":"40iQF","context/auth-context/hook":"2UX0M","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hedYd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
const PayoutsTablePaging = ({ pageSize, currentPage, recordCount, onPageChange })=>{
    const totalPages = Math.ceil(recordCount / pageSize);
    return (0, _jsxRuntime.jsxs)("div", {
        className: "d-flex justify-content-between align-items-center mt-2",
        children: [
            (0, _jsxRuntime.jsxs)("span", {
                className: "text-muted small",
                children: [
                    recordCount,
                    " registros \u2014 p\u00E1gina ",
                    currentPage,
                    " de ",
                    totalPages
                ]
            }),
            (0, _jsxRuntime.jsxs)("div", {
                className: "d-flex gap-1",
                children: [
                    totalPages >= 10 && (0, _jsxRuntime.jsx)("button", {
                        className: "btn btn-sm btn-outline-secondary",
                        disabled: currentPage <= 1,
                        onClick: ()=>onPageChange(currentPage - 1),
                        children: "\u2039"
                    }),
                    Array.from({
                        length: totalPages
                    }, (_, i)=>i + 1).filter((p)=>Math.abs(p - currentPage) <= 2).map((p)=>(0, _jsxRuntime.jsx)("button", {
                            className: `btn btn-sm ${p === currentPage ? 'btn-primary' : 'btn-outline-secondary'}`,
                            onClick: ()=>onPageChange(p),
                            children: p
                        }, p)),
                    totalPages >= 10 && (0, _jsxRuntime.jsx)("button", {
                        className: "btn btn-sm btn-outline-secondary",
                        disabled: currentPage >= totalPages,
                        onClick: ()=>onPageChange(currentPage + 1),
                        children: "\u203A"
                    })
                ]
            })
        ]
    });
};
exports.default = PayoutsTablePaging;

},{"react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"50J7d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PayoutDetailPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _fortawesome = require("external/fortawesome");
var _fortawesomeDefault = parcelHelpers.interopDefault(_fortawesome);
var _hook = require("context/accounting-context/hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
const formatAmount = (amount)=>new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'usd'
    }).format(amount / 100);
const formatDate = (unixTimestamp)=>new Date(unixTimestamp * 1000).toLocaleDateString('es-PR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
const statusLabels = {
    paid: {
        label: 'Pagado',
        className: 'bg-success'
    },
    failed: {
        label: 'Fallido',
        className: 'bg-danger'
    },
    pending: {
        label: 'Pendiente',
        className: 'bg-warning'
    },
    in_transit: {
        label: "En tr\xe1nsito",
        className: 'bg-info'
    },
    canceled: {
        label: 'Cancelado',
        className: 'bg-secondary'
    }
};
const txnTypeLabels = {
    charge: 'Cargos',
    refund: 'Reembolsos',
    adjustment: 'Ajustes',
    stripe_fee: 'Comisiones Stripe',
    payout: 'Pago',
    payout_failure: 'Fallo de pago'
};
const thStyle = {
    fontWeight: 600,
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    color: '#6b7280',
    borderBottom: '1px solid #e5e7eb',
    padding: '8px 12px',
    background: 'transparent'
};
const tdStyle = {
    padding: '10px 12px',
    borderBottom: '1px solid #f3f4f6',
    fontSize: '0.875rem'
};
const tfootTdStyle = {
    padding: '10px 12px',
    fontWeight: 600,
    fontSize: '0.875rem',
    borderTop: '2px solid #e5e7eb'
};
const sectionTitle = {
    fontSize: '1rem',
    fontWeight: 600,
    marginBottom: '12px',
    color: '#111827'
};
const formatFee = (fee)=>fee === 0 ? '$0.00' : formatAmount(-fee);
const PayoutDetailPage = ()=>{
    const { payout } = (0, _hookDefault.default)();
    if (payout.loading) return (0, _jsxRuntime.jsx)((0, _react.Card).Body, {
        className: "d-flex justify-content-center align-items-center",
        style: {
            height: 300
        },
        children: (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
            name: "faSpinner",
            spin: true,
            size: "2x",
            className: "text-muted"
        })
    });
    if (!payout.data) return null;
    const { payout: payoutRow, summary, transactions } = payout.data;
    const p = payoutRow.properties;
    const summaryRows = [
        'charge',
        'refund',
        'adjustment',
        'stripe_fee'
    ].map((type)=>({
            type,
            label: txnTypeLabels[type] ?? type,
            ...summary[type] ?? {
                count: 0,
                gross: 0,
                fee: 0,
                net: 0
            }
        }));
    const visibleTransactions = transactions.filter((txn)=>(txn._type ?? txn.type) !== 'payout');
    return (0, _jsxRuntime.jsxs)((0, _react.Card).Body, {
        children: [
            (0, _jsxRuntime.jsxs)("div", {
                className: "row g-4 mb-4",
                children: [
                    (0, _jsxRuntime.jsxs)("div", {
                        className: "col-12 col-md-8",
                        children: [
                            (0, _jsxRuntime.jsx)("p", {
                                style: sectionTitle,
                                children: "Resumen"
                            }),
                            (0, _jsxRuntime.jsxs)("table", {
                                style: {
                                    width: '100%',
                                    borderCollapse: 'collapse'
                                },
                                children: [
                                    (0, _jsxRuntime.jsx)("thead", {
                                        children: (0, _jsxRuntime.jsxs)("tr", {
                                            children: [
                                                (0, _jsxRuntime.jsx)("th", {
                                                    style: thStyle
                                                }),
                                                (0, _jsxRuntime.jsx)("th", {
                                                    style: {
                                                        ...thStyle,
                                                        textAlign: 'right'
                                                    },
                                                    children: "Cantidad"
                                                }),
                                                (0, _jsxRuntime.jsx)("th", {
                                                    style: {
                                                        ...thStyle,
                                                        textAlign: 'right'
                                                    },
                                                    children: "Bruto"
                                                }),
                                                (0, _jsxRuntime.jsx)("th", {
                                                    style: {
                                                        ...thStyle,
                                                        textAlign: 'right'
                                                    },
                                                    children: "Comisiones"
                                                }),
                                                (0, _jsxRuntime.jsx)("th", {
                                                    style: {
                                                        ...thStyle,
                                                        textAlign: 'right'
                                                    },
                                                    children: "Total"
                                                })
                                            ]
                                        })
                                    }),
                                    (0, _jsxRuntime.jsx)("tbody", {
                                        children: summaryRows.map((row)=>(0, _jsxRuntime.jsxs)("tr", {
                                                children: [
                                                    (0, _jsxRuntime.jsx)("td", {
                                                        style: tdStyle,
                                                        children: row.label
                                                    }),
                                                    (0, _jsxRuntime.jsx)("td", {
                                                        style: {
                                                            ...tdStyle,
                                                            textAlign: 'right'
                                                        },
                                                        children: row.count
                                                    }),
                                                    (0, _jsxRuntime.jsx)("td", {
                                                        style: {
                                                            ...tdStyle,
                                                            textAlign: 'right'
                                                        },
                                                        children: formatAmount(row.gross)
                                                    }),
                                                    (0, _jsxRuntime.jsx)("td", {
                                                        style: {
                                                            ...tdStyle,
                                                            textAlign: 'right'
                                                        },
                                                        children: formatFee(row.fee)
                                                    }),
                                                    (0, _jsxRuntime.jsx)("td", {
                                                        style: {
                                                            ...tdStyle,
                                                            textAlign: 'right'
                                                        },
                                                        children: formatAmount(row.net)
                                                    })
                                                ]
                                            }, row.type))
                                    }),
                                    (0, _jsxRuntime.jsx)("tfoot", {
                                        children: (0, _jsxRuntime.jsxs)("tr", {
                                            children: [
                                                (0, _jsxRuntime.jsx)("td", {
                                                    colSpan: 4,
                                                    style: {
                                                        ...tfootTdStyle,
                                                        textAlign: 'right'
                                                    },
                                                    children: "Pagos"
                                                }),
                                                (0, _jsxRuntime.jsx)("td", {
                                                    style: {
                                                        ...tfootTdStyle,
                                                        textAlign: 'right'
                                                    },
                                                    children: formatAmount(p.amount)
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, _jsxRuntime.jsxs)("div", {
                        className: "col-12 col-md-4",
                        children: [
                            (0, _jsxRuntime.jsx)("p", {
                                style: sectionTitle,
                                children: "Detalles"
                            }),
                            (0, _jsxRuntime.jsx)("table", {
                                style: {
                                    width: '100%',
                                    borderCollapse: 'collapse'
                                },
                                children: (0, _jsxRuntime.jsx)("tbody", {
                                    children: [
                                        [
                                            'Completado',
                                            formatDate(p.arrival_date)
                                        ],
                                        [
                                            'ID',
                                            payoutRow.id
                                        ],
                                        [
                                            "M\xe9todo",
                                            p.method
                                        ],
                                        [
                                            'Trace ID',
                                            p.trace_id?.value ?? "\u2014"
                                        ],
                                        [
                                            "Comisi\xf3n",
                                            '$0.00'
                                        ],
                                        [
                                            'Monto',
                                            formatAmount(p.amount)
                                        ]
                                    ].map(([label, value])=>(0, _jsxRuntime.jsxs)("tr", {
                                            children: [
                                                (0, _jsxRuntime.jsx)("td", {
                                                    style: {
                                                        ...tdStyle,
                                                        color: '#6b7280',
                                                        width: '40%'
                                                    },
                                                    children: label
                                                }),
                                                (0, _jsxRuntime.jsx)("td", {
                                                    style: {
                                                        ...tdStyle,
                                                        wordBreak: 'break-all'
                                                    },
                                                    children: value
                                                })
                                            ]
                                        }, label))
                                })
                            }),
                            (0, _jsxRuntime.jsx)("p", {
                                style: {
                                    ...sectionTitle,
                                    marginTop: '20px'
                                },
                                children: "Cuenta"
                            }),
                            (0, _jsxRuntime.jsxs)("div", {
                                className: "d-flex align-items-center gap-2",
                                style: {
                                    fontSize: '0.875rem'
                                },
                                children: [
                                    (0, _jsxRuntime.jsx)((0, _fortawesomeDefault.default), {
                                        name: "faCreditCard",
                                        className: "text-muted"
                                    }),
                                    (0, _jsxRuntime.jsx)("span", {
                                        children: payoutRow.bank_name ? `${payoutRow.bank_name} \u{2022}\u{2022}\u{2022}\u{2022} ${payoutRow.last4}` : "\u2014"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)("p", {
                style: sectionTitle,
                children: "Transacciones"
            }),
            (0, _jsxRuntime.jsxs)("table", {
                style: {
                    width: '100%',
                    borderCollapse: 'collapse'
                },
                children: [
                    (0, _jsxRuntime.jsx)("thead", {
                        children: (0, _jsxRuntime.jsxs)("tr", {
                            children: [
                                (0, _jsxRuntime.jsx)("th", {
                                    style: thStyle,
                                    children: "Tipo"
                                }),
                                (0, _jsxRuntime.jsx)("th", {
                                    style: {
                                        ...thStyle,
                                        textAlign: 'right'
                                    },
                                    children: "Bruto"
                                }),
                                (0, _jsxRuntime.jsx)("th", {
                                    style: {
                                        ...thStyle,
                                        textAlign: 'right'
                                    },
                                    children: "Comisi\u00F3n"
                                }),
                                (0, _jsxRuntime.jsx)("th", {
                                    style: {
                                        ...thStyle,
                                        textAlign: 'right'
                                    },
                                    children: "Total"
                                }),
                                (0, _jsxRuntime.jsx)("th", {
                                    style: thStyle,
                                    children: "Descripci\u00F3n"
                                }),
                                (0, _jsxRuntime.jsx)("th", {
                                    style: thStyle,
                                    children: "Fecha"
                                })
                            ]
                        })
                    }),
                    (0, _jsxRuntime.jsx)("tbody", {
                        children: visibleTransactions.map((txn)=>(0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    (0, _jsxRuntime.jsx)("td", {
                                        style: tdStyle,
                                        children: txnTypeLabels[txn._type ?? txn.type] ?? txn.type
                                    }),
                                    (0, _jsxRuntime.jsx)("td", {
                                        style: {
                                            ...tdStyle,
                                            textAlign: 'right'
                                        },
                                        children: formatAmount(txn.amount)
                                    }),
                                    (0, _jsxRuntime.jsx)("td", {
                                        style: {
                                            ...tdStyle,
                                            textAlign: 'right'
                                        },
                                        children: formatFee(txn.fee)
                                    }),
                                    (0, _jsxRuntime.jsx)("td", {
                                        style: {
                                            ...tdStyle,
                                            textAlign: 'right'
                                        },
                                        children: formatAmount(txn.net)
                                    }),
                                    (0, _jsxRuntime.jsx)("td", {
                                        style: tdStyle,
                                        children: txn._description ?? txn.description ?? "\u2014"
                                    }),
                                    (0, _jsxRuntime.jsx)("td", {
                                        style: tdStyle,
                                        children: formatDate(txn.created)
                                    })
                                ]
                            }, txn.id))
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"1Glst","external/fortawesome":"7JvBl","context/accounting-context/hook":"cCF1x","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}]},["6MveM","4UKz9"], "4UKz9", "parcelRequire94c2")

//# sourceMappingURL=index.c0d8ddfb.js.map
